// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/images/icons/reply.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/images/icons/category.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Figtree:wght@400;500;600;700&family=Poppins:wght@400;500;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*--------------------------------------------------------------
>> TABLE OF CONTENTS:
----------------------------------------------------------------
1. Typography
2. Preloader
3. Spacing
4. General
5. Slider
6. Video Popup
7. Header
8. Footer
9. Sidebar
10. Isotope
11. Hero
12. Iconbox
13. Posts
14. Banner
15. Testimonial
16. Portfolio
17. Brands
18. Accordians
19. Departments
20. About
21. Team
22. Funfact
---------------------------------------------------------------*/
/*--------------------------------------------------------------
## Color Variable
----------------------------------------------------------------*/
/*--------------------------------------------------------------
1. Typography
----------------------------------------------------------------*/
body,
html {
  color: rgba(1, 113, 206, 0.52);
  font-family: "Poppins", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.625em;
  overflow-x: hidden !important;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  clear: both;
  color: #0171CE;
  padding: 0;
  margin: 0 0 20px 0;
  font-weight: 700;
  line-height: 1.2em;
  font-family: "Figtree", sans-serif;
}

.cs_primary_font,
.cs_btn {
  font-family: "Figtree", sans-serif;
}

.cs_secondary_font {
  font-family: "Poppins", sans-serif;
}

h1 {
  font-size: 56px;
}

h2 {
  font-size: 42px;
}

h3 {
  font-size: 30px;
}

h4 {
  font-size: 24px;
}

h5 {
  font-size: 18px;
}

h6 {
  font-size: 16px;
}

p {
  margin-bottom: 15px;
}

ul {
  margin: 0 0 25px 0;
  padding-left: 20px;
  list-style: square outside none;
}

ol {
  padding-left: 20px;
  margin-bottom: 25px;
}

dfn,
cite,
em,
i {
  font-style: italic;
}

blockquote {
  margin: 0 15px;
  font-style: italic;
  font-size: 20px;
  line-height: 1.6em;
  margin: 0;
}

address {
  margin: 0 0 15px;
}

img {
  border: 0;
  max-width: 100%;
  height: auto;
}

a {
  color: inherit;
  text-decoration: none;
  transition: all 0.3s ease;
}

button {
  color: inherit;
  transition: all 0.3s ease;
}

a:hover {
  text-decoration: none;
  color: #01AE42;
}

table {
  width: 100%;
  margin-bottom: 25px;
}
table th {
  font-weight: 600;
  color: rgba(1, 113, 206, 0.52);
}
table td,
table th {
  border-top: 1px solid #eaeaea;
  padding: 11px 10px;
}

dl {
  margin-bottom: 25px;
}
dl dt {
  font-weight: 600;
}

b,
strong {
  font-weight: bold;
}

pre {
  color: rgba(1, 113, 206, 0.52);
  border: 1px solid #eaeaea;
  font-size: 18px;
  padding: 25px;
  border-radius: 5px;
}

kbd {
  font-size: 100%;
  background-color: rgba(1, 113, 206, 0.52);
  border-radius: 5px;
}

@media screen and (max-width: 991px) {
  body,
  html {
    font-size: 16px;
    line-height: 1.6em;
  }
  h2 {
    font-size: 36px;
    margin-bottom: 10px;
  }
}
input,
textarea {
  color: #0171CE;
}

/*--------------------------------------------------------------
2. Preloader
----------------------------------------------------------------*/
.cs_perloader {
  position: fixed;
  height: 100vh;
  width: 100vw;
  z-index: 99999;
  left: 0;
  top: 0;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cs_perloader .cs_perloader_in {
  position: relative;
}
.cs_perloader .cs_perloader_in svg {
  width: 110px;
  height: 110px;
}
.cs_perloader .cs_wave_first svg {
  fill: rgba(1, 174, 66, 0.15);
}
.cs_perloader .cs_wave_second {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  animation: spark 1.25s linear infinite;
}
.cs_perloader .cs_wave_second svg {
  fill: #01AE42;
}

@keyframes spark {
  0% {
    max-width: 0;
  }
  100% {
    max-width: 100%;
  }
}
/*--------------------------------------------------------------
3. Spacing
----------------------------------------------------------------*/
.cs_height_0 {
  height: 0px;
}

.cs_height_1 {
  height: 1px;
}

.cs_height_2 {
  height: 2px;
}

.cs_height_3 {
  height: 3px;
}

.cs_height_4 {
  height: 4px;
}

.cs_height_5 {
  height: 5px;
}

.cs_height_6 {
  height: 6px;
}

.cs_height_7 {
  height: 7px;
}

.cs_height_8 {
  height: 8px;
}

.cs_height_9 {
  height: 9px;
}

.cs_height_10 {
  height: 10px;
}

.cs_height_11 {
  height: 11px;
}

.cs_height_12 {
  height: 12px;
}

.cs_height_13 {
  height: 13px;
}

.cs_height_14 {
  height: 14px;
}

.cs_height_15 {
  height: 15px;
}

.cs_height_16 {
  height: 16px;
}

.cs_height_17 {
  height: 17px;
}

.cs_height_18 {
  height: 18px;
}

.cs_height_19 {
  height: 19px;
}

.cs_height_20 {
  height: 20px;
}

.cs_height_21 {
  height: 21px;
}

.cs_height_22 {
  height: 22px;
}

.cs_height_23 {
  height: 23px;
}

.cs_height_24 {
  height: 24px;
}

.cs_height_25 {
  height: 25px;
}

.cs_height_26 {
  height: 26px;
}

.cs_height_27 {
  height: 27px;
}

.cs_height_28 {
  height: 28px;
}

.cs_height_29 {
  height: 29px;
}

.cs_height_30 {
  height: 30px;
}

.cs_height_31 {
  height: 31px;
}

.cs_height_32 {
  height: 32px;
}

.cs_height_33 {
  height: 33px;
}

.cs_height_34 {
  height: 34px;
}

.cs_height_35 {
  height: 35px;
}

.cs_height_36 {
  height: 36px;
}

.cs_height_37 {
  height: 37px;
}

.cs_height_38 {
  height: 38px;
}

.cs_height_39 {
  height: 39px;
}

.cs_height_40 {
  height: 40px;
}

.cs_height_41 {
  height: 41px;
}

.cs_height_42 {
  height: 42px;
}

.cs_height_43 {
  height: 43px;
}

.cs_height_44 {
  height: 44px;
}

.cs_height_45 {
  height: 45px;
}

.cs_height_46 {
  height: 46px;
}

.cs_height_47 {
  height: 47px;
}

.cs_height_48 {
  height: 48px;
}

.cs_height_49 {
  height: 49px;
}

.cs_height_50 {
  height: 50px;
}

.cs_height_51 {
  height: 51px;
}

.cs_height_52 {
  height: 52px;
}

.cs_height_53 {
  height: 53px;
}

.cs_height_54 {
  height: 54px;
}

.cs_height_55 {
  height: 55px;
}

.cs_height_56 {
  height: 56px;
}

.cs_height_57 {
  height: 57px;
}

.cs_height_58 {
  height: 58px;
}

.cs_height_59 {
  height: 59px;
}

.cs_height_60 {
  height: 60px;
}

.cs_height_61 {
  height: 61px;
}

.cs_height_62 {
  height: 62px;
}

.cs_height_63 {
  height: 63px;
}

.cs_height_64 {
  height: 64px;
}

.cs_height_65 {
  height: 65px;
}

.cs_height_66 {
  height: 66px;
}

.cs_height_67 {
  height: 67px;
}

.cs_height_68 {
  height: 68px;
}

.cs_height_69 {
  height: 69px;
}

.cs_height_70 {
  height: 70px;
}

.cs_height_71 {
  height: 71px;
}

.cs_height_72 {
  height: 72px;
}

.cs_height_73 {
  height: 73px;
}

.cs_height_74 {
  height: 74px;
}

.cs_height_75 {
  height: 75px;
}

.cs_height_76 {
  height: 76px;
}

.cs_height_77 {
  height: 77px;
}

.cs_height_78 {
  height: 78px;
}

.cs_height_79 {
  height: 79px;
}

.cs_height_80 {
  height: 80px;
}

.cs_height_81 {
  height: 81px;
}

.cs_height_82 {
  height: 82px;
}

.cs_height_83 {
  height: 83px;
}

.cs_height_84 {
  height: 84px;
}

.cs_height_85 {
  height: 85px;
}

.cs_height_86 {
  height: 86px;
}

.cs_height_87 {
  height: 87px;
}

.cs_height_88 {
  height: 88px;
}

.cs_height_89 {
  height: 89px;
}

.cs_height_90 {
  height: 90px;
}

.cs_height_91 {
  height: 91px;
}

.cs_height_92 {
  height: 92px;
}

.cs_height_93 {
  height: 93px;
}

.cs_height_94 {
  height: 94px;
}

.cs_height_95 {
  height: 95px;
}

.cs_height_96 {
  height: 96px;
}

.cs_height_97 {
  height: 97px;
}

.cs_height_98 {
  height: 98px;
}

.cs_height_99 {
  height: 99px;
}

.cs_height_100 {
  height: 100px;
}

.cs_height_101 {
  height: 101px;
}

.cs_height_102 {
  height: 102px;
}

.cs_height_103 {
  height: 103px;
}

.cs_height_104 {
  height: 104px;
}

.cs_height_105 {
  height: 105px;
}

.cs_height_106 {
  height: 106px;
}

.cs_height_107 {
  height: 107px;
}

.cs_height_108 {
  height: 108px;
}

.cs_height_109 {
  height: 109px;
}

.cs_height_110 {
  height: 110px;
}

.cs_height_111 {
  height: 111px;
}

.cs_height_112 {
  height: 112px;
}

.cs_height_113 {
  height: 113px;
}

.cs_height_114 {
  height: 114px;
}

.cs_height_115 {
  height: 115px;
}

.cs_height_116 {
  height: 116px;
}

.cs_height_117 {
  height: 117px;
}

.cs_height_118 {
  height: 118px;
}

.cs_height_119 {
  height: 119px;
}

.cs_height_120 {
  height: 120px;
}

.cs_height_121 {
  height: 121px;
}

.cs_height_122 {
  height: 122px;
}

.cs_height_123 {
  height: 123px;
}

.cs_height_124 {
  height: 124px;
}

.cs_height_125 {
  height: 125px;
}

.cs_height_126 {
  height: 126px;
}

.cs_height_127 {
  height: 127px;
}

.cs_height_128 {
  height: 128px;
}

.cs_height_129 {
  height: 129px;
}

.cs_height_130 {
  height: 130px;
}

.cs_height_131 {
  height: 131px;
}

.cs_height_132 {
  height: 132px;
}

.cs_height_133 {
  height: 133px;
}

.cs_height_134 {
  height: 134px;
}

.cs_height_135 {
  height: 135px;
}

.cs_height_136 {
  height: 136px;
}

.cs_height_137 {
  height: 137px;
}

.cs_height_138 {
  height: 138px;
}

.cs_height_139 {
  height: 139px;
}

.cs_height_140 {
  height: 140px;
}

.cs_height_141 {
  height: 141px;
}

.cs_height_142 {
  height: 142px;
}

.cs_height_143 {
  height: 143px;
}

.cs_height_144 {
  height: 144px;
}

.cs_height_145 {
  height: 145px;
}

.cs_height_146 {
  height: 146px;
}

.cs_height_147 {
  height: 147px;
}

.cs_height_148 {
  height: 148px;
}

.cs_height_149 {
  height: 149px;
}

.cs_height_150 {
  height: 150px;
}

.cs_height_151 {
  height: 151px;
}

.cs_height_152 {
  height: 152px;
}

.cs_height_153 {
  height: 153px;
}

.cs_height_154 {
  height: 154px;
}

.cs_height_155 {
  height: 155px;
}

.cs_height_156 {
  height: 156px;
}

.cs_height_157 {
  height: 157px;
}

.cs_height_158 {
  height: 158px;
}

.cs_height_159 {
  height: 159px;
}

.cs_height_160 {
  height: 160px;
}

.cs_height_161 {
  height: 161px;
}

.cs_height_162 {
  height: 162px;
}

.cs_height_163 {
  height: 163px;
}

.cs_height_164 {
  height: 164px;
}

.cs_height_165 {
  height: 165px;
}

.cs_height_166 {
  height: 166px;
}

.cs_height_167 {
  height: 167px;
}

.cs_height_168 {
  height: 168px;
}

.cs_height_169 {
  height: 169px;
}

.cs_height_170 {
  height: 170px;
}

.cs_height_171 {
  height: 171px;
}

.cs_height_172 {
  height: 172px;
}

.cs_height_173 {
  height: 173px;
}

.cs_height_174 {
  height: 174px;
}

.cs_height_175 {
  height: 175px;
}

.cs_height_176 {
  height: 176px;
}

.cs_height_177 {
  height: 177px;
}

.cs_height_178 {
  height: 178px;
}

.cs_height_179 {
  height: 179px;
}

.cs_height_180 {
  height: 180px;
}

.cs_height_181 {
  height: 181px;
}

.cs_height_182 {
  height: 182px;
}

.cs_height_183 {
  height: 183px;
}

.cs_height_184 {
  height: 184px;
}

.cs_height_185 {
  height: 185px;
}

.cs_height_186 {
  height: 186px;
}

.cs_height_187 {
  height: 187px;
}

.cs_height_188 {
  height: 188px;
}

.cs_height_189 {
  height: 189px;
}

.cs_height_190 {
  height: 190px;
}

.cs_height_191 {
  height: 191px;
}

.cs_height_192 {
  height: 192px;
}

.cs_height_193 {
  height: 193px;
}

.cs_height_194 {
  height: 194px;
}

.cs_height_195 {
  height: 195px;
}

.cs_height_196 {
  height: 196px;
}

.cs_height_197 {
  height: 197px;
}

.cs_height_198 {
  height: 198px;
}

.cs_height_199 {
  height: 199px;
}

.cs_height_200 {
  height: 200px;
}

@media screen and (max-width: 1700px) {
  .cs_height_xl_0 {
    height: 0px;
  }
  .cs_height_xl_1 {
    height: 1px;
  }
  .cs_height_xl_2 {
    height: 2px;
  }
  .cs_height_xl_3 {
    height: 3px;
  }
  .cs_height_xl_4 {
    height: 4px;
  }
  .cs_height_xl_5 {
    height: 5px;
  }
  .cs_height_xl_6 {
    height: 6px;
  }
  .cs_height_xl_7 {
    height: 7px;
  }
  .cs_height_xl_8 {
    height: 8px;
  }
  .cs_height_xl_9 {
    height: 9px;
  }
  .cs_height_xl_10 {
    height: 10px;
  }
  .cs_height_xl_11 {
    height: 11px;
  }
  .cs_height_xl_12 {
    height: 12px;
  }
  .cs_height_xl_13 {
    height: 13px;
  }
  .cs_height_xl_14 {
    height: 14px;
  }
  .cs_height_xl_15 {
    height: 15px;
  }
  .cs_height_xl_16 {
    height: 16px;
  }
  .cs_height_xl_17 {
    height: 17px;
  }
  .cs_height_xl_18 {
    height: 18px;
  }
  .cs_height_xl_19 {
    height: 19px;
  }
  .cs_height_xl_20 {
    height: 20px;
  }
  .cs_height_xl_21 {
    height: 21px;
  }
  .cs_height_xl_22 {
    height: 22px;
  }
  .cs_height_xl_23 {
    height: 23px;
  }
  .cs_height_xl_24 {
    height: 24px;
  }
  .cs_height_xl_25 {
    height: 25px;
  }
  .cs_height_xl_26 {
    height: 26px;
  }
  .cs_height_xl_27 {
    height: 27px;
  }
  .cs_height_xl_28 {
    height: 28px;
  }
  .cs_height_xl_29 {
    height: 29px;
  }
  .cs_height_xl_30 {
    height: 30px;
  }
  .cs_height_xl_31 {
    height: 31px;
  }
  .cs_height_xl_32 {
    height: 32px;
  }
  .cs_height_xl_33 {
    height: 33px;
  }
  .cs_height_xl_34 {
    height: 34px;
  }
  .cs_height_xl_35 {
    height: 35px;
  }
  .cs_height_xl_36 {
    height: 36px;
  }
  .cs_height_xl_37 {
    height: 37px;
  }
  .cs_height_xl_38 {
    height: 38px;
  }
  .cs_height_xl_39 {
    height: 39px;
  }
  .cs_height_xl_40 {
    height: 40px;
  }
  .cs_height_xl_41 {
    height: 41px;
  }
  .cs_height_xl_42 {
    height: 42px;
  }
  .cs_height_xl_43 {
    height: 43px;
  }
  .cs_height_xl_44 {
    height: 44px;
  }
  .cs_height_xl_45 {
    height: 45px;
  }
  .cs_height_xl_46 {
    height: 46px;
  }
  .cs_height_xl_47 {
    height: 47px;
  }
  .cs_height_xl_48 {
    height: 48px;
  }
  .cs_height_xl_49 {
    height: 49px;
  }
  .cs_height_xl_50 {
    height: 50px;
  }
  .cs_height_xl_51 {
    height: 51px;
  }
  .cs_height_xl_52 {
    height: 52px;
  }
  .cs_height_xl_53 {
    height: 53px;
  }
  .cs_height_xl_54 {
    height: 54px;
  }
  .cs_height_xl_55 {
    height: 55px;
  }
  .cs_height_xl_56 {
    height: 56px;
  }
  .cs_height_xl_57 {
    height: 57px;
  }
  .cs_height_xl_58 {
    height: 58px;
  }
  .cs_height_xl_59 {
    height: 59px;
  }
  .cs_height_xl_60 {
    height: 60px;
  }
  .cs_height_xl_61 {
    height: 61px;
  }
  .cs_height_xl_62 {
    height: 62px;
  }
  .cs_height_xl_63 {
    height: 63px;
  }
  .cs_height_xl_64 {
    height: 64px;
  }
  .cs_height_xl_65 {
    height: 65px;
  }
  .cs_height_xl_66 {
    height: 66px;
  }
  .cs_height_xl_67 {
    height: 67px;
  }
  .cs_height_xl_68 {
    height: 68px;
  }
  .cs_height_xl_69 {
    height: 69px;
  }
  .cs_height_xl_70 {
    height: 70px;
  }
  .cs_height_xl_71 {
    height: 71px;
  }
  .cs_height_xl_72 {
    height: 72px;
  }
  .cs_height_xl_73 {
    height: 73px;
  }
  .cs_height_xl_74 {
    height: 74px;
  }
  .cs_height_xl_75 {
    height: 75px;
  }
  .cs_height_xl_76 {
    height: 76px;
  }
  .cs_height_xl_77 {
    height: 77px;
  }
  .cs_height_xl_78 {
    height: 78px;
  }
  .cs_height_xl_79 {
    height: 79px;
  }
  .cs_height_xl_80 {
    height: 80px;
  }
  .cs_height_xl_81 {
    height: 81px;
  }
  .cs_height_xl_82 {
    height: 82px;
  }
  .cs_height_xl_83 {
    height: 83px;
  }
  .cs_height_xl_84 {
    height: 84px;
  }
  .cs_height_xl_85 {
    height: 85px;
  }
  .cs_height_xl_86 {
    height: 86px;
  }
  .cs_height_xl_87 {
    height: 87px;
  }
  .cs_height_xl_88 {
    height: 88px;
  }
  .cs_height_xl_89 {
    height: 89px;
  }
  .cs_height_xl_90 {
    height: 90px;
  }
  .cs_height_xl_91 {
    height: 91px;
  }
  .cs_height_xl_92 {
    height: 92px;
  }
  .cs_height_xl_93 {
    height: 93px;
  }
  .cs_height_xl_94 {
    height: 94px;
  }
  .cs_height_xl_95 {
    height: 95px;
  }
  .cs_height_xl_96 {
    height: 96px;
  }
  .cs_height_xl_97 {
    height: 97px;
  }
  .cs_height_xl_98 {
    height: 98px;
  }
  .cs_height_xl_99 {
    height: 99px;
  }
  .cs_height_xl_100 {
    height: 100px;
  }
  .cs_height_xl_101 {
    height: 101px;
  }
  .cs_height_xl_102 {
    height: 102px;
  }
  .cs_height_xl_103 {
    height: 103px;
  }
  .cs_height_xl_104 {
    height: 104px;
  }
  .cs_height_xl_105 {
    height: 105px;
  }
  .cs_height_xl_106 {
    height: 106px;
  }
  .cs_height_xl_107 {
    height: 107px;
  }
  .cs_height_xl_108 {
    height: 108px;
  }
  .cs_height_xl_109 {
    height: 109px;
  }
  .cs_height_xl_110 {
    height: 110px;
  }
  .cs_height_xl_111 {
    height: 111px;
  }
  .cs_height_xl_112 {
    height: 112px;
  }
  .cs_height_xl_113 {
    height: 113px;
  }
  .cs_height_xl_114 {
    height: 114px;
  }
  .cs_height_xl_115 {
    height: 115px;
  }
  .cs_height_xl_116 {
    height: 116px;
  }
  .cs_height_xl_117 {
    height: 117px;
  }
  .cs_height_xl_118 {
    height: 118px;
  }
  .cs_height_xl_119 {
    height: 119px;
  }
  .cs_height_xl_120 {
    height: 120px;
  }
  .cs_height_xl_121 {
    height: 121px;
  }
  .cs_height_xl_122 {
    height: 122px;
  }
  .cs_height_xl_123 {
    height: 123px;
  }
  .cs_height_xl_124 {
    height: 124px;
  }
  .cs_height_xl_125 {
    height: 125px;
  }
  .cs_height_xl_126 {
    height: 126px;
  }
  .cs_height_xl_127 {
    height: 127px;
  }
  .cs_height_xl_128 {
    height: 128px;
  }
  .cs_height_xl_129 {
    height: 129px;
  }
  .cs_height_xl_130 {
    height: 130px;
  }
  .cs_height_xl_131 {
    height: 131px;
  }
  .cs_height_xl_132 {
    height: 132px;
  }
  .cs_height_xl_133 {
    height: 133px;
  }
  .cs_height_xl_134 {
    height: 134px;
  }
  .cs_height_xl_135 {
    height: 135px;
  }
  .cs_height_xl_136 {
    height: 136px;
  }
  .cs_height_xl_137 {
    height: 137px;
  }
  .cs_height_xl_138 {
    height: 138px;
  }
  .cs_height_xl_139 {
    height: 139px;
  }
  .cs_height_xl_140 {
    height: 140px;
  }
  .cs_height_xl_141 {
    height: 141px;
  }
  .cs_height_xl_142 {
    height: 142px;
  }
  .cs_height_xl_143 {
    height: 143px;
  }
  .cs_height_xl_144 {
    height: 144px;
  }
  .cs_height_xl_145 {
    height: 145px;
  }
  .cs_height_xl_146 {
    height: 146px;
  }
  .cs_height_xl_147 {
    height: 147px;
  }
  .cs_height_xl_148 {
    height: 148px;
  }
  .cs_height_xl_149 {
    height: 149px;
  }
  .cs_height_xl_150 {
    height: 150px;
  }
  .cs_height_xl_151 {
    height: 151px;
  }
  .cs_height_xl_152 {
    height: 152px;
  }
  .cs_height_xl_153 {
    height: 153px;
  }
  .cs_height_xl_154 {
    height: 154px;
  }
  .cs_height_xl_155 {
    height: 155px;
  }
  .cs_height_xl_156 {
    height: 156px;
  }
  .cs_height_xl_157 {
    height: 157px;
  }
  .cs_height_xl_158 {
    height: 158px;
  }
  .cs_height_xl_159 {
    height: 159px;
  }
  .cs_height_xl_160 {
    height: 160px;
  }
  .cs_height_xl_161 {
    height: 161px;
  }
  .cs_height_xl_162 {
    height: 162px;
  }
  .cs_height_xl_163 {
    height: 163px;
  }
  .cs_height_xl_164 {
    height: 164px;
  }
  .cs_height_xl_165 {
    height: 165px;
  }
  .cs_height_xl_166 {
    height: 166px;
  }
  .cs_height_xl_167 {
    height: 167px;
  }
  .cs_height_xl_168 {
    height: 168px;
  }
  .cs_height_xl_169 {
    height: 169px;
  }
  .cs_height_xl_170 {
    height: 170px;
  }
  .cs_height_xl_171 {
    height: 171px;
  }
  .cs_height_xl_172 {
    height: 172px;
  }
  .cs_height_xl_173 {
    height: 173px;
  }
  .cs_height_xl_174 {
    height: 174px;
  }
  .cs_height_xl_175 {
    height: 175px;
  }
  .cs_height_xl_176 {
    height: 176px;
  }
  .cs_height_xl_177 {
    height: 177px;
  }
  .cs_height_xl_178 {
    height: 178px;
  }
  .cs_height_xl_179 {
    height: 179px;
  }
  .cs_height_xl_180 {
    height: 180px;
  }
  .cs_height_xl_181 {
    height: 181px;
  }
  .cs_height_xl_182 {
    height: 182px;
  }
  .cs_height_xl_183 {
    height: 183px;
  }
  .cs_height_xl_184 {
    height: 184px;
  }
  .cs_height_xl_185 {
    height: 185px;
  }
  .cs_height_xl_186 {
    height: 186px;
  }
  .cs_height_xl_187 {
    height: 187px;
  }
  .cs_height_xl_188 {
    height: 188px;
  }
  .cs_height_xl_189 {
    height: 189px;
  }
  .cs_height_xl_190 {
    height: 190px;
  }
  .cs_height_xl_191 {
    height: 191px;
  }
  .cs_height_xl_192 {
    height: 192px;
  }
  .cs_height_xl_193 {
    height: 193px;
  }
  .cs_height_xl_194 {
    height: 194px;
  }
  .cs_height_xl_195 {
    height: 195px;
  }
  .cs_height_xl_196 {
    height: 196px;
  }
  .cs_height_xl_197 {
    height: 197px;
  }
  .cs_height_xl_198 {
    height: 198px;
  }
  .cs_height_xl_199 {
    height: 199px;
  }
  .cs_height_xl_200 {
    height: 200px;
  }
}
@media screen and (max-width: 991px) {
  .cs_height_lg_0 {
    height: 0px;
  }
  .cs_height_lg_1 {
    height: 1px;
  }
  .cs_height_lg_2 {
    height: 2px;
  }
  .cs_height_lg_3 {
    height: 3px;
  }
  .cs_height_lg_4 {
    height: 4px;
  }
  .cs_height_lg_5 {
    height: 5px;
  }
  .cs_height_lg_6 {
    height: 6px;
  }
  .cs_height_lg_7 {
    height: 7px;
  }
  .cs_height_lg_8 {
    height: 8px;
  }
  .cs_height_lg_9 {
    height: 9px;
  }
  .cs_height_lg_10 {
    height: 10px;
  }
  .cs_height_lg_11 {
    height: 11px;
  }
  .cs_height_lg_12 {
    height: 12px;
  }
  .cs_height_lg_13 {
    height: 13px;
  }
  .cs_height_lg_14 {
    height: 14px;
  }
  .cs_height_lg_15 {
    height: 15px;
  }
  .cs_height_lg_16 {
    height: 16px;
  }
  .cs_height_lg_17 {
    height: 17px;
  }
  .cs_height_lg_18 {
    height: 18px;
  }
  .cs_height_lg_19 {
    height: 19px;
  }
  .cs_height_lg_20 {
    height: 20px;
  }
  .cs_height_lg_21 {
    height: 21px;
  }
  .cs_height_lg_22 {
    height: 22px;
  }
  .cs_height_lg_23 {
    height: 23px;
  }
  .cs_height_lg_24 {
    height: 24px;
  }
  .cs_height_lg_25 {
    height: 25px;
  }
  .cs_height_lg_26 {
    height: 26px;
  }
  .cs_height_lg_27 {
    height: 27px;
  }
  .cs_height_lg_28 {
    height: 28px;
  }
  .cs_height_lg_29 {
    height: 29px;
  }
  .cs_height_lg_30 {
    height: 30px;
  }
  .cs_height_lg_31 {
    height: 31px;
  }
  .cs_height_lg_32 {
    height: 32px;
  }
  .cs_height_lg_33 {
    height: 33px;
  }
  .cs_height_lg_34 {
    height: 34px;
  }
  .cs_height_lg_35 {
    height: 35px;
  }
  .cs_height_lg_36 {
    height: 36px;
  }
  .cs_height_lg_37 {
    height: 37px;
  }
  .cs_height_lg_38 {
    height: 38px;
  }
  .cs_height_lg_39 {
    height: 39px;
  }
  .cs_height_lg_40 {
    height: 40px;
  }
  .cs_height_lg_41 {
    height: 41px;
  }
  .cs_height_lg_42 {
    height: 42px;
  }
  .cs_height_lg_43 {
    height: 43px;
  }
  .cs_height_lg_44 {
    height: 44px;
  }
  .cs_height_lg_45 {
    height: 45px;
  }
  .cs_height_lg_46 {
    height: 46px;
  }
  .cs_height_lg_47 {
    height: 47px;
  }
  .cs_height_lg_48 {
    height: 48px;
  }
  .cs_height_lg_49 {
    height: 49px;
  }
  .cs_height_lg_50 {
    height: 50px;
  }
  .cs_height_lg_51 {
    height: 51px;
  }
  .cs_height_lg_52 {
    height: 52px;
  }
  .cs_height_lg_53 {
    height: 53px;
  }
  .cs_height_lg_54 {
    height: 54px;
  }
  .cs_height_lg_55 {
    height: 55px;
  }
  .cs_height_lg_56 {
    height: 56px;
  }
  .cs_height_lg_57 {
    height: 57px;
  }
  .cs_height_lg_58 {
    height: 58px;
  }
  .cs_height_lg_59 {
    height: 59px;
  }
  .cs_height_lg_60 {
    height: 60px;
  }
  .cs_height_lg_61 {
    height: 61px;
  }
  .cs_height_lg_62 {
    height: 62px;
  }
  .cs_height_lg_63 {
    height: 63px;
  }
  .cs_height_lg_64 {
    height: 64px;
  }
  .cs_height_lg_65 {
    height: 65px;
  }
  .cs_height_lg_66 {
    height: 66px;
  }
  .cs_height_lg_67 {
    height: 67px;
  }
  .cs_height_lg_68 {
    height: 68px;
  }
  .cs_height_lg_69 {
    height: 69px;
  }
  .cs_height_lg_70 {
    height: 70px;
  }
  .cs_height_lg_71 {
    height: 71px;
  }
  .cs_height_lg_72 {
    height: 72px;
  }
  .cs_height_lg_73 {
    height: 73px;
  }
  .cs_height_lg_74 {
    height: 74px;
  }
  .cs_height_lg_75 {
    height: 75px;
  }
  .cs_height_lg_76 {
    height: 76px;
  }
  .cs_height_lg_77 {
    height: 77px;
  }
  .cs_height_lg_78 {
    height: 78px;
  }
  .cs_height_lg_79 {
    height: 79px;
  }
  .cs_height_lg_80 {
    height: 80px;
  }
  .cs_height_lg_81 {
    height: 81px;
  }
  .cs_height_lg_82 {
    height: 82px;
  }
  .cs_height_lg_83 {
    height: 83px;
  }
  .cs_height_lg_84 {
    height: 84px;
  }
  .cs_height_lg_85 {
    height: 85px;
  }
  .cs_height_lg_86 {
    height: 86px;
  }
  .cs_height_lg_87 {
    height: 87px;
  }
  .cs_height_lg_88 {
    height: 88px;
  }
  .cs_height_lg_89 {
    height: 89px;
  }
  .cs_height_lg_90 {
    height: 90px;
  }
  .cs_height_lg_91 {
    height: 91px;
  }
  .cs_height_lg_92 {
    height: 92px;
  }
  .cs_height_lg_93 {
    height: 93px;
  }
  .cs_height_lg_94 {
    height: 94px;
  }
  .cs_height_lg_95 {
    height: 95px;
  }
  .cs_height_lg_96 {
    height: 96px;
  }
  .cs_height_lg_97 {
    height: 97px;
  }
  .cs_height_lg_98 {
    height: 98px;
  }
  .cs_height_lg_99 {
    height: 99px;
  }
  .cs_height_lg_100 {
    height: 100px;
  }
  .cs_height_lg_101 {
    height: 101px;
  }
  .cs_height_lg_102 {
    height: 102px;
  }
  .cs_height_lg_103 {
    height: 103px;
  }
  .cs_height_lg_104 {
    height: 104px;
  }
  .cs_height_lg_105 {
    height: 105px;
  }
  .cs_height_lg_106 {
    height: 106px;
  }
  .cs_height_lg_107 {
    height: 107px;
  }
  .cs_height_lg_108 {
    height: 108px;
  }
  .cs_height_lg_109 {
    height: 109px;
  }
  .cs_height_lg_110 {
    height: 110px;
  }
  .cs_height_lg_111 {
    height: 111px;
  }
  .cs_height_lg_112 {
    height: 112px;
  }
  .cs_height_lg_113 {
    height: 113px;
  }
  .cs_height_lg_114 {
    height: 114px;
  }
  .cs_height_lg_115 {
    height: 115px;
  }
  .cs_height_lg_116 {
    height: 116px;
  }
  .cs_height_lg_117 {
    height: 117px;
  }
  .cs_height_lg_118 {
    height: 118px;
  }
  .cs_height_lg_119 {
    height: 119px;
  }
  .cs_height_lg_120 {
    height: 120px;
  }
  .cs_height_lg_121 {
    height: 121px;
  }
  .cs_height_lg_122 {
    height: 122px;
  }
  .cs_height_lg_123 {
    height: 123px;
  }
  .cs_height_lg_124 {
    height: 124px;
  }
  .cs_height_lg_125 {
    height: 125px;
  }
  .cs_height_lg_126 {
    height: 126px;
  }
  .cs_height_lg_127 {
    height: 127px;
  }
  .cs_height_lg_128 {
    height: 128px;
  }
  .cs_height_lg_129 {
    height: 129px;
  }
  .cs_height_lg_130 {
    height: 130px;
  }
  .cs_height_lg_131 {
    height: 131px;
  }
  .cs_height_lg_132 {
    height: 132px;
  }
  .cs_height_lg_133 {
    height: 133px;
  }
  .cs_height_lg_134 {
    height: 134px;
  }
  .cs_height_lg_135 {
    height: 135px;
  }
  .cs_height_lg_136 {
    height: 136px;
  }
  .cs_height_lg_137 {
    height: 137px;
  }
  .cs_height_lg_138 {
    height: 138px;
  }
  .cs_height_lg_139 {
    height: 139px;
  }
  .cs_height_lg_140 {
    height: 140px;
  }
  .cs_height_lg_141 {
    height: 141px;
  }
  .cs_height_lg_142 {
    height: 142px;
  }
  .cs_height_lg_143 {
    height: 143px;
  }
  .cs_height_lg_144 {
    height: 144px;
  }
  .cs_height_lg_145 {
    height: 145px;
  }
  .cs_height_lg_146 {
    height: 146px;
  }
  .cs_height_lg_147 {
    height: 147px;
  }
  .cs_height_lg_148 {
    height: 148px;
  }
  .cs_height_lg_149 {
    height: 149px;
  }
  .cs_height_lg_150 {
    height: 150px;
  }
  .cs_height_lg_151 {
    height: 151px;
  }
  .cs_height_lg_152 {
    height: 152px;
  }
  .cs_height_lg_153 {
    height: 153px;
  }
  .cs_height_lg_154 {
    height: 154px;
  }
  .cs_height_lg_155 {
    height: 155px;
  }
  .cs_height_lg_156 {
    height: 156px;
  }
  .cs_height_lg_157 {
    height: 157px;
  }
  .cs_height_lg_158 {
    height: 158px;
  }
  .cs_height_lg_159 {
    height: 159px;
  }
  .cs_height_lg_160 {
    height: 160px;
  }
  .cs_height_lg_161 {
    height: 161px;
  }
  .cs_height_lg_162 {
    height: 162px;
  }
  .cs_height_lg_163 {
    height: 163px;
  }
  .cs_height_lg_164 {
    height: 164px;
  }
  .cs_height_lg_165 {
    height: 165px;
  }
  .cs_height_lg_166 {
    height: 166px;
  }
  .cs_height_lg_167 {
    height: 167px;
  }
  .cs_height_lg_168 {
    height: 168px;
  }
  .cs_height_lg_169 {
    height: 169px;
  }
  .cs_height_lg_170 {
    height: 170px;
  }
  .cs_height_lg_171 {
    height: 171px;
  }
  .cs_height_lg_172 {
    height: 172px;
  }
  .cs_height_lg_173 {
    height: 173px;
  }
  .cs_height_lg_174 {
    height: 174px;
  }
  .cs_height_lg_175 {
    height: 175px;
  }
  .cs_height_lg_176 {
    height: 176px;
  }
  .cs_height_lg_177 {
    height: 177px;
  }
  .cs_height_lg_178 {
    height: 178px;
  }
  .cs_height_lg_179 {
    height: 179px;
  }
  .cs_height_lg_180 {
    height: 180px;
  }
  .cs_height_lg_181 {
    height: 181px;
  }
  .cs_height_lg_182 {
    height: 182px;
  }
  .cs_height_lg_183 {
    height: 183px;
  }
  .cs_height_lg_184 {
    height: 184px;
  }
  .cs_height_lg_185 {
    height: 185px;
  }
  .cs_height_lg_186 {
    height: 186px;
  }
  .cs_height_lg_187 {
    height: 187px;
  }
  .cs_height_lg_188 {
    height: 188px;
  }
  .cs_height_lg_189 {
    height: 189px;
  }
  .cs_height_lg_190 {
    height: 190px;
  }
  .cs_height_lg_191 {
    height: 191px;
  }
  .cs_height_lg_192 {
    height: 192px;
  }
  .cs_height_lg_193 {
    height: 193px;
  }
  .cs_height_lg_194 {
    height: 194px;
  }
  .cs_height_lg_195 {
    height: 195px;
  }
  .cs_height_lg_196 {
    height: 196px;
  }
  .cs_height_lg_197 {
    height: 197px;
  }
  .cs_height_lg_198 {
    height: 198px;
  }
  .cs_height_lg_199 {
    height: 199px;
  }
  .cs_height_lg_200 {
    height: 200px;
  }
}
/*--------------------------------------------------------------
4. General
----------------------------------------------------------------*/
.cs_gap_y_24 {
  gap: 24px 0;
}

.cs_gap_y_40 {
  gap: 40px 0;
}

.cs_gap_y_30 {
  gap: 30px 0;
}

.cs_gap_y_50 {
  gap: 50px 0;
}

.cs_row_gap_50 {
  gap: 50px 0;
}
@media (max-width: 991px) {
  .cs_row_gap_50 {
    gap: 30px 0;
  }
}

.cs_pr_95 {
  padding-right: 95px;
}
@media (max-width: 1700px) {
  .cs_pr_95 {
    padding-right: 45px;
  }
}
@media (max-width: 1400px) {
  .cs_pr_95 {
    padding-right: 25px;
  }
}
@media (max-width: 1199px) {
  .cs_pr_95 {
    padding-right: 0;
    padding-top: 10px;
  }
}

.cs_gap_40 {
  gap: 40px;
}

.cs_post_pr_136 {
  padding-right: 136px;
}
@media (max-width: 1700px) {
  .cs_post_pr_136 {
    padding-right: 50px;
  }
}
@media (max-width: 1199px) {
  .cs_post_pr_136 {
    padding-right: 0px;
  }
}

.cs_mt_minus_110 {
  margin-top: -110px;
  position: relative;
  z-index: 5;
}
@media (max-width: 991px) {
  .cs_mt_minus_110 {
    margin-top: 110px;
  }
}

.cs_fs_94 {
  font-size: 94px;
  line-height: 1.1em;
}
@media (max-width: 1700px) {
  .cs_fs_94 {
    font-size: 72px;
  }
}
@media (max-width: 1199px) {
  .cs_fs_94 {
    font-size: 60px;
  }
}
@media (max-width: 400px) {
  .cs_fs_94 {
    font-size: 42px;
  }
}

.cs_fs_84 {
  font-size: 84px;
  line-height: 1.12em;
}
@media (max-width: 1700px) {
  .cs_fs_84 {
    font-size: 68px;
  }
}
@media (max-width: 767px) {
  .cs_fs_84 {
    font-size: 56px;
  }
}
@media (max-width: 400px) {
  .cs_fs_84 {
    font-size: 48px;
  }
}

.cs_fs_72 {
  font-size: 72px;
  line-height: 1.14em;
}
@media (max-width: 1700px) {
  .cs_fs_72 {
    font-size: 56px;
  }
}
@media (max-width: 991px) {
  .cs_fs_72 {
    font-size: 50px;
  }
}
@media (max-width: 575px) {
  .cs_fs_72 {
    font-size: 48px;
  }
}
@media (max-width: 350px) {
  .cs_fs_72 {
    font-size: 42px;
  }
}

.cs_fs_48 {
  font-size: 48px;
  line-height: 1.04em;
}
@media (max-width: 1700px) {
  .cs_fs_48 {
    font-size: 36px;
  }
}
@media (max-width: 991px) {
  .cs_fs_48 {
    font-size: 26px;
  }
}

.cs_fs_40 {
  font-size: 40px;
  line-height: 1.25em;
}
@media (max-width: 1700px) {
  .cs_fs_40 {
    font-size: 32px;
  }
}
@media (max-width: 991px) {
  .cs_fs_40 {
    font-size: 28px;
  }
}

.cs_fs_32 {
  font-size: 32px;
  line-height: 1.31em;
}
@media (max-width: 1700px) {
  .cs_fs_32 {
    font-size: 26px;
  }
}
@media (max-width: 991px) {
  .cs_fs_32 {
    font-size: 24px;
  }
}
@media (max-width: 350px) {
  .cs_fs_32 {
    font-size: 21px;
  }
}

.cs_fs_24 {
  font-size: 24px;
  line-height: 1.41em;
}
@media (max-width: 1700px) {
  .cs_fs_24 {
    font-size: 22px;
  }
}

.cs_fs_20 {
  font-size: 20px;
  line-height: 1.5em;
}
@media (max-width: 991px) {
  .cs_fs_20 {
    font-size: 18px;
  }
}

.cs_fs_18 {
  font-size: 18px;
  line-height: 1.5em;
}

.cs_img_filed {
  height: 100%;
}
.cs_img_filed > img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.cs_light {
  font-weight: 300;
}

.cs_normal {
  font-weight: 400;
}

.cs_medium {
  font-weight: 500;
}

.cs_semibold {
  font-weight: 600;
}

.cs_bold {
  font-weight: 700;
}

.cs_extra_bold {
  font-weight: 800;
}

.cs_black {
  font-weight: 900;
}

.cs_radius_3 {
  border-radius: 3px;
}

.cs_radius_5 {
  border-radius: 5px;
}

.cs_radius_7 {
  border-radius: 7px;
}

.cs_radius_10 {
  border-radius: 10px;
}

.cs_radius_15 {
  border-radius: 15px;
}

.cs_radius_20 {
  border-radius: 20px;
}

.cs_radius_25 {
  border-radius: 25px;
}

.cs_radius_30 {
  border-radius: 30px;
}

.cs_mp0 {
  list-style: none;
  margin: 0;
  padding: 0;
}

.cs_m0 {
  margin: 0;
}

hr {
  margin: 0;
  padding: 0;
  border: none;
  border-top: 1px solid #bcbcbc;
  opacity: 1;
}

.cs_vertical_middle {
  display: flex;
  align-items: center;
  min-height: 100%;
}

.cs_vertical_middle_in {
  flex: none;
  width: 100%;
}

.cs_center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.cs_bg_filed {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.cs_heading_color {
  color: #0171CE;
}

.cs_body_color {
  color: rgba(1, 113, 206, 0.52);
}

.cs_accent_color {
  color: #01AE42;
}

.cs_white_color {
  color: #fff;
}

.cs_white_bg {
  background-color: #ffffff;
}

.cs_accent_bg {
  background-color: #01AE42;
}

.cs_gray_bg_1 {
  background-color: rgba(210, 234, 239, 0.2);
}

.cs_half_bg,
.cs_half_bg_2 {
  position: relative;
}
.cs_half_bg::before,
.cs_half_bg_2::before {
  content: "";
  position: absolute;
  height: 60%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #fff;
}
.cs_half_bg > *,
.cs_half_bg_2 > * {
  position: relative;
  z-index: 2;
}

.cs_half_bg_2::before {
  height: 50%;
  top: initial;
  bottom: 0;
}

@media (min-width: 1701px) {
  .container {
    max-width: 1650px;
  }
}
.cs_shadow_1 {
  box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);
}

.cs_shadow_2 {
  box-shadow: 6px 4px 70px 8px rgba(48, 123, 196, 0.09);
}

.cs_btn.cs_style_1 {
  border-radius: 24px;
  box-shadow: 0px 4px 20px 0px rgba(39, 71, 96, 0.17);
  font-weight: 500;
  color: #fff;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 12px 40px;
  outline: none;
  border: none;
  position: relative;
  background: transparent;
}
@media (max-width: 991px) {
  .cs_btn.cs_style_1 {
    padding: 12px 30px;
  }
}
.cs_btn.cs_style_1 span {
  position: relative;
  z-index: 2;
}
.cs_btn.cs_style_1 i {
  display: inline-block;
  position: relative;
  overflow: hidden;
  width: 15px;
  height: 11px;
  z-index: 2;
  transition: all 0.4s ease-in-out;
}
.cs_btn.cs_style_1 img {
  width: inherit;
  height: inherit;
  position: absolute;
  top: 0;
  transition: all 0.4s ease-in-out;
  filter: brightness(0) invert(1);
}
.cs_btn.cs_style_1 img:first-child {
  left: -20px;
}
.cs_btn.cs_style_1 img:last-child {
  left: 0;
}
.cs_btn.cs_style_1::before, .cs_btn.cs_style_1::after {
  content: "";
  position: absolute;
  height: 100%;
  width: 100%;
  border-radius: inherit;
  left: 0;
  top: 0;
  transition: all 0.4s ease-in-out;
}
.cs_btn.cs_style_1::before {
  background-image: linear-gradient(134deg, #307bc4 0%, #274760 100%);
}
.cs_btn.cs_style_1::after {
  background-image: linear-gradient(270deg, #307bc4 0%, #274760 100%);
  opacity: 0;
}
.cs_btn.cs_style_1:hover::before {
  opacity: 1;
}
.cs_btn.cs_style_1:hover::after {
  opacity: 1;
}
.cs_btn.cs_style_1:hover img:first-child {
  left: 0px;
}
.cs_btn.cs_style_1:hover img:last-child {
  left: 20px;
}

.cs_text_btn {
  display: inline-flex;
  position: relative;
  padding-bottom: 5px;
}
.cs_text_btn::before {
  content: "";
  position: absolute;
  height: 1px;
  width: 100%;
  background-color: currentColor;
  right: 0;
  bottom: 0;
  transition: all 0.4s ease;
}
.cs_text_btn:hover {
  color: #fff;
}
.cs_text_btn:hover::before {
  width: 60%;
}

.cs_text_btn_2 {
  display: inline-flex;
  align-items: center;
  gap: 14px;
}
.cs_text_btn_2 .cs_text_btn_text {
  display: inline-block;
  position: relative;
}
.cs_text_btn_2 .cs_text_btn_text::before {
  content: "";
  position: absolute;
  height: 2px;
  width: 100%;
  bottom: 0;
  left: 0;
  background-color: currentColor;
  transform: scaleX(0);
  transform-origin: 0 50%;
  transition-property: transform;
  transition-duration: 0.6s;
  transition-timing-function: ease-out;
}
.cs_text_btn_2 .cs_text_btn_icon {
  transition: all 0.4s ease-in-out;
}
.cs_text_btn_2:hover .cs_text_btn_text::before {
  transform: scaleX(1);
  transition-timing-function: cubic-bezier(0.52, 1.64, 0.37, 0.66);
}
.cs_text_btn_2:hover .cs_text_btn_icon {
  transform: scale(1.1);
}

.cs_input_label {
  margin-bottom: 12px;
}
@media (max-width: 1700px) {
  .cs_input_label {
    margin-bottom: 10px;
  }
}

.cs_form_field,
.react-datepicker-wrapper input {
  display: block;
  width: 100%;
  border-radius: 30px;
  outline: none;
  transition: all 0.3s ease;
  border: 1px solid rgba(1, 174, 66, 0.5);
  padding: 26px 30px;
  background-color: transparent;
}
.cs_form_field:focus,
.react-datepicker-wrapper input:focus {
  border-color: #01AE42;
}
@media (max-width: 1700px) {
  .cs_form_field,
  .react-datepicker-wrapper input {
    padding: 16px 20px;
    border-radius: 15px;
  }
}

.cs_form_field_2 {
  width: 100%;
  display: block;
  border: 1px solid #636363;
  outline: none;
  border-radius: 6px;
  padding: 13px 20px;
  transition: all 0.3s ease;
}
.cs_form_field_2:focus {
  border-color: #01AE42;
}

textarea.cs_form_field {
  resize: none;
}

textarea::placeholder,
input::placeholder,
.cs_form_field::placeholder,
.cs_form_field_2::placeholder {
  color: rgba(1, 113, 206, 0.52);
}

textarea:-ms-input-placeholder,
input:-ms-input-placeholder,
.cs_form_field:-ms-input-placeholder,
.cs_form_field_2:-ms-input-placeholder {
  color: rgba(1, 113, 206, 0.52);
}

textarea::-ms-input-placeholder,
input::-ms-input-placeholder,
.cs_form_field::-ms-input-placeholder,
.cs_form_field_2::-ms-input-placeholder {
  color: rgba(1, 113, 206, 0.52);
}

.cs_with_icon_input {
  position: relative;
}
.cs_with_icon_input i {
  position: absolute;
  top: 30px;
  right: 30px;
  color: #01AE42;
  font-size: 20px;
  pointer-events: none;
  display: flex;
}
@media (max-width: 1700px) {
  .cs_with_icon_input i {
    top: 20px;
    left: 20px;
  }
}

.cs_random_features {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  gap: 15px 110px;
  justify-content: center;
}
@media (max-width: 1700px) {
  .cs_random_features {
    gap: 15px 60px;
  }
}
@media (max-width: 1380px) {
  .cs_random_features {
    gap: 15px 24px;
  }
}
@media (max-width: 1121px) {
  .cs_random_features {
    gap: 24px;
    align-items: initial;
  }
}
.cs_random_features .cs_random_features_col {
  padding-top: 55px;
}
@media (max-width: 1700px) {
  .cs_random_features .cs_random_features_col {
    padding-top: 45px;
  }
}
@media (max-width: 1380px) {
  .cs_random_features .cs_random_features_col {
    padding-top: 25px;
  }
}
@media (max-width: 1121px) {
  .cs_random_features .cs_random_features_col {
    padding-top: 0px;
  }
}
@media (max-width: 767px) {
  .cs_random_features .cs_random_features_col {
    width: 100%;
  }
}
.cs_random_features .cs_random_features_col:nth-child(2) {
  padding-top: 0;
}
@media (min-width: 992px) {
  .cs_random_features .cs_iconbox.cs_style_13 {
    max-width: 390px;
  }
}

.cs_feature.cs_style_1 {
  max-width: 420px;
  width: 100%;
  height: 100%;
  flex: none;
  padding: 70px 50px;
}
@media (max-width: 1700px) {
  .cs_feature.cs_style_1 {
    max-width: 390px;
    padding: 50px 30px;
  }
}
@media (max-width: 1380px) {
  .cs_feature.cs_style_1 {
    max-width: 350px;
  }
}
@media (max-width: 767px) {
  .cs_feature.cs_style_1 {
    max-width: 100%;
  }
}
@media (max-width: 575px) {
  .cs_feature.cs_style_1 {
    padding: 30px 20px;
  }
}
.cs_feature.cs_style_1 .cs_feature_icon {
  height: 45px;
  width: 45px;
  flex: none;
  padding: 9px;
}
.cs_feature.cs_style_1 .cs_feature_icon img {
  filter: brightness(0) invert(1);
}
.cs_feature.cs_style_1 .cs_feature_title {
  gap: 15px 18px;
  margin-bottom: 35px;
  position: relative;
}
@media (max-width: 1700px) {
  .cs_feature.cs_style_1 .cs_feature_title {
    gap: 15px;
  }
}
.cs_feature.cs_style_1 .cs_feature_title > * {
  position: relative;
  z-index: 2;
}
.cs_feature.cs_style_1 .cs_feature_title::before {
  content: "";
  position: absolute;
  height: calc(100% + 42px);
  width: calc(100% + 160px);
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) scale(0.5);
  opacity: 0;
  border-radius: 30px;
  background-color: #86bbf1;
  transition: all 0.4s ease;
}
@media (max-width: 1700px) {
  .cs_feature.cs_style_1 .cs_feature_title::before {
    width: calc(100% + 100px);
  }
}
.cs_feature.cs_style_1:hover .cs_feature_title::before {
  opacity: 1;
  transform: translate(-50%, -50%) scale(1);
}

.cs_tab {
  display: none;
}
.cs_tab.active {
  display: block;
}

.cs_tabs.cs_style1 {
  display: flex;
  align-items: center;
}
@media (max-width: 991px) {
  .cs_tabs.cs_style1 {
    gap: 45px;
    flex-direction: column-reverse;
  }
}
.cs_tabs.cs_style1 .cs_tab_body {
  padding-left: 210px;
  position: relative;
  flex: none;
  width: 50%;
  padding-right: 7%;
}
@media (max-width: 1700px) {
  .cs_tabs.cs_style1 .cs_tab_body {
    padding-right: 0;
    padding-left: 160px;
  }
}
@media (max-width: 991px) {
  .cs_tabs.cs_style1 .cs_tab_body {
    width: 100%;
    padding-left: 75px;
  }
}
.cs_tabs.cs_style1 .cs_tab_links {
  list-style: none;
  margin: 0;
  padding: 0;
  border-right: 1px solid #01AE42;
  width: 50%;
  flex: none;
}
@media (max-width: 991px) {
  .cs_tabs.cs_style1 .cs_tab_links {
    width: 100%;
    display: flex;
    justify-content: center;
    border-top: 1px solid #01AE42;
    border-right: 0;
  }
  .cs_tabs.cs_style1 .cs_tab_links .cs_testimonial_1_avatar_right {
    display: none;
  }
}
.cs_tabs.cs_style1 .cs_tab_links li {
  position: relative;
}
@media (max-width: 991px) {
  .cs_tabs.cs_style1 .cs_tab_links li {
    padding-top: 30px;
  }
}
.cs_tabs.cs_style1 .cs_tab_links li::before {
  content: "";
  position: absolute;
  height: 10px;
  width: 10px;
  border-radius: 50%;
  right: -5px;
  top: 50%;
  margin-top: -5px;
  background-color: #01AE42;
  transition: all 0.4s ease;
}
@media (max-width: 991px) {
  .cs_tabs.cs_style1 .cs_tab_links li::before {
    right: initial;
    top: 0;
    left: 50%;
  }
}
.cs_tabs.cs_style1 .cs_tab_links li:not(:last-child) {
  margin-bottom: 35px;
}
@media (max-width: 991px) {
  .cs_tabs.cs_style1 .cs_tab_links li:not(:last-child) {
    margin-bottom: 0;
  }
}
.cs_tabs.cs_style1 .cs_tab_links li:nth-child(even) {
  padding-left: 110px;
}
@media (max-width: 991px) {
  .cs_tabs.cs_style1 .cs_tab_links li:nth-child(even) {
    padding-left: 0;
  }
}
.cs_tabs.cs_style1 .cs_tab_links li.active::before {
  transform: scale(1.8);
}
.cs_tabs.cs_style1 .cs_tab_links li.active .cs_tab_link_in {
  box-shadow: 6px 4px 70px 8px rgba(48, 123, 196, 0.09);
}
.cs_tabs.cs_style1 .cs_tab_links .cs_tab_link_in {
  position: relative;
  display: inline-flex;
  padding: 22px 50px;
  border-radius: 25px;
  transition: all 0.4s ease;
}
@media (max-width: 1700px) {
  .cs_tabs.cs_style1 .cs_tab_links .cs_tab_link_in {
    padding: 20px 35px;
    margin-right: 60px;
  }
}
@media (max-width: 991px) {
  .cs_tabs.cs_style1 .cs_tab_links .cs_tab_link_in {
    padding: 20px 35px;
    margin-right: 0px;
  }
}
@media (max-width: 575px) {
  .cs_tabs.cs_style1 .cs_tab_links .cs_tab_link_in {
    padding: 15px;
    border-radius: 15px;
  }
}
.cs_tabs.cs_style1 .cs_tab_links .cs_tab_link_in > a {
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 1;
  top: 0;
  left: 0;
}
.cs_tabs.cs_style1 .cs_tab_links .cs_testimonial_1_avatar {
  display: inline-flex;
  align-items: center;
  gap: 20px 40px;
}
@media (max-width: 1700px) {
  .cs_tabs.cs_style1 .cs_tab_links .cs_testimonial_1_avatar {
    gap: 20px;
  }
}
.cs_tabs.cs_style1 .cs_tab_links .cs_testimonial_1_avatar img {
  border-radius: 50%;
  height: 126px;
  width: 126px;
  object-fit: cover;
}
@media (max-width: 1700px) {
  .cs_tabs.cs_style1 .cs_tab_links .cs_testimonial_1_avatar img {
    height: 80px;
    width: 80px;
  }
}
@media (max-width: 575px) {
  .cs_tabs.cs_style1 .cs_tab_links .cs_testimonial_1_avatar img {
    height: 60px;
    width: 60px;
  }
}
.cs_tabs.cs_style1 .cs_tab_links .cs_testimonial_1_avatar p {
  line-height: 1.6em;
}

.cs_rating {
  width: 99px;
  position: relative;
  font-size: 16px;
}
.cs_rating .cs_rating_bg {
  display: flex;
  gap: 2px;
}
.cs_rating .cs_rating_percentage {
  display: flex;
  gap: 2px;
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  z-index: 1;
}

.cs_radio_wrap {
  position: relative;
}
.cs_radio_wrap .cs_radio_input {
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 1;
  opacity: 0;
  cursor: pointer;
}
.cs_radio_wrap .cs_radio_input:checked + .cs_radio_label::after {
  transform: scale(1);
}
.cs_radio_wrap .cs_radio_label {
  display: block;
  padding-left: 32px;
}
.cs_radio_wrap .cs_radio_label::before {
  content: "";
  height: 20px;
  width: 20px;
  border: 1px solid #01AE42;
  border-radius: 50%;
  position: absolute;
  top: 3px;
  left: 0;
}
.cs_radio_wrap .cs_radio_label::after {
  content: "";
  height: 14px;
  width: 14px;
  background-color: #01AE42;
  border-radius: 50%;
  position: absolute;
  top: 6px;
  left: 3px;
  transition: all 0.3s ease;
  transform: scale(0);
}

.cs_radio_group {
  display: flex;
  flex-wrap: wrap;
  gap: 20px 42px;
}
@media (max-width: 1700px) {
  .cs_radio_group {
    gap: 10px 30px;
  }
}

.cs_shape_wrap {
  position: relative;
}
.cs_shape_wrap .cs_shape_1 {
  width: 1884px;
  height: 1884px;
  border-radius: 50%;
  opacity: 0.6;
  background: radial-gradient(42.35% 42.35% at 50% 50%, rgba(134, 187, 241, 0.38) 0%, rgba(134, 187, 241, 0) 100%);
  position: absolute;
  top: 31%;
  right: -37%;
  z-index: -1;
}
.cs_shape_wrap .cs_shape_1.cs_position_1 {
  right: initial;
  left: -38%;
  top: -59%;
}
.cs_shape_wrap .cs_shape_1.cs_position_2 {
  right: 38%;
  top: 39%;
}
.cs_shape_wrap .cs_shape_1.cs_position_3 {
  right: 42%;
  top: 22%;
}
.cs_shape_wrap .cs_shape_1.cs_position_4 {
  right: -35%;
  top: initial;
  bottom: -10%;
}
.cs_shape_wrap .cs_shape_1.cs_position_5 {
  right: -30%;
  top: -8%;
}
.cs_shape_wrap .cs_shape_2 {
  position: absolute;
  left: 52%;
  top: 13%;
  z-index: -1;
}
.cs_shape_wrap .cs_shape_3 {
  position: absolute;
  right: 0;
  top: -41%;
  z-index: -1;
}

.cs_appointment_section_1 .container {
  position: relative;
}
.cs_appointment_section_1 .cs_appointment_img {
  position: absolute;
  bottom: 0;
  left: -9.5%;
  width: 55%;
}
@media (max-width: 1400px) {
  .cs_appointment_section_1 .cs_appointment_img {
    left: -16%;
    width: 63%;
  }
}
@media (max-width: 1199px) {
  .cs_appointment_section_1 .cs_appointment_img {
    left: -24%;
    width: 72%;
  }
}
@media (max-width: 991px) {
  .cs_appointment_section_1 .cs_appointment_img {
    display: none;
  }
}

.cs_iconbox_carousel_1 .cs_slider_activate {
  width: 65.5vw;
  padding-left: 55px;
  padding-right: 55px;
}
@media (max-width: 1700px) {
  .cs_iconbox_carousel_1 .cs_slider_activate {
    width: 64vw;
  }
}
@media (max-width: 1500px) {
  .cs_iconbox_carousel_1 .cs_slider_activate {
    width: 66vw;
  }
}
@media (max-width: 991px) {
  .cs_iconbox_carousel_1 .cs_slider_activate {
    width: 100%;
    padding-left: 30px;
    padding-right: 30px;
  }
}
@media (max-width: 480px) {
  .cs_iconbox_carousel_1 .cs_slider_activate {
    padding-left: 20px;
    padding-right: 20px;
    width: 100%;
  }
}
.cs_iconbox_carousel_1 .cs_slider_activate::before {
  content: "";
  position: absolute;
  height: 60%;
  top: 0;
  left: 0;
  width: 100%;
  border-radius: 20px 0px 0px 20px;
  background: linear-gradient(154deg, #d2eaef 0%, #86bbf1 100%);
}
@media (max-width: 991px) {
  .cs_iconbox_carousel_1 .cs_slider_activate::before {
    width: 100%;
    border-radius: 20px 20px 0px 0px;
  }
}
.cs_iconbox_carousel_1 .slick-list {
  position: relative;
  z-index: 2;
  padding-bottom: 40px;
  padding-top: 80px;
  margin-bottom: -40px;
}
@media (max-width: 991px) {
  .cs_iconbox_carousel_1 .slick-list {
    padding-top: 40px;
  }
}
@media (max-width: 480px) {
  .cs_iconbox_carousel_1 .slick-list {
    padding-top: 20px;
  }
}

.cs_pagination_box {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 25px;
}
@media (max-width: 991px) {
  .cs_pagination_box {
    gap: 15px;
  }
}
.cs_pagination_box .cs_pagination_item {
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 4px 20px 0px rgba(21, 32, 70, 0.07);
  height: 45px;
  width: 45px;
  color: #0171CE;
}
.cs_pagination_box .cs_pagination_item.active {
  background-color: #01AE42;
  color: #fff;
  pointer-events: none;
}
.cs_pagination_box a.cs_pagination_item:hover {
  background-color: #01AE42;
  color: #fff;
}
.cs_pagination_box .cs_pagination_arrow {
  transition: all 0.4s ease;
}
.cs_pagination_box .cs_pagination_arrow img {
  width: 16px;
}
.cs_pagination_box .cs_pagination_arrow:hover {
  transform: scale(1.2);
}

.cs_appointment_form.cs_style_1 {
  background-color: #fff;
  box-shadow: 6px 4px 70px 8px rgba(48, 123, 196, 0.09);
  padding: 60px 90px;
}
@media (max-width: 1700px) {
  .cs_appointment_form.cs_style_1 {
    padding: 60px 50px;
  }
}
@media (max-width: 575px) {
  .cs_appointment_form.cs_style_1 {
    padding: 50px 25px;
  }
}
.cs_appointment_form.cs_style_1 .cs_appointment_categories {
  display: flex;
  flex-wrap: wrap;
  gap: 15px 70px;
}
@media (max-width: 1700px) {
  .cs_appointment_form.cs_style_1 .cs_appointment_categories {
    gap: 15px 30px;
  }
}
.cs_appointment_form.cs_style_1 .cs_appointment_form_head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 80px;
  gap: 25px;
  flex-wrap: wrap;
}
@media (max-width: 1400px) {
  .cs_appointment_form.cs_style_1 .cs_appointment_form_head {
    margin-bottom: 40px;
  }
  .cs_appointment_form.cs_style_1 .cs_appointment_form_head > h2 {
    width: 100%;
  }
}
@media (max-width: 991px) {
  .cs_appointment_form.cs_style_1 .cs_appointment_form_head {
    margin-bottom: 30px;
    gap: 20px;
  }
  .cs_appointment_form.cs_style_1 .cs_appointment_form_head > * {
    width: 100%;
  }
}
.cs_appointment_form.cs_style_1 .cs_appointment_form_icon {
  flex: none;
  height: 70px;
  width: 70px;
  padding: 18px;
}
.cs_appointment_form.cs_style_1 label {
  display: block;
  color: #0171CE;
  font-weight: 500;
  margin-bottom: 5px;
  margin-top: -5px;
}
.cs_appointment_form.cs_style_1 input,
.cs_appointment_form.cs_style_1 textarea {
  border: 0;
  border-bottom: 1px solid #b7b7b7;
  display: block;
  width: 100%;
  padding: 0;
  outline: none;
  transition: all 0.3s ease;
}
.cs_appointment_form.cs_style_1 input:focus,
.cs_appointment_form.cs_style_1 textarea:focus {
  border-color: #01AE42;
}
.cs_appointment_form.cs_style_1 .cs_appointment_form_field {
  display: flex;
  align-items: center;
  gap: 25px;
  width: 300px;
  flex: none;
}
@media (max-width: 991px) {
  .cs_appointment_form.cs_style_1 .cs_appointment_form_field {
    gap: 15px;
    width: 280px;
  }
}
@media (max-width: 767px) {
  .cs_appointment_form.cs_style_1 .cs_appointment_form_field {
    width: 100%;
  }
}
.cs_appointment_form.cs_style_1 .cs_appointment_form_field_right {
  flex: 1 1;
}
.cs_appointment_form.cs_style_1 .cs_appointment_form_fields {
  display: flex;
  flex-wrap: wrap;
  gap: 60px 100px;
  justify-content: space-between;
}
@media (max-width: 1400px) {
  .cs_appointment_form.cs_style_1 .cs_appointment_form_fields {
    gap: 40px 30px;
  }
}
@media (max-width: 991px) {
  .cs_appointment_form.cs_style_1 .cs_appointment_form_fields {
    gap: 25px;
  }
}
@media (max-width: 767px) {
  .cs_appointment_form.cs_style_1 .cs_appointment_form_fields {
    flex-direction: column;
  }
}
.cs_appointment_form.cs_style_1 .cs_appointment_category {
  position: relative;
}
.cs_appointment_form.cs_style_1 .cs_appointment_category span {
  display: inline-block;
  position: relative;
  transition: all 0.3s ease;
}
.cs_appointment_form.cs_style_1 .cs_appointment_category span::before {
  content: "";
  position: absolute;
  height: 1px;
  width: 0%;
  bottom: -5px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #01AE42;
  transition: all 0.3s ease;
}
.cs_appointment_form.cs_style_1 .cs_appointment_category input {
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 2;
  opacity: 0;
  cursor: pointer;
}
.cs_appointment_form.cs_style_1 .cs_appointment_category input:checked + span {
  color: #0171CE;
}
.cs_appointment_form.cs_style_1 .cs_appointment_category input:checked + span::before {
  width: 100%;
}
.cs_appointment_form.cs_style_1.cs_type_1 {
  border-radius: 25px 25px 0px 0px;
  border: 1px solid #fff;
  border-bottom: 0;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(21.5px);
  max-width: 670px;
  width: 100%;
  padding: 45px 50px;
  position: relative;
  z-index: 2;
}
@media (max-width: 991px) {
  .cs_appointment_form.cs_style_1.cs_type_1 {
    padding: 30px 25px;
  }
}
.cs_appointment_form.cs_style_1.cs_type_1 .cs_down_btn {
  height: 60px;
  width: 60px;
  position: absolute;
  right: -30px;
  top: -30px;
  background-color: #fff;
  color: #01AE42;
}
.cs_appointment_form.cs_style_1.cs_type_1 .cs_down_btn:hover {
  transform: rotate(-20deg);
}
@media (max-width: 575px) {
  .cs_appointment_form.cs_style_1.cs_type_1 .cs_down_btn {
    right: 5px;
    top: 5px;
    transform: scale(0.6);
  }
  .cs_appointment_form.cs_style_1.cs_type_1 .cs_down_btn:hover {
    transform: scale(0.6) rotate(-20deg);
  }
}
.cs_appointment_form.cs_style_1.cs_type_1 label {
  color: #fff;
}
.cs_appointment_form.cs_style_1.cs_type_1 .cs_appointment_form_field {
  width: 100%;
  margin-bottom: 35px;
}
@media (max-width: 991px) {
  .cs_appointment_form.cs_style_1.cs_type_1 .cs_appointment_form_field {
    margin-bottom: 25px;
  }
}
.cs_appointment_form.cs_style_1.cs_type_1 .cs_appointment_form_field input,
.cs_appointment_form.cs_style_1.cs_type_1 .cs_appointment_form_field textarea {
  background-color: transparent;
  border-color: rgba(255, 255, 255, 0.5);
  color: #fff;
  padding-bottom: 4px;
}
.cs_appointment_form.cs_style_1.cs_type_1 .cs_appointment_form_field input::placeholder,
.cs_appointment_form.cs_style_1.cs_type_1 .cs_appointment_form_field textarea::placeholder {
  color: rgba(255, 255, 255, 0.6);
}
.cs_appointment_form.cs_style_1.cs_type_1 .cs_appointment_form_field input::-ms-input-placeholder,
.cs_appointment_form.cs_style_1.cs_type_1 .cs_appointment_form_field textarea::-ms-input-placeholder {
  color: rgba(255, 255, 255, 0.6);
}
.cs_appointment_form.cs_style_1.cs_type_1 .cs_appointment_form_field input:focus,
.cs_appointment_form.cs_style_1.cs_type_1 .cs_appointment_form_field textarea:focus {
  border-color: #fff;
}

.cs_page_heading {
  background: #fff;
  box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);
}

.cs_page_heading_in {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
  padding: 25px 0;
}

.breadcrumb {
  margin: 0;
  font-size: 20px;
}

.breadcrumb-item.active {
  color: #b7b7b7;
}

.breadcrumb-item + .breadcrumb-item::before {
  color: rgba(1, 113, 206, 0.52);
}

.cs_search_form {
  max-width: 360px;
  width: 100%;
  position: relative;
}
.cs_search_form input {
  width: 100%;
  border: 1px solid #01AE42;
  height: 50px;
  border-radius: 20px;
  padding: 5px 20px;
  outline: none;
}
.cs_search_form .cs_search_btn {
  position: absolute;
}
.cs_search_form .cs_search_btn {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 50px;
  border: none;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #274760;
}
.cs_search_form .cs_search_btn:hover {
  color: #01AE42;
}

.cs_related_doctor_title {
  position: absolute;
  z-index: 1;
  left: 50%;
  width: 50%;
  top: 80px;
  margin-bottom: 0;
}
@media (max-width: 1700px) {
  .cs_related_doctor_title {
    top: 50px;
    padding-left: 80px;
  }
}
@media (max-width: 1199px) {
  .cs_related_doctor_title {
    top: 30px;
    padding-left: 50px;
  }
}
@media (max-width: 991px) {
  .cs_related_doctor_title {
    position: initial;
    padding-left: 0px;
    padding-bottom: 50px;
  }
}

.cs_doctor_profile.cs_style_1 {
  display: flex;
  align-items: flex-end;
}
@media (max-width: 991px) {
  .cs_doctor_profile.cs_style_1 {
    flex-direction: column;
  }
}
.cs_doctor_profile.cs_style_1 .cs_doctor_info {
  margin-left: -180px;
  box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);
}
@media (max-width: 991px) {
  .cs_doctor_profile.cs_style_1 .cs_doctor_info {
    margin-left: 0px;
  }
}
.cs_doctor_profile.cs_style_1 .cs_doctor_profile_right {
  flex: 1 1;
  padding: 180px 85px 100px 0px;
}
@media (max-width: 1700px) {
  .cs_doctor_profile.cs_style_1 .cs_doctor_profile_right {
    padding: 150px 85px 70px 0px;
  }
}
@media (max-width: 1400px) {
  .cs_doctor_profile.cs_style_1 .cs_doctor_profile_right {
    padding: 150px 0px 70px 0px;
  }
}
@media (max-width: 1199px) {
  .cs_doctor_profile.cs_style_1 .cs_doctor_profile_right {
    padding: 150px 0px 0px 0px;
  }
}
@media (max-width: 991px) {
  .cs_doctor_profile.cs_style_1 .cs_doctor_profile_right {
    padding: 25px 0px 0px 0px;
    width: 100%;
  }
}
.cs_doctor_profile.cs_style_1 .cs_social_links a {
  height: 30px;
  width: 30px;
  background-color: #01AE42;
  color: #fff;
  font-size: 14px;
}
.cs_doctor_profile.cs_style_1 .cs_doctor_info_in {
  padding: 50px 95px 46px;
}
@media (max-width: 1700px) {
  .cs_doctor_profile.cs_style_1 .cs_doctor_info_in {
    padding: 40px 50px 40px;
  }
}
@media (max-width: 767px) {
  .cs_doctor_profile.cs_style_1 .cs_doctor_info_in {
    padding: 30px;
  }
}
@media (max-width: 480px) {
  .cs_doctor_profile.cs_style_1 .cs_doctor_info_in br {
    display: none;
  }
}
.cs_doctor_profile.cs_style_1 .cs_doctor_meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 37px 95px;
}
@media (max-width: 1700px) {
  .cs_doctor_profile.cs_style_1 .cs_doctor_meta {
    padding: 30px 50px;
  }
}
@media (max-width: 1400px) {
  .cs_doctor_profile.cs_style_1 .cs_doctor_meta {
    padding: 20px 50px;
  }
}
@media (max-width: 767px) {
  .cs_doctor_profile.cs_style_1 .cs_doctor_meta {
    padding: 20px 30px;
  }
}
@media (max-width: 480px) {
  .cs_doctor_profile.cs_style_1 .cs_doctor_meta {
    flex-direction: column;
    gap: 6px 0;
    padding: 20px 15px;
  }
}
.cs_doctor_profile.cs_style_1 .cs_doctor_meta_left {
  display: flex;
  align-items: center;
  gap: 20px 70px;
}
@media (max-width: 1700px) {
  .cs_doctor_profile.cs_style_1 .cs_doctor_meta_left {
    gap: 15px 40px;
  }
}
@media (max-width: 575px) {
  .cs_doctor_profile.cs_style_1 .cs_doctor_meta_left {
    gap: 15px 20px;
  }
}
.cs_doctor_profile.cs_style_1 .cs_doctor_meta_left a {
  display: flex;
  align-items: center;
  gap: 15px;
}
@media (max-width: 991px) {
  .cs_doctor_profile.cs_style_1 .cs_doctor_meta_left a {
    gap: 10px;
  }
}
.cs_doctor_profile.cs_style_1 .cs_doctor_meta_left a:hover {
  color: rgba(255, 255, 255, 0.5);
}
.cs_doctor_profile.cs_style_1 .cs_doctor_meta_right a {
  display: flex;
  gap: 11px;
  align-items: center;
}
.cs_doctor_profile.cs_style_1 .cs_doctor_meta_right a span {
  position: relative;
}
.cs_doctor_profile.cs_style_1 .cs_doctor_meta_right a span::before {
  content: "";
  position: absolute;
  height: 1px;
  width: 100%;
  background-color: #fff;
  bottom: 3px;
  right: 0;
  transition: all 0.3s ease;
}
.cs_doctor_profile.cs_style_1 .cs_doctor_meta_right a:hover {
  color: #ffffff;
}
.cs_doctor_profile.cs_style_1 .cs_doctor_meta_right a:hover span::before {
  width: 60%;
}
.cs_doctor_profile.cs_style_1 .cs_doctor_img {
  max-width: 45%;
}
@media (max-width: 1700px) {
  .cs_doctor_profile.cs_style_1 .cs_doctor_img {
    max-width: 50%;
  }
}
@media (max-width: 991px) {
  .cs_doctor_profile.cs_style_1 .cs_doctor_img {
    max-width: 100%;
  }
}

.cs_single_doctor {
  box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);
}
.cs_single_doctor h3 {
  padding: 23px 15px;
  margin-top: -35px;
  position: relative;
  z-index: 1;
}

.cs_list.cs_style_1 .cs_list_title,
.cs_list.cs_style_2 .cs_list_title,
.cs_list.cs_style_3 .cs_list_title {
  padding-left: 50px;
  position: relative;
  margin-bottom: 25px;
}
.cs_list.cs_style_1 .cs_list_title svg,
.cs_list.cs_style_1 .cs_list_title img,
.cs_list.cs_style_2 .cs_list_title svg,
.cs_list.cs_style_2 .cs_list_title img,
.cs_list.cs_style_3 .cs_list_title svg,
.cs_list.cs_style_3 .cs_list_title img {
  position: absolute;
  left: 0;
  top: 4px;
}

.cs_list.cs_style_1 p + p {
  margin-top: 4px;
}
.cs_list.cs_style_1 ul {
  list-style: none;
  padding-left: 50px;
  margin: 0;
}
.cs_list.cs_style_1 ul li {
  position: relative;
  padding-left: 28px;
}
.cs_list.cs_style_1 ul li::before {
  content: "";
  height: 10px;
  width: 10px;
  border-radius: 50%;
  background-color: #01AE42;
  position: absolute;
  left: 0;
  top: 8px;
}
.cs_list.cs_style_1 ul li:not(:last-child) {
  margin-bottom: 24px;
}

.cs_list.cs_style_2 ul li {
  position: relative;
  padding-left: 22px;
}
.cs_list.cs_style_2 ul li svg,
.cs_list.cs_style_2 ul li img {
  position: absolute;
  left: 0;
  top: 8px;
}
.cs_list.cs_style_2 ul li:not(:last-child) {
  margin-bottom: 20px;
}

.cs_list.cs_style_3 ul {
  box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);
  padding: 35px 45px;
  max-width: 454px;
}
.cs_list.cs_style_3 ul li {
  display: flex;
  justify-content: space-between;
}
.cs_list.cs_style_3 ul li:not(:last-child) {
  margin-bottom: 24px;
}
.cs_list.cs_style_3 ul li span {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 120px;
}
.cs_list.cs_style_3 ul li span i {
  color: #01AE42;
}

.cs_doctor_details {
  position: relative;
}
.cs_doctor_details .cs_doctor_details_bg {
  position: absolute;
  left: 0;
  top: 0;
  height: 490px;
  width: 100%;
  z-index: -1;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
@media (max-width: 1700px) {
  .cs_doctor_details .cs_doctor_details_bg {
    height: 420px;
  }
}
@media (max-width: 1199px) {
  .cs_doctor_details .cs_doctor_details_bg {
    height: 467px;
  }
}
@media (max-width: 575px) {
  .cs_doctor_details .cs_doctor_details_bg {
    height: 280px;
  }
}
.cs_doctor_details .cs_social_links {
  padding: 23px 40px;
  display: inline-flex;
  position: absolute;
  top: 368px;
  right: 12px;
  z-index: 2;
}
@media (max-width: 1700px) {
  .cs_doctor_details .cs_social_links {
    top: 298px;
  }
}
@media (max-width: 1199px) {
  .cs_doctor_details .cs_social_links {
    top: 342px;
  }
}
@media (max-width: 991px) {
  .cs_doctor_details .cs_social_links {
    position: initial;
    margin-top: 35px;
    padding: 15px 30px;
  }
}
.cs_doctor_details .cs_social_links a {
  height: 30px;
  width: 30px;
  background-color: #fff;
  color: #01AE42;
  font-size: 16px;
}

.cs_contact_info.cs_style_1 li:not(:last-child) {
  margin-bottom: 42px;
}
@media (max-width: 1700px) {
  .cs_contact_info.cs_style_1 li:not(:last-child) {
    margin-bottom: 25px;
  }
}
@media (max-width: 991px) {
  .cs_contact_info.cs_style_1 li:not(:last-child) {
    margin-bottom: 25px;
  }
}

.cs_timetable {
  height: 1950px;
  padding-left: 110px;
  position: relative;
  padding-right: 10px;
  margin-top: 15px;
}
.cs_timetable::before, .cs_timetable::after {
  content: "";
  height: calc(100% - 40px);
  width: 10px;
  background-color: #fff;
  position: absolute;
  top: 20px;
  z-index: 2;
}
.cs_timetable::before {
  left: 100px;
}
.cs_timetable::after {
  left: 100%;
  width: 15vw;
  top: 0;
  height: 100%;
}
@media (max-width: 1199px) {
  .cs_timetable {
    width: 1230px;
  }
}

.cs_timetable_vertical {
  position: absolute;
  left: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.cs_timetable_vertical > div {
  position: relative;
}
.cs_timetable_vertical > div::before {
  content: "";
  position: absolute;
  height: 1px;
  width: 100vw;
  left: 100px;
  top: 12px;
  background-color: rgba(1, 174, 66, 0.5);
}
.cs_timetable_vertical > div:first-child::before, .cs_timetable_vertical > div:last-child::before {
  background-color: #01AE42;
}

.cs_timetable_in {
  width: 100%;
  height: 100%;
  display: flex;
  border: 1px solid #01AE42;
  border-top: none;
  border-bottom: none;
}
.cs_timetable_in::before, .cs_timetable_in::after {
  content: "";
  position: absolute;
  height: 12px;
  width: calc(100% - 130px);
  right: 14px;
  background-color: #fff;
  z-index: 1;
}
.cs_timetable_in::before {
  top: 0;
}
.cs_timetable_in::after {
  bottom: 0;
  height: 13px;
}
.cs_timetable_in > div {
  flex: 1 1;
  border-right: 1px solid rgba(1, 174, 66, 0.5);
  position: relative;
  padding: 12px 0;
}
.cs_timetable_in > div:last-child {
  border-right: 0;
}
.cs_timetable_in > div > div {
  padding: 8px;
}
.cs_timetable_in > div .cs_timetable_date {
  position: absolute;
  top: -20px;
  z-index: 1;
  padding: 0 !important;
  width: 100%;
  text-align: center;
}

.cs_hour_1 {
  height: 148px !important;
}

.cs_hour_2 {
  height: 296px !important;
}

.cs_hour_3 {
  height: 444px !important;
}

.cs_hour_4 {
  height: 592px !important;
}

.cs_hour_5 {
  height: 740px !important;
}

.cs_hour_6 {
  height: 888px !important;
}

.cs_hour_7 {
  height: 1036px !important;
}

.cs_hour_8 {
  height: 1184px !important;
}

.cs_hour_9 {
  height: 1332px !important;
}

.cs_hour_10 {
  height: 1480px !important;
}

.cs_hour_11 {
  height: 1628px !important;
}

.cs_hour_12 {
  height: 1776px !important;
}

.cs_hour_13 {
  height: 1924px !important;
}

.cs_table_doctor {
  border-radius: 10px;
  border: 1.5px solid #01AE42;
  background-color: #d2eaef;
  height: 100%;
  padding: 28px 20px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.cs_table_doctor p {
  margin-bottom: 0;
}
.cs_table_doctor p:not(:last-child) {
  border-bottom: 1px solid #01AE42;
  padding-bottom: 10px;
  margin-bottom: 10px;
}
@media (max-width: 1700px) {
  .cs_table_doctor {
    padding: 15px 12px;
  }
}

.cs_contact_form.cs_style_1 {
  padding: 83px 21.5%;
  box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);
}
@media (max-width: 991px) {
  .cs_contact_form.cs_style_1 {
    padding: 50px;
  }
}
@media (max-width: 400px) {
  .cs_contact_form.cs_style_1 {
    padding: 50px 25px;
  }
}

.cs_map {
  height: 650px;
}
@media (max-width: 1700px) {
  .cs_map {
    height: 550px;
  }
}
@media (max-width: 1400px) {
  .cs_map {
    height: 450px;
  }
}
@media (max-width: 575px) {
  .cs_map {
    height: 350px;
  }
}
.cs_map iframe {
  height: 100%;
  width: 100%;
  border: none;
  filter: grayscale(100%);
  border-radius: 30px;
}

.cs_blog_details_info {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 20px 30px;
}
.cs_blog_details_info .cs_social_links a {
  height: 42px;
  width: 42px;
  border: 1px solid #01AE42;
  color: #01AE42;
  font-size: 18px;
}
.cs_blog_details_info .cs_social_links a:hover {
  background-color: #01AE42;
  color: #fff;
  transform: initial;
}

.cs_blog_details_info_left {
  display: flex;
  align-items: center;
  gap: 20px 40px;
}
@media (max-width: 1199px) {
  .cs_blog_details_info_left {
    flex-direction: column-reverse;
    align-items: flex-start;
  }
}

.cs_blog_details_tags {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
@media (max-width: 991px) {
  .cs_blog_details_tags {
    gap: 12px;
  }
}
.cs_blog_details_tags a {
  padding: 11px 24px;
  border: 1px solid #01AE42;
  border-radius: 20px;
  color: #0171CE;
}
@media (max-width: 991px) {
  .cs_blog_details_tags a {
    padding: 7px 15px;
    border-radius: 15px;
  }
}
.cs_blog_details_tags a:hover {
  background-color: #01AE42;
  color: #fff;
}

.cs_blog_details {
  font-size: 18px;
  line-height: 1.55em;
  color: #0171CE;
}
.cs_blog_details h2 {
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 20px;
  line-height: 1.31em;
}
@media (max-width: 991px) {
  .cs_blog_details h2 {
    font-size: 28px;
  }
}
.cs_blog_details p {
  margin-bottom: 34px;
}
.cs_blog_details ol {
  margin-bottom: 60px;
}
.cs_blog_details ol li:not(:last-child) {
  margin-bottom: 20px;
}
.cs_blog_details blockquote {
  min-height: 645px;
  border-radius: 20px;
  background-size: cover;
  background-position: center;
  margin: 75px 0;
  padding: 100px 146px 0 0;
  display: flex;
  align-items: flex-end;
  font-size: 32px;
  line-height: 1.31em;
  color: #fff;
  font-weight: 600;
  font-style: normal;
}
@media (max-width: 1400px) {
  .cs_blog_details blockquote {
    padding: 100px 100px 0 0;
  }
}
@media (max-width: 991px) {
  .cs_blog_details blockquote {
    font-size: 24px;
  }
}
@media (max-width: 575px) {
  .cs_blog_details blockquote {
    padding: 50px 30px 0 0;
    min-height: 450px;
  }
}
@media (max-width: 400px) {
  .cs_blog_details blockquote {
    padding-right: 0;
  }
}
.cs_blog_details blockquote p {
  margin: 0;
  width: 100%;
  background-color: #01AE42;
  padding: 40px 70px 40px 120px;
  position: relative;
  border-radius: 0 20px 0 0;
}
@media (max-width: 1400px) {
  .cs_blog_details blockquote p {
    padding: 40px 40px 40px 120px;
  }
}
@media (max-width: 575px) {
  .cs_blog_details blockquote p {
    padding: 40px 30px 40px 80px;
  }
}
.cs_blog_details blockquote p::before {
  content: "“";
  position: absolute;
  left: 48px;
  top: 55px;
  font-size: 80px;
  color: rgba(255, 255, 255, 0.3);
}
@media (max-width: 575px) {
  .cs_blog_details blockquote p::before {
    left: 25px;
  }
}
@media (max-width: 400px) {
  .cs_blog_details blockquote p::before {
    display: none;
  }
}
.cs_blog_details h3 {
  font-size: 24px;
  font-weight: 600;
  line-height: 1.41em;
  margin-bottom: 15px;
}
.cs_blog_details ul {
  list-style: none;
  padding: 0;
  margin: 55px 0 86px 0;
}
.cs_blog_details ul li:not(:last-child) {
  margin-bottom: 55px;
}
.cs_blog_details > *:last-child {
  margin-bottom: 0;
}

.cs_author {
  display: flex;
  gap: 44px;
  padding: 58px 0;
  border-top: 1px solid #aaa;
  border-bottom: 1px solid #aaa;
}
@media (max-width: 1700px) {
  .cs_author {
    gap: 30px;
  }
}
@media (max-width: 575px) {
  .cs_author {
    flex-direction: column;
    gap: 20px;
  }
}
.cs_author .cs_author_img {
  flex: none;
  height: 100px;
  width: 100px;
  border-radius: 50%;
  overflow: hidden;
}
.cs_author .cs_author_img img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: inherit;
}
.cs_author h3 {
  font-size: 18px;
  font-weight: 600;
  line-height: 1.6em;
  margin-bottom: 15px;
}
@media (max-width: 575px) {
  .cs_author h3 {
    margin-bottom: 5px;
  }
}

.form-check {
  padding-left: 38px;
  margin-bottom: 0;
  color: #0171CE;
  font-size: 18px;
  line-height: 1.5em;
}
.form-check .form-check-input {
  margin-left: -38px;
  width: 24px;
  height: 24px;
  margin-top: 2px;
}
.form-check .form-check-input:checked {
  background-color: #01AE42;
  border-color: #01AE42;
}

.cs_newsletter.cs_style_1 .cs_newsletter_title {
  font-size: 42px;
  font-weight: 700;
  margin-bottom: 11px;
}
@media (max-width: 1700px) {
  .cs_newsletter.cs_style_1 .cs_newsletter_title {
    font-size: 34px;
  }
}
@media (max-width: 991px) {
  .cs_newsletter.cs_style_1 .cs_newsletter_title {
    font-size: 30px;
  }
}
.cs_newsletter.cs_style_1 .cs_newsletter_form {
  position: relative;
  margin-top: 25px;
}
.cs_newsletter.cs_style_1 .cs_btn.cs_style_1 {
  position: absolute;
  right: 15px;
  top: 15px;
}
@media (max-width: 1700px) {
  .cs_newsletter.cs_style_1 .cs_btn.cs_style_1 {
    top: 10px;
    right: 10px;
  }
}

.cs_newsletter.cs_style_5 {
  text-align: center;
}
.cs_newsletter.cs_style_5 .cs_newsletter_title {
  font-size: 28px;
  font-weight: 600;
  line-height: 1.5em;
  margin-bottom: 30px;
}
@media (max-width: 1700px) {
  .cs_newsletter.cs_style_5 .cs_newsletter_title {
    font-size: 24px;
  }
}
.cs_newsletter.cs_style_5 .cs_form_field {
  border-color: #636363;
  font-size: 20px;
  line-height: 1.5em;
  padding: 19px 25px;
  border-radius: 7px;
  margin-bottom: 28px;
}
@media (max-width: 1700px) {
  .cs_newsletter.cs_style_5 .cs_form_field {
    font-size: 18px;
    padding: 13px 20px;
    margin-bottom: 20px;
  }
}

/* Start Comment */
.comments-area {
  background-color: #f3f5f6;
  border-radius: 10px;
  padding: 40px 50px;
}
@media (max-width: 1199px) {
  .comments-area {
    padding: 35px 25px;
  }
}

.comment-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.comment-list > .comment {
  padding: 0px 15px;
  margin-bottom: 45px;
}
@media (max-width: 575px) {
  .comment-list > .comment {
    padding: 0;
  }
}
.comment-list > .comment:last-child {
  margin-bottom: 0;
}
.comment-list .children {
  margin-top: 45px;
}
.comment-list .children .comment:not(:first-child) {
  border-width: 1px 0 0;
  border-style: solid;
  margin-top: 30px;
  padding-top: 30px;
}
.comment-list .bypostauthor:not(:last-child) {
  border-bottom: 1px solid #eaeaea;
  margin-bottom: 50px;
}
.comment-list .comment-body {
  padding-left: 90px;
  padding-top: 0;
  position: relative;
  padding-right: 150px;
}
@media (max-width: 1199px) {
  .comment-list .comment-body {
    padding-right: 120px;
  }
}
@media (max-width: 575px) {
  .comment-list .comment-body {
    padding-right: 0;
    padding-bottom: 40px;
    padding-left: 70px;
  }
}
.comment-list ol {
  list-style: none;
  padding: 0;
  margin: 0;
}
.comment-list .avatar {
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 50%;
  height: 60px;
  width: 60px;
}
.comment-list .comment-author .says {
  display: none;
}
.comment-list .fn {
  font-style: initial;
  font-weight: 500;
  color: #0171CE;
  display: inline-block;
  font-size: 18px;
  margin-bottom: 0px;
  line-height: 1.2em;
}
.comment-list .comment-meta {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 5px;
  color: #b7b7b7;
}
.comment-list .comment-meta a {
  display: inline-flex;
  position: relative;
  align-items: center;
  gap: 10px;
}
.comment-list .comment-meta a:hover {
  color: #0171CE;
}
.comment-list .comment-meta + p,
.comment-list .comment-meta + p + p {
  font-size: 18px;
  line-height: 1.55em;
  margin-bottom: 0;
  margin-left: -90px;
}
@media (max-width: 1700px) {
  .comment-list .comment-meta + p,
  .comment-list .comment-meta + p + p {
    font-size: 16px;
  }
}
@media (max-width: 575px) {
  .comment-list .comment-meta + p,
  .comment-list .comment-meta + p + p {
    margin-left: -70px;
  }
}
.comment-list .reply {
  line-height: 1.6em;
  font-size: 18px;
  font-weight: 600;
  position: absolute;
  bottom: 2px;
  right: 0;
  color: #636363;
  padding-left: 40px;
}
@media (max-width: 1700px) {
  .comment-list .reply {
    font-size: 16px;
  }
}
.comment-list .reply a {
  display: inline-block;
  position: relative;
}
.comment-list .reply a::before {
  content: "";
  position: absolute;
  height: 1px;
  width: 100%;
  background-color: currentColor;
  right: 0;
  bottom: 2px;
  transition: all 0.4s ease;
}
.comment-list .reply a:hover::before {
  width: 60%;
}
.comment-list .reply::before {
  content: "";
  position: absolute;
  width: 27px;
  height: 22px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  left: 0;
  background-size: contain;
  background-position: center;
  top: 2px;
}
.comment-list .bypostauthor .comment-body:last-child {
  margin-bottom: 0;
}

.url {
  font-weight: 600;
  font-size: 20px;
  color: #0171CE;
  display: inline-block;
  line-height: 1.5em;
}
@media (max-width: 1700px) {
  .url {
    font-size: 18px;
  }
}

#commentform p.logged-in-as {
  font-size: 16px;
  margin-top: -5px;
}

#commentform p.logged-in-as a:hover {
  text-decoration: underline;
}

.comment-reply-title small {
  margin-left: 15px;
  font-size: 16px;
  font-weight: 500;
  color: red;
}

.comment-reply-title small a:hover {
  text-decoration: underline;
}

/* End Comment */
/* Start Time Picker */
.ui-timepicker-standard {
  border: 1px solid #01AE42;
  border-radius: 20px;
  padding: 10px;
  margin-top: 5px;
  color: #0171CE;
  font-family: inherit;
}
.ui-timepicker-standard .ui-state-hover {
  color: #0171CE;
  border-color: rgba(1, 174, 66, 0.3);
  background-color: rgba(1, 174, 66, 0.15);
  border-radius: 10px;
  color: #01AE42;
}
.ui-timepicker-standard a {
  cursor: pointer;
  font-size: 16px;
  line-height: 1.2em;
  padding: 9px 15px;
}
.ui-timepicker-standard .ui-timepicker-viewport {
  padding-right: 0 !important;
}
.ui-timepicker-standard .ui-widget.ui-widget-content {
  border: none;
}

.ui-widget-content a {
  color: #0171CE;
}

/* End Time Picker */
/* Start Date Picker */
.ui-datepicker.ui-widget.ui-widget-content {
  border-color: #01AE42;
  border-radius: 20px;
  margin: 5px 0;
  color: #0171CE;
}

.ui-state-default,
.ui-widget-content .ui-state-default,
.ui-widget-header .ui-state-default,
.ui-button,
html .ui-button.ui-state-disabled:hover,
html .ui-button.ui-state-disabled:active {
  border: none;
  color: #0171CE;
  background: transparent;
  text-align: center;
}

.ui-widget {
  font-family: inherit;
}

.ui-datepicker table {
  font-size: 16px;
  margin: 0 0 4px;
}

.ui-widget-header {
  background: transparent;
  border: none;
}

.ui-datepicker {
  width: 388px;
  padding: 5px;
}

.ui-state-highlight,
.ui-widget-content .ui-state-highlight,
.ui-widget-header .ui-state-highlight {
  color: #01AE42;
  font-weight: 500;
}

.ui-state-hover,
.ui-widget-content .ui-state-hover,
.ui-widget-header .ui-state-hover,
.ui-state-focus,
.ui-widget-content .ui-state-focus,
.ui-widget-header .ui-state-focus,
.ui-button:hover,
.ui-button:focus {
  color: #01AE42;
}

.ui-state-active,
.ui-widget-content .ui-state-active,
.ui-widget-header .ui-state-active,
a.ui-button:active,
.ui-button:active,
.ui-button.ui-state-active:hover {
  background-color: rgba(1, 174, 66, 0.15);
  color: #01AE42;
  border: 1px solid rgba(1, 174, 66, 0.3);
  border-radius: 7px;
  font-weight: 500;
}

.ui-widget-header {
  color: #0171CE;
  font-weight: 600;
  font-weight: 16px;
}

.ui-datepicker th {
  color: #0171CE;
  font-weight: 500;
  font-size: 16px;
}

/* End Date Picker */
/* Start Select Two */
.select2-container {
  width: 100% !important;
}
.select2-container .select2-selection--single {
  height: 78px;
}
@media (max-width: 1700px) {
  .select2-container .select2-selection--single {
    height: 60px;
  }
}

.select2-container--default .select2-selection--single {
  border-color: rgba(1, 174, 66, 0.5);
  border-radius: 30px;
  background-color: transparent;
}
@media (max-width: 1700px) {
  .select2-container--default .select2-selection--single {
    border-radius: 15px;
  }
}

.select2-container .select2-selection--single .select2-selection__rendered {
  display: block;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 15px 30px;
  color: #0171CE;
  line-height: 1.5em;
}
@media (max-width: 1700px) {
  .select2-container .select2-selection--single .select2-selection__rendered {
    padding: 15px 20px;
  }
}

.select2-container--default .select2-selection--single .select2-selection__placeholder {
  color: rgba(1, 113, 206, 0.52);
}

.select2-container--default .select2-selection--single .select2-selection__arrow {
  top: 26px;
  right: 15px;
  width: 20px;
  transform: scale(1.3);
}
@media (max-width: 1700px) {
  .select2-container--default .select2-selection--single .select2-selection__arrow {
    top: 17px;
  }
}

.select2-dropdown {
  border-color: rgba(1, 174, 66, 0.5);
  border-radius: 30px;
}
@media (max-width: 1700px) {
  .select2-dropdown {
    border-radius: 15px;
  }
}

.select2-search--dropdown {
  padding: 20px 20px 10px 20px;
}

.select2-results__option {
  padding: 7px 20px;
}

.select2-container--default .select2-search--dropdown .select2-search__field {
  border-color: rgba(1, 174, 66, 0.5);
  border-radius: 10px;
}

.select2-search--dropdown .select2-search__field {
  padding: 9px 15px;
  outline: none;
}

.select2-results__option {
  padding: 10px 20px;
  margin: 0 20px;
  border-radius: 10px;
}

.select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: rgba(1, 174, 66, 0.15);
  color: #01AE42;
}

.select2-container--default .select2-results__option[aria-selected=true] {
  background-color: #01AE42;
  color: white;
}

.select2-container--default .select2-results > .select2-results__options {
  padding-bottom: 10px;
  color: #0171CE;
}

/* End Select Two */
/* Start Scroll Up */
.cs_scrollup {
  position: fixed;
  bottom: -60px;
  right: 40px;
  color: #01AE42;
  padding: 5px;
  height: 50px;
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.4s ease;
  z-index: 10;
  background-color: #ffffff;
  box-shadow: 0px 4px 20px 0px rgba(39, 71, 96, 0.17);
  border-radius: 50%;
  font-size: 22px;
}
.cs_scrollup:hover {
  background-color: #0171CE;
  color: #ffffff;
}
@media (max-width: 575px) {
  .cs_scrollup {
    right: 20px;
  }
}

.cs_scrollup.cs_scrollup_show {
  bottom: 50px;
}
@media (max-width: 575px) {
  .cs_scrollup.cs_scrollup_show {
    bottom: 30px;
  }
}

/* End Scroll Up */
/* Start New Animations */
@keyframes particalAnimation {
  0%, 100% {
    transform: translate(0px, 0px);
  }
  20% {
    transform: translate(80px, -10px);
  }
  40% {
    transform: translate(140px, 70px);
  }
  60% {
    transform: translate(90px, 130px);
  }
  80% {
    transform: translate(-40px, 80px);
  }
  100% {
    transform: translate(0px, 0px);
  }
}
@keyframes animo-x {
  50% {
    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transform: translateX(44px);
  }
}
@keyframes anim-y {
  50% {
    animation-timing-function: cubic-bezier(0.55, 0, 0.2, 1);
    transform: translateY(-25px);
  }
}
@keyframes rotate-anim {
  100% {
    transform: rotate(360deg);
  }
}
@keyframes semi-rotate-anim {
  50% {
    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transform: translateY(25px) rotate(-53deg);
  }
}
@keyframes up-down-anim {
  40% {
    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transform: translateY(40px) rotate(-1deg);
  }
}
@keyframes swing-anim {
  65% {
    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transform: translateY(-48px) rotate(-75deg);
  }
}
@keyframes zoom-anim {
  50% {
    transform: scale(0.7);
  }
}
/* End New Animations */
.cursor {
  position: fixed;
  left: 0;
  pointer-events: none;
  font-weight: 500;
  font-size: 24px;
  line-height: 23px;
  color: #01AE42;
  background-color: #fff;
  text-transform: capitalize;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 100%;
  transform: translate(-50%, -50%);
  z-index: 999;
  opacity: 0;
  transition: 0.15s;
  box-shadow: 0px 4px 20px 0px rgba(39, 71, 96, 0.17);
}

.cs_cursor_lg,
.cs_cursor_sm {
  position: fixed;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}
@media (max-width: 991px) {
  .cs_cursor_lg,
  .cs_cursor_sm {
    display: none !important;
  }
}

.cs_cursor_lg {
  width: 40px;
  height: 40px;
  background-color: rgba(1, 174, 66, 0.15);
  left: 0;
  top: 0;
  pointer-events: none;
  transition: 0.15s;
}

.cs_cursor_sm {
  width: 8px;
  height: 8px;
  background-color: #01AE42;
  left: 0;
  top: 0;
  pointer-events: none;
  transition: 0.2s;
}

@media (max-width: 991px) {
  .cs_section_heading.cs_style_1 .cs_section_title br {
    display: none;
  }
}

.cs_section_wrap_1 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  gap: 50px;
}
@media (max-width: 991px) {
  .cs_section_wrap_1 .cs_avatar_card {
    margin-bottom: -60px;
  }
}

.cs_avatar_card .cs_avatar_card_title {
  margin-bottom: 24px;
}

.cs_avatar_group {
  display: flex;
  padding-left: 30px;
}
.cs_avatar_group .cs_avatar_item {
  flex: none;
  height: 106px;
  width: 106px;
  border-radius: 50%;
  padding: 5px;
  margin-left: -30px;
  background-color: #fff;
}
@media (max-width: 1400px) {
  .cs_avatar_group .cs_avatar_item {
    height: 80px;
    width: 80px;
    padding: 4px;
  }
}
@media (max-width: 991px) {
  .cs_avatar_group .cs_avatar_item {
    height: 60px;
    width: 60px;
    padding: 1px;
  }
  .cs_avatar_group .cs_avatar_item svg {
    width: 24px;
    height: 24px;
  }
}
.cs_avatar_group .cs_avatar_item img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
@media (max-width: 420px) {
  .cs_avatar_group .cs_avatar_item {
    display: none;
  }
  .cs_avatar_group .cs_avatar_item:nth-child(2), .cs_avatar_group .cs_avatar_item:first-child, .cs_avatar_group .cs_avatar_item:last-child {
    display: flex;
  }
}

/*--------------------------------------------------------------
5. Slider
----------------------------------------------------------------*/
.slick-initialized .slick-slide > div {
  display: flex;
}
.slick-initialized .slick-slide > div > * {
  width: 100%;
}

.cs_gap_20 .slick-slide {
  padding-left: 10px;
  padding-right: 10px;
}
.cs_gap_20 .slick-list {
  margin-left: -10px;
  margin-right: -10px;
}

.cs_slider_navigation.cs_style_1 {
  display: flex;
  gap: 25px;
}
@media (max-width: 1700px) {
  .cs_slider_navigation.cs_style_1 {
    gap: 15px;
  }
}
.cs_slider_navigation.cs_style_1 .cs_slider_prev,
.cs_slider_navigation.cs_style_1 .cs_slider_next {
  width: 90px;
  height: 70px;
  background-color: #fff;
  border-radius: 10px;
  padding: 5px;
  transition: all 0.4s ease;
  cursor: pointer;
}
@media (max-width: 1700px) {
  .cs_slider_navigation.cs_style_1 .cs_slider_prev,
  .cs_slider_navigation.cs_style_1 .cs_slider_next {
    width: 80px;
    height: 60px;
  }
}
.cs_slider_navigation.cs_style_1 .cs_slider_prev img,
.cs_slider_navigation.cs_style_1 .cs_slider_next img {
  transition: inherit;
}
.cs_slider_navigation.cs_style_1 .cs_slider_prev:hover,
.cs_slider_navigation.cs_style_1 .cs_slider_next:hover {
  background-color: #01AE42;
}
.cs_slider_navigation.cs_style_1 .cs_slider_prev:hover img,
.cs_slider_navigation.cs_style_1 .cs_slider_next:hover img {
  filter: brightness(0) invert(1);
}
@media (max-width: 575px) {
  .cs_slider_navigation.cs_style_1 {
    margin-top: 40px;
  }
}

.cs_slider_navigation.cs_style_2 {
  display: flex;
  gap: 12px;
  margin-top: 40px;
  position: relative;
  z-index: 5;
}
.cs_slider_navigation.cs_style_2 .cs_slider_prev,
.cs_slider_navigation.cs_style_2 .cs_slider_next {
  height: 40px;
  width: 40px;
  border: 2px solid #01AE42;
  border-radius: 50%;
  padding: 8px;
  transition: all 0.4s ease;
  cursor: pointer;
}
.cs_slider_navigation.cs_style_2 .cs_slider_prev img,
.cs_slider_navigation.cs_style_2 .cs_slider_next img {
  transition: inherit;
}
.cs_slider_navigation.cs_style_2 .cs_slider_prev:hover,
.cs_slider_navigation.cs_style_2 .cs_slider_next:hover {
  background-color: #01AE42;
}
.cs_slider_navigation.cs_style_2 .cs_slider_prev:hover img,
.cs_slider_navigation.cs_style_2 .cs_slider_next:hover img {
  filter: brightness(0) invert(1);
}

.slick-dots {
  display: flex !important;
  justify-content: center;
  gap: 10px 15px;
  margin-top: 60px;
  list-style: none;
  padding: 0;
  margin-bottom: 0;
}
@media (max-width: 991px) {
  .slick-dots {
    margin-top: 30px;
  }
}
.slick-dots li {
  height: 12px;
  width: 12px;
  background-color: #fff;
  border: 2px solid #01AE42;
  opacity: 1;
  border-radius: 1.6em;
  transition: all 0.4s ease;
  overflow: hidden;
  position: relative;
}
.slick-dots li button {
  position: absolute;
  top: -10px;
  left: -10px;
  opacity: 0;
  z-index: 1;
}
.slick-dots li.slick-active {
  background-color: #01AE42;
}

.cs_slider_heading_1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
@media (max-width: 991px) {
  .cs_slider_heading_1 {
    flex-direction: column;
    align-items: flex-start;
    gap: 50px;
  }
}
@media (max-width: 575px) {
  .cs_slider_heading_1 .cs_slider_navigation.cs_style_1 {
    margin-top: 0;
  }
}

.cs_related_doctor .cs_slider_navigation.cs_style_2 {
  margin-top: 50px;
  justify-content: flex-end;
  max-width: 50%;
  margin-left: auto;
}
@media (max-width: 991px) {
  .cs_related_doctor .cs_slider_navigation.cs_style_2 {
    margin-top: 30px;
    max-width: 100%;
    justify-content: center;
  }
}
.cs_related_doctor .slick-dots {
  position: absolute;
  bottom: -76px;
  margin-top: 0;
  z-index: 6;
  gap: 10px 18px;
  z-index: 3;
}
@media (max-width: 991px) {
  .cs_related_doctor .slick-dots {
    display: none !important;
  }
}
.cs_related_doctor .slick-dots li {
  background-color: #01AE42;
}
.cs_related_doctor .slick-dots li.slick-active {
  transform: scale(1.3);
}
@media (max-width: 1400px) {
  .cs_related_doctor .slick-list {
    overflow: initial;
  }
  .cs_related_doctor .slick-list .slick-slide {
    opacity: 0;
    transition: all 0.4s ease;
  }
  .cs_related_doctor .slick-list .slick-slide.slick-current {
    opacity: 1;
  }
}

.cs_department_carousel {
  position: relative;
}
.cs_department_carousel .slick-list {
  overflow: initial;
}
.cs_department_carousel .slick-slide {
  opacity: 0;
  transition: all 0.3s ease;
}
.cs_department_carousel .slick-slide.slick-active {
  opacity: 1;
}
.cs_department_carousel .cs_slider_navigation.cs_style_1 .cs_slider_prev,
.cs_department_carousel .cs_slider_navigation.cs_style_1 .cs_slider_next {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: #fff;
  width: 70px;
  box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);
  opacity: 0;
}
@media (max-width: 991px) {
  .cs_department_carousel .cs_slider_navigation.cs_style_1 .cs_slider_prev,
  .cs_department_carousel .cs_slider_navigation.cs_style_1 .cs_slider_next {
    opacity: 1;
    width: 50px;
    height: 50px;
    padding: 12px;
  }
}
.cs_department_carousel .cs_slider_navigation.cs_style_1 .cs_slider_prev img,
.cs_department_carousel .cs_slider_navigation.cs_style_1 .cs_slider_next img {
  filter: initial;
}
.cs_department_carousel .cs_slider_navigation.cs_style_1 .cs_slider_prev {
  left: -35px;
}
@media (max-width: 991px) {
  .cs_department_carousel .cs_slider_navigation.cs_style_1 .cs_slider_prev {
    left: -15px;
  }
}
.cs_department_carousel .cs_slider_navigation.cs_style_1 .cs_slider_next {
  right: -35px;
}
@media (max-width: 991px) {
  .cs_department_carousel .cs_slider_navigation.cs_style_1 .cs_slider_next {
    right: -15px;
  }
}
.cs_department_carousel:hover .cs_slider_navigation.cs_style_1 .cs_slider_next,
.cs_department_carousel:hover .cs_slider_navigation.cs_style_1 .cs_slider_prev {
  opacity: 1;
}

/*--------------------------------------------------------------
6. Video Popup
----------------------------------------------------------------*/
.cs_pd_video .cs_video_open,
.cs_sample_img .cs_video_open {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 68px;
  transition: all 0.3s ease;
  line-height: 48px;
}

.cs_pd_video .cs_video_open:hover,
.cs_sample_img .cs_video_open:hover {
  color: rgba(255, 255, 255, 0.7);
}

.cs_video_popup {
  position: fixed;
  z-index: 1000;
  top: 0;
  width: 100%;
  height: 100%;
  left: -100%;
  transition-delay: 0.3s;
}

.cs_video_popup.active {
  left: 0;
  transition-delay: 0s;
  left: 0;
}

.cs_video_popup_overlay {
  position: absolute;
  left: 0;
  right: 0;
  background: #000;
  transition: all 0.4s ease-out;
  opacity: 0;
}

.cs_video_popup.active .cs_video_popup_overlay {
  opacity: 0.8;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.cs_video_popup_content {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  font-size: 0;
  text-align: center;
  transition: all 0.4s ease-out;
  transform: translateY(100px);
  opacity: 0;
  visibility: hidden;
  padding: 15px;
}

.cs_video_popup.active .cs_video_popup_content {
  transform: translateY(0);
  opacity: 1;
  visibility: visible;
}

.cs_video_popup_content:after {
  content: "";
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}

.cs_video_popup_container {
  display: inline-block;
  position: relative;
  text-align: left;
  background: #fff;
  max-width: 1380px;
  width: 100%;
  vertical-align: middle;
}

.cs_video_popup_container .embed-responsive {
  width: 100%;
}

.embed-responsive {
  position: relative;
  display: block;
  height: 0;
  padding: 0;
  overflow: hidden;
  height: 100%;
}

.embed-responsive-16by9::before {
  display: block;
  content: "";
  padding-top: 56.25%;
}

.embed-responsive iframe,
.embed-responsive video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.cs_video_popup_close {
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 40px;
  background: #d90d0d;
  cursor: pointer;
  transition: all 0.4s ease-in-out;
}

.cs_video_popup iframe {
  width: 100%;
  height: 100%;
  position: absolute;
}

.cs_video_popup_close:before {
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 20px;
  height: 1px;
  background: #fff;
  margin-left: -10px;
  transform: rotate(-45deg);
  transition: all 0.4s ease-in-out;
}

.cs_video_popup_close:after {
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 20px;
  height: 1px;
  background: #fff;
  margin-left: -10px;
  transform: rotate(45deg);
  transition: all 0.4s ease-in-out;
}

.cs_video_popup_close:hover:before,
.cs_video_popup_close:hover:after {
  background: #000;
}

.cs_video_popup_layer {
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
}

.cs_video_popup_align {
  overflow: hidden;
}

/*End Video Popup*/
/*--------------------------------------------------------------
7. Header
----------------------------------------------------------------*/
.cs_site_header {
  position: relative;
  z-index: 101;
}

.cs_site-branding {
  display: inline-block;
  max-width: 180px;
}

.cs_site_header {
  position: absolute;
  width: 100%;
  left: 0;
  top: 0px;
  transition: all 0.4s ease;
}

.cs_toolbox {
  display: flex;
  gap: 45px;
}
.cs_toolbox .cs_toolbox_btn {
  border: none;
  background-color: transparent;
  display: flex;
  padding: 0;
  cursor: pointer;
  transition: all 0.4s ease;
}
.cs_toolbox .cs_toolbox_btn:hover {
  color: #01AE42;
}

.cs_site_header.cs_style1 .cs_main_header_in,
.cs_site_header.cs_style1 .cs_top_header_in {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  height: 100px;
  position: relative;
}
.cs_site_header.cs_style1 .cs_main_header_right {
  display: flex;
  align-items: center;
  height: 100%;
}
.cs_site_header.cs_style1.cs_white_color .cs_toolbox {
  color: #0171CE;
}
@media (max-width: 1199px) {
  .cs_site_header.cs_style1.cs_white_color .cs_nav .cs_nav_list {
    color: #fff;
    background-color: #0171CE;
  }
  .cs_site_header.cs_style1.cs_white_color .cs_menu_toggle.cs_toggle_active {
    color: #fff;
  }
}
.cs_site_header.cs_style1.cs_gescout_sticky.cs_white_color .cs_toolbox {
  color: #fff;
}
.cs_site_header.cs_style1.cs_gescout_sticky.cs_white_color .cs_menu_toggle:not(.cs_toggle_active) span {
  color: #fff;
}
.cs_site_header.cs_style1.cs_color_1 .cs_toolbox_btn {
  color: #fff;
}
.cs_site_header.cs_style1.cs_color_1 .cs_menu_toggle {
  color: #fff;
}

.cs_site_header.cs_style1.cs_sticky_active {
  background-color: #ffffff;
  box-shadow: 0 10px 10px -10px rgba(33, 43, 53, 0.1);
}
.cs_site_header.cs_style1 .cs_action_box {
  display: flex;
  align-items: center;
}
.cs_site_header.cs_style1 .cs_action_box .cs_action_value {
  margin-left: 15px;
}
.cs_site_header.cs_style1 .cs_action_box > *:not(:last-child) {
  margin-right: 35px;
}

.cs_site_header_full_width .container {
  max-width: 100%;
  padding: 0 100px;
}

.cs_site_header_style1 {
  border-bottom: 1px solid #1a188d;
}
.cs_site_header_style1 .cs_main_header_right {
  display: flex;
  align-items: center;
}
.cs_site_header_style1 .cs_nav + .cs_header_toolbox.cs_center {
  margin-left: 35px;
}
.cs_site_header_style1 .cs_nav .cs_nav_list > li.current-menu-item > a:before {
  bottom: -4px;
  background-color: #ffffff;
}

.cs_sidenav {
  position: fixed;
  z-index: 1111;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: flex-end;
  transition: all 0.4s ease;
  opacity: 0;
  visibility: hidden;
}
.cs_sidenav.active {
  opacity: 1;
  visibility: visible;
}

.cs_sidenav_overlay {
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(11, 11, 11, 0.5);
  height: 100%;
  width: 100%;
  cursor: zoom-out;
}

.cs_sidenav_in {
  position: relative;
  z-index: 2;
  background-color: #fff;
  width: 100%;
  max-width: 620px;
  padding: 60px 80px;
  overflow-y: auto;
  overflow-x: hidden;
}
.cs_sidenav_in hr {
  width: calc(100% + 80px);
}
.cs_sidenav_in .cs_newsletter.cs_style1 .cs_newsletter_title {
  font-size: 28px;
  line-height: 1.35em;
  margin-bottom: 9px;
}
.cs_sidenav_in .cs_social_links a {
  background-color: #0171CE;
  color: #fff;
  height: 30px;
  width: 30px;
  font-size: 14px;
}
.cs_sidenav_in .cs_social_links a:hover {
  background-color: #01AE42;
}
.cs_sidenav_in .cs_close {
  margin-bottom: 52px;
}

.cs_close {
  border: none;
  outline: none;
  background-color: transparent;
  cursor: pointer;
  transition: all 0.4s ease;
}
.cs_close:hover {
  transform: rotate(90deg);
}

.cs_header_search {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  opacity: 0;
  visibility: hidden;
  transition: all 0.4s ease;
}
.cs_header_search.active {
  opacity: 1;
  visibility: visible;
}

.cs_header_search_in {
  position: relative;
  z-index: 1;
  background-color: #fff;
  padding: 50px 0;
}
.cs_header_search_in .cs_search_form {
  max-width: 100%;
}
.cs_header_search_in .cs_search_form input {
  border-radius: 40px;
  padding: 10px 90px 10px 35px;
  font-size: 20px;
  height: 80px;
}
@media (max-width: 575px) {
  .cs_header_search_in .cs_search_form input {
    padding: 10px 65px 10px 20px;
    font-size: 18px;
    height: 66px;
  }
}
.cs_header_search_in .cs_search_form .cs_search_btn {
  width: 80px;
}
@media (max-width: 575px) {
  .cs_header_search_in .cs_search_form .cs_search_btn {
    width: 60px;
  }
}
.cs_header_search_in .cs_search_form .cs_search_btn svg {
  width: 28px;
  height: 28px;
}
@media (max-width: 575px) {
  .cs_header_search_in .cs_search_form .cs_search_btn svg {
    width: 24px;
    height: 24px;
  }
}

.cs_header_search_box {
  display: flex;
  align-items: center;
  gap: 0 30px;
}
@media (max-width: 991px) {
  .cs_header_search_box {
    gap: 0 15px;
  }
}

@media screen and (max-width: 1199px) {
  .cs_main_header .container {
    max-width: 100%;
  }
  .cs_site_header.cs_style1 .cs_nav {
    display: flex;
  }
}
.cs_nav ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.cs_sticky_header {
  position: fixed !important;
  width: 100%;
  z-index: 999;
}

.cs_gescout_sticky {
  position: fixed !important;
  top: -110px;
  opacity: 0;
  visibility: hidden;
  transition: all 0.4s ease;
  background-color: #fff;
}
.cs_gescout_sticky .cs_main_header_in {
  height: 90px;
}
.cs_gescout_sticky.cs_white_color {
  background-color: #0171CE;
}

.cs_gescout_show {
  top: 0 !important;
  opacity: 1;
  visibility: visible;
  box-shadow: 0px 1px 2px 0px rgba(2, 0, 181, 0.1);
}

.cs_site_branding {
  display: inline-block;
}

@media screen and (min-width: 1200px) {
  .cs_site_header.cs_style1.cs_white_color .menu-item-has-children ul {
    color: #0171CE;
  }
  .cs_main_header {
    position: relative;
  }
  .cs_main_header .container-fluid {
    padding-right: 40px;
    padding-left: 40px;
  }
  .cs_main_header_center,
  .cs_top_header_center {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .cs_site_header.cs_style1 .cs_main_header_center {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    max-width: calc(100% - 300px);
  }
  .cs_site_header.cs_style1 .cs_main_header_left {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px 124px;
  }
  .cs_nav {
    display: flex;
    align-items: center;
    height: 100%;
    line-height: 1.6em;
  }
  .cs_nav .cs_nav_list {
    display: flex !important;
    flex-wrap: wrap;
    height: inherit;
  }
  .cs_nav .cs_nav_list > li {
    margin-right: 50px;
    height: inherit;
  }
  .cs_nav .cs_nav_list > li:last-child {
    margin-right: 0;
  }
  .cs_nav .cs_nav_list > li > a {
    padding: 10px 0;
    display: inline-flex;
    position: relative;
    height: inherit;
    align-items: center;
  }
  .cs_nav .cs_nav_list > li > ul {
    left: 0;
    top: calc(100% + 15px);
  }
  .cs_nav .cs_nav_list > li:hover > ul {
    top: 100%;
    opacity: 1;
    visibility: visible;
    transition: all 0.4s ease;
  }
  .cs_nav .cs_nav_list > li.menu-item-has-children > a {
    position: relative;
  }
  .cs_nav .cs_nav_list > li.menu-item-has-children > a::after {
    content: "";
    display: inline-block;
    height: 6px;
    width: 6px;
    border: 2px solid currentColor;
    transform: rotate(45deg);
    border-left: 0;
    border-top: 0;
    margin-left: 6px;
    position: relative;
    top: -1px;
    border-radius: 0px 0px 2px 0px;
  }
  .cs_nav .cs_nav_list li:not(.cs_mega_menu) {
    position: relative;
  }
  .cs_nav .cs_nav_list ul {
    width: 260px;
    background-color: #fff;
    position: absolute;
    box-shadow: 0px 1px 2px 0px rgba(2, 0, 181, 0.1);
    padding: 10px 0;
    z-index: 100;
    opacity: 0;
    visibility: hidden;
    display: block !important;
    border-radius: 15px;
    box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);
    transition: all 0.1s ease;
  }
  .cs_nav .cs_nav_list ul li:hover ul {
    top: 0px;
  }
  .cs_nav .cs_nav_list ul li:hover > ul {
    opacity: 1;
    visibility: visible;
    transition: all 0.4s ease;
  }
  .cs_nav .cs_nav_list ul a {
    display: block;
    line-height: inherit;
    padding: 10px 20px;
  }
  .cs_nav .cs_nav_list ul ul {
    top: 15px;
    left: 100%;
  }
  .cs_menu_toggle,
  .cs_munu_dropdown_toggle {
    display: none;
  }
  .cs_nav .cs_nav_list .cs_mega_menu {
    position: relative;
  }
  .cs_nav .cs_nav_list .cs_mega_wrapper {
    width: 475px !important;
    left: 0;
    display: flex !important;
    position: absolute;
    padding: 5px 15px 10px;
  }
  .cs_nav .cs_nav_list .cs_mega_wrapper a {
    padding: 7px 10px;
  }
  .cs_nav .cs_nav_list .cs_mega_wrapper > li {
    flex: 1 1;
    padding: 10px 0;
  }
  .cs_nav .cs_nav_list .cs_mega_wrapper > li > a {
    font-size: 18px;
    font-weight: 600;
    pointer-events: none;
  }
  .cs_nav .cs_nav_list .cs_mega_wrapper > li > a:hover {
    background-color: transparent;
  }
  .cs_nav .cs_nav_list .cs_mega_wrapper > li ul {
    position: initial;
    border: none;
    padding: 0;
    width: 100%;
    box-shadow: none;
    background-color: transparent;
  }
  .cs_nav .cs_nav_list .cs_mega_wrapper > li ul a {
    transition: all 0.4s ease;
  }
  .cs_nav .cs_nav_list .cs_mega_wrapper > li ul a:hover {
    letter-spacing: 1px;
  }
  .cs_nav .cs_nav_list .cs_mega_menu:hover .cs_mega_wrapper li ul {
    opacity: 1;
    visibility: visible;
  }
  .cs_nav .cs_nav_list > li ul:not(.cs_mega_wrapper) .menu-item-has-children > a {
    position: relative;
  }
}
@media screen and (max-width: 1400px) {
  .cs_nav .cs_nav_list .cs_mega_wrapper {
    width: 1116px !important;
  }
  .cs_site-branding {
    max-width: 190px;
  }
  .cs_site_header_full_width .container {
    max-width: 100%;
  }
}
@media screen and (max-width: 1199px) {
  .cs_site_header.cs_style1.cs_mobile_toggle_active {
    background-color: #fff;
  }
  .cs_site_header.cs_style1.cs_mobile_toggle_active.cs_white_color {
    background-color: #0171CE;
  }
  .cs_toolbox .cs_sidebar_toggle_btn {
    display: none;
  }
  .cs_site_header.cs_style1 .cs_main_header_right {
    padding-right: 50px;
  }
  .cs_toolbox .cs_toolbox_btn {
    max-width: 26px;
  }
  .cs_nav .cs_nav_list .cs_mega_wrapper {
    width: 100% !important;
  }
  .cs_site_header_full_width .container {
    padding: 0 15px;
  }
  .cs_munu_dropdown_toggle {
    position: absolute;
    height: 40px;
    width: 100%;
    top: 0;
    left: 0px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 28px 18px;
    cursor: pointer;
    z-index: 3;
  }
  .cs_munu_dropdown_toggle span {
    display: block;
    position: relative;
    height: 10px;
    width: 10px;
    line-height: 1.2em;
  }
  .cs_munu_dropdown_toggle span:before, .cs_munu_dropdown_toggle span:after {
    content: "";
    display: block;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    height: 2px;
    width: 10px;
    background-color: currentColor;
    transition: all 0.3s ease;
  }
  .cs_munu_dropdown_toggle span:before {
    transform: translate(-50%, -50%) rotate(90deg);
  }
  .cs_munu_dropdown_toggle.active span:before {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  .menu-item-has-children .menu-item-has-children .cs_munu_dropdown_toggle {
    padding: 20px 18px;
  }
  .cs_site_branding {
    position: relative;
    z-index: 101;
  }
  .cs_nav .cs_nav_list {
    position: fixed;
    width: 100vw;
    left: -100vw;
    background-color: #fff;
    color: #0171CE;
    padding: 10px 0;
    top: 80px;
    overflow: auto;
    height: calc(100vh - 80px);
    line-height: 1.6em;
    transition: all 0.4s ease;
  }
  .cs_nav .cs_nav_list.cs_active {
    left: 0vw;
  }
  .cs_nav .cs_nav_list ul {
    padding-left: 15px;
    display: none;
  }
  .cs_nav .cs_nav_list a {
    display: block;
    padding: 12px 15px;
    line-height: 16px;
  }
  .cs_nav .cs_nav_list > li > a {
    font-size: 18px;
    line-height: 1.4em;
  }
  .cs_nav .menu-item-has-children {
    position: relative;
  }
  /*Mobile Menu Button*/
  .cs_menu_toggle {
    display: inline-block;
    width: 30px;
    height: 27px;
    cursor: pointer;
    position: absolute;
    top: 27px;
    right: 30px;
    color: #0171CE;
  }
  .cs_menu_toggle span,
  .cs_menu_toggle span:before,
  .cs_menu_toggle span:after {
    width: 100%;
    height: 3px;
    background-color: currentColor;
    display: block;
    border-radius: 5px;
  }
  .cs_menu_toggle span {
    margin: 0 auto;
    position: relative;
    top: 12px;
    transition-duration: 0s;
    transition-delay: 0.2s;
  }
  .cs_menu_toggle span:before {
    content: "";
    position: absolute;
    margin-top: -9px;
    transition-property: margin, transform;
    transition-duration: 0.2s;
    transition-delay: 0.2s, 0s;
  }
  .cs_menu_toggle span:after {
    content: "";
    position: absolute;
    margin-top: 9px;
    transition-property: margin, transform;
    transition-duration: 0.2s;
    transition-delay: 0.2s, 0s;
  }
  .cs_site_header.cs_style1 .cs_menu_toggle {
    top: 50%;
    right: 0px;
    margin-top: -13px;
  }
  .cs_toggle_active span {
    background-color: rgba(0, 0, 0, 0);
    transition-delay: 0.2s;
  }
  .cs_toggle_active span:before {
    margin-top: 0;
    transform: rotate(45deg);
    transition-delay: 0s, 0.2s;
  }
  .cs_toggle_active span:after {
    margin-top: 0;
    transform: rotate(-45deg);
    transition-delay: 0s, 0.2s;
  }
  .cs_nav .cs_nav_list a {
    position: relative;
  }
  .cs_site_header.cs_style1 .cs_main_header_in {
    height: 80px;
  }
  .cs_site_header .current-menu-item > a:before {
    display: none;
  }
  .cs_site_header.cs_style1 .cs_main_header_center .cs_site_branding {
    position: absolute;
    left: 0px;
    top: 50%;
    transform: translateY(-50%);
  }
  .cs_site_header.cs_style1 {
    top: 0;
  }
  .cs_has_main_nav {
    display: none;
  }
}
@media screen and (max-width: 991px) {
  .cs_site_header .container {
    max-width: 100%;
  }
  .cs_site_header.cs_style1 .cs_action_box > *:not(:last-child) {
    margin-right: 25px;
  }
}
@media screen and (max-width: 575px) {
  .cs_site-branding {
    max-width: 150px;
  }
}
/*Start Demo Menu*/
@media (min-width: 1200px) {
  .cs_nav .cs_nav_list > li > ul.cs_demo_mega {
    width: 1110px;
    display: flex !important;
    text-align: center;
    padding: 15px;
    left: 50%;
    transform: translateX(-50%);
    position: fixed;
    top: 100px;
  }
  .cs_nav .cs_nav_list > li > ul.cs_demo_mega a {
    padding: 10px;
  }
  .cs_nav .cs_nav_list > li > ul.cs_demo_mega img {
    border-radius: 8px;
    box-shadow: 0px 3px 18px 1px rgba(48, 123, 196, 0.1);
    border: 1px solid rgba(1, 113, 206, 0.06);
  }
  .cs_nav .cs_nav_list > li > ul.cs_demo_mega span {
    display: block;
    margin-top: 6px;
    font-size: 90%;
    margin-bottom: -8px;
  }
  .cs_nav .cs_nav_list > li > ul.cs_demo_mega + ul {
    display: none !important;
  }
}
@media (max-width: 1199px) {
  .cs_nav .cs_nav_list > li > ul.cs_demo_mega {
    display: none !important;
  }
}
/*End Demo Menu*/
.cs_site_header.cs_style1.cs_color_2 {
  background-color: #fff;
}
@media (max-width: 420px) {
  .cs_site_header.cs_style1 .cs_btn.cs_style_1 {
    padding: 7px 15px;
    font-size: 14px;
  }
  .cs_site_header.cs_style1 .cs_btn.cs_style_1 i {
    display: none;
  }
}
@media (max-width: 350px) {
  .cs_site_header.cs_style1 .cs_btn.cs_style_1 {
    display: none;
  }
}

/*--------------------------------------------------------------
8. Footer
----------------------------------------------------------------*/
.cs_newsletter_1_wrap {
  position: relative;
}
.cs_newsletter_1_wrap::before {
  content: "";
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  height: 70%;
  background-color: #fff;
}

.cs_newsletter.cs_style_2 {
  border-radius: 20px;
  background: #fff;
  box-shadow: 6px 4px 70px 8px rgba(48, 123, 196, 0.09);
  display: flex;
  padding: 107px 135px;
  justify-content: space-between;
  gap: 40px 40px;
  align-items: center;
  position: relative;
  z-index: 1;
}
@media (max-width: 1400px) {
  .cs_newsletter.cs_style_2 {
    padding: 80px 100px;
  }
}
@media (max-width: 1199px) {
  .cs_newsletter.cs_style_2 {
    padding: 70px;
  }
}
@media (max-width: 575px) {
  .cs_newsletter.cs_style_2 {
    padding: 50px 25px;
  }
  .cs_newsletter.cs_style_2 br {
    display: none;
  }
}
@media (max-width: 991px) {
  .cs_newsletter.cs_style_2 {
    flex-direction: column;
    align-items: flex-start;
  }
  .cs_newsletter.cs_style_2 .cs_newsletter_title br {
    display: none;
  }
}
.cs_newsletter.cs_style_2 .cs_newsletter_title {
  font-size: 42px;
  line-height: 1.23em;
}
.cs_newsletter.cs_style_2 p {
  color: #0171CE;
  margin: 0;
}
.cs_newsletter.cs_style_2 .cs_newsletter_right {
  min-width: 500px;
}
.cs_newsletter.cs_style_2 .cs_newsletter_right p {
  margin-bottom: 12px;
}
@media (max-width: 1400px) {
  .cs_newsletter.cs_style_2 .cs_newsletter_right {
    min-width: 400px;
  }
}
@media (max-width: 575px) {
  .cs_newsletter.cs_style_2 .cs_newsletter_right {
    min-width: 100%;
  }
}

.cs_newsletter.cs_style_1 .cs_newsletter_form,
.cs_newsletter.cs_style_2 .cs_newsletter_form,
.cs_newsletter.cs_style_3 .cs_newsletter_form,
.cs_newsletter.cs_style_4 .cs_newsletter_form {
  position: relative;
}
.cs_newsletter.cs_style_1 .cs_btn.cs_style_1,
.cs_newsletter.cs_style_2 .cs_btn.cs_style_1,
.cs_newsletter.cs_style_3 .cs_btn.cs_style_1,
.cs_newsletter.cs_style_4 .cs_btn.cs_style_1 {
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
}
@media (max-width: 1700px) {
  .cs_newsletter.cs_style_1 .cs_btn.cs_style_1,
  .cs_newsletter.cs_style_2 .cs_btn.cs_style_1,
  .cs_newsletter.cs_style_3 .cs_btn.cs_style_1,
  .cs_newsletter.cs_style_4 .cs_btn.cs_style_1 {
    right: 5px;
  }
}
.cs_newsletter.cs_style_1 .cs_form_field,
.cs_newsletter.cs_style_2 .cs_form_field,
.cs_newsletter.cs_style_3 .cs_form_field,
.cs_newsletter.cs_style_4 .cs_form_field {
  padding-right: 180px;
}
@media (max-width: 1700px) {
  .cs_newsletter.cs_style_1 .cs_form_field,
  .cs_newsletter.cs_style_2 .cs_form_field,
  .cs_newsletter.cs_style_3 .cs_form_field,
  .cs_newsletter.cs_style_4 .cs_form_field {
    padding-right: 165px;
  }
}
@media (max-width: 575px) {
  .cs_newsletter.cs_style_1 .cs_form_field,
  .cs_newsletter.cs_style_2 .cs_form_field,
  .cs_newsletter.cs_style_3 .cs_form_field,
  .cs_newsletter.cs_style_4 .cs_form_field {
    padding-right: 135px;
    padding-left: 15px;
  }
}
@media (max-width: 350px) {
  .cs_newsletter.cs_style_1 .cs_form_field,
  .cs_newsletter.cs_style_2 .cs_form_field,
  .cs_newsletter.cs_style_3 .cs_form_field,
  .cs_newsletter.cs_style_4 .cs_form_field {
    padding-right: 120px;
  }
}
@media (max-width: 1700px) {
  .cs_newsletter.cs_style_1 .cs_form_field,
  .cs_newsletter.cs_style_2 .cs_form_field,
  .cs_newsletter.cs_style_3 .cs_form_field,
  .cs_newsletter.cs_style_4 .cs_form_field {
    border-radius: 30px;
  }
}
@media (max-width: 575px) {
  .cs_newsletter.cs_style_1 .cs_btn.cs_style_1,
  .cs_newsletter.cs_style_2 .cs_btn.cs_style_1,
  .cs_newsletter.cs_style_3 .cs_btn.cs_style_1,
  .cs_newsletter.cs_style_4 .cs_btn.cs_style_1 {
    padding: 12px 25px;
  }
}
@media (max-width: 350px) {
  .cs_newsletter.cs_style_1 .cs_btn.cs_style_1,
  .cs_newsletter.cs_style_2 .cs_btn.cs_style_1,
  .cs_newsletter.cs_style_3 .cs_btn.cs_style_1,
  .cs_newsletter.cs_style_4 .cs_btn.cs_style_1 {
    padding: 12px 18px;
  }
}

.cs_newsletter.cs_style_1 .cs_form_field {
  border-radius: 2.4em;
}

.cs_newsletter_2_wrap {
  position: relative;
}
.cs_newsletter_2_wrap::before {
  content: "";
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  height: 50%;
  background-color: #fff;
}

.cs_newsletter.cs_style_3 {
  border-radius: 20px;
  background: linear-gradient(154deg, #d2eaef 0%, #86bbf1 100%);
  box-shadow: 6px 4px 70px 8px rgba(48, 123, 196, 0.09);
  position: relative;
  z-index: 2;
  margin-top: 240px;
}
@media (max-width: 991px) {
  .cs_newsletter.cs_style_3 {
    margin-top: 0;
  }
}
.cs_newsletter.cs_style_3 .cs_newsletter_img {
  position: absolute;
  bottom: -3px;
  left: -115px;
}
@media (max-width: 1199px) {
  .cs_newsletter.cs_style_3 .cs_newsletter_img {
    left: -140px;
  }
}
@media (max-width: 991px) {
  .cs_newsletter.cs_style_3 .cs_newsletter_img {
    display: none;
  }
}
.cs_newsletter.cs_style_3 .cs_newsletter_in {
  padding: 87px 80px 100px 500px;
}
@media (max-width: 1199px) {
  .cs_newsletter.cs_style_3 .cs_newsletter_in {
    padding: 87px 30px 100px 420px;
  }
}
@media (max-width: 991px) {
  .cs_newsletter.cs_style_3 .cs_newsletter_in {
    padding: 75px 50px 80px 50px;
  }
}
@media (max-width: 575px) {
  .cs_newsletter.cs_style_3 .cs_newsletter_in {
    padding: 55px 25px 60px 25px;
  }
}
.cs_newsletter.cs_style_3 .cs_newsletter_form {
  max-width: 560px;
}
.cs_newsletter.cs_style_3 .cs_newsletter_title {
  margin-bottom: 50px;
}
@media (max-width: 575px) {
  .cs_newsletter.cs_style_3 .cs_newsletter_title {
    margin-bottom: 30px;
  }
}
.cs_newsletter.cs_style_3 .cs_newsletter_subtitle {
  margin-bottom: 13px;
}

.cs_newsletter.cs_style_4 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 40px 0;
  border-bottom: 1px solid #fff;
}
@media (max-width: 991px) {
  .cs_newsletter.cs_style_4 {
    flex-direction: column;
    align-items: flex-start;
    gap: 35px;
  }
}
@media (max-width: 380px) {
  .cs_newsletter.cs_style_4 br {
    display: none;
  }
}
.cs_newsletter.cs_style_4 .cs_newsletter_right {
  max-width: 500px;
  width: 100%;
}
.cs_newsletter.cs_style_4 .cs_form_field {
  border-color: rgba(255, 255, 255, 0.5);
  color: #fff;
}
.cs_newsletter.cs_style_4 .cs_form_field:focus {
  border-color: rgba(255, 255, 255, 0.8);
}
.cs_newsletter.cs_style_4 .cs_form_field::placeholder {
  color: rgba(255, 255, 255, 0.6);
}
.cs_newsletter.cs_style_4 .cs_form_field::-ms-input-placeholder {
  color: rgba(255, 255, 255, 0.6);
}
.cs_newsletter.cs_style_4 .cs_btn.cs_style_1 {
  color: #01AE42;
}
.cs_newsletter.cs_style_4 .cs_btn.cs_style_1:before {
  background: #fff;
}
.cs_newsletter.cs_style_4 .cs_btn.cs_style_1:after {
  background: #fff;
}
.cs_newsletter.cs_style_4 .cs_btn.cs_style_1 img {
  filter: initial;
}
.cs_newsletter.cs_style_4 .cs_newsletter_title {
  font-size: 42px;
  margin-bottom: 0;
}
@media (max-width: 1199px) {
  .cs_newsletter.cs_style_4 .cs_newsletter_title {
    font-size: 36px;
  }
}
.cs_newsletter.cs_style_4 .cs_newsletter_left {
  display: flex;
  align-items: center;
  gap: 35px;
}
@media (max-width: 1400px) {
  .cs_newsletter.cs_style_4 .cs_newsletter_left {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
}

.cs_social_links_wrap {
  display: flex;
  align-items: center;
  gap: 20px 30px;
}
.cs_social_links_wrap h2 {
  font-size: 16px;
  font-weight: 400;
  margin: 0;
}

.cs_social_links {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}
.cs_social_links a {
  height: 20px;
  width: 20px;
  flex: none;
  display: flex;
  align-items: center;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.5);
  color: #01AE42;
  font-size: 12px;
  justify-content: center;
}
.cs_social_links a:hover {
  transform: scale(1.2);
  background-color: #fff;
}

.cs_footer_bottom_in {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px 30px;
  flex-wrap: wrap;
  padding: 37px 0;
}
@media (max-width: 575px) {
  .cs_footer_bottom_in {
    flex-direction: column;
    text-align: center;
  }
}

.cs_copyright {
  color: rgba(255, 255, 255, 0.5);
}

.cs_footer.cs_style_1 {
  position: relative;
  margin-top: 305px;
}
@media (max-width: 991px) {
  .cs_footer.cs_style_1 {
    margin-top: 200px;
  }
}
.cs_footer.cs_style_1 .cs_footer_logo_wrap {
  position: absolute;
  height: calc(100% + 200px);
  width: 100%;
  left: 0;
  bottom: 0;
  background-position: top center;
  background-size: cover;
}
@media (max-width: 991px) {
  .cs_footer.cs_style_1 .cs_footer_logo_wrap {
    height: calc(100% + 120px);
  }
}
.cs_footer.cs_style_1 .cs_footer_brand {
  height: 448px;
  width: 426px;
  background-position: 6px 0px;
  position: absolute;
  left: 50%;
  top: -180px;
  transform: translateX(-50%);
  margin-left: 6px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-size: 100% 100%;
}
.cs_footer.cs_style_1 .cs_footer_brand img {
  animation: spinAnimaiton 6s linear infinite;
}
@media (max-width: 991px) {
  .cs_footer.cs_style_1 .cs_footer_brand {
    height: 360px;
    width: 360px;
    top: -140px;
  }
}
.cs_footer.cs_style_1 .cs_footer_brand_text {
  font-size: 36px;
  font-weight: 400;
  color: #fff;
  margin: 5px 0 0;
}
@media (max-width: 991px) {
  .cs_footer.cs_style_1 .cs_footer_brand_text {
    font-size: 32px;
  }
}
.cs_footer.cs_style_1 .cs_text_widget + .cs_contact_widget {
  margin-top: 62px;
}
.cs_footer.cs_style_1 .cs_footer_main {
  padding: 70px 0;
}
.cs_footer.cs_style_1 .cs_newsletter.cs_style_2 .cs_form_field {
  border-radius: 2.4em;
}

.cs_footer_margin_0 + .cs_footer.cs_style_1 {
  margin-top: 0;
}

.cs_footer.cs_style_2 .cs_footer_in {
  display: flex;
  justify-content: space-between;
  gap: 40px 30px;
  padding: 40px 0 50px;
}
@media (max-width: 991px) {
  .cs_footer.cs_style_2 .cs_footer_in {
    flex-direction: column;
    gap: 0;
  }
}
.cs_footer.cs_style_2 .cs_footer_bottom {
  text-align: center;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  padding: 30px 0;
}
.cs_footer.cs_style_2 .cs_social_links_wrap {
  flex-direction: column;
  align-items: flex-start;
}
.cs_footer.cs_style_2 .cs_contact_widget i {
  background-color: #fff;
  color: #01AE42;
}
.cs_footer.cs_style_2 .cs_text_widget img + p {
  margin-top: 50px;
}
.cs_footer.cs_style_2 .cs_text_widget + .cs_contact_widget {
  margin-top: 20px;
}
.cs_footer.cs_style_2 .cs_menu_widget + .cs_social_links_wrap {
  margin-top: 80px;
}
.cs_footer.cs_style_2 .cs_menu_widget a:hover {
  color: #fff;
  opacity: 0.6;
}

.cs_footer_main,
.cs_footer_bottom {
  position: relative;
  z-index: 2;
}

.cs_text_widget {
  font-size: 20px;
  line-height: 1.5em;
  font-weight: 500;
}
.cs_text_widget p {
  margin: 0;
}

.cs_contact_widget {
  list-style: none;
  padding: 0;
  margin: 0;
}
.cs_contact_widget li {
  display: flex;
  align-items: flex-start;
}
.cs_contact_widget li:not(:last-child) {
  margin-bottom: 13px;
}
.cs_contact_widget i {
  height: 20px;
  width: 20px;
  display: flex;
  flex: none;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 50%;
  margin-right: 19px;
  margin-top: 5px;
}

.cs_menu_widget li:not(:last-child) {
  margin-bottom: 17px;
}

.cs_footer_item {
  padding: 30px 0;
}
@media (max-width: 575px) {
  .cs_footer_item {
    padding: 20px 0;
  }
}

.cs_footer_spacing_305 {
  width: 100%;
  height: 305px;
}

@keyframes spinAnimaiton {
  0% {
    transform: rotateX(-20deg) rotateY(0deg);
  }
  75% {
    transform: rotateX(-20deg) rotateY(360deg);
  }
  100% {
    transform: rotateX(-20deg) rotateY(360deg);
  }
}
.cs_footer.cs_style_2.cs_type_1 .cs_footer_bottom {
  border: none;
  padding: 16px 0;
  background: linear-gradient(119deg, #d2eaef 17.16%, #86bbf1 89.78%);
}
.cs_footer.cs_style_2.cs_type_1 .cs_copyright {
  color: #0171CE;
}

/*--------------------------------------------------------------
9. Sidebar
----------------------------------------------------------------*/
.cs_sidebar {
  padding-left: 100px;
}
@media (max-width: 1700px) {
  .cs_sidebar {
    padding-left: 40px;
  }
}
@media (max-width: 1400px) {
  .cs_sidebar {
    padding-left: 0px;
  }
}
@media (max-width: 1199px) {
  .cs_sidebar .cs_btn.cs_style_1 {
    padding: 12px 30px;
  }
}
@media (max-width: 991px) {
  .cs_sidebar {
    padding-top: 80px;
  }
}

.cs_sidebar_item {
  border-radius: 6px;
  background-color: #fff;
  box-shadow: 0px 6px 31px 0px rgba(65, 91, 245, 0.06);
  padding: 50px;
}
@media (max-width: 1700px) {
  .cs_sidebar_item {
    padding: 40px 35px;
  }
}
@media (max-width: 1400px) {
  .cs_sidebar_item {
    padding: 40px 25px;
  }
}
.cs_sidebar_item:not(:last-child) {
  margin-bottom: 70px;
}
@media (max-width: 1700px) {
  .cs_sidebar_item:not(:last-child) {
    margin-bottom: 40px;
  }
}

.widget_categories ul {
  list-style: none;
  padding: 0;
  margin: 0;
  font-size: 20px;
  line-height: 1.5em;
  color: #01AE42;
  font-weight: 500;
}
@media (max-width: 1700px) {
  .widget_categories ul {
    font-size: 18px;
  }
}
.widget_categories ul li {
  position: relative;
  padding-left: 45px;
}
.widget_categories ul li:not(:last-child) {
  margin-bottom: 32px;
}
@media (max-width: 1700px) {
  .widget_categories ul li:not(:last-child) {
    margin-bottom: 22px;
  }
}
.widget_categories ul li::before {
  content: "";
  height: 27px;
  width: 26px;
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: contain;
  background-position: center;
  position: absolute;
  left: 0;
  top: 2px;
}

.cs_sidebar_widget_title {
  font-size: 28px;
  font-weight: 600;
  line-height: 1.5em;
  margin-bottom: 30px;
}
@media (max-width: 1700px) {
  .cs_sidebar_widget_title {
    font-size: 24px;
    margin-bottom: 20px;
  }
}

.cs_popular_posts {
  list-style: none;
  padding: 0;
  margin: 0;
}
.cs_popular_posts > li:not(:last-child) {
  margin-bottom: 40px;
}
@media (max-width: 1700px) {
  .cs_popular_posts > li:not(:last-child) {
    margin-bottom: 30px;
  }
}

.cs_popular_post_title {
  font-size: 20px;
  font-weight: 500;
  line-height: 1.5em;
  color: #01AE42;
  margin-bottom: 15px;
}
@media (max-width: 1700px) {
  .cs_popular_post_title {
    font-size: 18px;
    margin-bottom: 10px;
  }
}
.cs_popular_post_title a:hover {
  text-decoration: underline;
}

.cs_popular_post_meta {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 5px 15px;
  justify-content: space-between;
}
.cs_popular_post_meta li {
  display: flex;
  gap: 10px;
  align-items: center;
}
.cs_popular_post_meta li.cs_posted_author a {
  color: #0171CE;
}
.cs_popular_post_meta li.cs_posted_author a:hover {
  color: #01AE42;
}

/*--------------------------------------------------------------
10. Isotope
----------------------------------------------------------------*/
.cs_isotop {
  transition: all 0.4s ease;
}

.cs_isotop.cs_has_gutter_24 {
  margin-left: -12px;
  margin-right: -12px;
  margin-bottom: -24px;
}
.cs_isotop.cs_has_gutter_24 .cs_isotop_item {
  padding: 0 12px;
  margin-bottom: 24px;
}

.cs_isotop.cs_has_gutter_24_67 {
  margin-left: -12px;
  margin-right: -12px;
  margin-bottom: -67px;
}
.cs_isotop.cs_has_gutter_24_67 .cs_isotop_item {
  padding: 0 12px;
  margin-bottom: 67px;
}

.cs_isotop.cs_has_gutter_80 {
  margin-left: -40px;
  margin-right: -40px;
  margin-bottom: -80px;
}
.cs_isotop.cs_has_gutter_80 .cs_isotop_item {
  padding: 0 40px;
  margin-bottom: 80px;
}

.cs_isotop.cs_has_gutter_40 {
  margin-left: -20px;
  margin-right: -20px;
  margin-bottom: -30px;
}
.cs_isotop.cs_has_gutter_40 .cs_isotop_item {
  padding: 0 20px;
  margin-bottom: 30px;
}

.cs_isotop.cs_has_gutter_100 {
  margin-left: -50px;
  margin-right: -50px;
  margin-bottom: -40px;
}
.cs_isotop.cs_has_gutter_100 .cs_isotop_item {
  padding: 0 50px;
  margin-bottom: 40px;
}

.cs_isotop_col_6 .cs_grid_sizer,
.cs_isotop_col_6 .cs_isotop_item {
  width: 16.666667%;
}

.cs_isotop_col_5 .cs_grid_sizer,
.cs_isotop_col_5 .cs_isotop_item {
  width: 20%;
}

.cs_isotop_col_4 .cs_grid_sizer,
.cs_isotop_col_4 .cs_isotop_item {
  width: 25%;
}

.cs_isotop_col_3 .cs_grid_sizer,
.cs_isotop_col_3 .cs_isotop_item {
  width: 33.333333%;
}

.cs_isotop_col_2 .cs_grid_sizer,
.cs_isotop_col_2 .cs_isotop_item {
  width: 50%;
}

.cs_isotop_col_1 .cs_grid_sizer,
.cs_isotop_col_1 .cs_isotop_item {
  width: 100%;
}

.cs_grid_sizer {
  width: 33.333333%;
}

.cs_isotop_col_5 .cs_w20,
.cs_isotop_col_4 .cs_w20,
.cs_isotop_col_3 .cs_w20,
.cs_isotop_col_2 .cs_w20,
.cs_isotop_col_1 .cs_w20 {
  width: 20%;
}

.cs_isotop_col_5 .cs_w25,
.cs_isotop_col_4 .cs_w25,
.cs_isotop_col_3 .cs_w25,
.cs_isotop_col_2 .cs_w25,
.cs_isotop_col_1 .cs_w25 {
  width: 25%;
}

.cs_isotop_col_5 .cs_w33,
.cs_isotop_col_4 .cs_w33,
.cs_isotop_col_3 .cs_w33,
.cs_isotop_col_2 .cs_w33,
.cs_isotop_col_1 .cs_w33 {
  width: 33.333333%;
}

.cs_isotop_col_5 .cs_w50,
.cs_isotop_col_4 .cs_w50,
.cs_isotop_col_3 .cs_w50,
.cs_isotop_col_2 .cs_w50,
.cs_isotop_col_1 .cs_w50 {
  width: 50%;
}

.cs_isotop_col_5 .cs_w66,
.cs_isotop_col_4 .cs_w66,
.cs_isotop_col_3 .cs_w66,
.cs_isotop_col_2 .cs_w66,
.cs_isotop_col_1 .cs_w66 {
  width: 66.666666%;
}

.cs_isotop_col_5 .cs_w100,
.cs_isotop_col_4 .cs_w100,
.cs_isotop_col_3 .cs_w100,
.cs_isotop_col_2 .cs_w100,
.cs_isotop_col_1 .cs_w100 {
  width: 100%;
}

.cs_isotop_filter.cs_style1 {
  display: flex;
  align-items: center;
  gap: 20px 80px;
}
@media (max-width: 1700px) {
  .cs_isotop_filter.cs_style1 {
    gap: 20px 30px;
  }
}
@media (max-width: 991px) {
  .cs_isotop_filter.cs_style1 {
    flex-direction: column;
    align-items: flex-start;
  }
}
.cs_isotop_filter.cs_style1 ul {
  display: flex;
  flex-wrap: wrap;
  gap: 20px 36px;
}
@media (max-width: 1700px) {
  .cs_isotop_filter.cs_style1 ul {
    gap: 20px;
  }
}
@media (max-width: 991px) {
  .cs_isotop_filter.cs_style1 ul {
    gap: 15px;
  }
}
.cs_isotop_filter.cs_style1 ul a,
.cs_isotop_filter.cs_style1 ul span {
  border: 1px solid #01AE42;
  border-radius: 20px;
  display: inline-block;
  cursor: pointer;
  color: #0171CE;
  padding: 11px 26px;
  transition: all 0.3s ease;
}
@media (max-width: 991px) {
  .cs_isotop_filter.cs_style1 ul a,
  .cs_isotop_filter.cs_style1 ul span {
    padding: 7px 20px;
  }
}
.cs_isotop_filter.cs_style1 ul a:hover,
.cs_isotop_filter.cs_style1 ul span:hover {
  background-color: rgba(1, 174, 66, 0.15);
  color: #01AE42;
}
.cs_isotop_filter.cs_style1 ul .active a,
.cs_isotop_filter.cs_style1 ul .active span {
  color: #fff;
  background-color: #01AE42;
}

.cs_view_box {
  display: flex;
  align-items: center;
  gap: 30px;
}

.cs_view_box_in {
  display: flex;
  gap: 15px;
}
.cs_view_box_in button {
  padding: 0;
  border: none;
  background-color: transparent;
  transition: all 0.3s ease;
  opacity: 0.5;
}
.cs_view_box_in button:hover {
  opacity: 1;
}
.cs_view_box_in button.active {
  opacity: 1;
  color: #01AE42;
}

.cs_doctors_heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
  flex-wrap: wrap;
}

@media screen and (max-width: 1199px) {
  .cs_isotop.cs_has_gutter_100 .cs_isotop_item {
    padding: 0 15px;
    margin-bottom: 30px;
  }
  .cs_isotop.cs_has_gutter_100 {
    margin-left: -15px;
    margin-right: -15px;
    margin-bottom: -30px;
  }
  .cs_isotop.cs_has_gutter_80 {
    margin-left: -12px;
    margin-right: -12px;
    margin-bottom: -25px;
  }
  .cs_isotop.cs_has_gutter_80 .cs_isotop_item {
    padding: 0 12px;
    margin-bottom: 25px;
  }
  .cs_isotop_col_4 .cs_grid_sizer,
  .cs_isotop_col_4 .cs_isotop_item {
    width: 33.333333%;
  }
}
@media screen and (max-width: 991px) {
  .cs_isotop_col_4 .cs_grid_sizer,
  .cs_isotop_col_4 .cs_isotop_item {
    width: 50%;
  }
  .cs_isotop_col_4 .cs_w50 {
    width: 100%;
  }
  .cs_isotop_col_3 .cs_grid_sizer,
  .cs_isotop_col_3 .cs_isotop_item {
    width: 50%;
  }
  .cs_isotop_col_2 .cs_grid_sizer,
  .cs_isotop_col_2 .cs_isotop_item {
    width: 100%;
  }
}
@media screen and (max-width: 767px) {
  .cs_isotop_col_5 .cs_w50,
  .cs_isotop_col_4 .cs_w50,
  .cs_isotop_col_3 .cs_w50,
  .cs_isotop_col_2 .cs_w50,
  .cs_isotop_col_1 .cs_w50,
  .cs_isotop_col_5 .cs_w66,
  .cs_isotop_col_4 .cs_w66,
  .cs_isotop_col_3 .cs_w66,
  .cs_isotop_col_2 .cs_w66,
  .cs_isotop_col_1 .cs_w66 {
    width: 100%;
  }
  .cs_isotop_col_5 .cs_grid_sizer,
  .cs_isotop_col_5 .cs_isotop_item {
    width: 100%;
  }
  .cs_isotop_col_4 .cs_grid_sizer,
  .cs_isotop_col_4 .cs_isotop_item {
    width: 100%;
  }
  .cs_isotop_col_3 .cs_grid_sizer,
  .cs_isotop_col_3 .cs_isotop_item {
    width: 100%;
  }
  .cs_isotop_col_2 .cs_grid_sizer,
  .cs_isotop_col_2 .cs_isotop_item {
    width: 100%;
  }
}
/*--------------------------------------------------------------
11. Hero
----------------------------------------------------------------*/
.cs_hero.cs_style_1 {
  height: 1200px;
  padding-bottom: 110px;
  position: relative;
}
@media (max-width: 1700px) {
  .cs_hero.cs_style_1 {
    height: 1075px;
  }
}
@media (max-width: 1480px) {
  .cs_hero.cs_style_1 {
    height: 1115px;
  }
}
@media (max-width: 1380px) {
  .cs_hero.cs_style_1 {
    height: 980px;
  }
}
@media (max-width: 1300px) {
  .cs_hero.cs_style_1 {
    height: 1010px;
  }
}
@media (max-width: 991px) {
  .cs_hero.cs_style_1 {
    height: initial;
  }
}
.cs_hero.cs_style_1 .cs_hero_text {
  position: relative;
  z-index: 1;
}
.cs_hero.cs_style_1 .cs_hero_wrap {
  height: 100%;
  width: 100%;
  padding-top: 248px;
  position: relative;
}
@media (max-width: 1300px) {
  .cs_hero.cs_style_1 .cs_hero_wrap {
    padding-top: 220px;
  }
}
@media (max-width: 1199px) {
  .cs_hero.cs_style_1 .cs_hero_wrap {
    padding-top: 150px;
  }
}
.cs_hero.cs_style_1 .cs_hero_wrap > .container {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.cs_hero.cs_style_1 .cs_hero_title {
  margin-bottom: 29px;
  max-width: 900px;
}
@media (max-width: 1700px) {
  .cs_hero.cs_style_1 .cs_hero_title {
    max-width: 710px;
  }
}
@media (max-width: 1199px) {
  .cs_hero.cs_style_1 .cs_hero_title {
    max-width: 580px;
  }
}
@media (max-width: 1199px) {
  .cs_hero.cs_style_1 .cs_hero_title {
    margin-bottom: 20px;
  }
}
.cs_hero.cs_style_1 .cs_hero_subtitle {
  max-width: 700px;
  margin-bottom: 110px;
}
@media (max-width: 1700px) {
  .cs_hero.cs_style_1 .cs_hero_subtitle {
    max-width: 600px;
  }
}
@media (max-width: 1199px) {
  .cs_hero.cs_style_1 .cs_hero_subtitle {
    max-width: 580px;
  }
}
@media (max-width: 991px) {
  .cs_hero.cs_style_1 .cs_hero_subtitle {
    margin-bottom: 35px;
  }
}
.cs_hero.cs_style_1 .cs_hero_info_wrap {
  padding: 70px 140px;
  margin-bottom: -110px;
  flex-wrap: wrap;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 30px;
  position: relative;
  z-index: 2;
}
@media (max-width: 1700px) {
  .cs_hero.cs_style_1 .cs_hero_info_wrap {
    padding: 70px;
  }
}
@media (max-width: 1199px) {
  .cs_hero.cs_style_1 .cs_hero_info_wrap {
    padding: 70px 25px;
    gap: 24px;
  }
}
@media (max-width: 991px) {
  .cs_hero.cs_style_1 .cs_hero_info_wrap {
    justify-content: center;
  }
}
@media (max-width: 767px) {
  .cs_hero.cs_style_1 .cs_hero_info_wrap {
    justify-content: space-between;
  }
}
@media (max-width: 575px) {
  .cs_hero.cs_style_1 .cs_hero_info_wrap {
    flex-direction: column;
    align-items: flex-start;
    padding: 40px 25px;
  }
}
.cs_hero.cs_style_1 .cs_hero_info_title {
  font-size: 16px;
  line-height: 1.6em;
  margin-bottom: 4px;
}
.cs_hero.cs_style_1 .cs_hero_info_subtitle {
  line-height: 1.3em;
  margin: 0;
}
.cs_hero.cs_style_1 .cs_hero_info_icon {
  height: 70px;
  width: 70px;
  padding: 18px;
}
@media (max-width: 1199px) {
  .cs_hero.cs_style_1 .cs_hero_info_icon {
    height: 60px;
    width: 60px;
    padding: 15px;
  }
}
.cs_hero.cs_style_1 .cs_hero_info_icon img {
  filter: brightness(0) invert(1);
}
.cs_hero.cs_style_1 .cs_hero_info {
  gap: 24px;
}
@media (max-width: 1199px) {
  .cs_hero.cs_style_1 .cs_hero_info {
    gap: 15px;
  }
}
.cs_hero.cs_style_1 .cs_hero_img {
  position: absolute;
  bottom: -10px;
  right: 6%;
  max-height: 86%;
}
@media (max-width: 1700px) {
  .cs_hero.cs_style_1 .cs_hero_img {
    right: 4%;
    max-height: 84%;
  }
}
@media (max-width: 1480px) {
  .cs_hero.cs_style_1 .cs_hero_img {
    right: 1%;
  }
}
@media (max-width: 1300px) {
  .cs_hero.cs_style_1 .cs_hero_img {
    max-height: 82%;
    right: 0;
  }
}
@media (max-width: 1199px) {
  .cs_hero.cs_style_1 .cs_hero_img {
    max-height: 72%;
  }
}
@media (max-width: 991px) {
  .cs_hero.cs_style_1 .cs_hero_img {
    max-height: 100%;
    position: initial;
    margin-bottom: -100px;
    margin-top: 20px;
  }
}
@media (max-width: 575px) {
  .cs_hero.cs_style_1 .cs_hero_img {
    margin-bottom: -55px;
  }
}
.cs_hero.cs_style_1 .cs_hero_patents {
  position: absolute;
  left: 39.3%;
  top: 58.5%;
}
@media (max-width: 1700px) {
  .cs_hero.cs_style_1 .cs_hero_patents {
    left: 33%;
  }
}

.cs_hero.cs_style_2 {
  height: 100vh;
  min-height: 750px;
  max-height: 1080px;
  padding: 218px 0 0;
  position: relative;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  background-color: #35546c;
}
@media (max-width: 1700px) {
  .cs_hero.cs_style_2 {
    padding: 190px 0 0;
  }
}
@media (max-width: 1380px) {
  .cs_hero.cs_style_2 {
    padding-top: 170px;
  }
}
@media (max-width: 1199px) {
  .cs_hero.cs_style_2 {
    min-height: initial;
    height: initial;
    max-height: initial;
    padding-top: 150px;
  }
}
.cs_hero.cs_style_2 .cs_hero_text {
  position: relative;
  z-index: 2;
}
@media (max-width: 1199px) {
  .cs_hero.cs_style_2 .cs_hero_text {
    margin-bottom: 60px;
  }
}
@media (max-width: 767px) {
  .cs_hero.cs_style_2 .cs_hero_text {
    margin-bottom: 40px;
  }
}
.cs_hero.cs_style_2 > .container:first-child {
  flex: 1 1;
  position: relative;
}
.cs_hero.cs_style_2 .cs_hero_bottom {
  display: flex;
  gap: 0 50px;
  min-height: 100px;
}
@media (max-width: 1380px) {
  .cs_hero.cs_style_2 .cs_hero_bottom {
    flex-direction: column;
    gap: 40px 0;
  }
}
.cs_hero.cs_style_2 .cs_hero_bottom_left {
  flex: none;
  width: 350px;
}
@media (max-width: 1700px) {
  .cs_hero.cs_style_2 .cs_hero_bottom_left {
    width: 280px;
  }
}
.cs_hero.cs_style_2 .cs_hero_title {
  max-width: 900px;
  margin-bottom: 82px;
}
@media (max-width: 1380px) {
  .cs_hero.cs_style_2 .cs_hero_title {
    margin-bottom: 50px;
  }
}
@media (max-width: 767px) {
  .cs_hero.cs_style_2 .cs_hero_title {
    margin-bottom: 20px;
  }
}
.cs_hero.cs_style_2 .cs_hero_text_in {
  display: flex;
  gap: 30px 75px;
}
@media (max-width: 767px) {
  .cs_hero.cs_style_2 .cs_hero_text_in {
    flex-direction: column-reverse;
  }
}
.cs_hero.cs_style_2 .cs_hero_subtitle {
  margin: 0;
  max-width: 500px;
}
.cs_hero.cs_style_2 .cs_hero_patents {
  position: absolute;
  top: -75px;
  right: 0;
  z-index: 1;
  animation: anim-y 5s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
@media (max-width: 1380px) {
  .cs_hero.cs_style_2 .cs_hero_patents {
    top: -40px;
  }
}
@media (max-width: 991px) {
  .cs_hero.cs_style_2 .cs_hero_patents {
    display: none;
  }
}
.cs_hero.cs_style_2 .cs_hero_funfact {
  display: flex;
  max-width: 1210px;
  margin-left: auto;
  position: relative;
  gap: 0 97px;
  justify-content: space-between;
  padding: 57px 0 73px 73px;
}
@media (max-width: 1700px) {
  .cs_hero.cs_style_2 .cs_hero_funfact {
    gap: 0 30px;
    padding: 40px 0 50px 60px;
  }
}
@media (max-width: 1700px) {
  .cs_hero.cs_style_2 .cs_hero_funfact {
    padding: 30px 0 50px 40px;
  }
}
@media (max-width: 991px) {
  .cs_hero.cs_style_2 .cs_hero_funfact {
    flex-wrap: wrap;
    gap: 30px 0px;
    padding: 30px 0 35px 30px;
  }
}
@media (max-width: 575px) {
  .cs_hero.cs_style_2 .cs_hero_funfact {
    padding-left: 0;
  }
}
.cs_hero.cs_style_2 .cs_hero_funfact::before {
  content: "";
  position: absolute;
  height: 100%;
  width: 100vw;
  left: 0;
  top: 0;
  border-radius: 25px 0px 0px 0px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(21.5px);
  box-shadow: 0px 0px 0px 1px rgba(255, 255, 255, 0.4);
}
.cs_hero.cs_style_2 .cs_hero_funfact h3 {
  margin-bottom: 8px;
}
.cs_hero.cs_style_2 .cs_hero_funfact .cs_hero_funfact_col {
  position: relative;
  z-index: 2;
}
@media (max-width: 991px) {
  .cs_hero.cs_style_2 .cs_hero_funfact .cs_hero_funfact_col {
    width: 50%;
    padding: 0 10px;
  }
}
@media (max-width: 450px) {
  .cs_hero.cs_style_2 .cs_hero_funfact .cs_hero_funfact_col h3 {
    font-size: 36px;
  }
}
.cs_hero.cs_style_2 .cs_text_btn_2:hover {
  color: #fff;
}

.cs_hero.cs_style_2.cs_type_1 {
  background: linear-gradient(-89deg, #274760 0.95%, rgba(39, 71, 96, 0.59) 98.78%);
}
.cs_hero.cs_style_2.cs_type_1 .cs_hero_funfact {
  background-color: rgba(39, 71, 96, 0.9);
  width: 100%;
  padding: 57px 60px 73px 60px;
  gap: 0 30px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-bottom: 0;
  border-radius: 25px 25px 0px 0px;
}
@media (max-width: 1700px) {
  .cs_hero.cs_style_2.cs_type_1 .cs_hero_funfact {
    padding: 40px 50px 50px 50px;
  }
}
@media (max-width: 1199px) {
  .cs_hero.cs_style_2.cs_type_1 .cs_hero_funfact {
    padding: 30px 30px 35px 30px;
  }
}
@media (max-width: 991px) {
  .cs_hero.cs_style_2.cs_type_1 .cs_hero_funfact {
    padding: 30px 0px 35px 0px;
    gap: 30px 0px;
  }
}
.cs_hero.cs_style_2.cs_type_1 .cs_hero_funfact:before {
  display: none;
}
.cs_hero.cs_style_2.cs_type_1 .cs_hero_text {
  padding-left: 50%;
}
@media (max-width: 1400px) {
  .cs_hero.cs_style_2.cs_type_1 .cs_hero_text {
    padding-left: 42%;
  }
}
@media (max-width: 1199px) {
  .cs_hero.cs_style_2.cs_type_1 .cs_hero_text {
    padding-left: 0%;
  }
}
@media (max-width: 420px) {
  .cs_hero.cs_style_2.cs_type_1 .cs_hero_text .cd-headline {
    display: block;
  }
}
.cs_hero.cs_style_2.cs_type_1 .cs_hero_img {
  position: absolute;
  bottom: 0;
  width: 50%;
  left: 0;
  text-align: center;
  padding-top: 8%;
  height: 100%;
  padding-left: 15px;
  padding-right: 15px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
@media (max-width: 1400px) {
  .cs_hero.cs_style_2.cs_type_1 .cs_hero_img {
    width: 42%;
  }
}
@media (max-width: 1199px) {
  .cs_hero.cs_style_2.cs_type_1 .cs_hero_img {
    width: 100%;
    position: initial;
    max-width: 600px;
    padding-top: 0;
  }
}
.cs_hero.cs_style_2.cs_type_1 .cs_hero_img img {
  max-height: 100%;
}
.cs_hero.cs_style_2.cs_type_1 .cs_hero_btn {
  flex: none;
}
.cs_hero.cs_style_2.cs_type_1 .cs_hero_title span {
  color: #01AE42;
}

.cs_hero.cs_style_3 {
  height: calc(100vh + 235px);
  max-height: 1350px;
  min-height: 1050px;
  position: relative;
  padding-top: 240px;
  overflow: hidden;
}
@media (max-width: 1380px) {
  .cs_hero.cs_style_3 {
    padding-top: 200px;
  }
}
@media (max-width: 991px) {
  .cs_hero.cs_style_3 {
    padding-top: 160px;
    padding-bottom: 400px;
    min-height: calc(100vh + 210px);
    max-height: initial;
    height: initial;
  }
}
@media (max-width: 991px) {
  .cs_hero.cs_style_3 {
    display: flex;
    align-items: center;
  }
}
@media (max-width: 575px) {
  .cs_hero.cs_style_3 {
    padding-top: 140px;
    min-height: initial;
    max-height: initial;
    height: initial;
  }
  .cs_hero.cs_style_3 .cs_fs_20 {
    font-size: 16px;
  }
}
.cs_hero.cs_style_3 .cs_hero_bg {
  position: absolute;
  height: calc(100% - 235px);
  width: 100%;
  left: 0;
  top: 0;
  display: flex;
  align-items: flex-end;
}
@media (max-width: 991px) {
  .cs_hero.cs_style_3 .cs_hero_bg {
    height: calc(100% - 210px);
  }
}
.cs_hero.cs_style_3 > .container {
  position: relative;
  z-index: 2;
}
.cs_hero.cs_style_3 .cs_hero_title {
  max-width: 1000px;
  margin-bottom: 52px;
}
@media (max-width: 1700px) {
  .cs_hero.cs_style_3 .cs_hero_title {
    max-width: 750px;
  }
}
@media (max-width: 1199px) {
  .cs_hero.cs_style_3 .cs_hero_title {
    max-width: 550px;
  }
}
@media (max-width: 991px) {
  .cs_hero.cs_style_3 .cs_hero_title {
    margin-bottom: 20px;
  }
}
.cs_hero.cs_style_3 .cs_hero_subtitle {
  max-width: 540px;
}
.cs_hero.cs_style_3 .cs_hero_img_1 {
  position: absolute;
  top: 150px;
  right: 90px;
}
@media (max-width: 1700px) {
  .cs_hero.cs_style_3 .cs_hero_img_1 {
    top: 170px;
    right: 70px;
    max-width: 880px;
  }
}
@media (max-width: 1400px) {
  .cs_hero.cs_style_3 .cs_hero_img_1 {
    right: 15px;
    margin-left: 15px;
    max-width: 800px;
  }
}
@media (max-width: 991px) {
  .cs_hero.cs_style_3 .cs_hero_img_1 {
    display: none;
  }
}
.cs_hero.cs_style_3 .cs_hero_img_2 {
  position: absolute;
  right: 5%;
  top: 69%;
  animation: animo-x 7s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
@media (max-width: 1700px) {
  .cs_hero.cs_style_3 .cs_hero_img_2 {
    top: 66%;
  }
}
@media (max-width: 991px) {
  .cs_hero.cs_style_3 .cs_hero_img_2 {
    display: none;
  }
}
.cs_hero.cs_style_3 .cs_hero_img_3 {
  position: absolute;
  right: 38%;
  top: 40%;
  animation: anim-y 5s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
@media (max-width: 1700px) {
  .cs_hero.cs_style_3 .cs_hero_img_3 {
    right: 30%;
  }
}
@media (max-width: 1400px) {
  .cs_hero.cs_style_3 .cs_hero_img_3 {
    top: 50%;
  }
}
@media (max-width: 1380px) {
  .cs_hero.cs_style_3 .cs_hero_img_3 {
    top: 60%;
    right: 34%;
  }
}
@media (max-width: 1199px) {
  .cs_hero.cs_style_3 .cs_hero_img_3 {
    display: none;
  }
}
.cs_hero.cs_style_3 .cs_hero_img_4 {
  position: absolute;
  right: 7%;
  top: 24%;
  animation: zoom-anim 7s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
@media (max-width: 991px) {
  .cs_hero.cs_style_3 .cs_hero_img_4 {
    display: none;
  }
}
.cs_hero.cs_style_3 .cs_hero_card {
  display: inline-block;
  border-radius: 20px;
  background: linear-gradient(163deg, #86bbf1 0%, #d2eaef 100%);
  padding: 30px 40px;
  position: relative;
  bottom: -100px;
  z-index: 2;
}
@media (max-width: 575px) {
  .cs_hero.cs_style_3 .cs_hero_card {
    width: 100%;
    padding: 30px 15px;
  }
}
@media (max-width: 380px) {
  .cs_hero.cs_style_3 .cs_hero_card .cs_fs_24 {
    font-size: 18px;
  }
  .cs_hero.cs_style_3 .cs_hero_card .cs_hero_shedule_list li {
    gap: 8px;
  }
}
.cs_hero.cs_style_3 .cs_hero_card_media {
  display: flex;
  align-items: center;
  margin-bottom: 23px;
}
.cs_hero.cs_style_3 .cs_hero_card_media img {
  flex: none;
  border-radius: 50%;
  width: 63px;
  height: 63px;
  margin-right: 12px;
  object-fit: cover;
}
@media (max-width: 380px) {
  .cs_hero.cs_style_3 .cs_hero_card_media img {
    width: 50px;
    height: 50px;
  }
}
.cs_hero.cs_style_3 .cs_hero_shedule_list {
  list-style: none;
  margin: 0;
  padding: 0;
}
.cs_hero.cs_style_3 .cs_hero_shedule_list li {
  display: flex;
  align-items: center;
  gap: 12px;
}
.cs_hero.cs_style_3 .cs_hero_shedule_list li:not(:last-child) {
  margin-bottom: 3px;
}
.cs_hero.cs_style_3 .cs_hero_shedule_list strong {
  font-weight: 600;
}
.cs_hero.cs_style_3.cs_type_1 {
  height: 100vh;
  min-height: initial;
  max-height: 1050px;
}
@media (max-width: 991px) {
  .cs_hero.cs_style_3.cs_type_1 {
    padding: 150px 0 110px;
  }
}
.cs_hero.cs_style_3.cs_type_1 .cs_hero_bg {
  height: 100%;
}
.cs_hero.cs_style_3.cs_type_1 .cs_hero_bg::before {
  content: "";
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 1;
  background: linear-gradient(90deg, #274760 0%, rgba(48, 123, 196, 0) 100%);
}

.cs_hero.cs_style_4 {
  min-height: 750px;
  position: relative;
  padding: 210px 0 0;
}
@media (max-width: 1700px) {
  .cs_hero.cs_style_4 {
    padding: 190px 0 0;
  }
}
@media (max-width: 1199px) {
  .cs_hero.cs_style_4 {
    padding: 150px 0 0;
  }
}
.cs_hero.cs_style_4 .cs_hero_text {
  max-width: 920px;
  position: relative;
  z-index: 2;
}
.cs_hero.cs_style_4 .cs_hero_title {
  margin-bottom: 40px;
}
@media (max-width: 1199px) {
  .cs_hero.cs_style_4 .cs_hero_title {
    margin-bottom: 20px;
  }
}
.cs_hero.cs_style_4 .cs_hero_subtitle {
  max-width: 700px;
  margin-bottom: 110px;
}
@media (max-width: 1700px) {
  .cs_hero.cs_style_4 .cs_hero_subtitle {
    margin-bottom: 60px;
  }
}
.cs_hero.cs_style_4 .cs_hero_img_1 {
  position: absolute;
  left: 53%;
  top: 50%;
  animation: anim-y 5s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
@media (max-width: 991px) {
  .cs_hero.cs_style_4 .cs_hero_img_1 {
    display: none;
  }
}
.cs_hero.cs_style_4 .cs_hero_img_2 {
  position: absolute;
  right: 3%;
  bottom: 0%;
  animation: animo-x 7s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
@media (max-width: 991px) {
  .cs_hero.cs_style_4 .cs_hero_img_2 {
    display: none;
  }
}
.cs_hero.cs_style_4 .cs_hero_img_3 {
  position: absolute;
  right: 8%;
  top: 22%;
  animation: zoom-anim 7s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
@media (max-width: 991px) {
  .cs_hero.cs_style_4 .cs_hero_img_3 {
    display: none;
  }
}

/*--------------------------------------------------------------
12. Iconbox
----------------------------------------------------------------*/
.cs_iconbox.cs_style_1 {
  padding: 25px 30px 40px 30px;
  height: 100%;
}
@media (max-width: 1700px) {
  .cs_iconbox.cs_style_1 {
    padding: 25px 20px 30px 20px;
  }
}
@media (max-width: 1280px) {
  .cs_iconbox.cs_style_1 {
    padding: 25px 25px 30px 25px;
  }
}
@media (max-width: 991px) {
  .cs_iconbox.cs_style_1 .cs_fs_20 {
    font-size: 20px;
  }
}
@media (max-width: 340px) {
  .cs_iconbox.cs_style_1 .cs_fs_20 {
    font-size: 18px;
  }
}
.cs_iconbox.cs_style_1 .cs_iconbox_icon {
  height: 120px;
  width: 120px;
  flex: none;
  padding: 25px;
  position: relative;
  overflow: hidden;
}
@media (max-width: 1700px) {
  .cs_iconbox.cs_style_1 .cs_iconbox_icon {
    height: 90px;
    width: 90px;
    padding: 15px;
  }
}
.cs_iconbox.cs_style_1 .cs_iconbox_icon img {
  max-height: 100%;
}
.cs_iconbox.cs_style_1 .cs_iconbox_icon:before {
  content: "";
  position: absolute;
  top: 0;
  left: -80%;
  z-index: 2;
  width: 50%;
  height: 100%;
  background: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.13));
  transform: skewX(-25deg);
  z-index: 1;
}
.cs_iconbox.cs_style_1:hover .cs_iconbox_icon:before {
  animation: shine 1.3s;
}
.cs_iconbox.cs_style_1 .cs_iconbox_top {
  display: flex;
  align-items: center;
  gap: 25px;
  margin-bottom: 43px;
  max-width: 340px;
}
@media (max-width: 1700px) {
  .cs_iconbox.cs_style_1 .cs_iconbox_top {
    gap: 15px;
    margin-bottom: 30px;
  }
  .cs_iconbox.cs_style_1 .cs_iconbox_top .cs_iconbox_title {
    line-height: 1.4em;
  }
}
@media (max-width: 991px) {
  .cs_iconbox.cs_style_1 .cs_iconbox_top {
    margin-bottom: 20px;
  }
}
.cs_iconbox.cs_style_1 .cs_iconbox_text {
  padding-left: 14px;
  margin: 0;
}
@media (max-width: 1199px) {
  .cs_iconbox.cs_style_1 .cs_iconbox_text {
    padding-left: 0;
  }
}

@keyframes shine {
  100% {
    left: 125%;
  }
}
.cs_iconbox.cs_style_2 {
  display: flex;
  align-items: center;
  min-height: 250px;
  gap: 60px;
  border-radius: 20px;
  border: 1px solid #01AE42;
  padding: 40px 70px;
  margin-bottom: 60px;
  transition: all 0.4s ease;
}
@media (max-width: 1700px) {
  .cs_iconbox.cs_style_2 {
    min-height: 220px;
    gap: 30px;
    padding: 40px;
    margin-bottom: 50px;
  }
}
@media (max-width: 1700px) {
  .cs_iconbox.cs_style_2 {
    min-height: 200px;
    margin-bottom: 25px;
  }
}
@media (max-width: 450px) {
  .cs_iconbox.cs_style_2 {
    min-height: 150px;
    gap: 25px;
    padding: 35px;
  }
}
.cs_iconbox.cs_style_2 .cs_iconbox_title {
  transition: all 0.4s ease;
}
.cs_iconbox.cs_style_2 img {
  transition: all 0.4s ease;
  color: #01AE42;
}
@media (max-width: 350px) {
  .cs_iconbox.cs_style_2 img {
    max-width: 65px;
  }
}
.cs_iconbox.cs_style_2 .cs_iconbox_icon {
  flex: none;
}
.cs_iconbox.cs_style_2:hover {
  background-color: #01AE42;
  box-shadow: 6px 4px 70px 8px rgba(1, 174, 66, 0.09);
}
.cs_iconbox.cs_style_2:hover .cs_iconbox_title {
  color: #fff;
}
.cs_iconbox.cs_style_2:hover img {
  filter: brightness(0) invert(1);
}

.cs_iconbox.cs_style_3 {
  display: flex;
  position: relative;
}
@media (max-width: 991px) {
  .cs_iconbox.cs_style_3 {
    gap: 0 20px;
  }
}
@media (max-width: 420px) {
  .cs_iconbox.cs_style_3 {
    flex-direction: column;
  }
}
.cs_iconbox.cs_style_3::before {
  content: "";
  position: absolute;
  width: 9px;
  height: calc(100% + 50px);
  background-color: #01AE42;
  left: 50%;
  margin-left: -4px;
  margin-top: -25px;
  transition: all 0.4s ease;
  opacity: 0;
}
@media (max-width: 991px) {
  .cs_iconbox.cs_style_3::before {
    display: none;
  }
}
.cs_iconbox.cs_style_3 .cs_iconbox_left,
.cs_iconbox.cs_style_3 .cs_iconbox_right {
  width: 50%;
  flex: none;
}
@media (max-width: 991px) {
  .cs_iconbox.cs_style_3 .cs_iconbox_left,
  .cs_iconbox.cs_style_3 .cs_iconbox_right {
    width: initial;
    flex: initial;
  }
}
.cs_iconbox.cs_style_3 .cs_iconbox_left {
  padding-right: 120px;
}
@media (max-width: 991px) {
  .cs_iconbox.cs_style_3 .cs_iconbox_left {
    padding-right: 0;
    padding-top: 10px;
  }
}
.cs_iconbox.cs_style_3 .cs_iconbox_right {
  padding-left: 200px;
  position: relative;
}
@media (max-width: 1400px) {
  .cs_iconbox.cs_style_3 .cs_iconbox_right br {
    display: none;
  }
}
@media (max-width: 991px) {
  .cs_iconbox.cs_style_3 .cs_iconbox_right {
    padding-left: 0;
  }
}
.cs_iconbox.cs_style_3 .cs_iconbox_number {
  font-size: 72px;
  color: rgba(1, 174, 66, 0.08);
  line-height: 1.14;
  position: absolute;
  left: 84px;
  top: -20px;
}
@media (max-width: 991px) {
  .cs_iconbox.cs_style_3 .cs_iconbox_number {
    position: initial;
    font-size: 56px;
    margin-bottom: 10px;
  }
}
@media (max-width: 420px) {
  .cs_iconbox.cs_style_3 .cs_iconbox_number {
    display: none;
  }
}
.cs_iconbox.cs_style_3 .cs_iconbox_icon {
  height: 136px;
  width: 136px;
  background: rgba(1, 174, 66, 0.17);
  margin-left: auto;
  transition: all 0.4s ease;
  padding: 25px;
}
@media (max-width: 991px) {
  .cs_iconbox.cs_style_3 .cs_iconbox_icon {
    height: 100px;
    width: 100px;
  }
}
@media (max-width: 420px) {
  .cs_iconbox.cs_style_3 .cs_iconbox_icon {
    height: 80px;
    width: 80px;
    margin-left: initial;
    padding: 20px;
    margin-bottom: 20px;
  }
}
.cs_iconbox.cs_style_3 .cs_iconbox_title {
  margin-bottom: 20px;
}
@media (max-width: 420px) {
  .cs_iconbox.cs_style_3 .cs_iconbox_title {
    margin-bottom: 10px;
  }
}
.cs_iconbox.cs_style_3:hover::before {
  opacity: 1;
}
.cs_iconbox.cs_style_3:hover .cs_iconbox_icon {
  background-color: #01AE42;
}

.cs_iconbox_3_wrap {
  position: relative;
}
.cs_iconbox_3_wrap::before {
  content: "";
  position: absolute;
  left: 50%;
  top: 0;
  height: 100%;
  width: 1px;
  background-color: #0171CE;
}
@media (max-width: 991px) {
  .cs_iconbox_3_wrap::before {
    display: none;
  }
}
.cs_iconbox_3_wrap .cs_iconbox.cs_style_3:not(:last-child) {
  margin-bottom: 146px;
}
@media (max-width: 991px) {
  .cs_iconbox_3_wrap .cs_iconbox.cs_style_3:not(:last-child) {
    margin-bottom: 50px;
  }
}
.cs_iconbox_3_wrap .cs_iconbox.cs_style_3:nth-child(even) {
  flex-direction: row-reverse;
}
@media (max-width: 991px) {
  .cs_iconbox_3_wrap .cs_iconbox.cs_style_3:nth-child(even) {
    flex-direction: row;
  }
}
@media (max-width: 420px) {
  .cs_iconbox_3_wrap .cs_iconbox.cs_style_3:nth-child(even) {
    flex-direction: column;
  }
}
.cs_iconbox_3_wrap .cs_iconbox.cs_style_3:nth-child(even) .cs_iconbox_left {
  padding-right: 0px;
  padding-left: 120px;
}
@media (max-width: 991px) {
  .cs_iconbox_3_wrap .cs_iconbox.cs_style_3:nth-child(even) .cs_iconbox_left {
    padding-left: 0;
  }
}
.cs_iconbox_3_wrap .cs_iconbox.cs_style_3:nth-child(even) .cs_iconbox_right {
  padding-right: 200px;
  padding-left: 0;
  text-align: right;
}
@media (max-width: 991px) {
  .cs_iconbox_3_wrap .cs_iconbox.cs_style_3:nth-child(even) .cs_iconbox_right {
    padding-right: 0;
    text-align: left;
  }
}
.cs_iconbox_3_wrap .cs_iconbox.cs_style_3:nth-child(even) .cs_iconbox_icon {
  margin-left: initial;
}
.cs_iconbox_3_wrap .cs_iconbox.cs_style_3:nth-child(even) .cs_iconbox_number {
  left: initial;
  right: 84px;
}

.cs_iconbox.cs_style_4,
.cs_iconbox.cs_style_7 {
  border-radius: 20px;
  background: #fff;
  box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);
  transition: all 0.4s ease;
  position: relative;
}
.cs_iconbox.cs_style_4 .cs_iconbox_btn,
.cs_iconbox.cs_style_7 .cs_iconbox_btn {
  width: 90px;
  height: 70px;
  background-color: rgba(1, 174, 66, 0.5);
  border-radius: 10px 0 20px 0;
  position: absolute;
  right: 0;
  bottom: 0;
  overflow: hidden;
}
@media (max-width: 1700px) {
  .cs_iconbox.cs_style_4 .cs_iconbox_btn,
  .cs_iconbox.cs_style_7 .cs_iconbox_btn {
    width: 70px;
    height: 50px;
  }
}
.cs_iconbox.cs_style_4 .cs_iconbox_btn img,
.cs_iconbox.cs_style_7 .cs_iconbox_btn img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.4s ease;
}
.cs_iconbox.cs_style_4 .cs_iconbox_btn img:last-child,
.cs_iconbox.cs_style_7 .cs_iconbox_btn img:last-child {
  left: -50%;
}
.cs_iconbox.cs_style_4 .cs_iconbox_btn:hover,
.cs_iconbox.cs_style_7 .cs_iconbox_btn:hover {
  background-color: #01AE42;
}
.cs_iconbox.cs_style_4:hover .cs_iconbox_btn img:first-child,
.cs_iconbox.cs_style_7:hover .cs_iconbox_btn img:first-child {
  left: 150%;
}
.cs_iconbox.cs_style_4:hover .cs_iconbox_btn img:last-child,
.cs_iconbox.cs_style_7:hover .cs_iconbox_btn img:last-child {
  left: 50%;
}

.cs_iconbox.cs_style_4 {
  padding: 30px 110px 32px 40px;
  margin-bottom: 20px;
}
@media (max-width: 1700px) {
  .cs_iconbox.cs_style_4 {
    padding: 30px 90px 50px 25px;
  }
}
@media (max-width: 1400px) {
  .cs_iconbox.cs_style_4 {
    padding: 30px 35px 50px 25px;
  }
}
@media (max-width: 991px) {
  .cs_iconbox.cs_style_4 {
    padding: 30px 25px 70px 25px;
  }
}
.cs_iconbox.cs_style_4 .cs_iconbox_title {
  margin-bottom: 12px;
  min-height: 83px;
}
@media (max-width: 1700px) {
  .cs_iconbox.cs_style_4 .cs_iconbox_title {
    min-height: initial;
  }
}
@media (min-width: 1701px) {
  .cs_iconbox.cs_style_4 .cs_iconbox_subtitle {
    padding-right: 20%;
  }
}
.cs_iconbox.cs_style_4 .cs_iconbox_icon {
  height: 40px;
  width: 40px;
  margin-bottom: 21px;
}

.cs_iconbox.cs_style_5 {
  display: flex;
  gap: 25px;
  align-items: center;
  box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);
  padding: 25px 30px;
}
@media (max-width: 1700px) {
  .cs_iconbox.cs_style_5 {
    padding: 20px;
    gap: 15px;
  }
  .cs_iconbox.cs_style_5 .cs_iconbox_title {
    line-height: 1.3em;
  }
}
.cs_iconbox.cs_style_5 .cs_iconbox_icon {
  flex: none;
  width: 120px;
  height: 120px;
  padding: 18px;
  position: relative;
  overflow: hidden;
}
@media (max-width: 1700px) {
  .cs_iconbox.cs_style_5 .cs_iconbox_icon {
    width: 80px;
    height: 80px;
    padding: 20px;
  }
}
.cs_iconbox.cs_style_5 .cs_iconbox_icon:before {
  content: "";
  position: absolute;
  top: 0;
  left: -80%;
  z-index: 2;
  width: 50%;
  height: 100%;
  background: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.13));
  transform: skewX(-25deg);
  z-index: 1;
}
.cs_iconbox.cs_style_5:hover .cs_iconbox_icon:before {
  animation: shine 1.3s;
}

.cs_iconbox.cs_style_6 .cs_iconbox_icon {
  height: 40px;
  width: 40px;
  margin-bottom: 18px;
  padding: 8px;
}
.cs_iconbox.cs_style_6 .cs_iconbox_icon img {
  max-height: 100%;
}
.cs_iconbox.cs_style_6 .cs_iconbox_title {
  margin-bottom: 12px;
}
@media (max-width: 1700px) {
  .cs_iconbox.cs_style_6 br {
    display: none;
  }
}

.cs_iconbox.cs_style_7 {
  padding: 48px 80px 88px 130px;
  margin-bottom: 50px;
}
@media (max-width: 1700px) {
  .cs_iconbox.cs_style_7 {
    padding: 48px 50px 88px 130px;
  }
}
@media (max-width: 1400px) {
  .cs_iconbox.cs_style_7 {
    padding: 40px 30px 88px 100px;
  }
}
@media (max-width: 991px) {
  .cs_iconbox.cs_style_7 {
    margin-bottom: 25px;
    padding: 30px 30px 70px 100px;
  }
}
.cs_iconbox.cs_style_7 .cs_iconbox_title {
  margin-bottom: 18px;
}
.cs_iconbox.cs_style_7 .cs_iconbox_icon {
  position: absolute;
  top: 56px;
  left: 34px;
}
@media (max-width: 1400px) {
  .cs_iconbox.cs_style_7 .cs_iconbox_icon {
    top: 50px;
    left: 25px;
    max-width: 54px;
  }
}
@media (max-width: 991px) {
  .cs_iconbox.cs_style_7 .cs_iconbox_icon {
    top: 40px;
  }
}
.cs_iconbox.cs_style_7::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  border-radius: inherit;
  background: linear-gradient(154deg, #d2eaef 0%, #86bbf1 100%);
  height: 100%;
  width: 100%;
  transition: all 0.4s ease;
  opacity: 0;
}
.cs_iconbox.cs_style_7 .cs_iconbox_title,
.cs_iconbox.cs_style_7 .cs_iconbox_subtitle {
  position: relative;
  z-index: 2;
}
.cs_iconbox.cs_style_7:hover::before {
  opacity: 1;
}

.cs_iconbox.cs_style_8 {
  padding: 72px 41px 66px;
  transition: all 0.4s ease;
}
@media (max-width: 1700px) {
  .cs_iconbox.cs_style_8 {
    padding: 55px 26px 50px;
  }
}
@media (max-width: 1400px) {
  .cs_iconbox.cs_style_8 {
    padding: 30px 15px;
  }
}
.cs_iconbox.cs_style_8 .cs_iconbox_title {
  margin-bottom: 12px;
  color: #fff;
  transition: all 0.3s ease;
}
.cs_iconbox.cs_style_8 .cs_iconbox_subtitle {
  color: #fff;
  transition: all 0.3s ease;
}
.cs_iconbox.cs_style_8 .cs_iconbox_icon {
  height: 72px;
  width: 72px;
  border: 1px solid #01AE42;
  margin-bottom: 25px;
  margin-left: auto;
  margin-right: auto;
}
.cs_iconbox.cs_style_8:hover {
  background-color: #fff;
  box-shadow: 6px 4px 70px 8px rgba(48, 123, 196, 0.09);
  transform: translateY(-30px);
}
.cs_iconbox.cs_style_8:hover .cs_iconbox_title,
.cs_iconbox.cs_style_8:hover .cs_iconbox_subtitle {
  color: #0171CE;
}

.cs_iconbox_8_wrap {
  background: linear-gradient(172deg, #d2eaef 0%, #86bbf1 100%);
}
@media (max-width: 1400px) {
  .cs_iconbox_8_wrap {
    padding: 40px 15px;
  }
}

.cs_iconbox.cs_style_9 {
  background: linear-gradient(154deg, #d2eaef 0%, #86bbf1 100%);
  padding: 40px 25px;
  transition: all 0.4s ease;
  margin-bottom: 24px;
  min-height: 290px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
@media (max-width: 1700px) {
  .cs_iconbox.cs_style_9 {
    min-height: 250px;
    padding: 25px 15px;
  }
}
@media (max-width: 991px) {
  .cs_iconbox.cs_style_9 {
    min-height: 250px;
    padding: 25px 25px;
  }
}
.cs_iconbox.cs_style_9:hover {
  transform: scale(1.04);
}
.cs_iconbox.cs_style_9 .cs_iconbox_title {
  margin-top: 20px;
}

.cs_iconbox.cs_style_10 {
  padding: 55px 50px;
  box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);
  transition: all 0.4s ease;
}
.cs_iconbox.cs_style_10:hover {
  transform: translateY(-30px);
  box-shadow: 6px 4px 70px 8px rgba(48, 123, 196, 0.09);
}
.cs_iconbox.cs_style_10 .cs_iconbox_title {
  margin-bottom: 20px;
}
.cs_iconbox.cs_style_10 .cs_iconbox_icon {
  height: 111px;
  width: 111px;
  padding: 10px;
  border: 1px solid #01AE42;
  margin-bottom: 24px;
  margin-left: auto;
  margin-right: auto;
}
@media (max-width: 575px) {
  .cs_iconbox.cs_style_10 {
    padding: 40px 25px;
  }
}
@media (max-width: 340px) {
  .cs_iconbox.cs_style_10 {
    padding: 40px 20px;
  }
}

.cs_iconbox.cs_style_11 {
  display: flex;
  align-items: center;
  background-color: rgba(210, 234, 239, 0.5);
  padding: 38px 54px;
  gap: 30px;
}
@media (max-width: 1700px) {
  .cs_iconbox.cs_style_11 {
    padding: 30px;
    gap: 20px;
  }
}
@media (max-width: 380px) {
  .cs_iconbox.cs_style_11 {
    padding: 25px 20px;
    gap: 15px;
  }
}
@media (max-width: 330px) {
  .cs_iconbox.cs_style_11 {
    padding: 20px 20px;
    gap: 10px;
  }
}
.cs_iconbox.cs_style_11 .cs_iconbox_icon {
  flex: none;
}
@media (max-width: 1700px) {
  .cs_iconbox.cs_style_11 .cs_iconbox_icon {
    max-width: 60px;
  }
}
@media (max-width: 380px) {
  .cs_iconbox.cs_style_11 .cs_iconbox_icon {
    max-width: 40px;
  }
}
@media (max-width: 330px) {
  .cs_iconbox.cs_style_11 .cs_iconbox_icon {
    max-width: 35px;
  }
}
.cs_iconbox.cs_style_11 .cs_iconbox_right {
  flex: 1 1;
}

.cs_iconbox.cs_style_12 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 40px;
}
@media (max-width: 1400px) {
  .cs_iconbox.cs_style_12 {
    gap: 20px;
  }
}
@media (max-width: 575px) {
  .cs_iconbox.cs_style_12 {
    flex-direction: column-reverse;
    align-items: flex-start;
    gap: 15px;
  }
}
.cs_iconbox.cs_style_12 .cs_iconbox_icon {
  flex: none;
  width: 160px;
  height: 160px;
  border-radius: 50%;
  padding: 35px;
  background-color: #86bbf1;
  transition: all 0.4s ease;
}
.cs_iconbox.cs_style_12 .cs_iconbox_icon img {
  filter: brightness(0) invert(1);
}
@media (max-width: 1400px) {
  .cs_iconbox.cs_style_12 .cs_iconbox_icon {
    width: 120px;
    height: 120px;
    padding: 30px;
  }
}
@media (max-width: 575px) {
  .cs_iconbox.cs_style_12 .cs_iconbox_icon {
    width: 80px;
    height: 80px;
    padding: 20px;
  }
}
.cs_iconbox.cs_style_12 .cs_iconbox_circle {
  display: block;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  margin-bottom: 28px;
}
@media (max-width: 1400px) {
  .cs_iconbox.cs_style_12 .cs_iconbox_circle {
    margin-bottom: 15px;
  }
}
@media (max-width: 991px) {
  .cs_iconbox.cs_style_12 .cs_iconbox_circle {
    display: none;
  }
}
.cs_iconbox.cs_style_12 .cs_iconbox_title {
  margin-bottom: 16px;
}
@media (max-width: 1400px) {
  .cs_iconbox.cs_style_12 .cs_iconbox_title {
    margin-bottom: 8px;
  }
}
.cs_iconbox.cs_style_12 .cs_iconbox_info {
  max-width: 440px;
  padding: 30px;
  transition: all 0.4s ease;
}
@media (max-width: 1400px) {
  .cs_iconbox.cs_style_12 .cs_iconbox_info {
    padding: 25px;
  }
}
@media (max-width: 575px) {
  .cs_iconbox.cs_style_12 .cs_iconbox_info {
    padding: 0px;
    box-shadow: none;
  }
}
.cs_iconbox.cs_style_12:hover .cs_iconbox_icon {
  background-color: #01AE42;
}
@media (min-width: 575px) {
  .cs_iconbox.cs_style_12:hover .cs_iconbox_info {
    background-color: #fff;
    box-shadow: 6px 4px 70px 8px rgba(48, 123, 196, 0.09);
  }
}

.cs_iconbox_12_wrap {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0 50px;
}
@media (max-width: 991px) {
  .cs_iconbox_12_wrap {
    grid-template-columns: repeat(1, 1fr);
  }
}
@media (max-width: 575px) {
  .cs_iconbox_12_wrap {
    gap: 35px;
  }
}
.cs_iconbox_12_wrap > * {
  display: flex;
  align-items: center;
}
.cs_iconbox_12_wrap > * > * {
  width: 100%;
}
.cs_iconbox_12_wrap > *:nth-child(even) .cs_iconbox.cs_style_12 {
  flex-direction: row-reverse;
}
@media (max-width: 575px) {
  .cs_iconbox_12_wrap > *:nth-child(even) .cs_iconbox.cs_style_12 {
    flex-direction: column-reverse;
  }
}

.cs_iconbox.cs_style_13 {
  background-color: #fff;
  box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);
  margin-top: 60px;
  padding: 1px 25px 32px;
}
.cs_iconbox.cs_style_13 .cs_iconbox_title {
  margin-bottom: 18px;
}
.cs_iconbox.cs_style_13 .cs_iconbox_icon {
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);
  height: 120px;
  width: 120px;
  padding: 10px;
  margin-left: auto;
  margin-right: auto;
  margin-top: -60px;
  margin-bottom: 32px;
}
.cs_iconbox.cs_style_13 .cs_iconbox_icon_in {
  height: 100%;
  width: 100%;
  border-radius: inherit;
  padding: 20px;
}

/*--------------------------------------------------------------
13. Posts
----------------------------------------------------------------*/
.cs_post.cs_style_1 {
  box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);
  border-radius: 20px;
  overflow: hidden;
  background-color: #fff;
  transition: all 0.4s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.cs_post.cs_style_1:hover {
  transform: translateY(-20px);
  box-shadow: 6px 4px 70px 8px rgba(48, 123, 196, 0.09);
}
.cs_post.cs_style_1 .cs_post_thumb {
  display: block;
  width: 100%;
}
.cs_post.cs_style_1 .cs_post_thumb img {
  width: 100%;
  border-radius: 20px;
}
.cs_post.cs_style_1 .cs_post_info {
  padding: 30px 40px 40px;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
@media (max-width: 991px) {
  .cs_post.cs_style_1 .cs_post_info {
    padding: 30px 25px 30px;
  }
}
.cs_post.cs_style_1 .cs_post_social {
  display: flex;
  gap: 10px;
}
.cs_post.cs_style_1 .cs_post_social a {
  height: 30px;
  width: 30px;
  border: 1px solid #01AE42;
  color: #01AE42;
  font-size: 14px;
}
.cs_post.cs_style_1 .cs_post_social a:hover {
  background-color: #01AE42;
  color: #fff;
}
.cs_post.cs_style_1 .cs_post_meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 28px;
}
.cs_post.cs_style_1 .cs_post_title {
  margin-bottom: 18px;
}
.cs_post.cs_style_1 .cs_post_btn {
  display: inline-block;
}
.cs_post.cs_style_1 .cs_post_btn:hover {
  text-decoration: underline;
}
.cs_post.cs_style_1.cs_type_1 {
  padding: 28px 28px 0;
}
@media (max-width: 1400px) {
  .cs_post.cs_style_1.cs_type_1 {
    padding: 15px 15px 0;
  }
}
.cs_post.cs_style_1.cs_type_1 .cs_post_title {
  margin: 0;
}
.cs_post.cs_style_1.cs_type_1 .cs_post_info {
  padding: 25px 15px 56px;
}
@media (max-width: 1400px) {
  .cs_post.cs_style_1.cs_type_1 .cs_post_info {
    padding: 25px 0px 30px 10px;
  }
}
.cs_post.cs_style_1.cs_type_2 {
  height: initial;
  display: block;
}
.cs_post.cs_style_1.cs_type_2 .cs_post_thumb img {
  border-radius: 20px 20px 0 0;
}
.cs_post.cs_style_1.cs_type_2 .cs_post_title {
  margin-bottom: 20px;
}
.cs_post.cs_style_1.cs_type_2 .cs_post_info {
  padding: 45px 40px 45px;
}
.cs_post.cs_style_1.cs_type_2 .cs_post_info > div {
  display: flex;
  flex-direction: column-reverse;
}
@media (max-width: 480px) {
  .cs_post.cs_style_1.cs_type_2 .cs_post_info {
    padding: 30px 25px;
  }
}
.cs_post.cs_style_1.cs_type_2 .cs_post_meta {
  margin-bottom: 0;
}
.cs_post.cs_style_1.cs_type_2 .cs_post_thumb {
  height: 381px;
}
@media (max-width: 1700px) {
  .cs_post.cs_style_1.cs_type_2 .cs_post_thumb {
    height: 396px;
  }
}
@media (max-width: 991px) {
  .cs_post.cs_style_1.cs_type_2 .cs_post_thumb {
    height: initial;
  }
}
.cs_post.cs_style_1.cs_type_2 .cs_post_thumb img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.cs_post.cs_style_2 {
  display: flex;
  box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);
  transition: all 0.5s ease;
}
.cs_post.cs_style_2:hover {
  transform: scale(1.03);
}
@media (max-width: 380px) {
  .cs_post.cs_style_2 {
    flex-direction: column;
  }
}
.cs_post.cs_style_2 .cs_post_title {
  margin-bottom: 12px;
}
.cs_post.cs_style_2 .cs_post_info {
  padding: 15px 15px 15px 60px;
  display: flex;
  align-items: center;
}
@media (max-width: 1700px) {
  .cs_post.cs_style_2 .cs_post_info {
    padding-left: 30px;
  }
}
@media (max-width: 575px) {
  .cs_post.cs_style_2 .cs_post_info {
    padding-left: 20px;
  }
}
.cs_post.cs_style_2 .cs_post_thumb {
  flex: none;
  width: 190px;
  min-height: 188px;
}
.cs_post.cs_style_2 .cs_post_thumb img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
@media (max-width: 575px) {
  .cs_post.cs_style_2 .cs_post_thumb {
    width: 150px;
    min-height: 150px;
  }
}
@media (max-width: 380px) {
  .cs_post.cs_style_2 .cs_post_thumb {
    height: 180px;
    width: 180px;
    border-radius: 0 0 20px 0;
    overflow: hidden;
  }
}

.cs_post.cs_style_3 {
  transition: all 0.4s ease;
}
.cs_post.cs_style_3:hover {
  box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);
}
.cs_post.cs_style_3 .cs_post_thumb {
  display: block;
}
.cs_post.cs_style_3 .cs_post_category {
  display: inline-flex;
  border: 1px solid #01AE42;
  padding: 6px 19px;
  border-radius: 20px;
  margin-bottom: 18px;
}
.cs_post.cs_style_3 .cs_post_category:hover {
  background-color: #01AE42;
  color: #fff;
}
.cs_post.cs_style_3 .cs_post_title {
  margin-bottom: 18px;
}
.cs_post.cs_style_3 .cs_posted_by {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #0171CE;
}
.cs_post.cs_style_3 .cs_posted_by i {
  font-size: 18px;
  color: #01AE42;
  display: flex;
}
.cs_post.cs_style_3 .cs_post_info {
  padding: 35px 40px;
}
@media (max-width: 1700px) {
  .cs_post.cs_style_3 .cs_post_info {
    padding: 25px 24px;
  }
}

/*--------------------------------------------------------------
14. Banner
----------------------------------------------------------------*/
.cs_banner.cs_style_1 {
  position: relative;
  padding: 100px 90px;
  border-radius: 25px;
  margin-top: 165px;
}
@media (max-width: 1700px) {
  .cs_banner.cs_style_1 {
    margin-top: 85px;
  }
}
@media (max-width: 1199px) {
  .cs_banner.cs_style_1 {
    margin-top: 0px;
  }
}
@media (max-width: 991px) {
  .cs_banner.cs_style_1 {
    padding: 70px 30px;
  }
}
.cs_banner.cs_style_1 .cs_banner_title {
  max-width: 800px;
  margin-bottom: 24px;
  position: relative;
  z-index: 1;
}
@media (max-width: 1700px) {
  .cs_banner.cs_style_1 .cs_banner_title {
    max-width: 650px;
  }
}
.cs_banner.cs_style_1 .cs_banner_subtitle {
  max-width: 500px;
  position: relative;
  z-index: 1;
}
.cs_banner.cs_style_1 .cs_banner_img {
  position: absolute;
  bottom: -30px;
  right: -15px;
}
@media (max-width: 1700px) {
  .cs_banner.cs_style_1 .cs_banner_img {
    max-width: 535px;
  }
}
@media (max-width: 1199px) {
  .cs_banner.cs_style_1 .cs_banner_img {
    max-height: 100%;
    bottom: 0;
  }
}
@media (max-width: 991px) {
  .cs_banner.cs_style_1 .cs_banner_img {
    display: none;
  }
}

.cs_banner.cs_style_2 {
  padding: 200px 9% 200px 43%;
}
@media (max-width: 1700px) {
  .cs_banner.cs_style_2 {
    padding: 150px 9% 150px 43%;
  }
}
@media (max-width: 1400px) {
  .cs_banner.cs_style_2 {
    padding: 150px 5% 150px 40%;
  }
}
@media (max-width: 1199px) {
  .cs_banner.cs_style_2 {
    padding: 120px 4% 120px 36%;
  }
}
@media (max-width: 991px) {
  .cs_banner.cs_style_2 {
    padding: 80px 30px 80px 25%;
  }
}
@media (max-width: 767px) {
  .cs_banner.cs_style_2 {
    padding: 80px 30px;
    background-position: right center;
  }
  .cs_banner.cs_style_2 br {
    display: none;
  }
}

.cs_banner.cs_style_3,
.cs_banner.cs_style_5 {
  padding: 225px 0 155px;
  min-height: 700px;
  position: relative;
}
@media (max-width: 1700px) {
  .cs_banner.cs_style_3,
  .cs_banner.cs_style_5 {
    min-height: 600px;
  }
}
@media (max-width: 1199px) {
  .cs_banner.cs_style_3,
  .cs_banner.cs_style_5 {
    min-height: 500px;
    padding: 160px 0 125px;
  }
  .cs_banner.cs_style_3 .container,
  .cs_banner.cs_style_5 .container {
    max-width: 100%;
  }
}
@media (max-width: 991px) {
  .cs_banner.cs_style_3,
  .cs_banner.cs_style_5 {
    padding: 155px 0 100px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .cs_banner.cs_style_3 .container,
  .cs_banner.cs_style_5 .container {
    max-width: 720px;
  }
}
@media (max-width: 767px) {
  .cs_banner.cs_style_3 .container,
  .cs_banner.cs_style_5 .container {
    max-width: 540px;
  }
}
.cs_banner.cs_style_3 .cs_banner_title,
.cs_banner.cs_style_5 .cs_banner_title {
  margin-bottom: 25px;
}
@media (max-width: 1199px) {
  .cs_banner.cs_style_3 .cs_banner_title,
  .cs_banner.cs_style_5 .cs_banner_title {
    font-size: 50px;
  }
}
@media (max-width: 575px) {
  .cs_banner.cs_style_3 .cs_banner_title,
  .cs_banner.cs_style_5 .cs_banner_title {
    font-size: 48px;
  }
}
.cs_banner.cs_style_3 .cs_banner_img,
.cs_banner.cs_style_5 .cs_banner_img {
  position: absolute;
  bottom: 0;
  height: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-top: 110px;
}
.cs_banner.cs_style_3 .cs_banner_img img,
.cs_banner.cs_style_5 .cs_banner_img img {
  max-height: 100%;
}
@media (max-width: 991px) {
  .cs_banner.cs_style_3 .cs_banner_img,
  .cs_banner.cs_style_5 .cs_banner_img {
    display: none;
  }
}
.cs_banner.cs_style_3 .cs_banner_text,
.cs_banner.cs_style_5 .cs_banner_text {
  position: relative;
  z-index: 1;
  width: 50%;
}
@media (max-width: 991px) {
  .cs_banner.cs_style_3 .cs_banner_text,
  .cs_banner.cs_style_5 .cs_banner_text {
    width: 100%;
  }
}
@media (max-width: 1400px) {
  .cs_banner.cs_style_3 .cs_fs_20,
  .cs_banner.cs_style_5 .cs_fs_20 {
    font-size: 18px;
  }
}
@media (max-width: 991px) {
  .cs_banner.cs_style_3 .cs_fs_20,
  .cs_banner.cs_style_5 .cs_fs_20 {
    font-size: 16px;
  }
}
@media (max-width: 575px) {
  .cs_banner.cs_style_3 br,
  .cs_banner.cs_style_5 br {
    display: none;
  }
}

.cs_banner.cs_style_3 .cs_banner_img {
  left: 0;
  width: 50%;
  padding-left: 6%;
  padding-right: 12px;
}
@media (max-width: 1700px) {
  .cs_banner.cs_style_3 .cs_banner_img {
    padding-left: 12px;
  }
}
.cs_banner.cs_style_3 .cs_banner_subtitle {
  max-width: 550px;
}
@media (max-width: 991px) {
  .cs_banner.cs_style_3 .cs_banner_subtitle {
    margin-left: auto;
    margin-right: auto;
  }
}
@media (min-width: 991px) {
  .cs_banner.cs_style_3 .cs_banner_text {
    margin-left: auto;
  }
}

.cs_banner.cs_style_4 {
  position: relative;
  box-shadow: 6px 4px 70px 8px rgba(48, 123, 196, 0.09);
  padding: 280px 130px 340px;
  border-radius: 30px 30px 0 0;
}
@media (max-width: 1700px) {
  .cs_banner.cs_style_4 {
    padding: 140px 130px 340px;
  }
}
@media (max-width: 991px) {
  .cs_banner.cs_style_4 {
    padding: 120px 30px 250px;
  }
}
@media (max-width: 767px) {
  .cs_banner.cs_style_4 br {
    display: none;
  }
}
.cs_banner.cs_style_4 > * {
  position: relative;
  z-index: 2;
}
.cs_banner.cs_style_4 .cs_banner_title {
  margin-bottom: 12px;
}

.cs_banner.cs_style_5 .cs_banner_img {
  right: 0;
  width: 50%;
  padding-left: 12px;
  padding-right: 5%;
}
@media (max-width: 1700px) {
  .cs_banner.cs_style_5 .cs_banner_img {
    padding-right: 12px;
  }
}
@media (max-width: 1199px) {
  .cs_banner.cs_style_5 .cs_banner_img {
    width: 56%;
  }
}

.cs_banner.cs_style_6 {
  position: relative;
  padding: 86px 70px 350px 50.4%;
  box-shadow: 6px 4px 70px 8px rgba(48, 123, 196, 0.09);
  margin-top: 100px;
}
@media (max-width: 1700px) {
  .cs_banner.cs_style_6 {
    margin-top: 35px;
  }
}
@media (max-width: 1400px) {
  .cs_banner.cs_style_6 {
    padding: 86px 70px 350px 44%;
    margin-top: 0;
  }
}
@media (max-width: 1199px) {
  .cs_banner.cs_style_6 {
    padding: 80px 30px 340px 36%;
  }
}
@media (max-width: 991px) {
  .cs_banner.cs_style_6 {
    padding: 70px 30px 240px 30px;
  }
}
@media (max-width: 767px) {
  .cs_banner.cs_style_6 br {
    display: none;
  }
}
.cs_banner.cs_style_6 .cs_banner_title {
  margin-bottom: 22px;
  position: relative;
  z-index: 1;
}
.cs_banner.cs_style_6 .cs_banner_subtitle {
  position: relative;
  z-index: 1;
}
.cs_banner.cs_style_6 .cs_banner_img {
  left: -10px;
  bottom: 30px;
  position: absolute;
}
@media (max-width: 1700px) {
  .cs_banner.cs_style_6 .cs_banner_img {
    max-width: 670px;
  }
}
@media (max-width: 1400px) {
  .cs_banner.cs_style_6 .cs_banner_img {
    max-width: 610px;
    left: -100px;
  }
}
@media (max-width: 1199px) {
  .cs_banner.cs_style_6 .cs_banner_img {
    max-width: 560px;
    left: -130px;
  }
}
@media (max-width: 991px) {
  .cs_banner.cs_style_6 .cs_banner_img {
    display: none;
  }
}

.cs_banner.cs_style_7 {
  padding: 77px 50px 405px;
  box-shadow: 6px 4px 70px 8px rgba(48, 123, 196, 0.09);
  position: relative;
  margin-top: 390px;
}
@media (max-width: 991px) {
  .cs_banner.cs_style_7 {
    padding: 70px 25px 245px;
    margin-top: 305px;
  }
}
@media (max-width: 767px) {
  .cs_banner.cs_style_7 {
    margin-top: 0;
  }
  .cs_banner.cs_style_7 br {
    display: none;
  }
}
.cs_banner.cs_style_7 .cs_banner_img {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -390px;
  z-index: -1;
}
@media (max-width: 991px) {
  .cs_banner.cs_style_7 .cs_banner_img {
    top: -310px;
  }
}
@media (max-width: 767px) {
  .cs_banner.cs_style_7 .cs_banner_img {
    display: none;
  }
}

.cs_banner_8_wrap {
  position: relative;
}
.cs_banner_8_wrap::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  height: 50%;
  width: 100%;
  background-color: #fff;
}

.cs_banner.cs_style_8 {
  position: relative;
  padding: 127px 100px 146px;
  z-index: 2;
  margin-top: 75px;
}
@media (max-width: 1700px) {
  .cs_banner.cs_style_8 {
    margin-top: 0;
    padding: 110px 80px 110px;
  }
}
@media (max-width: 1400px) {
  .cs_banner.cs_style_8 {
    margin-top: 0;
    padding: 90px 60px 90px;
  }
}
@media (max-width: 767px) {
  .cs_banner.cs_style_8 {
    padding: 70px 30px 70px;
  }
}
.cs_banner.cs_style_8 .cs_banner_title {
  margin-bottom: 17px;
}
.cs_banner.cs_style_8 .cs_banner_in {
  max-width: 540px;
  position: relative;
  z-index: 2;
}
.cs_banner.cs_style_8 .cs_banner_img {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 62%;
}
@media (max-width: 1700px) {
  .cs_banner.cs_style_8 .cs_banner_img {
    width: 58%;
  }
}
@media (max-width: 1400px) {
  .cs_banner.cs_style_8 .cs_banner_img {
    width: 55%;
  }
}
@media (max-width: 1199px) {
  .cs_banner.cs_style_8 .cs_banner_img {
    width: 52%;
  }
}
@media (max-width: 991px) {
  .cs_banner.cs_style_8 .cs_banner_img {
    display: none;
  }
}

.cs_banner.cs_style_9 {
  position: relative;
  box-shadow: 6px 4px 70px 8px rgba(48, 123, 196, 0.09);
  padding: 183px 0 382px 130px;
  margin-top: 130px;
}
@media (max-width: 1700px) {
  .cs_banner.cs_style_9 {
    padding: 140px 0 350px 110px;
    margin-top: 80px;
  }
}
@media (max-width: 1199px) {
  .cs_banner.cs_style_9 {
    padding: 100px 0 350px 50px;
    margin-top: 0;
  }
}
@media (max-width: 991px) {
  .cs_banner.cs_style_9 {
    padding: 100px 0 250px 30px;
  }
}
@media (max-width: 767px) {
  .cs_banner.cs_style_9 br {
    display: none;
  }
}
.cs_banner.cs_style_9 .cs_banner_img {
  position: absolute;
  right: 0;
  bottom: 0;
}
@media (max-width: 1700px) {
  .cs_banner.cs_style_9 .cs_banner_img {
    max-width: 500px;
  }
}
@media (max-width: 1199px) {
  .cs_banner.cs_style_9 .cs_banner_img {
    max-width: 400px;
  }
}
@media (max-width: 991px) {
  .cs_banner.cs_style_9 .cs_banner_img {
    display: none;
  }
}
.cs_banner.cs_style_9 .cs_banner_title {
  margin-bottom: 22px;
}
.cs_banner.cs_style_9.cs_type_1 {
  padding: 150px 60px 340px 50%;
  margin: 0;
}
@media (max-width: 1199px) {
  .cs_banner.cs_style_9.cs_type_1 {
    padding: 90px 60px 340px 50%;
  }
}
@media (max-width: 991px) {
  .cs_banner.cs_style_9.cs_type_1 {
    padding: 90px 30px 240px 30px;
  }
}
.cs_banner.cs_style_9.cs_type_1 .cs_banner_img {
  right: initial;
  left: 0;
  max-width: 48%;
}

/*--------------------------------------------------------------
15. Testimonial
----------------------------------------------------------------*/
.cs_testimonial.cs_style_1 {
  line-height: 1.87em;
  position: relative;
}
.cs_testimonial.cs_style_1 > img {
  position: absolute;
  left: -88px;
  top: -37px;
}
@media (max-width: 991px) {
  .cs_testimonial.cs_style_1 > img {
    top: -15px;
    left: -75px;
  }
}
.cs_testimonial.cs_style_1 > p {
  margin-bottom: 30px;
}

.cs_testimonial.cs_style_2 .cs_testimonial_text {
  padding: 80px 80px 80px 144px;
  position: relative;
}
@media (max-width: 1700px) {
  .cs_testimonial.cs_style_2 .cs_testimonial_text {
    padding: 60px 60px 60px 124px;
  }
}
@media (max-width: 575px) {
  .cs_testimonial.cs_style_2 .cs_testimonial_text {
    padding: 80px 25px 50px 45px;
  }
}
.cs_testimonial.cs_style_2 .cs_testimonial_text p {
  margin-bottom: 32px;
}
.cs_testimonial.cs_style_2 .cs_testimonial_text {
  margin-bottom: 35px;
}
.cs_testimonial.cs_style_2 .cs_quote_icon {
  position: absolute;
  left: 60px;
  top: 70px;
}
@media (max-width: 1700px) {
  .cs_testimonial.cs_style_2 .cs_quote_icon {
    left: 40px;
  }
}
@media (max-width: 575px) {
  .cs_testimonial.cs_style_2 .cs_quote_icon {
    left: 25px;
    top: 30px;
  }
}
.cs_testimonial.cs_style_2 .cs_testimonial_meta {
  display: flex;
  gap: 25px 40px;
  align-items: center;
}
@media (max-width: 575px) {
  .cs_testimonial.cs_style_2 .cs_testimonial_meta {
    gap: 20px;
  }
}
.cs_testimonial.cs_style_2 .cs_testimonial_avatar {
  height: 96px;
  width: 96px;
  border-radius: 50%;
}
.cs_testimonial.cs_style_2 .cs_testimonial_avatar img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: inherit;
}

.cs_testimonial.cs_style_3 {
  padding: 1px 82px 42px;
  margin-top: 75px;
}
@media (max-width: 575px) {
  .cs_testimonial.cs_style_3 {
    padding: 1px 20px 30px;
  }
}
.cs_testimonial.cs_style_3 .cs_testimonial_img {
  height: 150px;
  width: 150px;
  margin-left: auto;
  margin-right: auto;
  margin-top: -75px;
  margin-bottom: 24px;
}
.cs_testimonial.cs_style_3 .cs_testimonial_avatar {
  margin-bottom: 10px;
}
.cs_testimonial.cs_style_3 .cs_testimonial_text {
  margin-top: 42px;
}
.cs_testimonial.cs_style_3 .cs_rating {
  margin-left: auto;
  margin-right: auto;
}

.cs_testimonial.cs_style_4 {
  background-color: #fff;
  padding: 50px 30px;
  box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);
  padding: 40px 20px;
}
.cs_testimonial.cs_style_4 .cs_testimonial_meta {
  display: flex;
  align-items: center;
  gap: 25px;
}
.cs_testimonial.cs_style_4 .cs_testimonial_avatar {
  height: 80px;
  width: 80px;
  border-radius: 50%;
  overflow: hidden;
  flex: none;
}
.cs_testimonial.cs_style_4 .cs_testimonial_avatar img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.cs_testimonial.cs_style_4 .cs_testimonial_meta {
  margin-bottom: 32px;
}
.cs_testimonial.cs_style_4 .cs_rating {
  margin-top: 32px;
}

.cs_testimonial_carousel_2 .cs_slider_activate {
  width: 58vw;
}
@media (max-width: 991px) {
  .cs_testimonial_carousel_2 .cs_slider_activate {
    width: 90vw;
  }
}
@media (max-width: 575px) {
  .cs_testimonial_carousel_2 .cs_slider_activate {
    width: 100%;
  }
}
.cs_testimonial_carousel_2 .cs_testimonial.cs_style_4 {
  max-width: 390px;
}
@media (max-width: 420px) {
  .cs_testimonial_carousel_2 .cs_testimonial.cs_style_4 {
    max-width: 300px;
  }
}
.cs_testimonial_carousel_2 .slick-list {
  padding-top: 30px;
  padding-bottom: 30px;
  margin-top: -30px;
  margin-bottom: -30px;
  box-shadow: -10px 0px 30px -20px rgba(48, 123, 196, 0.1);
  border-radius: 60px;
}
.cs_testimonial_carousel_2 .cs_slider_navigation.cs_style_1 {
  justify-content: flex-end;
  margin-top: 0;
}

/*--------------------------------------------------------------
16. Portfolio
----------------------------------------------------------------*/
.cs_portfolio.cs_style_1 {
  height: 429px;
}
@media (max-width: 991px) {
  .cs_portfolio.cs_style_1 {
    height: 350px;
  }
}
.cs_portfolio.cs_style_1 .cs_portfolio_img {
  height: 100%;
  border-radius: inherit;
  position: relative;
}
.cs_portfolio.cs_style_1 .cs_portfolio_img::before {
  content: "";
  background: #01AE42;
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  opacity: 0;
  transition: all 0.3s ease;
}
.cs_portfolio.cs_style_1 .cs_link_hover {
  position: absolute;
  z-index: 2;
  top: -100px;
  right: 50px;
  width: 60px;
  height: 200px;
  background: #01AE42;
  border-radius: 0 0 40px 40px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  opacity: 0;
  transition: all 0.3s ease;
  font-size: 20px;
}
.cs_portfolio.cs_style_1 .cs_link_hover i {
  color: #01AE42;
  background-color: #fff;
  height: 50px;
  width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin-bottom: 5px;
  opacity: 0;
  transform: scale(0.5) rotate(180deg);
  transition: all 0.3s ease;
}
.cs_portfolio.cs_style_1:hover .cs_link_hover {
  opacity: 1;
  top: 0px;
}
.cs_portfolio.cs_style_1:hover .cs_link_hover i {
  opacity: 1;
  transform: scale(1) rotate(0deg);
  transition-delay: 0.15s;
}
.cs_portfolio.cs_style_1:hover .cs_portfolio_img::before {
  opacity: 0.4;
}
.cs_portfolio.cs_style_1.cs_size_1 {
  height: 716px;
}
@media (max-width: 991px) {
  .cs_portfolio.cs_style_1.cs_size_1 {
    height: 607px;
  }
}

/*--------------------------------------------------------------
17. Brands
----------------------------------------------------------------*/
.cs_brands.cs_style_1 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 60px 30px;
}
@media (max-width: 1700px) {
  .cs_brands.cs_style_1 {
    gap: 40px 120px;
  }
}
@media (max-width: 991px) {
  .cs_brands.cs_style_1 {
    gap: 20px 60px;
  }
}
@media (max-width: 767px) {
  .cs_brands.cs_style_1 {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 575px) {
  .cs_brands.cs_style_1 {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 420px) {
  .cs_brands.cs_style_1 {
    gap: 20px 30px;
  }
}

.cs_brands.cs_style_2 {
  padding: 0 20px;
  text-align: center;
  height: 136px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cs_brands.cs_style_3 {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 30px 70px;
  background-color: #fff;
  box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);
  padding: 70px;
}
@media (max-width: 1400px) {
  .cs_brands.cs_style_3 {
    justify-content: center;
  }
}
@media (max-width: 575px) {
  .cs_brands.cs_style_3 {
    gap: 30px;
    padding: 70px 40px;
  }
}

/*--------------------------------------------------------------
18. Accordians
----------------------------------------------------------------*/
.cs_accordians.cs_style1 .cs_accordian {
  border-radius: 25px;
  border: 1px solid #d2eaef;
  background: rgba(39, 71, 96, 0);
  transition: all 0.4s ease;
  width: 100%;
}
@media (max-width: 1700px) {
  .cs_accordians.cs_style1 .cs_accordian {
    border-radius: 15px;
  }
}
.cs_accordians.cs_style1 .cs_accordian:not(:last-child) {
  margin-bottom: 20px;
}
.cs_accordians.cs_style1 .cs_accordian.active {
  background-color: #d2eaef;
  margin-left: 50px;
}
@media (max-width: 991px) {
  .cs_accordians.cs_style1 .cs_accordian.active {
    margin-left: 0;
  }
}
.cs_accordians.cs_style1 .cs_accordian.active .cs_accordian_arrow {
  transform: rotate(180deg);
}
.cs_accordians.cs_style1 .cs_accordian_arrow {
  position: absolute;
  display: flex;
  right: 44px;
  top: 25px;
  height: 28px;
  width: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}
@media (max-width: 1700px) {
  .cs_accordians.cs_style1 .cs_accordian_arrow {
    right: 30px;
    top: 18px;
  }
}
@media (max-width: 991px) {
  .cs_accordians.cs_style1 .cs_accordian_arrow {
    right: 20px;
    top: 15px;
  }
}
.cs_accordians.cs_style1 .cs_accordian_head {
  font-size: 20px;
  line-height: 1.6em;
  font-weight: 500;
  cursor: pointer;
  position: relative;
  padding: 23px 62px 23px 40px;
  margin: 0;
}
@media (max-width: 1700px) {
  .cs_accordians.cs_style1 .cs_accordian_head {
    padding: 16px 62px 16px 30px;
  }
}
@media (max-width: 991px) {
  .cs_accordians.cs_style1 .cs_accordian_head {
    font-size: 18px;
    padding: 14px 55px 14px 20px;
  }
}
.cs_accordians.cs_style1 .cs_accordian_body {
  padding: 0 40px 38px 40px;
}
@media (max-width: 1700px) {
  .cs_accordians.cs_style1 .cs_accordian_body {
    padding: 0 30px 28px 30px;
  }
}
@media (max-width: 991px) {
  .cs_accordians.cs_style1 .cs_accordian_body {
    padding: 0 20px 20px 20px;
  }
}
.cs_accordians.cs_style1 .cs_accordian_body p {
  margin: 0;
}
.cs_accordians.cs_style1.cs_type_1 .cs_accordian {
  box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);
  border-color: transparent;
  background-color: #fff;
}
.cs_accordians.cs_style1.cs_type_1 .cs_accordian.active {
  margin-left: -50px;
}
@media (max-width: 1400px) {
  .cs_accordians.cs_style1.cs_type_1 .cs_accordian.active {
    margin-left: 0;
  }
}
.cs_accordians.cs_style1.cs_type_1 .cs_accordian.active .cs_accordian {
  box-shadow: 6px 4px 70px 8px rgba(48, 123, 196, 0.09);
  background-color: #fff;
}
.cs_accordians.cs_style1.cs_type_2 .cs_accordian {
  border-radius: 0;
  border-left: 0;
  border-right: 0;
  border-color: #01AE42;
  margin-bottom: -1px;
}
.cs_accordians.cs_style1.cs_type_2 .cs_accordian.active {
  background-color: transparent;
  margin-left: 0;
}
.cs_accordians.cs_style1.cs_type_2 .cs_accordian .cs_accordian_arrow {
  right: initial;
  left: 20px;
  top: 32px;
}
.cs_accordians.cs_style1.cs_type_2 .cs_accordian_head {
  padding: 30px 20px 30px 85px;
}
.cs_accordians.cs_style1.cs_type_2 .cs_accordian_body {
  padding: 0 20px 38px 85px;
}
.cs_accordians.cs_style1.cs_type_3 .cs_accordian {
  border-color: #01AE42;
  border-radius: 20px;
}
.cs_accordians.cs_style1.cs_type_3 .cs_accordian.active {
  margin-left: 0px;
  background-color: transparent;
}
.cs_accordians.cs_style1.cs_type_3 .cs_accordian.active .cs_accordian_head {
  background: linear-gradient(119deg, #d2eaef 17.16%, #86bbf1 89.78%);
  border-bottom: 1px solid #01AE42;
  border-radius: 20px 20px 0 0;
}
.cs_accordians.cs_style1.cs_type_3 .cs_accordian_head {
  font-size: 24px;
  padding: 27px 62px 27px 40px;
}
@media (max-width: 1700px) {
  .cs_accordians.cs_style1.cs_type_3 .cs_accordian_head {
    padding: 18px 52px 18px 24px;
  }
}
@media (max-width: 991px) {
  .cs_accordians.cs_style1.cs_type_3 .cs_accordian_head {
    font-size: 20px;
  }
}
.cs_accordians.cs_style1.cs_type_3 .cs_accordian_arrow {
  right: 40px;
  top: 32px;
}
@media (max-width: 1700px) {
  .cs_accordians.cs_style1.cs_type_3 .cs_accordian_arrow {
    right: 24px;
    top: 24px;
  }
}
@media (max-width: 991px) {
  .cs_accordians.cs_style1.cs_type_3 .cs_accordian_arrow {
    top: 20px;
  }
}
.cs_accordians.cs_style1.cs_type_3 .cs_accordian_body {
  padding: 38px 40px;
}
@media (max-width: 1700px) {
  .cs_accordians.cs_style1.cs_type_3 .cs_accordian_body {
    padding: 24px 24px;
  }
}

/*--------------------------------------------------------------
19. Departments
----------------------------------------------------------------*/
.cs_departments.cs_style_1 {
  padding-top: 100px;
  position: relative;
}
.cs_departments.cs_style_1 .cs_department_list {
  position: relative;
  z-index: 1;
  padding: 0 25px;
}
@media (max-width: 991px) {
  .cs_departments.cs_style_1 .cs_department_list {
    padding: 0 15px;
  }
}
@media (max-width: 575px) {
  .cs_departments.cs_style_1 .cs_department_list .cs_slider_navigation.cs_style_1 {
    margin-top: 0;
  }
}
.cs_departments.cs_style_1 .cs_section_heading {
  position: relative;
  z-index: 1;
}
.cs_departments.cs_style_1 .cs_department {
  flex: 1 1;
  text-align: center;
  padding: 30px 30px;
  height: 290px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
@media (max-width: 991px) {
  .cs_departments.cs_style_1 .cs_department {
    height: 250px;
  }
}
@media (max-width: 400px) {
  .cs_departments.cs_style_1 .cs_department {
    padding: 30px 20%;
  }
}
.cs_departments.cs_style_1 .cs_department:hover {
  transform: translateY(-20px);
  background-color: #01AE42;
}
.cs_departments.cs_style_1 .cs_department:hover img {
  filter: brightness(0) invert(1);
}
.cs_departments.cs_style_1 .cs_department:hover .cs_heading_color {
  color: #fff;
}
.cs_departments.cs_style_1 svg {
  transition: all 0.4s ease;
}
.cs_departments.cs_style_1 .cs_department_title {
  margin-top: 20px;
  transition: all 0.4s ease;
}
.cs_departments.cs_style_1 .cs_departments_bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100% - 122px);
}

/*--------------------------------------------------------------
20. About
----------------------------------------------------------------*/
.cs_about.cs_style_1 .cs_about_img {
  position: relative;
}
@media (min-width: 992px) {
  .cs_about.cs_style_1 .cs_about_img {
    padding-right: 70px;
  }
}
.cs_about.cs_style_1 .cs_about_text_list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.cs_about.cs_style_1 .cs_about_text_list li {
  position: relative;
  padding-left: 60px;
}
.cs_about.cs_style_1 .cs_about_text_list li:not(:last-child) {
  margin-bottom: 50px;
}
.cs_about.cs_style_1 .cs_about_text_list li > i {
  position: absolute;
  left: 0;
  top: 5px;
}
@media (max-width: 991px) {
  .cs_about.cs_style_1 .cs_about_text_list li > i {
    top: 2px;
  }
}
.cs_about.cs_style_1 .cs_about_text_list li > h3 {
  margin-bottom: 25px;
}
.cs_about.cs_style_1 .cs_about_mini_img {
  position: absolute;
  top: -75px;
  right: 20%;
}
.cs_about.cs_style_1 .cs_right_icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.cs_about.cs_style_1 .cs_rotate_animation {
  animation: rotate360 15s linear infinite;
}
.cs_about.cs_style_1.cs_type_1 .cs_about_mini_img {
  right: initial;
  top: 44%;
  left: 35%;
}
@media (max-width: 1400px) {
  .cs_about.cs_style_1.cs_type_1 br {
    display: none;
  }
}
.cs_about.cs_style_1.cs_type_2 {
  padding-left: 102px;
}
@media (max-width: 1700px) {
  .cs_about.cs_style_1.cs_type_2 {
    padding-left: 50px;
  }
}
@media (max-width: 1400px) {
  .cs_about.cs_style_1.cs_type_2 {
    padding-left: 0px;
  }
}
.cs_about.cs_style_1.cs_type_2 .cs_about_mini_img {
  top: 50%;
  right: initial;
  left: 50%;
  transform: translate(-50%, -50%);
}
.cs_about.cs_style_1.cs_type_2 .cs_about_img {
  padding-right: 0;
  position: relative;
}

@keyframes rotate360 {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.cs_about.cs_style_2 .cs_about_img {
  padding-left: 80px;
}
@media (max-width: 1700px) {
  .cs_about.cs_style_2 .cs_about_img {
    padding-left: 0;
  }
}
.cs_about.cs_style_2 .cs_section_heading.cs_style_1 p {
  max-width: 580px;
}

.cs_about.cs_style_3 {
  background: linear-gradient(119deg, #d2eaef 17.16%, #86bbf1 89.78%);
}
.cs_about.cs_style_3 .cs_section_heading.cs_style_1 {
  padding: 145px 80px;
}
@media (max-width: 1400px) {
  .cs_about.cs_style_3 .cs_section_heading.cs_style_1 {
    padding: 145px 30px 145px 50px;
  }
}
@media (max-width: 1199px) {
  .cs_about.cs_style_3 .cs_section_heading.cs_style_1 {
    padding: 50px 50px 50px 50px;
  }
}
@media (max-width: 767px) {
  .cs_about.cs_style_3 .cs_section_heading.cs_style_1 {
    padding: 35px 24px 35px 24px;
  }
}
.cs_about.cs_style_3 .cs_about_text {
  height: 100%;
}
@media (max-width: 1199px) {
  .cs_about.cs_style_3 .cs_about_text {
    height: initial;
  }
}
.cs_about.cs_style_3 .cs_about_img {
  height: 100%;
}
.cs_about.cs_style_3 .cs_about_img img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.cs_about.cs_style_3 .cs_section_minititle {
  max-width: 630px;
}
.cs_about.cs_style_3 .cs_support_card {
  border-radius: 50px;
  border: 1px solid #fff;
  background-color: #fff;
  box-shadow: 6px 4px 70px 8px rgba(48, 123, 196, 0.09);
  padding: 20px 30px;
  display: flex;
  align-items: center;
  gap: 14px;
  position: absolute;
  right: -26%;
  bottom: 75px;
}
.cs_about.cs_style_3 .cs_support_card .cs_support_card_icon {
  flex: none;
}
@media (max-width: 1700px) {
  .cs_about.cs_style_3 .cs_support_card {
    right: -34%;
    bottom: 65px;
  }
}
@media (max-width: 1199px) {
  .cs_about.cs_style_3 .cs_support_card {
    position: initial;
    margin-left: 50px;
    margin-right: 50px;
    margin-bottom: 60px;
  }
}
@media (max-width: 1199px) and (max-width: 767px) {
  .cs_about.cs_style_3 .cs_support_card {
    margin-left: 24px;
    margin-right: 24px;
    margin-bottom: 35px;
    padding: 20px 20px;
  }
}

/*--------------------------------------------------------------
21. Team
----------------------------------------------------------------*/
.cs_team.cs_style_1 {
  border-radius: 20px;
  background: linear-gradient(154deg, rgba(210, 234, 239, 0.27) 0%, rgba(134, 187, 241, 0.27) 100%);
  box-shadow: initial;
  transition: all 0.4s ease;
}
.cs_team.cs_style_1:hover {
  box-shadow: 6px 4px 70px 8px rgba(48, 123, 196, 0.09);
}
.cs_team.cs_style_1 .cs_team_meta {
  padding: 32px 40px;
}
@media (max-width: 1400px) {
  .cs_team.cs_style_1 .cs_team_meta {
    padding: 32px 20px;
  }
}
.cs_team.cs_style_1 .cs_member_name {
  margin-bottom: 7px;
}
.cs_team.cs_style_1 .cs_member_designation {
  margin-bottom: 9px;
}
.cs_team.cs_style_1 .cs_member_description {
  margin-bottom: 32px;
}
.cs_team.cs_style_1 .cs_social_links {
  justify-content: center;
}
.cs_team.cs_style_1 .cs_social_links a {
  height: 40px;
  width: 40px;
  background-color: rgba(1, 174, 66, 0.6);
  color: #fff;
  font-size: 18px;
  transform: initial;
}
.cs_team.cs_style_1 .cs_social_links a:hover {
  background-color: #01AE42;
}
.cs_team.cs_style_1 .cs_label {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  padding: 12px 30px;
  text-align: center;
  min-width: 292px;
  border-radius: 20px 20px 0 0;
}
.cs_team.cs_style_1.cs_type_1 {
  background: #fff;
  margin-top: 115px;
  height: initial;
  padding-top: 1px;
}
.cs_team.cs_style_1.cs_type_1 .cs_member_img {
  margin-top: -115px;
}
.cs_team.cs_style_1.cs_type_2 {
  box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);
  margin-bottom: 0px;
}
.cs_team.cs_style_1.cs_type_2 .cs_member_img {
  position: relative;
}
.cs_team.cs_style_1.cs_type_2 .cs_member_name {
  margin-bottom: 5px;
}
.cs_team.cs_style_1.cs_type_2 .cs_member_designation,
.cs_team.cs_style_1.cs_type_2 .cs_member_description {
  margin-bottom: 28px;
}
.cs_team.cs_style_1.cs_type_2 .cs_team_meta {
  padding: 36px 50px 34px;
}
@media (max-width: 1600px) {
  .cs_team.cs_style_1.cs_type_2 .cs_team_meta {
    padding: 36px 40px 34px;
  }
}
@media (max-width: 1400px) {
  .cs_team.cs_style_1.cs_type_2 .cs_team_meta {
    padding: 30px 25px 34px;
  }
}

@media (min-width: 992px) {
  .cs_list_view_wrap .cs_team.cs_style_1.cs_type_2 {
    display: flex;
  }
  .cs_list_view_wrap .cs_team.cs_style_1.cs_type_2 .cs_member_img {
    position: relative;
    flex: none;
    width: 450px;
  }
  .cs_list_view_wrap .cs_team.cs_style_1.cs_type_2 .cs_label {
    position: initial;
    width: 100%;
    transform: initial;
    border-radius: 0;
    padding: 12px 15px;
  }
  .cs_list_view_wrap .cs_team.cs_style_1.cs_type_2 .cs_team_meta {
    display: flex;
    flex-direction: column;
    text-align: left;
    justify-content: center;
    padding-right: 30%;
  }
}
@media (min-width: 992px) and (max-width: 1700px) {
  .cs_list_view_wrap .cs_team.cs_style_1.cs_type_2 .cs_team_meta {
    padding-right: 20%;
  }
}
@media (min-width: 992px) and (max-width: 1700px) {
  .cs_list_view_wrap .cs_team.cs_style_1.cs_type_2 .cs_team_meta {
    padding-right: 30px;
  }
}
@media (min-width: 992px) {
  .cs_list_view_wrap .cs_team.cs_style_1.cs_type_2 .cs_social_links {
    justify-content: flex-start;
  }
}
/*--------------------------------------------------------------
22. Funfact
----------------------------------------------------------------*/
.cs_funfact_1_wrap {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding: 80px 50px 90px;
}
@media (max-width: 1400px) {
  .cs_funfact_1_wrap {
    padding: 60px 30px 70px;
  }
}

.cs_funfact.cs_style_1 {
  max-width: 20%;
  padding: 20px 30px;
}
@media (max-width: 1400px) {
  .cs_funfact.cs_style_1 {
    padding: 10px 15px;
  }
}
@media (max-width: 1199px) {
  .cs_funfact.cs_style_1 {
    padding: 20px 20px;
    max-width: 33.333333%;
  }
}
@media (max-width: 767px) {
  .cs_funfact.cs_style_1 {
    padding: 20px 20px;
    max-width: 50%;
  }
}
@media (max-width: 575px) {
  .cs_funfact.cs_style_1 {
    max-width: 100%;
    padding: 15px 0;
  }
}
.cs_funfact.cs_style_1 {
  flex: none;
}
.cs_funfact.cs_style_1 .cs_funfact_number {
  margin-bottom: 8px;
}

.cs_cta.cs_style_1 {
  padding: 125px 60px 140px 50%;
}
@media (max-width: 1199px) {
  .cs_cta.cs_style_1 {
    padding: 95px 30px 100px 45%;
  }
}
@media (max-width: 767px) {
  .cs_cta.cs_style_1 {
    padding: 95px 30px 100px 35%;
  }
}
@media (max-width: 575px) {
  .cs_cta.cs_style_1 {
    padding: 100px 24px 90px;
  }
}
.cs_cta.cs_style_1 .cs_cta_title,
.cs_cta.cs_style_1 .cs_cta_subtitle {
  margin-bottom: 38px;
}
.cs_cta.cs_style_1 .cs_cta_subtitle {
  max-width: 600px;
}

.cs_pricing_card.cs_style_1 {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.cs_pricing_card.cs_style_1 .cs_pricing_card_head {
  padding: 30px 40px 40px;
}
@media (max-width: 1400px) {
  .cs_pricing_card.cs_style_1 .cs_pricing_card_head {
    padding: 30px 30px 40px;
  }
}
.cs_pricing_card.cs_style_1 .cs_pricing_card_head h3 {
  margin-bottom: 0px;
  border: 1px solid #fff;
  display: inline-flex;
  border-radius: 1.6em;
  background: linear-gradient(119deg, #d2eaef 17.16%, #86bbf1 89.78%);
}
.cs_pricing_card.cs_style_1 .cs_pricing_card_head h3 span {
  display: inline-flex;
  padding: 7px 20px;
  position: relative;
  z-index: 2;
}
.cs_pricing_card.cs_style_1 .cs_pricing_card_head h3 span:first-child {
  border-radius: 1.6em;
  border: 1px solid #fff;
  margin: -1px;
}
.cs_pricing_card.cs_style_1 .cs_pricing_card_head p {
  margin-top: 28px;
  margin-bottom: 0;
}
.cs_pricing_card.cs_style_1 .cs_pricing_card_head h2 {
  margin-top: 40px;
}
.cs_pricing_card.cs_style_1 .cs_pricing_card_body {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 50px 40px 30px;
  border: 1px solid #01AE42;
  border-top: 0;
  border-radius: 0 0 20px 20px;
  gap: 50px;
}
@media (max-width: 1400px) {
  .cs_pricing_card.cs_style_1 .cs_pricing_card_body {
    padding: 40px 24px 30px;
  }
}
.cs_pricing_card.cs_style_1 .cs_pricing_card_feature {
  list-style: none;
  padding: 0;
  margin: 0;
}
.cs_pricing_card.cs_style_1 .cs_pricing_card_feature li {
  position: relative;
  padding-left: 36px;
}
.cs_pricing_card.cs_style_1 .cs_pricing_card_feature li:not(:last-child) {
  margin-bottom: 30px;
}
.cs_pricing_card.cs_style_1 .cs_pricing_card_feature i {
  position: absolute;
  left: 0;
  color: #01AE42;
}

.cs_site_header.cs_style1.cs_active_sticky {
  background-color: #fff;
}

.cs_site_header.cs_style1.cs_white_color.cs_active_sticky {
  background-color: #274760;
}

.cs_accent_bg .cs_social_links_wrap h2,
.cs_site_header.cs_style1.cs_white_color.cs_active_sticky .cs_toolbox {
  color: #fff;
}

.cs_contact_widget i {
  height: 20px;
  width: 20px;
  margin-top: 2px;
  color: #fff;
  padding: 4px;
}

.cs_video_open {
  cursor: pointer;
}

.cs_hero.cs_style_1 .cs_text_btn_2,
.cs_hero.cs_style_1 .cs_hero_title,
.cs_hero.cs_style_1 .cs_hero_subtitle {
  position: relative;
  z-index: 1;
}
.cs_hero.cs_style_1 .cs_hero_text {
  position: initial;
  z-index: initial;
}

.cs_accordian_body_wrap {
  overflow: hidden;
  transition: all 0.4s ease;
}

.cs_tabs.cs_style1 .cs_tab_links .cs_tab_link_in {
  cursor: pointer;
}

.cs_rating i {
  display: flex;
}

.cs_shape_wrap .cs_shape_2 {
  top: -3%;
}

.cs_cs_slider_navigation_1 .cs_slider_next,
.cs_cs_slider_navigation_1 .cs_slider_prev {
  transition: all 0.4s ease;
  cursor: pointer;
  border-radius: 10px;
  padding: 5px;
  height: 60px;
  transform: translateY(-50%);
  background-color: #fff;
  width: 70px;
  box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);
  position: absolute;
  top: 50%;
  display: flex !important;
  z-index: 1;
}
@media (min-width: 991px) {
  .cs_cs_slider_navigation_1 .cs_slider_next,
  .cs_cs_slider_navigation_1 .cs_slider_prev {
    opacity: 0;
  }
}
.cs_cs_slider_navigation_1 .cs_slider_next {
  right: -35px;
}
.cs_cs_slider_navigation_1 .cs_slider_prev {
  left: -35px;
}
.cs_cs_slider_navigation_1:hover .cs_slider_next,
.cs_cs_slider_navigation_1:hover .cs_slider_prev {
  opacity: 1;
}

.cs_cs_slider_navigation_2 .cs_slider_next,
.cs_cs_slider_navigation_2 .cs_slider_prev {
  height: 40px;
  width: 40px;
  border: 2px solid #01AE42;
  border-radius: 50%;
  padding: 8px;
  transition: all 0.4s ease;
  cursor: pointer;
  position: absolute;
  display: flex !important;
  bottom: 0;
}
.cs_cs_slider_navigation_2 .cs_slider_next {
  right: 0;
}
.cs_cs_slider_navigation_2 .cs_slider_prev {
  right: 52px;
}

.cs_cs_slider_navigation_3 .cs_slider_next,
.cs_cs_slider_navigation_3 .cs_slider_prev {
  width: 90px;
  height: 70px;
  background-color: #fff;
  border-radius: 10px;
  padding: 5px;
  transition: all 0.4s ease;
  cursor: pointer;
  display: flex !important;
  position: absolute;
  top: -213px;
}
@media (max-width: 1700px) {
  .cs_cs_slider_navigation_3 .cs_slider_next,
  .cs_cs_slider_navigation_3 .cs_slider_prev {
    width: 80px;
    height: 60px;
    top: -188px;
  }
}
@media (max-width: 991px) {
  .cs_cs_slider_navigation_3 .cs_slider_next,
  .cs_cs_slider_navigation_3 .cs_slider_prev {
    display: none !important;
  }
}
.cs_cs_slider_navigation_3 .cs_slider_next img,
.cs_cs_slider_navigation_3 .cs_slider_prev img {
  transition: inherit;
}
.cs_cs_slider_navigation_3 .cs_slider_next:hover,
.cs_cs_slider_navigation_3 .cs_slider_prev:hover {
  background-color: #01AE42;
}
.cs_cs_slider_navigation_3 .cs_slider_next:hover img,
.cs_cs_slider_navigation_3 .cs_slider_prev:hover img {
  filter: brightness(0) invert(1);
}
.cs_cs_slider_navigation_3 .cs_slider_next {
  right: 0;
}
.cs_cs_slider_navigation_3 .cs_slider_prev {
  right: 115px;
}
@media (max-width: 1700px) {
  .cs_cs_slider_navigation_3 .cs_slider_prev {
    right: 100px;
  }
}
.cs_cs_slider_navigation_3 .slick-dots {
  display: none !important;
}
@media (max-width: 991px) {
  .cs_cs_slider_navigation_3 .slick-dots {
    display: flex !important;
  }
}

.cs_related_doctor {
  padding-bottom: 90px;
}
@media (max-width: 400px) {
  .cs_related_doctor {
    padding-bottom: 75px;
  }
}
.cs_related_doctor .slick-dots {
  bottom: 15px;
}

.cs_gallery_grid_1 {
  display: grid;
  grid-gap: 25px;
  grid-template-columns: repeat(3, 1fr);
}
@media (max-width: 991px) {
  .cs_gallery_grid_1 {
    grid-template-columns: repeat(2, 1fr);
  }
  .cs_gallery_grid_1 .cs_grid_item:nth-child(2) {
    display: none;
  }
}
@media (max-width: 767px) {
  .cs_gallery_grid_1 {
    display: flex;
    flex-direction: column;
    gap: 25px;
  }
}
.cs_gallery_grid_1 .cs_section_heading.cs_style_1 {
  min-height: 263px;
}
@media (max-width: 1700px) {
  .cs_gallery_grid_1 .cs_section_heading.cs_style_1 {
    min-height: 166px;
  }
}
@media (max-width: 991px) {
  .cs_gallery_grid_1 .cs_section_heading.cs_style_1 {
    min-height: initial;
  }
}
.cs_gallery_grid_1 .cs_grid_item:first-child {
  grid-column: span 2;
}
@media (min-width: 992px) {
  .cs_gallery_grid_1 .cs_grid_item:nth-child(6) {
    grid-column: span 2;
  }
}
.cs_gallery_grid_1 .cs_grid_item:nth-child(5) .cs_portfolio.cs_style_1 {
  height: 767px;
  margin-top: -338px;
}
@media (max-width: 1700px) {
  .cs_gallery_grid_1 .cs_grid_item:nth-child(5) .cs_portfolio.cs_style_1 {
    height: 590px;
    margin-top: -240px;
  }
}
@media (max-width: 991px) {
  .cs_gallery_grid_1 .cs_grid_item:nth-child(5) .cs_portfolio.cs_style_1 {
    margin-top: 0;
    height: 400px;
  }
}
@media (max-width: 991px) {
  .cs_gallery_grid_1 .cs_grid_item:nth-child(5) {
    grid-column: span 2;
  }
}
@media (max-width: 767px) {
  .cs_gallery_grid_1 .cs_grid_item:nth-child(5) {
    grid-column: initial;
  }
}
@media (max-width: 1700px) {
  .cs_gallery_grid_1 .cs_portfolio.cs_style_1 {
    height: 350px;
  }
}

.cs_gallery_grid_2 {
  display: grid;
  grid-gap: 25px;
  grid-template-columns: repeat(3, 1fr);
}
@media (max-width: 991px) {
  .cs_gallery_grid_2 {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 767px) {
  .cs_gallery_grid_2 {
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 25px 0px;
  }
}
@media (min-width: 768px) {
  .cs_gallery_grid_2 .cs_grid_item:first-child {
    grid-column: span 2;
  }
}
@media (min-width: 992px) {
  .cs_gallery_grid_2 .cs_grid_item:nth-child(7) {
    grid-column: span 2;
  }
}
@media (max-width: 1700px) {
  .cs_gallery_grid_2 .cs_portfolio.cs_style_1 {
    height: 350px;
  }
}
@media (max-width: 420px) {
  .cs_gallery_grid_2 .cs_portfolio.cs_style_1 {
    height: 300px;
  }
}

.cs_portfolio.cs_style_1 .cs_portfolio_img > div > img {
  cursor: zoom-in;
  height: 100%;
  left: 0;
  object-fit: cover;
  opacity: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 5;
}

.cs_team_grid {
  display: grid;
  grid-gap: 50px 25px;
  grid-template-columns: repeat(3, 1fr);
}
@media (max-width: 991px) {
  .cs_team_grid {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 40px 25px;
  }
}
@media (max-width: 767px) {
  .cs_team_grid {
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 40px 25px;
  }
}
.cs_team_grid.cs_list_view_wrap {
  grid-template-columns: repeat(1, 1fr);
}
.cs_team_grid.cs_grid_view_wrap .cs_team.cs_style_1.cs_type_2 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.cs_isotop_filter.cs_style1 {
  text-transform: capitalize;
}

.cs_pagination_box .cs_pagination_item,
.cs_pagination_box .cs_pagination_arrow {
  border: none;
}
.cs_pagination_box .cs_pagination_item:hover,
.cs_pagination_box .cs_pagination_arrow:hover {
  color: #01AE42;
}
.cs_pagination_box .cs_pagination_arrow {
  background-color: transparent;
}

.form-check .form-check-input {
  border-color: #636363;
}

.cs_related_doctor .slick-dots {
  display: flex !important;
}

.react-datepicker-wrapper {
  display: block;
}

.cs_blog_grid_1 {
  display: grid;
  grid-gap: 20px 130px;
  grid-template-columns: repeat(4, 1fr);
}
@media (max-width: 1700px) {
  .cs_blog_grid_1 {
    grid-gap: 20px 80px;
  }
}
@media (max-width: 1400px) {
  .cs_blog_grid_1 {
    grid-gap: 20px;
  }
}
@media (max-width: 991px) {
  .cs_blog_grid_1 {
    grid-template-columns: repeat(1, 1fr);
  }
}
@media (min-width: 992px) {
  .cs_blog_grid_1 > * {
    grid-column: span 2;
  }
  .cs_blog_grid_1 > *:first-child {
    grid-row: span 3;
  }
}

.cs_error {
  padding: 80px 0;
  min-height: 100vh;
}

.cs_nav .cs_nav_list .cs_munu_dropdown_toggle.active + ul {
  display: block;
}

input[type=date]::-webkit-inner-spin-button,
input[type=date]::-webkit-calendar-picker-indicator,
input[type=time]::-webkit-inner-spin-button,
input[type=time]::-webkit-calendar-picker-indicator {
  display: none;
  -webkit-appearance: none;
}

/* Typewriter Effect Styles */
.typewriter-cursor {
  animation: blink 1s infinite;
  font-weight: 100;
  color: #01AE42;
}

@keyframes blink {
  0%, 50% {
    opacity: 1;
  }
  51%, 100% {
    opacity: 0;
  }
}
/* React-Typed Styles */
.typed-cursor {
  animation: typedjsBlink 0.7s infinite;
  font-weight: 100;
  color: #01AE42;
  font-size: inherit;
}

@keyframes typedjsBlink {
  50% {
    opacity: 0;
  }
}
.typewriter-title .typed-cursor {
  font-size: inherit;
  color: #01AE42;
}

/* Language Selector Styles */
.cs_language_selector {
  position: relative;
  display: inline-block;
}

.cs_language_btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  color: inherit;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  font-weight: 500;
}
.cs_language_btn:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.3);
}

.cs_language_flag {
  font-size: 16px;
  line-height: 1;
}

.cs_language_code {
  font-weight: 600;
  letter-spacing: 0.5px;
}

.cs_dropdown_arrow {
  transition: transform 0.3s ease;
}
.cs_dropdown_arrow.active {
  transform: rotate(180deg);
}

.cs_language_dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  z-index: 1000;
  min-width: 140px;
}

.cs_language_option {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 12px 16px;
  background: transparent;
  border: none;
  color: #333;
  cursor: pointer;
  transition: background-color 0.2s ease;
  font-size: 14px;
  text-align: left;
}
.cs_language_option:hover {
  background: #f8f9fa;
}
.cs_language_option.active {
  background: #01AE42;
  color: #fff;
}

/* Dark theme support */
.cs_site_header.cs_style1.cs_white_color .cs_language_btn {
  border-color: rgba(255, 255, 255, 0.3);
  color: #fff;
}
.cs_site_header.cs_style1.cs_white_color .cs_language_btn:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.5);
}

/* Center menu horizontally on desktop only */
@media (min-width: 992px) {
  .cs_main_header_in {
    position: relative;
  }
  .cs_nav {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
}
/* WhatsApp Button Styles */
.whatsapp-button {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 60px;
  height: 60px;
  background: #25D366;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 20px rgba(37, 211, 102, 0.4);
  transition: all 0.3s ease;
  z-index: 1000;
}
.whatsapp-button:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 25px rgba(37, 211, 102, 0.6);
}
.whatsapp-button .whatsapp-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

/* WhatsApp Popup Styles */
.whatsapp-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.whatsapp-popup {
  background: white;
  border-radius: 15px;
  padding: 0;
  max-width: 400px;
  width: 90%;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.whatsapp-popup-header {
  background: #25D366;
  color: white;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.whatsapp-popup-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.whatsapp-close-btn {
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s ease;
}
.whatsapp-close-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.whatsapp-form {
  padding: 30px;
}
.whatsapp-form .whatsapp-form-group {
  margin-bottom: 20px;
}
.whatsapp-form .whatsapp-form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
}
.whatsapp-form .whatsapp-form-group input {
  width: 100%;
  padding: 12px 15px;
  border: 2px solid #e1e5e9;
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.3s ease;
}
.whatsapp-form .whatsapp-form-group input:focus {
  outline: none;
  border-color: #25D366;
}
.whatsapp-form .whatsapp-form-group input::placeholder {
  color: #999;
}

.whatsapp-submit-btn {
  width: 100%;
  background: #25D366;
  color: white;
  border: none;
  padding: 15px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
}
.whatsapp-submit-btn:hover {
  background: #128C7E;
}
.whatsapp-submit-btn:active {
  transform: translateY(1px);
}

/* Responsive */
@media (max-width: 768px) {
  .whatsapp-button {
    bottom: 20px;
    right: 20px;
    width: 55px;
    height: 55px;
  }
  .whatsapp-button .whatsapp-icon {
    width: 35px;
    height: 35px;
  }
  .whatsapp-popup {
    width: 95%;
    margin: 20px;
  }
  .whatsapp-form {
    padding: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/sass/index.scss","webpack://./src/sass/default/_color_variable.scss","webpack://./src/sass/default/_typography.scss","webpack://./src/sass/common/_preloader.scss","webpack://./src/sass/common/_spacing.scss","webpack://./src/sass/common/_general.scss","webpack://./src/sass/common/_slider.scss","webpack://./src/sass/common/_video-modal.scss","webpack://./src/sass/common/_header.scss","webpack://./src/sass/common/_footer.scss","webpack://./src/sass/common/_sidebar.scss","webpack://./src/sass/common/_isotope.scss","webpack://./src/sass/shortcode/_hero.scss","webpack://./src/sass/shortcode/_iconbox.scss","webpack://./src/sass/shortcode/_post.scss","webpack://./src/sass/shortcode/_banner.scss","webpack://./src/sass/shortcode/_testimonial.scss","webpack://./src/sass/shortcode/_portfolio.scss","webpack://./src/sass/shortcode/_brands.scss","webpack://./src/sass/shortcode/_accordion.scss","webpack://./src/sass/shortcode/_department.scss","webpack://./src/sass/shortcode/_about.scss","webpack://./src/sass/shortcode/_team.scss","webpack://./src/sass/shortcode/_funfact.scss","webpack://./src/sass/shortcode/_cta.scss","webpack://./src/sass/shortcode/_pricing_card.scss","webpack://./src/sass/_custom.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;;;;;;;;;;;;;;;;;;;;;;;gEAAA;ACAA;;iEAAA;ACAA;;iEAAA;AAMA;;EAEE,8BDFU;ECGV,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,6BAAA;AF6BF;;AE1BA;;;;;;EAME,WAAA;EACA,cDlBQ;ECmBR,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kCAAA;AF6BF;;AE1BA;;EAEE,kCAAA;AF6BF;;AE1BA;EACE,kCAAA;AF6BF;;AE1BA;EACE,eAAA;AF6BF;;AE1BA;EACE,eAAA;AF6BF;;AE1BA;EACE,eAAA;AF6BF;;AE1BA;EACE,eAAA;AF6BF;;AE1BA;EACE,eAAA;AF6BF;;AE1BA;EACE,eAAA;AF6BF;;AE1BA;EACE,mBAAA;AF6BF;;AE1BA;EACE,kBAAA;EACA,kBAAA;EACA,+BAAA;AF6BF;;AE1BA;EACE,kBAAA;EACA,mBAAA;AF6BF;;AE1BA;;;;EAIE,kBAAA;AF6BF;;AE1BA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;AF6BF;;AE1BA;EACE,gBAAA;AF6BF;;AE1BA;EACE,SAAA;EACA,eAAA;EACA,YAAA;AF6BF;;AE1BA;EACE,cAAA;EACA,qBAAA;EACA,yBAAA;AF6BF;;AE1BA;EACE,cAAA;EACA,yBAAA;AF6BF;;AE1BA;EACE,qBAAA;EACA,cD3GO;ADwIT;;AE1BA;EACE,WAAA;EACA,mBAAA;AF6BF;AE3BE;EACE,gBAAA;EACA,8BDxHQ;ADqJZ;AE1BE;;EAEE,6BAAA;EACA,kBAAA;AF4BJ;;AExBA;EACE,mBAAA;AF2BF;AEzBE;EACE,gBAAA;AF2BJ;;AEvBA;;EAEE,iBAAA;AF0BF;;AEvBA;EACE,8BDhJU;ECiJV,yBAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;AF0BF;;AEvBA;EACE,eAAA;EACA,yCDzJU;EC0JV,kBAAA;AF0BF;;AEvBA;EACE;;IAEE,eAAA;IACA,kBAAA;EF0BF;EExBA;IACE,eAAA;IACA,mBAAA;EF0BF;AACF;AExBA;;EAEE,cD3KQ;ADqMV;;AG1MA;;iEAAA;AAGA;EACE,eAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,OAAA;EACA,MAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AH6MF;AG5ME;EACE,kBAAA;AH8MJ;AG5MI;EACE,YAAA;EACA,aAAA;AH8MN;AGzMI;EACE,4BAAA;AH2MN;AGvME;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,gBAAA;EACA,sCAAA;AHyMJ;AGvMI;EACE,aF5BG;ADqOT;;AGpMA;EACE;IACE,YAAA;EHuMF;EGpMA;IACE,eAAA;EHsMF;AACF;AIxPA;;iEAAA;AAIE;EACE,WAAA;AJyPJ;;AI1PE;EACE,WAAA;AJ6PJ;;AI9PE;EACE,WAAA;AJiQJ;;AIlQE;EACE,WAAA;AJqQJ;;AItQE;EACE,WAAA;AJyQJ;;AI1QE;EACE,WAAA;AJ6QJ;;AI9QE;EACE,WAAA;AJiRJ;;AIlRE;EACE,WAAA;AJqRJ;;AItRE;EACE,WAAA;AJyRJ;;AI1RE;EACE,WAAA;AJ6RJ;;AI9RE;EACE,YAAA;AJiSJ;;AIlSE;EACE,YAAA;AJqSJ;;AItSE;EACE,YAAA;AJySJ;;AI1SE;EACE,YAAA;AJ6SJ;;AI9SE;EACE,YAAA;AJiTJ;;AIlTE;EACE,YAAA;AJqTJ;;AItTE;EACE,YAAA;AJyTJ;;AI1TE;EACE,YAAA;AJ6TJ;;AI9TE;EACE,YAAA;AJiUJ;;AIlUE;EACE,YAAA;AJqUJ;;AItUE;EACE,YAAA;AJyUJ;;AI1UE;EACE,YAAA;AJ6UJ;;AI9UE;EACE,YAAA;AJiVJ;;AIlVE;EACE,YAAA;AJqVJ;;AItVE;EACE,YAAA;AJyVJ;;AI1VE;EACE,YAAA;AJ6VJ;;AI9VE;EACE,YAAA;AJiWJ;;AIlWE;EACE,YAAA;AJqWJ;;AItWE;EACE,YAAA;AJyWJ;;AI1WE;EACE,YAAA;AJ6WJ;;AI9WE;EACE,YAAA;AJiXJ;;AIlXE;EACE,YAAA;AJqXJ;;AItXE;EACE,YAAA;AJyXJ;;AI1XE;EACE,YAAA;AJ6XJ;;AI9XE;EACE,YAAA;AJiYJ;;AIlYE;EACE,YAAA;AJqYJ;;AItYE;EACE,YAAA;AJyYJ;;AI1YE;EACE,YAAA;AJ6YJ;;AI9YE;EACE,YAAA;AJiZJ;;AIlZE;EACE,YAAA;AJqZJ;;AItZE;EACE,YAAA;AJyZJ;;AI1ZE;EACE,YAAA;AJ6ZJ;;AI9ZE;EACE,YAAA;AJiaJ;;AIlaE;EACE,YAAA;AJqaJ;;AItaE;EACE,YAAA;AJyaJ;;AI1aE;EACE,YAAA;AJ6aJ;;AI9aE;EACE,YAAA;AJibJ;;AIlbE;EACE,YAAA;AJqbJ;;AItbE;EACE,YAAA;AJybJ;;AI1bE;EACE,YAAA;AJ6bJ;;AI9bE;EACE,YAAA;AJicJ;;AIlcE;EACE,YAAA;AJqcJ;;AItcE;EACE,YAAA;AJycJ;;AI1cE;EACE,YAAA;AJ6cJ;;AI9cE;EACE,YAAA;AJidJ;;AIldE;EACE,YAAA;AJqdJ;;AItdE;EACE,YAAA;AJydJ;;AI1dE;EACE,YAAA;AJ6dJ;;AI9dE;EACE,YAAA;AJieJ;;AIleE;EACE,YAAA;AJqeJ;;AIteE;EACE,YAAA;AJyeJ;;AI1eE;EACE,YAAA;AJ6eJ;;AI9eE;EACE,YAAA;AJifJ;;AIlfE;EACE,YAAA;AJqfJ;;AItfE;EACE,YAAA;AJyfJ;;AI1fE;EACE,YAAA;AJ6fJ;;AI9fE;EACE,YAAA;AJigBJ;;AIlgBE;EACE,YAAA;AJqgBJ;;AItgBE;EACE,YAAA;AJygBJ;;AI1gBE;EACE,YAAA;AJ6gBJ;;AI9gBE;EACE,YAAA;AJihBJ;;AIlhBE;EACE,YAAA;AJqhBJ;;AIthBE;EACE,YAAA;AJyhBJ;;AI1hBE;EACE,YAAA;AJ6hBJ;;AI9hBE;EACE,YAAA;AJiiBJ;;AIliBE;EACE,YAAA;AJqiBJ;;AItiBE;EACE,YAAA;AJyiBJ;;AI1iBE;EACE,YAAA;AJ6iBJ;;AI9iBE;EACE,YAAA;AJijBJ;;AIljBE;EACE,YAAA;AJqjBJ;;AItjBE;EACE,YAAA;AJyjBJ;;AI1jBE;EACE,YAAA;AJ6jBJ;;AI9jBE;EACE,YAAA;AJikBJ;;AIlkBE;EACE,YAAA;AJqkBJ;;AItkBE;EACE,YAAA;AJykBJ;;AI1kBE;EACE,YAAA;AJ6kBJ;;AI9kBE;EACE,YAAA;AJilBJ;;AIllBE;EACE,YAAA;AJqlBJ;;AItlBE;EACE,YAAA;AJylBJ;;AI1lBE;EACE,YAAA;AJ6lBJ;;AI9lBE;EACE,YAAA;AJimBJ;;AIlmBE;EACE,YAAA;AJqmBJ;;AItmBE;EACE,YAAA;AJymBJ;;AI1mBE;EACE,YAAA;AJ6mBJ;;AI9mBE;EACE,YAAA;AJinBJ;;AIlnBE;EACE,YAAA;AJqnBJ;;AItnBE;EACE,YAAA;AJynBJ;;AI1nBE;EACE,YAAA;AJ6nBJ;;AI9nBE;EACE,YAAA;AJioBJ;;AIloBE;EACE,YAAA;AJqoBJ;;AItoBE;EACE,aAAA;AJyoBJ;;AI1oBE;EACE,aAAA;AJ6oBJ;;AI9oBE;EACE,aAAA;AJipBJ;;AIlpBE;EACE,aAAA;AJqpBJ;;AItpBE;EACE,aAAA;AJypBJ;;AI1pBE;EACE,aAAA;AJ6pBJ;;AI9pBE;EACE,aAAA;AJiqBJ;;AIlqBE;EACE,aAAA;AJqqBJ;;AItqBE;EACE,aAAA;AJyqBJ;;AI1qBE;EACE,aAAA;AJ6qBJ;;AI9qBE;EACE,aAAA;AJirBJ;;AIlrBE;EACE,aAAA;AJqrBJ;;AItrBE;EACE,aAAA;AJyrBJ;;AI1rBE;EACE,aAAA;AJ6rBJ;;AI9rBE;EACE,aAAA;AJisBJ;;AIlsBE;EACE,aAAA;AJqsBJ;;AItsBE;EACE,aAAA;AJysBJ;;AI1sBE;EACE,aAAA;AJ6sBJ;;AI9sBE;EACE,aAAA;AJitBJ;;AIltBE;EACE,aAAA;AJqtBJ;;AIttBE;EACE,aAAA;AJytBJ;;AI1tBE;EACE,aAAA;AJ6tBJ;;AI9tBE;EACE,aAAA;AJiuBJ;;AIluBE;EACE,aAAA;AJquBJ;;AItuBE;EACE,aAAA;AJyuBJ;;AI1uBE;EACE,aAAA;AJ6uBJ;;AI9uBE;EACE,aAAA;AJivBJ;;AIlvBE;EACE,aAAA;AJqvBJ;;AItvBE;EACE,aAAA;AJyvBJ;;AI1vBE;EACE,aAAA;AJ6vBJ;;AI9vBE;EACE,aAAA;AJiwBJ;;AIlwBE;EACE,aAAA;AJqwBJ;;AItwBE;EACE,aAAA;AJywBJ;;AI1wBE;EACE,aAAA;AJ6wBJ;;AI9wBE;EACE,aAAA;AJixBJ;;AIlxBE;EACE,aAAA;AJqxBJ;;AItxBE;EACE,aAAA;AJyxBJ;;AI1xBE;EACE,aAAA;AJ6xBJ;;AI9xBE;EACE,aAAA;AJiyBJ;;AIlyBE;EACE,aAAA;AJqyBJ;;AItyBE;EACE,aAAA;AJyyBJ;;AI1yBE;EACE,aAAA;AJ6yBJ;;AI9yBE;EACE,aAAA;AJizBJ;;AIlzBE;EACE,aAAA;AJqzBJ;;AItzBE;EACE,aAAA;AJyzBJ;;AI1zBE;EACE,aAAA;AJ6zBJ;;AI9zBE;EACE,aAAA;AJi0BJ;;AIl0BE;EACE,aAAA;AJq0BJ;;AIt0BE;EACE,aAAA;AJy0BJ;;AI10BE;EACE,aAAA;AJ60BJ;;AI90BE;EACE,aAAA;AJi1BJ;;AIl1BE;EACE,aAAA;AJq1BJ;;AIt1BE;EACE,aAAA;AJy1BJ;;AI11BE;EACE,aAAA;AJ61BJ;;AI91BE;EACE,aAAA;AJi2BJ;;AIl2BE;EACE,aAAA;AJq2BJ;;AIt2BE;EACE,aAAA;AJy2BJ;;AI12BE;EACE,aAAA;AJ62BJ;;AI92BE;EACE,aAAA;AJi3BJ;;AIl3BE;EACE,aAAA;AJq3BJ;;AIt3BE;EACE,aAAA;AJy3BJ;;AI13BE;EACE,aAAA;AJ63BJ;;AI93BE;EACE,aAAA;AJi4BJ;;AIl4BE;EACE,aAAA;AJq4BJ;;AIt4BE;EACE,aAAA;AJy4BJ;;AI14BE;EACE,aAAA;AJ64BJ;;AI94BE;EACE,aAAA;AJi5BJ;;AIl5BE;EACE,aAAA;AJq5BJ;;AIt5BE;EACE,aAAA;AJy5BJ;;AI15BE;EACE,aAAA;AJ65BJ;;AI95BE;EACE,aAAA;AJi6BJ;;AIl6BE;EACE,aAAA;AJq6BJ;;AIt6BE;EACE,aAAA;AJy6BJ;;AI16BE;EACE,aAAA;AJ66BJ;;AI96BE;EACE,aAAA;AJi7BJ;;AIl7BE;EACE,aAAA;AJq7BJ;;AIt7BE;EACE,aAAA;AJy7BJ;;AI17BE;EACE,aAAA;AJ67BJ;;AI97BE;EACE,aAAA;AJi8BJ;;AIl8BE;EACE,aAAA;AJq8BJ;;AIt8BE;EACE,aAAA;AJy8BJ;;AI18BE;EACE,aAAA;AJ68BJ;;AI98BE;EACE,aAAA;AJi9BJ;;AIl9BE;EACE,aAAA;AJq9BJ;;AIt9BE;EACE,aAAA;AJy9BJ;;AI19BE;EACE,aAAA;AJ69BJ;;AI99BE;EACE,aAAA;AJi+BJ;;AIl+BE;EACE,aAAA;AJq+BJ;;AIt+BE;EACE,aAAA;AJy+BJ;;AI1+BE;EACE,aAAA;AJ6+BJ;;AI9+BE;EACE,aAAA;AJi/BJ;;AIl/BE;EACE,aAAA;AJq/BJ;;AIt/BE;EACE,aAAA;AJy/BJ;;AI1/BE;EACE,aAAA;AJ6/BJ;;AI9/BE;EACE,aAAA;AJigCJ;;AIlgCE;EACE,aAAA;AJqgCJ;;AItgCE;EACE,aAAA;AJygCJ;;AI1gCE;EACE,aAAA;AJ6gCJ;;AI9gCE;EACE,aAAA;AJihCJ;;AIlhCE;EACE,aAAA;AJqhCJ;;AIthCE;EACE,aAAA;AJyhCJ;;AIrhCA;EAEI;IACE,WAAA;EJuhCJ;EIxhCE;IACE,WAAA;EJ0hCJ;EI3hCE;IACE,WAAA;EJ6hCJ;EI9hCE;IACE,WAAA;EJgiCJ;EIjiCE;IACE,WAAA;EJmiCJ;EIpiCE;IACE,WAAA;EJsiCJ;EIviCE;IACE,WAAA;EJyiCJ;EI1iCE;IACE,WAAA;EJ4iCJ;EI7iCE;IACE,WAAA;EJ+iCJ;EIhjCE;IACE,WAAA;EJkjCJ;EInjCE;IACE,YAAA;EJqjCJ;EItjCE;IACE,YAAA;EJwjCJ;EIzjCE;IACE,YAAA;EJ2jCJ;EI5jCE;IACE,YAAA;EJ8jCJ;EI/jCE;IACE,YAAA;EJikCJ;EIlkCE;IACE,YAAA;EJokCJ;EIrkCE;IACE,YAAA;EJukCJ;EIxkCE;IACE,YAAA;EJ0kCJ;EI3kCE;IACE,YAAA;EJ6kCJ;EI9kCE;IACE,YAAA;EJglCJ;EIjlCE;IACE,YAAA;EJmlCJ;EIplCE;IACE,YAAA;EJslCJ;EIvlCE;IACE,YAAA;EJylCJ;EI1lCE;IACE,YAAA;EJ4lCJ;EI7lCE;IACE,YAAA;EJ+lCJ;EIhmCE;IACE,YAAA;EJkmCJ;EInmCE;IACE,YAAA;EJqmCJ;EItmCE;IACE,YAAA;EJwmCJ;EIzmCE;IACE,YAAA;EJ2mCJ;EI5mCE;IACE,YAAA;EJ8mCJ;EI/mCE;IACE,YAAA;EJinCJ;EIlnCE;IACE,YAAA;EJonCJ;EIrnCE;IACE,YAAA;EJunCJ;EIxnCE;IACE,YAAA;EJ0nCJ;EI3nCE;IACE,YAAA;EJ6nCJ;EI9nCE;IACE,YAAA;EJgoCJ;EIjoCE;IACE,YAAA;EJmoCJ;EIpoCE;IACE,YAAA;EJsoCJ;EIvoCE;IACE,YAAA;EJyoCJ;EI1oCE;IACE,YAAA;EJ4oCJ;EI7oCE;IACE,YAAA;EJ+oCJ;EIhpCE;IACE,YAAA;EJkpCJ;EInpCE;IACE,YAAA;EJqpCJ;EItpCE;IACE,YAAA;EJwpCJ;EIzpCE;IACE,YAAA;EJ2pCJ;EI5pCE;IACE,YAAA;EJ8pCJ;EI/pCE;IACE,YAAA;EJiqCJ;EIlqCE;IACE,YAAA;EJoqCJ;EIrqCE;IACE,YAAA;EJuqCJ;EIxqCE;IACE,YAAA;EJ0qCJ;EI3qCE;IACE,YAAA;EJ6qCJ;EI9qCE;IACE,YAAA;EJgrCJ;EIjrCE;IACE,YAAA;EJmrCJ;EIprCE;IACE,YAAA;EJsrCJ;EIvrCE;IACE,YAAA;EJyrCJ;EI1rCE;IACE,YAAA;EJ4rCJ;EI7rCE;IACE,YAAA;EJ+rCJ;EIhsCE;IACE,YAAA;EJksCJ;EInsCE;IACE,YAAA;EJqsCJ;EItsCE;IACE,YAAA;EJwsCJ;EIzsCE;IACE,YAAA;EJ2sCJ;EI5sCE;IACE,YAAA;EJ8sCJ;EI/sCE;IACE,YAAA;EJitCJ;EIltCE;IACE,YAAA;EJotCJ;EIrtCE;IACE,YAAA;EJutCJ;EIxtCE;IACE,YAAA;EJ0tCJ;EI3tCE;IACE,YAAA;EJ6tCJ;EI9tCE;IACE,YAAA;EJguCJ;EIjuCE;IACE,YAAA;EJmuCJ;EIpuCE;IACE,YAAA;EJsuCJ;EIvuCE;IACE,YAAA;EJyuCJ;EI1uCE;IACE,YAAA;EJ4uCJ;EI7uCE;IACE,YAAA;EJ+uCJ;EIhvCE;IACE,YAAA;EJkvCJ;EInvCE;IACE,YAAA;EJqvCJ;EItvCE;IACE,YAAA;EJwvCJ;EIzvCE;IACE,YAAA;EJ2vCJ;EI5vCE;IACE,YAAA;EJ8vCJ;EI/vCE;IACE,YAAA;EJiwCJ;EIlwCE;IACE,YAAA;EJowCJ;EIrwCE;IACE,YAAA;EJuwCJ;EIxwCE;IACE,YAAA;EJ0wCJ;EI3wCE;IACE,YAAA;EJ6wCJ;EI9wCE;IACE,YAAA;EJgxCJ;EIjxCE;IACE,YAAA;EJmxCJ;EIpxCE;IACE,YAAA;EJsxCJ;EIvxCE;IACE,YAAA;EJyxCJ;EI1xCE;IACE,YAAA;EJ4xCJ;EI7xCE;IACE,YAAA;EJ+xCJ;EIhyCE;IACE,YAAA;EJkyCJ;EInyCE;IACE,YAAA;EJqyCJ;EItyCE;IACE,YAAA;EJwyCJ;EIzyCE;IACE,YAAA;EJ2yCJ;EI5yCE;IACE,YAAA;EJ8yCJ;EI/yCE;IACE,YAAA;EJizCJ;EIlzCE;IACE,YAAA;EJozCJ;EIrzCE;IACE,YAAA;EJuzCJ;EIxzCE;IACE,YAAA;EJ0zCJ;EI3zCE;IACE,YAAA;EJ6zCJ;EI9zCE;IACE,YAAA;EJg0CJ;EIj0CE;IACE,aAAA;EJm0CJ;EIp0CE;IACE,aAAA;EJs0CJ;EIv0CE;IACE,aAAA;EJy0CJ;EI10CE;IACE,aAAA;EJ40CJ;EI70CE;IACE,aAAA;EJ+0CJ;EIh1CE;IACE,aAAA;EJk1CJ;EIn1CE;IACE,aAAA;EJq1CJ;EIt1CE;IACE,aAAA;EJw1CJ;EIz1CE;IACE,aAAA;EJ21CJ;EI51CE;IACE,aAAA;EJ81CJ;EI/1CE;IACE,aAAA;EJi2CJ;EIl2CE;IACE,aAAA;EJo2CJ;EIr2CE;IACE,aAAA;EJu2CJ;EIx2CE;IACE,aAAA;EJ02CJ;EI32CE;IACE,aAAA;EJ62CJ;EI92CE;IACE,aAAA;EJg3CJ;EIj3CE;IACE,aAAA;EJm3CJ;EIp3CE;IACE,aAAA;EJs3CJ;EIv3CE;IACE,aAAA;EJy3CJ;EI13CE;IACE,aAAA;EJ43CJ;EI73CE;IACE,aAAA;EJ+3CJ;EIh4CE;IACE,aAAA;EJk4CJ;EIn4CE;IACE,aAAA;EJq4CJ;EIt4CE;IACE,aAAA;EJw4CJ;EIz4CE;IACE,aAAA;EJ24CJ;EI54CE;IACE,aAAA;EJ84CJ;EI/4CE;IACE,aAAA;EJi5CJ;EIl5CE;IACE,aAAA;EJo5CJ;EIr5CE;IACE,aAAA;EJu5CJ;EIx5CE;IACE,aAAA;EJ05CJ;EI35CE;IACE,aAAA;EJ65CJ;EI95CE;IACE,aAAA;EJg6CJ;EIj6CE;IACE,aAAA;EJm6CJ;EIp6CE;IACE,aAAA;EJs6CJ;EIv6CE;IACE,aAAA;EJy6CJ;EI16CE;IACE,aAAA;EJ46CJ;EI76CE;IACE,aAAA;EJ+6CJ;EIh7CE;IACE,aAAA;EJk7CJ;EIn7CE;IACE,aAAA;EJq7CJ;EIt7CE;IACE,aAAA;EJw7CJ;EIz7CE;IACE,aAAA;EJ27CJ;EI57CE;IACE,aAAA;EJ87CJ;EI/7CE;IACE,aAAA;EJi8CJ;EIl8CE;IACE,aAAA;EJo8CJ;EIr8CE;IACE,aAAA;EJu8CJ;EIx8CE;IACE,aAAA;EJ08CJ;EI38CE;IACE,aAAA;EJ68CJ;EI98CE;IACE,aAAA;EJg9CJ;EIj9CE;IACE,aAAA;EJm9CJ;EIp9CE;IACE,aAAA;EJs9CJ;EIv9CE;IACE,aAAA;EJy9CJ;EI19CE;IACE,aAAA;EJ49CJ;EI79CE;IACE,aAAA;EJ+9CJ;EIh+CE;IACE,aAAA;EJk+CJ;EIn+CE;IACE,aAAA;EJq+CJ;EIt+CE;IACE,aAAA;EJw+CJ;EIz+CE;IACE,aAAA;EJ2+CJ;EI5+CE;IACE,aAAA;EJ8+CJ;EI/+CE;IACE,aAAA;EJi/CJ;EIl/CE;IACE,aAAA;EJo/CJ;EIr/CE;IACE,aAAA;EJu/CJ;EIx/CE;IACE,aAAA;EJ0/CJ;EI3/CE;IACE,aAAA;EJ6/CJ;EI9/CE;IACE,aAAA;EJggDJ;EIjgDE;IACE,aAAA;EJmgDJ;EIpgDE;IACE,aAAA;EJsgDJ;EIvgDE;IACE,aAAA;EJygDJ;EI1gDE;IACE,aAAA;EJ4gDJ;EI7gDE;IACE,aAAA;EJ+gDJ;EIhhDE;IACE,aAAA;EJkhDJ;EInhDE;IACE,aAAA;EJqhDJ;EIthDE;IACE,aAAA;EJwhDJ;EIzhDE;IACE,aAAA;EJ2hDJ;EI5hDE;IACE,aAAA;EJ8hDJ;EI/hDE;IACE,aAAA;EJiiDJ;EIliDE;IACE,aAAA;EJoiDJ;EIriDE;IACE,aAAA;EJuiDJ;EIxiDE;IACE,aAAA;EJ0iDJ;EI3iDE;IACE,aAAA;EJ6iDJ;EI9iDE;IACE,aAAA;EJgjDJ;EIjjDE;IACE,aAAA;EJmjDJ;EIpjDE;IACE,aAAA;EJsjDJ;EIvjDE;IACE,aAAA;EJyjDJ;EI1jDE;IACE,aAAA;EJ4jDJ;EI7jDE;IACE,aAAA;EJ+jDJ;EIhkDE;IACE,aAAA;EJkkDJ;EInkDE;IACE,aAAA;EJqkDJ;EItkDE;IACE,aAAA;EJwkDJ;EIzkDE;IACE,aAAA;EJ2kDJ;EI5kDE;IACE,aAAA;EJ8kDJ;EI/kDE;IACE,aAAA;EJilDJ;EIllDE;IACE,aAAA;EJolDJ;EIrlDE;IACE,aAAA;EJulDJ;EIxlDE;IACE,aAAA;EJ0lDJ;EI3lDE;IACE,aAAA;EJ6lDJ;EI9lDE;IACE,aAAA;EJgmDJ;EIjmDE;IACE,aAAA;EJmmDJ;EIpmDE;IACE,aAAA;EJsmDJ;EIvmDE;IACE,aAAA;EJymDJ;EI1mDE;IACE,aAAA;EJ4mDJ;EI7mDE;IACE,aAAA;EJ+mDJ;AACF;AI5mDA;EAEI;IACE,WAAA;EJ6mDJ;EI9mDE;IACE,WAAA;EJgnDJ;EIjnDE;IACE,WAAA;EJmnDJ;EIpnDE;IACE,WAAA;EJsnDJ;EIvnDE;IACE,WAAA;EJynDJ;EI1nDE;IACE,WAAA;EJ4nDJ;EI7nDE;IACE,WAAA;EJ+nDJ;EIhoDE;IACE,WAAA;EJkoDJ;EInoDE;IACE,WAAA;EJqoDJ;EItoDE;IACE,WAAA;EJwoDJ;EIzoDE;IACE,YAAA;EJ2oDJ;EI5oDE;IACE,YAAA;EJ8oDJ;EI/oDE;IACE,YAAA;EJipDJ;EIlpDE;IACE,YAAA;EJopDJ;EIrpDE;IACE,YAAA;EJupDJ;EIxpDE;IACE,YAAA;EJ0pDJ;EI3pDE;IACE,YAAA;EJ6pDJ;EI9pDE;IACE,YAAA;EJgqDJ;EIjqDE;IACE,YAAA;EJmqDJ;EIpqDE;IACE,YAAA;EJsqDJ;EIvqDE;IACE,YAAA;EJyqDJ;EI1qDE;IACE,YAAA;EJ4qDJ;EI7qDE;IACE,YAAA;EJ+qDJ;EIhrDE;IACE,YAAA;EJkrDJ;EInrDE;IACE,YAAA;EJqrDJ;EItrDE;IACE,YAAA;EJwrDJ;EIzrDE;IACE,YAAA;EJ2rDJ;EI5rDE;IACE,YAAA;EJ8rDJ;EI/rDE;IACE,YAAA;EJisDJ;EIlsDE;IACE,YAAA;EJosDJ;EIrsDE;IACE,YAAA;EJusDJ;EIxsDE;IACE,YAAA;EJ0sDJ;EI3sDE;IACE,YAAA;EJ6sDJ;EI9sDE;IACE,YAAA;EJgtDJ;EIjtDE;IACE,YAAA;EJmtDJ;EIptDE;IACE,YAAA;EJstDJ;EIvtDE;IACE,YAAA;EJytDJ;EI1tDE;IACE,YAAA;EJ4tDJ;EI7tDE;IACE,YAAA;EJ+tDJ;EIhuDE;IACE,YAAA;EJkuDJ;EInuDE;IACE,YAAA;EJquDJ;EItuDE;IACE,YAAA;EJwuDJ;EIzuDE;IACE,YAAA;EJ2uDJ;EI5uDE;IACE,YAAA;EJ8uDJ;EI/uDE;IACE,YAAA;EJivDJ;EIlvDE;IACE,YAAA;EJovDJ;EIrvDE;IACE,YAAA;EJuvDJ;EIxvDE;IACE,YAAA;EJ0vDJ;EI3vDE;IACE,YAAA;EJ6vDJ;EI9vDE;IACE,YAAA;EJgwDJ;EIjwDE;IACE,YAAA;EJmwDJ;EIpwDE;IACE,YAAA;EJswDJ;EIvwDE;IACE,YAAA;EJywDJ;EI1wDE;IACE,YAAA;EJ4wDJ;EI7wDE;IACE,YAAA;EJ+wDJ;EIhxDE;IACE,YAAA;EJkxDJ;EInxDE;IACE,YAAA;EJqxDJ;EItxDE;IACE,YAAA;EJwxDJ;EIzxDE;IACE,YAAA;EJ2xDJ;EI5xDE;IACE,YAAA;EJ8xDJ;EI/xDE;IACE,YAAA;EJiyDJ;EIlyDE;IACE,YAAA;EJoyDJ;EIryDE;IACE,YAAA;EJuyDJ;EIxyDE;IACE,YAAA;EJ0yDJ;EI3yDE;IACE,YAAA;EJ6yDJ;EI9yDE;IACE,YAAA;EJgzDJ;EIjzDE;IACE,YAAA;EJmzDJ;EIpzDE;IACE,YAAA;EJszDJ;EIvzDE;IACE,YAAA;EJyzDJ;EI1zDE;IACE,YAAA;EJ4zDJ;EI7zDE;IACE,YAAA;EJ+zDJ;EIh0DE;IACE,YAAA;EJk0DJ;EIn0DE;IACE,YAAA;EJq0DJ;EIt0DE;IACE,YAAA;EJw0DJ;EIz0DE;IACE,YAAA;EJ20DJ;EI50DE;IACE,YAAA;EJ80DJ;EI/0DE;IACE,YAAA;EJi1DJ;EIl1DE;IACE,YAAA;EJo1DJ;EIr1DE;IACE,YAAA;EJu1DJ;EIx1DE;IACE,YAAA;EJ01DJ;EI31DE;IACE,YAAA;EJ61DJ;EI91DE;IACE,YAAA;EJg2DJ;EIj2DE;IACE,YAAA;EJm2DJ;EIp2DE;IACE,YAAA;EJs2DJ;EIv2DE;IACE,YAAA;EJy2DJ;EI12DE;IACE,YAAA;EJ42DJ;EI72DE;IACE,YAAA;EJ+2DJ;EIh3DE;IACE,YAAA;EJk3DJ;EIn3DE;IACE,YAAA;EJq3DJ;EIt3DE;IACE,YAAA;EJw3DJ;EIz3DE;IACE,YAAA;EJ23DJ;EI53DE;IACE,YAAA;EJ83DJ;EI/3DE;IACE,YAAA;EJi4DJ;EIl4DE;IACE,YAAA;EJo4DJ;EIr4DE;IACE,YAAA;EJu4DJ;EIx4DE;IACE,YAAA;EJ04DJ;EI34DE;IACE,YAAA;EJ64DJ;EI94DE;IACE,YAAA;EJg5DJ;EIj5DE;IACE,YAAA;EJm5DJ;EIp5DE;IACE,YAAA;EJs5DJ;EIv5DE;IACE,aAAA;EJy5DJ;EI15DE;IACE,aAAA;EJ45DJ;EI75DE;IACE,aAAA;EJ+5DJ;EIh6DE;IACE,aAAA;EJk6DJ;EIn6DE;IACE,aAAA;EJq6DJ;EIt6DE;IACE,aAAA;EJw6DJ;EIz6DE;IACE,aAAA;EJ26DJ;EI56DE;IACE,aAAA;EJ86DJ;EI/6DE;IACE,aAAA;EJi7DJ;EIl7DE;IACE,aAAA;EJo7DJ;EIr7DE;IACE,aAAA;EJu7DJ;EIx7DE;IACE,aAAA;EJ07DJ;EI37DE;IACE,aAAA;EJ67DJ;EI97DE;IACE,aAAA;EJg8DJ;EIj8DE;IACE,aAAA;EJm8DJ;EIp8DE;IACE,aAAA;EJs8DJ;EIv8DE;IACE,aAAA;EJy8DJ;EI18DE;IACE,aAAA;EJ48DJ;EI78DE;IACE,aAAA;EJ+8DJ;EIh9DE;IACE,aAAA;EJk9DJ;EIn9DE;IACE,aAAA;EJq9DJ;EIt9DE;IACE,aAAA;EJw9DJ;EIz9DE;IACE,aAAA;EJ29DJ;EI59DE;IACE,aAAA;EJ89DJ;EI/9DE;IACE,aAAA;EJi+DJ;EIl+DE;IACE,aAAA;EJo+DJ;EIr+DE;IACE,aAAA;EJu+DJ;EIx+DE;IACE,aAAA;EJ0+DJ;EI3+DE;IACE,aAAA;EJ6+DJ;EI9+DE;IACE,aAAA;EJg/DJ;EIj/DE;IACE,aAAA;EJm/DJ;EIp/DE;IACE,aAAA;EJs/DJ;EIv/DE;IACE,aAAA;EJy/DJ;EI1/DE;IACE,aAAA;EJ4/DJ;EI7/DE;IACE,aAAA;EJ+/DJ;EIhgEE;IACE,aAAA;EJkgEJ;EIngEE;IACE,aAAA;EJqgEJ;EItgEE;IACE,aAAA;EJwgEJ;EIzgEE;IACE,aAAA;EJ2gEJ;EI5gEE;IACE,aAAA;EJ8gEJ;EI/gEE;IACE,aAAA;EJihEJ;EIlhEE;IACE,aAAA;EJohEJ;EIrhEE;IACE,aAAA;EJuhEJ;EIxhEE;IACE,aAAA;EJ0hEJ;EI3hEE;IACE,aAAA;EJ6hEJ;EI9hEE;IACE,aAAA;EJgiEJ;EIjiEE;IACE,aAAA;EJmiEJ;EIpiEE;IACE,aAAA;EJsiEJ;EIviEE;IACE,aAAA;EJyiEJ;EI1iEE;IACE,aAAA;EJ4iEJ;EI7iEE;IACE,aAAA;EJ+iEJ;EIhjEE;IACE,aAAA;EJkjEJ;EInjEE;IACE,aAAA;EJqjEJ;EItjEE;IACE,aAAA;EJwjEJ;EIzjEE;IACE,aAAA;EJ2jEJ;EI5jEE;IACE,aAAA;EJ8jEJ;EI/jEE;IACE,aAAA;EJikEJ;EIlkEE;IACE,aAAA;EJokEJ;EIrkEE;IACE,aAAA;EJukEJ;EIxkEE;IACE,aAAA;EJ0kEJ;EI3kEE;IACE,aAAA;EJ6kEJ;EI9kEE;IACE,aAAA;EJglEJ;EIjlEE;IACE,aAAA;EJmlEJ;EIplEE;IACE,aAAA;EJslEJ;EIvlEE;IACE,aAAA;EJylEJ;EI1lEE;IACE,aAAA;EJ4lEJ;EI7lEE;IACE,aAAA;EJ+lEJ;EIhmEE;IACE,aAAA;EJkmEJ;EInmEE;IACE,aAAA;EJqmEJ;EItmEE;IACE,aAAA;EJwmEJ;EIzmEE;IACE,aAAA;EJ2mEJ;EI5mEE;IACE,aAAA;EJ8mEJ;EI/mEE;IACE,aAAA;EJinEJ;EIlnEE;IACE,aAAA;EJonEJ;EIrnEE;IACE,aAAA;EJunEJ;EIxnEE;IACE,aAAA;EJ0nEJ;EI3nEE;IACE,aAAA;EJ6nEJ;EI9nEE;IACE,aAAA;EJgoEJ;EIjoEE;IACE,aAAA;EJmoEJ;EIpoEE;IACE,aAAA;EJsoEJ;EIvoEE;IACE,aAAA;EJyoEJ;EI1oEE;IACE,aAAA;EJ4oEJ;EI7oEE;IACE,aAAA;EJ+oEJ;EIhpEE;IACE,aAAA;EJkpEJ;EInpEE;IACE,aAAA;EJqpEJ;EItpEE;IACE,aAAA;EJwpEJ;EIzpEE;IACE,aAAA;EJ2pEJ;EI5pEE;IACE,aAAA;EJ8pEJ;EI/pEE;IACE,aAAA;EJiqEJ;EIlqEE;IACE,aAAA;EJoqEJ;EIrqEE;IACE,aAAA;EJuqEJ;EIxqEE;IACE,aAAA;EJ0qEJ;EI3qEE;IACE,aAAA;EJ6qEJ;EI9qEE;IACE,aAAA;EJgrEJ;EIjrEE;IACE,aAAA;EJmrEJ;EIprEE;IACE,aAAA;EJsrEJ;EIvrEE;IACE,aAAA;EJyrEJ;EI1rEE;IACE,aAAA;EJ4rEJ;EI7rEE;IACE,aAAA;EJ+rEJ;EIhsEE;IACE,aAAA;EJksEJ;EInsEE;IACE,aAAA;EJqsEJ;AACF;AKztEA;;iEAAA;AAGA;EACE,WAAA;AL2tEF;;AKztEA;EACE,WAAA;AL4tEF;;AK1tEA;EACE,WAAA;AL6tEF;;AK3tEA;EACE,WAAA;AL8tEF;;AK5tEA;EACE,WAAA;AL+tEF;AK9tEE;EAFF;IAGI,WAAA;ELiuEF;AACF;;AK/tEA;EACE,mBAAA;ALkuEF;AKjuEE;EAFF;IAGI,mBAAA;ELouEF;AACF;AKnuEE;EALF;IAMI,mBAAA;ELsuEF;AACF;AKruEE;EARF;IASI,gBAAA;IACA,iBAAA;ELwuEF;AACF;;AKtuEA;EACE,SAAA;ALyuEF;;AKvuEA;EACE,oBAAA;AL0uEF;AKzuEE;EAFF;IAGI,mBAAA;EL4uEF;AACF;AK3uEE;EALF;IAMI,kBAAA;EL8uEF;AACF;;AK5uEA;EACE,kBAAA;EACA,kBAAA;EACA,UAAA;AL+uEF;AK9uEE;EAJF;IAKI,iBAAA;ELivEF;AACF;;AK/uEA;EACE,eAAA;EACA,kBAAA;ALkvEF;AKjvEE;EAHF;IAII,eAAA;ELovEF;AACF;AKnvEE;EANF;IAOI,eAAA;ELsvEF;AACF;AKrvEE;EATF;IAUI,eAAA;ELwvEF;AACF;;AKtvEA;EACE,eAAA;EACA,mBAAA;ALyvEF;AKxvEE;EAHF;IAII,eAAA;EL2vEF;AACF;AK1vEE;EANF;IAOI,eAAA;EL6vEF;AACF;AK5vEE;EATF;IAUI,eAAA;EL+vEF;AACF;;AK7vEA;EACE,eAAA;EACA,mBAAA;ALgwEF;AK/vEE;EAHF;IAII,eAAA;ELkwEF;AACF;AKjwEE;EANF;IAOI,eAAA;ELowEF;AACF;AKnwEE;EATF;IAUI,eAAA;ELswEF;AACF;AKrwEE;EAZF;IAaI,eAAA;ELwwEF;AACF;;AKtwEA;EACE,eAAA;EACA,mBAAA;ALywEF;AKxwEE;EAHF;IAII,eAAA;EL2wEF;AACF;AK1wEE;EANF;IAOI,eAAA;EL6wEF;AACF;;AK3wEA;EACE,eAAA;EACA,mBAAA;AL8wEF;AK7wEE;EAHF;IAII,eAAA;ELgxEF;AACF;AK/wEE;EANF;IAOI,eAAA;ELkxEF;AACF;;AKhxEA;EACE,eAAA;EACA,mBAAA;ALmxEF;AKlxEE;EAHF;IAII,eAAA;ELqxEF;AACF;AKpxEE;EANF;IAOI,eAAA;ELuxEF;AACF;AKtxEE;EATF;IAUI,eAAA;ELyxEF;AACF;;AKvxEA;EACE,eAAA;EACA,mBAAA;AL0xEF;AKzxEE;EAHF;IAII,eAAA;EL4xEF;AACF;;AK1xEA;EACE,eAAA;EACA,kBAAA;AL6xEF;AK5xEE;EAHF;IAII,eAAA;EL+xEF;AACF;;AK7xEA;EACE,eAAA;EACA,kBAAA;ALgyEF;;AK7xEA;EACE,YAAA;ALgyEF;AK/xEE;EACE,YAAA;EACA,WAAA;EACA,iBAAA;ALiyEJ;;AK7xEA;EACE,gBAAA;ALgyEF;;AK7xEA;EACE,gBAAA;ALgyEF;;AK7xEA;EACE,gBAAA;ALgyEF;;AK7xEA;EACE,gBAAA;ALgyEF;;AK7xEA;EACE,gBAAA;ALgyEF;;AK7xEA;EACE,gBAAA;ALgyEF;;AK7xEA;EACE,gBAAA;ALgyEF;;AK7xEA;EACE,kBAAA;ALgyEF;;AK7xEA;EACE,kBAAA;ALgyEF;;AK7xEA;EACE,kBAAA;ALgyEF;;AK7xEA;EACE,mBAAA;ALgyEF;;AK7xEA;EACE,mBAAA;ALgyEF;;AK9xEA;EACE,mBAAA;ALiyEF;;AK/xEA;EACE,mBAAA;ALkyEF;;AKhyEA;EACE,mBAAA;ALmyEF;;AKhyEA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;ALmyEF;;AKhyEA;EACE,SAAA;ALmyEF;;AKhyEA;EACE,SAAA;EACA,UAAA;EACA,YAAA;EACA,6BAAA;EACA,UAAA;ALmyEF;;AKhyEA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;ALmyEF;;AKhyEA;EACE,UAAA;EACA,WAAA;ALmyEF;;AKhyEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;ALmyEF;;AKjyEA;EACE,sBAAA;EACA,4BAAA;EACA,2BAAA;ALoyEF;;AKlyEA;EACE,cJzPQ;AD8hFV;;AKnyEA;EACE,8BJ3PU;ADiiFZ;;AKpyEA;EACE,cJ1PO;ADiiFT;;AKryEA;EACE,WAAA;ALwyEF;;AKtyEA;EACE,yBJvQM;ADgjFR;;AKvyEA;EACE,yBJnQO;AD6iFT;;AKxyEA;EACE,0CAAA;AL2yEF;;AKzyEA;;EAEE,kBAAA;AL4yEF;AK3yEE;;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;AL8yEJ;AK5yEE;;EACE,kBAAA;EACA,UAAA;AL+yEJ;;AK3yEE;EACE,WAAA;EACA,YAAA;EACA,SAAA;AL8yEJ;;AK3yEA;EACE;IACE,iBAAA;EL8yEF;AACF;AK3yEA;EACE,oDAAA;AL6yEF;;AK3yEA;EACE,qDAAA;AL8yEF;;AK5yEA;EACE,mBAAA;EACA,mDAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;AL+yEF;AK9yEE;EAdF;IAeI,kBAAA;ELizEF;AACF;AKhzEE;EACE,kBAAA;EACA,UAAA;ALkzEJ;AKhzEE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gCAAA;ALkzEJ;AKhzEE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,MAAA;EACA,gCAAA;EACA,+BAAA;ALkzEJ;AKjzEI;EACE,WAAA;ALmzEN;AKjzEI;EACE,OAAA;ALmzEN;AKhzEE;EAEE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,OAAA;EACA,MAAA;EACA,gCAAA;ALizEJ;AK/yEE;EACE,mEAAA;ALizEJ;AK/yEE;EACE,mEAAA;EACA,UAAA;ALizEJ;AK9yEI;EACE,UAAA;ALgzEN;AK9yEI;EACE,UAAA;ALgzEN;AK7yEM;EACE,SAAA;AL+yER;AK7yEM;EACE,UAAA;AL+yER;;AK1yEA;EACE,oBAAA;EACA,kBAAA;EACA,mBAAA;AL6yEF;AK5yEE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,8BAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;AL8yEJ;AK5yEE;EACE,WAAA;AL8yEJ;AK7yEI;EACE,UAAA;AL+yEN;;AK3yEA;EACE,oBAAA;EACA,mBAAA;EACA,SAAA;AL8yEF;AK7yEE;EACE,qBAAA;EACA,kBAAA;AL+yEJ;AK9yEI;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;EACA,8BAAA;EACA,oBAAA;EACA,uBAAA;EACA,8BAAA;EAEA,yBAAA;EACA,oCAAA;ALgzEN;AK7yEE;EACE,gCAAA;AL+yEJ;AK3yEM;EACE,oBAAA;EACA,gEAAA;AL6yER;AK1yEI;EACE,qBAAA;AL4yEN;;AKxyEA;EACE,mBAAA;AL2yEF;AK1yEE;EAFF;IAGI,mBAAA;EL6yEF;AACF;;AK3yEA;;EAEE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,uCAAA;EACA,kBAAA;EACA,6BAAA;AL8yEF;AK7yEE;;EACE,qBJxcK;ADwvFT;AK9yEE;EAbF;;IAcI,kBAAA;IACA,mBAAA;ELkzEF;AACF;;AKhzEA;EACE,WAAA;EACA,cAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;ALmzEF;AKlzEE;EACE,qBJxdK;AD4wFT;;AKjzEA;EACE,YAAA;ALozEF;;AKlzEA;;;;EAIE,8BJteU;AD2xFZ;;AKlzEA;;;;EAIE,8BJ7eU;ADkyFZ;;AKlzEA;;;;EAIE,8BJpfU;ADyyFZ;;AKnzEA;EACE,kBAAA;ALszEF;AKrzEE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,cJxfK;EIyfL,eAAA;EACA,oBAAA;EACA,aAAA;ALuzEJ;AKtzEI;EARF;IASI,SAAA;IACA,UAAA;ELyzEJ;AACF;;AKrzEA;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,uBAAA;EACA,eAAA;EACA,uBAAA;ALwzEF;AKvzEE;EAPF;IAQI,cAAA;EL0zEF;AACF;AKzzEE;EAVF;IAWI,cAAA;EL4zEF;AACF;AK3zEE;EAbF;IAcI,SAAA;IACA,oBAAA;EL8zEF;AACF;AK7zEE;EACE,iBAAA;AL+zEJ;AK9zEI;EAFF;IAGI,iBAAA;ELi0EJ;AACF;AKh0EI;EALF;IAMI,iBAAA;ELm0EJ;AACF;AKl0EI;EARF;IASI,gBAAA;ELq0EJ;AACF;AKp0EI;EAXF;IAYI,WAAA;ELu0EJ;AACF;AKt0EI;EACE,cAAA;ALw0EN;AKr0EE;EACE;IACE,gBAAA;ELu0EJ;AACF;;AKp0EA;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;ALu0EF;AKt0EE;EANF;IAOI,gBAAA;IACA,kBAAA;ELy0EF;AACF;AKx0EE;EAVF;IAWI,gBAAA;EL20EF;AACF;AK10EE;EAbF;IAcI,eAAA;EL60EF;AACF;AK50EE;EAhBF;IAiBI,kBAAA;EL+0EF;AACF;AK90EE;EACE,YAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;ALg1EJ;AK/0EI;EACE,+BAAA;ALi1EN;AK90EE;EACE,cAAA;EACA,mBAAA;EACA,kBAAA;ALg1EJ;AK/0EI;EAJF;IAKI,SAAA;ELk1EJ;AACF;AKj1EI;EACE,kBAAA;EACA,UAAA;ALm1EN;AKj1EI;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,SAAA;EACA,QAAA;EACA,2CAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;ALm1EN;AKl1EM;EAZF;IAaI,yBAAA;ELq1EN;AACF;AKh1EM;EACE,UAAA;EACA,yCAAA;ALk1ER;;AK70EA;EACE,aAAA;ALg1EF;AK/0EE;EACE,cAAA;ALi1EJ;;AK70EA;EACE,aAAA;EACA,mBAAA;ALg1EF;AK90EE;EAJF;IAKI,SAAA;IACA,8BAAA;ELi1EF;AACF;AKh1EE;EACE,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,iBAAA;ALk1EJ;AKj1EI;EANF;IAOI,gBAAA;IACA,mBAAA;ELo1EJ;AACF;AKn1EI;EAVF;IAWI,WAAA;IACA,kBAAA;ELs1EJ;AACF;AKp1EE;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,+BAAA;EACA,UAAA;EACA,UAAA;ALs1EJ;AKr1EI;EAPF;IAQI,WAAA;IACA,aAAA;IACA,uBAAA;IACA,6BAAA;IACA,eAAA;ELw1EJ;EKv1EI;IACE,aAAA;ELy1EN;AACF;AKv1EI;EACE,kBAAA;ALy1EN;AKx1EM;EAFF;IAGI,iBAAA;EL21EN;AACF;AK11EM;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,gBAAA;EACA,yBJ1qBC;EI2qBD,yBAAA;AL41ER;AK31EQ;EAXF;IAYI,cAAA;IACA,MAAA;IACA,SAAA;EL81ER;AACF;AK51EM;EACE,mBAAA;AL81ER;AK71EQ;EAFF;IAGI,gBAAA;ELg2ER;AACF;AK91EM;EACE,mBAAA;ALg2ER;AK/1EQ;EAFF;IAGI,eAAA;ELk2ER;AACF;AK/1EQ;EACE,qBAAA;ALi2EV;AK/1EQ;EACE,qDAAA;ALi2EV;AK71EI;EACE,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AL+1EN;AK91EM;EANF;IAOI,kBAAA;IACA,kBAAA;ELi2EN;AACF;AKh2EM;EAVF;IAWI,kBAAA;IACA,iBAAA;ELm2EN;AACF;AKl2EM;EAdF;IAeI,aAAA;IACA,mBAAA;ELq2EN;AACF;AKp2EM;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;ALs2ER;AKn2EI;EACE,oBAAA;EACA,mBAAA;EACA,cAAA;ALq2EN;AKp2EM;EAJF;IAKI,SAAA;ELu2EN;AACF;AKt2EM;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;ALw2ER;AKv2EQ;EALF;IAMI,YAAA;IACA,WAAA;EL02ER;AACF;AKz2EQ;EATF;IAUI,YAAA;IACA,WAAA;EL42ER;AACF;AK12EM;EACE,kBAAA;AL42ER;;AKt2EA;EACE,WAAA;EACA,kBAAA;EACA,eAAA;ALy2EF;AKx2EE;EACE,aAAA;EACA,QAAA;AL02EJ;AKx2EE;EACE,aAAA;EACA,QAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,gBAAA;EACA,UAAA;AL02EJ;;AKt2EA;EACE,kBAAA;ALy2EF;AKx2EE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;AL02EJ;AKv2EQ;EACE,mBAAA;ALy2EV;AKp2EE;EACE,cAAA;EACA,kBAAA;ALs2EJ;AKr2EI;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;ALu2EN;AKr2EI;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,yBJnzBG;EIozBH,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;ALu2EN;;AKn2EA;EACE,aAAA;EACA,eAAA;EACA,cAAA;ALs2EF;AKr2EE;EAJF;IAKI,cAAA;ELw2EF;AACF;;AKt2EA;EACE,kBAAA;ALy2EF;AKx2EE;EACE,aAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,gHAAA;EAKA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;ALs2EJ;AKr2EI;EACE,cAAA;EACA,UAAA;EACA,SAAA;ALu2EN;AKr2EI;EACE,UAAA;EACA,QAAA;ALu2EN;AKr2EI;EACE,UAAA;EACA,QAAA;ALu2EN;AKr2EI;EACE,WAAA;EACA,YAAA;EACA,YAAA;ALu2EN;AKr2EI;EACE,WAAA;EACA,QAAA;ALu2EN;AKp2EE;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;ALs2EJ;AKp2EE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;ALs2EJ;;AKl2EE;EACE,kBAAA;ALq2EJ;AKn2EE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;ALq2EJ;AKp2EI;EALF;IAMI,UAAA;IACA,UAAA;ELu2EJ;AACF;AKt2EI;EATF;IAUI,UAAA;IACA,UAAA;ELy2EJ;AACF;AKx2EI;EAbF;IAcI,aAAA;EL22EJ;AACF;;AKt2EE;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;ALy2EJ;AKx2EI;EAJF;IAKI,WAAA;EL22EJ;AACF;AK12EI;EAPF;IAQI,WAAA;EL62EJ;AACF;AK52EI;EAVF;IAWI,WAAA;IACA,kBAAA;IACA,mBAAA;EL+2EJ;AACF;AK92EI;EAfF;IAgBI,kBAAA;IACA,mBAAA;IACA,WAAA;ELi3EJ;AACF;AKh3EI;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,gCAAA;EACA,6DAAA;ALk3EN;AKj3EM;EATF;IAUI,WAAA;IACA,gCAAA;ELo3EN;AACF;AK32EE;EACE,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,iBAAA;EACA,oBAAA;AL62EJ;AK32EI;EAPF;IAQI,iBAAA;EL82EJ;AACF;AK72EI;EAVF;IAWI,iBAAA;ELg3EJ;AACF;;AKr2EA;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;ALw2EF;AKv2EE;EARF;IASI,SAAA;EL02EF;AACF;AKz2EE;EACE,mBAAA;EACA,gBAAA;EACA,mDAAA;EACA,YAAA;EACA,WAAA;EACA,cJv+BM;ADk1GV;AK12EI;EACE,yBJp+BG;EIq+BH,WAAA;EACA,oBAAA;AL42EN;AKz2EE;EACE,yBJ1+BK;EI2+BL,WAAA;AL22EJ;AKz2EE;EACE,yBAAA;AL22EJ;AK12EI;EACE,WAAA;AL42EN;AK12EI;EACE,qBAAA;AL42EN;;AKv2EA;EACE,sBAAA;EACA,qDAAA;EACA,kBAAA;AL02EF;AKz2EE;EAJF;IAKI,kBAAA;EL42EF;AACF;AK32EE;EAPF;IAQI,kBAAA;EL82EF;AACF;AK72EE;EACE,aAAA;EACA,eAAA;EACA,cAAA;AL+2EJ;AK92EI;EAJF;IAKI,cAAA;ELi3EJ;AACF;AK/2EE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;ALi3EJ;AKh3EI;EAPF;IAQI,mBAAA;ELm3EJ;EKl3EI;IACE,WAAA;ELo3EN;AACF;AKl3EI;EAbF;IAcI,mBAAA;IACA,SAAA;ELq3EJ;EKp3EI;IACE,WAAA;ELs3EN;AACF;AKn3EE;EACE,UAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;ALq3EJ;AKn3EE;EACE,cAAA;EACA,cJ5iCM;EI6iCN,gBAAA;EACA,kBAAA;EACA,gBAAA;ALq3EJ;AKn3EE;;EAEE,SAAA;EACA,gCAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,yBAAA;ALq3EJ;AKp3EI;;EACE,qBJtjCG;AD66GT;AKp3EE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;ALs3EJ;AKr3EI;EANF;IAOI,SAAA;IACA,YAAA;ELw3EJ;AACF;AKv3EI;EAVF;IAWI,WAAA;EL03EJ;AACF;AKx3EE;EACE,SAAA;AL03EJ;AKx3EE;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,8BAAA;AL03EJ;AKz3EI;EALF;IAMI,cAAA;EL43EJ;AACF;AK33EI;EARF;IASI,SAAA;EL83EJ;AACF;AK73EI;EAXF;IAYI,sBAAA;ELg4EJ;AACF;AK93EE;EACE,kBAAA;ALg4EJ;AK/3EI;EACE,qBAAA;EACA,kBAAA;EACA,yBAAA;ALi4EN;AKh4EM;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,yBJvmCC;EIwmCD,yBAAA;ALk4ER;AK/3EI;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;ALi4EN;AK/3EQ;EACE,cJ3nCA;AD4/GV;AKh4EU;EACE,WAAA;ALk4EZ;AK53EE;EACE,gCAAA;EACA,sBAAA;EACA,gBAAA;EACA,oCAAA;EACA,6BAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AL83EJ;AK73EI;EAXF;IAYI,kBAAA;ELg4EJ;AACF;AK/3EI;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,sBAAA;EACA,cJnpCG;ADohHT;AKh4EM;EACE,yBAAA;ALk4ER;AKh4EM;EAXF;IAYI,UAAA;IACA,QAAA;IACA,qBAAA;ELm4EN;EKl4EM;IACE,oCAAA;ELo4ER;AACF;AKj4EI;EACE,WAAA;ALm4EN;AKj4EI;EACE,WAAA;EACA,mBAAA;ALm4EN;AKl4EM;EAHF;IAII,mBAAA;ELq4EN;AACF;AKp4EM;;EAEE,6BAAA;EACA,sCAAA;EACA,WAAA;EACA,mBAAA;ALs4ER;AKr4EQ;;EACE,+BAAA;ALw4EV;AKt4EQ;;EACE,+BAAA;ALy4EV;AKv4EQ;;EACE,kBAAA;AL04EV;;AKp4EA;EACE,gBAAA;EACA,oDAAA;ALu4EF;;AKr4EA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,SAAA;EACA,eAAA;ALw4EF;;AKt4EA;EACE,SAAA;EACA,eAAA;ALy4EF;;AKv4EA;EACE,cJhtCQ;AD0lHV;;AKx4EA;EACE,8BJptCU;AD+lHZ;;AKz4EA;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;AL44EF;AK34EE;EACE,WAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;AL64EJ;AK34EE;EACE,kBAAA;AL64EJ;AK34EE;EACE,kBAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;AL64EJ;AK54EI;EACE,cJ/uCG;AD6nHT;;AK14EA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;AL64EF;AK54EE;EAPF;IAQI,SAAA;IACA,kBAAA;EL+4EF;AACF;AK94EE;EAXF;IAYI,SAAA;IACA,kBAAA;ELi5EF;AACF;AKh5EE;EAfF;IAgBI,iBAAA;IACA,iBAAA;IACA,oBAAA;ELm5EF;AACF;;AKj5EA;EACE,aAAA;EACA,qBAAA;ALo5EF;AKn5EE;EAHF;IAII,sBAAA;ELs5EF;AACF;AKr5EE;EACE,mBAAA;EACA,oDAAA;ALu5EJ;AKt5EI;EAHF;IAII,gBAAA;ELy5EJ;AACF;AKt5EE;EACE,SAAA;EACA,6BAAA;ALw5EJ;AKv5EI;EAHF;IAII,4BAAA;EL05EJ;AACF;AKz5EI;EANF;IAOI,2BAAA;EL45EJ;AACF;AK35EI;EATF;IAUI,0BAAA;EL85EJ;AACF;AK75EI;EAZF;IAaI,yBAAA;IACA,WAAA;ELg6EJ;AACF;AK95EE;EACE,YAAA;EACA,WAAA;EACA,yBJ1yCK;EI2yCL,WAAA;EACA,eAAA;ALg6EJ;AK95EE;EACE,uBAAA;ALg6EJ;AK/5EI;EAFF;IAGI,uBAAA;ELk6EJ;AACF;AKj6EI;EALF;IAMI,aAAA;ELo6EJ;AACF;AKn6EI;EACE;IACE,aAAA;ELq6EN;AACF;AKl6EE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;ALo6EJ;AKn6EI;EALF;IAMI,kBAAA;ELs6EJ;AACF;AKr6EI;EARF;IASI,kBAAA;ELw6EJ;AACF;AKv6EI;EAXF;IAYI,kBAAA;EL06EJ;AACF;AKz6EI;EAdF;IAeI,sBAAA;IACA,UAAA;IACA,kBAAA;EL46EJ;AACF;AK16EE;EACE,aAAA;EACA,mBAAA;EACA,cAAA;AL46EJ;AK36EI;EAJF;IAKI,cAAA;EL86EJ;AACF;AK76EI;EAPF;IAQI,cAAA;ELg7EJ;AACF;AK/6EI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;ALi7EN;AKh7EM;EAJF;IAKI,SAAA;ELm7EN;AACF;AKl7EM;EACE,+BAAA;ALo7ER;AK/6EI;EACE,aAAA;EACA,SAAA;EACA,mBAAA;ALi7EN;AKh7EM;EACE,kBAAA;ALk7ER;AKj7EQ;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,WAAA;EACA,QAAA;EACA,yBAAA;ALm7EV;AKh7EM;EACE,cJh4CA;ADkzHR;AKh7EU;EACE,UAAA;ALk7EZ;AK56EE;EACE,cAAA;AL86EJ;AK76EI;EAFF;IAGI,cAAA;ELg7EJ;AACF;AK/6EI;EALF;IAMI,eAAA;ELk7EJ;AACF;;AK/6EA;EACE,oDAAA;ALk7EF;AKj7EE;EACE,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;ALm7EJ;;AK76EE;;;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;ALk7EJ;AKj7EI;;;;;;EAEE,kBAAA;EACA,OAAA;EACA,QAAA;ALu7EN;;AKl7EE;EACE,eAAA;ALq7EJ;AKn7EE;EACE,gBAAA;EACA,kBAAA;EACA,SAAA;ALq7EJ;AKp7EI;EACE,kBAAA;EACA,kBAAA;ALs7EN;AKr7EM;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBJp7CC;EIq7CD,kBAAA;EACA,OAAA;EACA,QAAA;ALu7ER;AKr7EM;EACE,mBAAA;ALu7ER;;AKh7EI;EACE,kBAAA;EACA,kBAAA;ALm7EN;AKl7EM;;EAEE,kBAAA;EACA,OAAA;EACA,QAAA;ALo7ER;AKl7EM;EACE,mBAAA;ALo7ER;;AK96EE;EACE,oDAAA;EACA,kBAAA;EACA,gBAAA;ALi7EJ;AKh7EI;EACE,aAAA;EACA,8BAAA;ALk7EN;AKj7EM;EACE,mBAAA;ALm7ER;AKj7EM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;ALm7ER;AKl7EQ;EACE,cJj+CD;ADq5HT;;AK96EA;EACE,kBAAA;ALi7EF;AKh7EE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;ALk7EJ;AKj7EI;EAVF;IAWI,aAAA;ELo7EJ;AACF;AKn7EI;EAbF;IAcI,aAAA;ELs7EJ;AACF;AKr7EI;EAhBF;IAiBI,aAAA;ELw7EJ;AACF;AKt7EE;EACE,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;ALw7EJ;AKv7EI;EAPF;IAQI,UAAA;EL07EJ;AACF;AKz7EI;EAVF;IAWI,UAAA;EL47EJ;AACF;AK37EI;EAbF;IAcI,iBAAA;IACA,gBAAA;IACA,kBAAA;EL87EJ;AACF;AK77EI;EACE,YAAA;EACA,WAAA;EACA,sBAAA;EACA,cJnhDG;EIohDH,eAAA;AL+7EN;;AKz7EI;EACE,mBAAA;AL47EN;AK37EM;EAFF;IAGI,mBAAA;EL87EN;AACF;AK77EM;EALF;IAMI,mBAAA;ELg8EN;AACF;;AK57EA;EACE,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AL+7EF;AK97EE;EAEE,WAAA;EACA,yBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AL+7EJ;AK77EE;EACE,WAAA;AL+7EJ;AK77EE;EACE,UAAA;EACA,WAAA;EACA,MAAA;EACA,YAAA;AL+7EJ;AK77EE;EAzBF;IA0BI,aAAA;ELg8EF;AACF;;AK77EA;EACE,kBAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;ALg8EF;AK/7EE;EACE,kBAAA;ALi8EJ;AKh8EI;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,uCAAA;ALk8EN;AK97EM;EACE,yBJxlDC;ADwhIT;;AK17EA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;AL67EF;AK57EE;EAEE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;EACA,sBAAA;EACA,UAAA;AL67EJ;AK37EE;EACE,MAAA;AL67EJ;AK37EE;EACE,SAAA;EACA,YAAA;AL67EJ;AK37EE;EACE,SAAA;EACA,6CAAA;EACA,kBAAA;EACA,eAAA;AL67EJ;AK57EI;EACE,eAAA;AL87EN;AK57EI;EACE,YAAA;AL87EN;AK57EI;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,qBAAA;EACA,WAAA;EACA,kBAAA;AL87EN;;AKz7EE;EACE,wBAAA;AL47EJ;;AK77EE;EACE,wBAAA;ALg8EJ;;AKj8EE;EACE,wBAAA;ALo8EJ;;AKr8EE;EACE,wBAAA;ALw8EJ;;AKz8EE;EACE,wBAAA;AL48EJ;;AK78EE;EACE,wBAAA;ALg9EJ;;AKj9EE;EACE,yBAAA;ALo9EJ;;AKr9EE;EACE,yBAAA;ALw9EJ;;AKz9EE;EACE,yBAAA;AL49EJ;;AK79EE;EACE,yBAAA;ALg+EJ;;AKj+EE;EACE,yBAAA;ALo+EJ;;AKr+EE;EACE,yBAAA;ALw+EJ;;AKz+EE;EACE,yBAAA;AL4+EJ;;AKz+EA;EACE,mBAAA;EACA,2BAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,sBAAA;AL4+EF;AK3+EE;EACE,gBAAA;AL6+EJ;AK5+EI;EACE,gCAAA;EACA,oBAAA;EACA,mBAAA;AL8+EN;AK3+EE;EAjBF;IAkBI,kBAAA;EL8+EF;AACF;;AK5+EA;EACE,mBAAA;EACA,oDAAA;AL++EF;AK9+EE;EAHF;IAII,aAAA;ELi/EF;AACF;AKh/EE;EANF;IAOI,kBAAA;ELm/EF;AACF;;AKh/EA;EACE,aAAA;ALm/EF;AKl/EE;EAFF;IAGI,aAAA;ELq/EF;AACF;AKp/EE;EALF;IAMI,aAAA;ELu/EF;AACF;AKt/EE;EARF;IASI,aAAA;ELy/EF;AACF;AKx/EE;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AL0/EJ;;AKv/EA;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA;AL0/EF;AKx/EI;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,cJ9sDG;EI+sDH,eAAA;AL0/EN;AKz/EM;EACE,yBJjtDC;EIktDD,WAAA;EACA,kBAAA;AL2/ER;;AKt/EA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;ALy/EF;AKx/EE;EAJF;IAKI,8BAAA;IACA,uBAAA;EL2/EF;AACF;;AKz/EA;EACE,aAAA;EACA,eAAA;EACA,SAAA;AL4/EF;AK3/EE;EAJF;IAKI,SAAA;EL8/EF;AACF;AK7/EE;EACE,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cJjvDM;ADgvIV;AK9/EI;EALF;IAMI,iBAAA;IACA,mBAAA;ELigFJ;AACF;AKhgFI;EACE,yBJlvDG;EImvDH,WAAA;ALkgFN;;AK9/EA;EACE,eAAA;EACA,mBAAA;EACA,cJ/vDQ;ADgwIV;AKhgFE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;ALkgFJ;AKjgFI;EALF;IAMI,eAAA;ELogFJ;AACF;AKlgFE;EACE,mBAAA;ALogFJ;AKlgFE;EACE,mBAAA;ALogFJ;AKlgFM;EACE,mBAAA;ALogFR;AKhgFE;EACE,iBAAA;EACA,mBAAA;EACA,sBAAA;EACA,2BAAA;EACA,cAAA;EACA,wBAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;ALkgFJ;AKjgFI;EAdF;IAeI,wBAAA;ELogFJ;AACF;AKngFI;EAjBF;IAkBI,eAAA;ELsgFJ;AACF;AKrgFI;EApBF;IAqBI,sBAAA;IACA,iBAAA;ELwgFJ;AACF;AKvgFI;EAxBF;IAyBI,gBAAA;EL0gFJ;AACF;AKzgFI;EACE,SAAA;EACA,WAAA;EACA,yBJ7yDG;EI8yDH,6BAAA;EACA,kBAAA;EACA,yBAAA;AL2gFN;AK1gFM;EAPF;IAQI,6BAAA;EL6gFN;AACF;AK5gFM;EAVF;IAWI,4BAAA;EL+gFN;AACF;AK9gFM;EACE,YAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,+BAAA;ALghFR;AK/gFQ;EAPF;IAQI,UAAA;ELkhFR;AACF;AKjhFQ;EAVF;IAWI,aAAA;ELohFR;AACF;AKhhFE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;ALkhFJ;AKhhFE;EACE,gBAAA;EACA,UAAA;EACA,qBAAA;ALkhFJ;AKhhFM;EACE,mBAAA;ALkhFR;AK9gFE;EACE,gBAAA;ALghFJ;;AK7gFA;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,0BAAA;EACA,6BAAA;ALghFF;AK/gFE;EANF;IAOI,SAAA;ELkhFF;AACF;AKjhFE;EATF;IAUI,sBAAA;IACA,SAAA;ELohFF;AACF;AKnhFE;EACE,UAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;ALqhFJ;AKphFI;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,sBAAA;ALshFN;AKnhFE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;ALqhFJ;AKphFI;EALF;IAMI,kBAAA;ELuhFJ;AACF;;AKphFA;EACE,kBAAA;EACA,gBAAA;EACA,cJv4DQ;EIw4DR,eAAA;EACA,kBAAA;ALuhFF;AKthFE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;ALwhFJ;AKvhFI;EACE,yBJ34DG;EI44DH,qBJ54DG;ADq6IT;;AKnhFE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;ALshFJ;AKrhFI;EAJF;IAKI,eAAA;ELwhFJ;AACF;AKvhFI;EAPF;IAQI,eAAA;EL0hFJ;AACF;AKxhFE;EACE,kBAAA;EACA,gBAAA;AL0hFJ;AKtgFE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;ALwgFJ;AKvgFI;EAJF;IAKI,SAAA;IACA,WAAA;EL0gFJ;AACF;;AKtgFA;EACE,kBAAA;ALygFF;AKxgFE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AL0gFJ;AKzgFI;EALF;IAMI,eAAA;EL4gFJ;AACF;AK1gFE;EACE,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AL4gFJ;AK3gFI;EAPF;IAQI,eAAA;IACA,kBAAA;IACA,mBAAA;EL8gFJ;AACF;;AK1gFA,kBAAA;AACA;EACE,yBAAA;EACA,mBAAA;EACA,kBAAA;AL6gFF;AK5gFE;EAJF;IAKI,kBAAA;EL+gFF;AACF;;AK7gFA;EACE,gBAAA;EACA,UAAA;EACA,SAAA;ALghFF;AK/gFE;EACE,iBAAA;EACA,mBAAA;ALihFJ;AKhhFI;EAHF;IAII,UAAA;ELmhFJ;AACF;AKlhFI;EACE,gBAAA;ALohFN;AKjhFE;EACE,gBAAA;ALmhFJ;AKjhFM;EACE,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;ALmhFR;AK9gFI;EACE,gCAAA;EACA,mBAAA;ALghFN;AK7gFE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;AL+gFJ;AK9gFI;EALF;IAMI,oBAAA;ELihFJ;AACF;AKhhFI;EARF;IASI,gBAAA;IACA,oBAAA;IACA,kBAAA;ELmhFJ;AACF;AKjhFE;EACE,gBAAA;EACA,UAAA;EACA,SAAA;ALmhFJ;AKjhFE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;ALmhFJ;AKhhFI;EACE,aAAA;ALkhFN;AK/gFE;EACE,mBAAA;EACA,gBAAA;EACA,cJxiEM;EIyiEN,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;ALihFJ;AK/gFE;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,cJljEM;ADmkJV;AK9gFI;EACE,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;ALghFN;AK/gFM;EACE,cJ7jEE;AD8kJV;AK7gFE;;EAEE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AL+gFJ;AK9gFI;EANF;;IAOI,eAAA;ELkhFJ;AACF;AKjhFI;EATF;;IAUI,kBAAA;ELqhFJ;AACF;AKnhFE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,cAAA;EACA,kBAAA;ALqhFJ;AKphFI;EATF;IAUI,eAAA;ELuhFJ;AACF;AKthFI;EACE,qBAAA;EACA,kBAAA;ALwhFN;AKvhFM;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,8BAAA;EACA,QAAA;EACA,WAAA;EACA,yBAAA;ALyhFR;AKthFQ;EACE,UAAA;ALwhFV;AKphFI;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yDAAA;EACA,OAAA;EACA,wBAAA;EACA,2BAAA;EACA,QAAA;ALshFN;AKlhFI;EACE,gBAAA;ALohFN;;AK/gFA;EACE,gBAAA;EACA,eAAA;EACA,cJnoEQ;EIooER,qBAAA;EACA,kBAAA;ALkhFF;AKjhFE;EANF;IAOI,eAAA;ELohFF;AACF;;AKjhFA;EACE,eAAA;EACA,gBAAA;ALohFF;;AKjhFA;EACE,0BAAA;ALohFF;;AKjhFA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;ALohFF;;AKjhFA;EACE,0BAAA;ALohFF;;AKlhFA,gBAAA;AAEA,sBAAA;AACA;EACE,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,cJtqEQ;EIuqER,oBAAA;ALohFF;AKnhFE;EACE,cJzqEM;EI0qEN,mCAAA;EACA,wCAAA;EACA,mBAAA;EACA,cJxqEK;AD6rJT;AKnhFE;EACE,eAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;ALqhFJ;AKnhFE;EACE,2BAAA;ALqhFJ;AKnhFE;EACE,YAAA;ALqhFJ;;AKlhFA;EACE,cJ7rEQ;ADktJV;;AKlhFA,oBAAA;AACA,sBAAA;AACA;EACE,qBJ9rEO;EI+rEP,mBAAA;EACA,aAAA;EACA,cJtsEQ;AD2tJV;;AKnhFA;;;;;;EAME,YAAA;EACA,cJ/sEQ;EIgtER,uBAAA;EACA,kBAAA;ALshFF;;AKphFA;EACE,oBAAA;ALuhFF;;AKrhFA;EACE,eAAA;EACA,eAAA;ALwhFF;;AKthFA;EACE,uBAAA;EACA,YAAA;ALyhFF;;AKvhFA;EACE,YAAA;EACA,YAAA;AL0hFF;;AKvhFA;;;EAGE,cJjuEO;EIkuEP,gBAAA;AL0hFF;;AKxhFA;;;;;;;;EAQE,cJ5uEO;ADuwJT;;AKzhFA;;;;;;EAME,wCAAA;EACA,cJrvEO;EIsvEP,uCAAA;EACA,kBAAA;EACA,gBAAA;AL4hFF;;AK1hFA;EACE,cJhwEQ;EIiwER,gBAAA;EACA,iBAAA;AL6hFF;;AK3hFA;EACE,cJrwEQ;EIswER,gBAAA;EACA,eAAA;AL8hFF;;AK5hFA,oBAAA;AACA,qBAAA;AACA;EACE,sBAAA;AL+hFF;AK9hFE;EACE,YAAA;ALgiFJ;AK/hFI;EAFF;IAGI,YAAA;ELkiFJ;AACF;;AK/hFA;EACE,mCAAA;EACA,mBAAA;EACA,6BAAA;ALkiFF;AKjiFE;EAJF;IAKI,mBAAA;ELoiFF;AACF;;AKliFA;EACE,cAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cJlyEQ;EImyER,kBAAA;ALqiFF;AKpiFE;EARF;IASI,kBAAA;ELuiFF;AACF;;AKriFA;EAGE,8BJ1yEU;ADg1JZ;;AKpiFA;EAGE,SAAA;EACA,WAAA;EACA,WAAA;EACA,qBAAA;ALqiFF;AKpiFE;EAPF;IAQI,SAAA;ELuiFF;AACF;;AKriFA;EACE,mCAAA;EACA,mBAAA;ALwiFF;AKviFE;EAHF;IAII,mBAAA;EL0iFF;AACF;;AKxiFA;EACE,4BAAA;AL2iFF;;AKziFA;EACE,iBAAA;AL4iFF;;AK1iFA;EACE,mCAAA;EACA,mBAAA;AL6iFF;;AK3iFA;EACE,iBAAA;EACA,aAAA;AL8iFF;;AK5iFA;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;AL+iFF;;AK7iFA;EAEE,wCAAA;EACA,cJh1EO;AD+3JT;;AK7iFA;EACE,yBJn1EO;EIo1EP,YAAA;ALgjFF;;AK9iFA;EACE,oBAAA;EACA,cJ71EQ;AD84JV;;AK9iFA,mBAAA;AACA,oBAAA;AACA;EACE,eAAA;EACA,aAAA;EACA,WAAA;EACA,cJj2EO;EIk2EP,YAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,WAAA;EACA,yBJl3EM;EIm3EN,mDAAA;EACA,kBAAA;EACA,eAAA;ALijFF;AKhjFE;EACE,yBJr3EM;EIs3EN,cJx3EI;AD06JR;AKhjFE;EAtBF;IAuBI,WAAA;ELmjFF;AACF;;AKhjFA;EACE,YAAA;ALmjFF;AKljFE;EAFF;IAGI,YAAA;ELqjFF;AACF;;AKnjFA,kBAAA;AACA,yBAAA;AACA;EACE;IAEE,8BAAA;ELqjFF;EKljFA;IACE,iCAAA;ELojFF;EKjjFA;IACE,iCAAA;ELmjFF;EKhjFA;IACE,iCAAA;ELkjFF;EK/iFA;IACE,iCAAA;ELijFF;EK9iFA;IACE,8BAAA;ELgjFF;AACF;AK7iFA;EACE;IACE,uDAAA;IACA,2BAAA;EL+iFF;AACF;AK5iFA;EACE;IACE,wDAAA;IACA,4BAAA;EL8iFF;AACF;AK3iFA;EACE;IACE,yBAAA;EL6iFF;AACF;AK1iFA;EACE;IACE,uDAAA;IACA,0CAAA;EL4iFF;AACF;AKziFA;EACE;IACE,uDAAA;IACA,yCAAA;EL2iFF;AACF;AKxiFA;EACE;IACE,uDAAA;IACA,2CAAA;EL0iFF;AACF;AKxiFA;EACE;IACE,qBAAA;EL0iFF;AACF;AKviFA,uBAAA;AACA;EACE,eAAA;EACA,OAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cJj9EO;EIk9EP,sBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gCAAA;EACA,YAAA;EACA,UAAA;EACA,iBAAA;EACA,mDAAA;ALyiFF;;AKtiFA;;EAEE,eAAA;EACA,kBAAA;EACA,gCAAA;EAEA,aAAA;ALwiFF;AKviFE;EAPF;;IAQI,wBAAA;EL2iFF;AACF;;AKziFA;EACE,WAAA;EACA,YAAA;EAEA,wCAAA;EACA,OAAA;EACA,MAAA;EACA,oBAAA;EACA,iBAAA;AL2iFF;;AKziFA;EACE,UAAA;EACA,WAAA;EACA,yBJz/EO;EI0/EP,OAAA;EACA,MAAA;EACA,oBAAA;EACA,gBAAA;AL4iFF;;AKziFE;EAEI;IACE,aAAA;EL2iFN;AACF;;AKviFA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,YAAA;EACA,SAAA;AL0iFF;AKziFE;EACE;IACE,oBAAA;EL2iFJ;AACF;;AKviFE;EACE,mBAAA;AL0iFJ;;AKviFA;EACE,aAAA;EACA,kBAAA;AL0iFF;AKziFE;EACE,UAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AL2iFJ;AK1iFI;EARF;IASI,YAAA;IACA,WAAA;IACA,YAAA;EL6iFJ;AACF;AK5iFI;EAbF;IAcI,YAAA;IACA,WAAA;IACA,YAAA;EL+iFJ;EK9iFI;IACE,WAAA;IACA,YAAA;ELgjFN;AACF;AK9iFI;EACE,YAAA;EACA,WAAA;EACA,iBAAA;ALgjFN;AK9iFI;EA3BF;IA4BI,aAAA;ELijFJ;EKhjFI;IAGE,aAAA;ELgjFN;AACF;;AMvnKA;;iEAAA;AAGA;EACE,aAAA;AN0nKF;AMznKE;EACE,WAAA;AN2nKJ;;AMvnKE;EACE,kBAAA;EACA,mBAAA;AN0nKJ;AMxnKE;EACE,kBAAA;EACA,mBAAA;AN0nKJ;;AMtnKA;EACE,aAAA;EACA,SAAA;ANynKF;AMxnKE;EAHF;IAII,SAAA;EN2nKF;AACF;AM1nKE;;EAEE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;AN4nKJ;AM3nKI;EATF;;IAUI,WAAA;IACA,YAAA;EN+nKJ;AACF;AM9nKI;;EACE,mBAAA;ANioKN;AM/nKI;;EACE,yBLjCG;ADmqKT;AMjoKM;;EACE,+BAAA;ANooKR;AMhoKE;EA7BF;IA8BI,gBAAA;ENmoKF;AACF;;AMjoKA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;ANooKF;AMnoKE;;EAEE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;ANqoKJ;AMpoKI;;EACE,mBAAA;ANuoKN;AMroKI;;EACE,yBL9DG;ADssKT;AMvoKM;;EACE,+BAAA;AN0oKR;;AMroKA;EACE,wBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;ANwoKF;AMvoKE;EARF;IASI,gBAAA;EN0oKF;AACF;AMzoKE;EACE,YAAA;EACA,WAAA;EACA,sBAAA;EACA,yBAAA;EACA,UAAA;EACA,oBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;AN2oKJ;AM1oKI;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;AN4oKN;AM1oKI;EACE,yBLlGG;AD8uKT;;AMxoKA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AN2oKF;AM1oKE;EAJF;IAKI,sBAAA;IACA,uBAAA;IACA,SAAA;EN6oKF;AACF;AM5oKE;EACE;IACE,aAAA;EN8oKJ;AACF;;AM1oKE;EACE,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;AN6oKJ;AM5oKI;EALF;IAMI,gBAAA;IACA,eAAA;IACA,uBAAA;EN+oKJ;AACF;AM7oKE;EACE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,UAAA;EACA,cAAA;EACA,UAAA;AN+oKJ;AM9oKI;EAPF;IAQI,wBAAA;ENipKJ;AACF;AMhpKI;EACE,yBL5IG;AD8xKT;AMjpKM;EACE,qBAAA;ANmpKR;AM/oKE;EACE;IACE,iBAAA;ENipKJ;EMhpKI;IACE,UAAA;IACA,yBAAA;ENkpKN;EMjpKM;IACE,UAAA;ENmpKR;AACF;;AM9oKA;EACE,kBAAA;ANipKF;AMhpKE;EACE,iBAAA;ANkpKJ;AMhpKE;EACE,UAAA;EACA,yBAAA;ANkpKJ;AMjpKI;EACE,UAAA;ANmpKN;AM/oKI;;EAEE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,sBAAA;EACA,WAAA;EACA,oDAAA;EACA,UAAA;ANipKN;AMhpKM;EATF;;IAUI,UAAA;IACA,WAAA;IACA,YAAA;IACA,aAAA;ENopKN;AACF;AMnpKM;;EACE,eAAA;ANspKR;AMnpKI;EACE,WAAA;ANqpKN;AMppKM;EAFF;IAGI,WAAA;ENupKN;AACF;AMrpKI;EACE,YAAA;ANupKN;AMtpKM;EAFF;IAGI,YAAA;ENypKN;AACF;AMppKM;;EAEE,UAAA;ANspKR;;AOh3KA;;iEAAA;AAGA;;EAEE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;APm3KF;;AOh3KA;;EAEE,+BAAA;APm3KF;;AOh3KA;EACE,eAAA;EACA,aAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;APm3KF;;AOh3KA;EACE,OAAA;EACA,oBAAA;EACA,OAAA;APm3KF;;AOh3KA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,gBAAA;EACA,6BAAA;EACA,UAAA;APm3KF;;AOh3KA;EACE,YAAA;EACA,YAAA;EACA,8BAAA;APm3KF;;AOh3KA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,cAAA;EACA,iCAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,4BAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;APm3KF;;AOh3KA;EACE,wBAAA;EACA,UAAA;EACA,mBAAA;APm3KF;;AOh3KA;EACE,WAAA;EACA,qBAAA;EACA,YAAA;EACA,sBAAA;APm3KF;;AOh3KA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;APm3KF;;AOh3KA;EACE,WAAA;APm3KF;;AOh3KA;EACE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;APm3KF;;AOh3KA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;APm3KF;;AOh3KA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;APm3KF;;AOh3KA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gCAAA;APm3KF;;AOh3KA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;APm3KF;;AOh3KA;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gCAAA;APm3KF;;AOh3KA;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,wBAAA;EACA,gCAAA;APm3KF;;AOh3KA;;EAEE,gBAAA;APm3KF;;AOh3KA;EACE,kBAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;APm3KF;;AOh3KA;EACE,gBAAA;APm3KF;;AOh3KA,kBAAA;ACtLA;;iEAAA;AAIA;EACE,kBAAA;EACA,YAAA;ARyiLF;;AQtiLA;EACE,qBAAA;EACA,gBAAA;ARyiLF;;AQviLA;EACE,kBAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,yBAAA;AR0iLF;;AQxiLA;EACE,aAAA;EACA,SAAA;AR2iLF;AQ1iLE;EACE,YAAA;EACA,6BAAA;EACA,aAAA;EACA,UAAA;EACA,eAAA;EACA,yBAAA;AR4iLJ;AQ3iLI;EACE,cPrBG;ADkkLT;;AQxiLE;;EAEE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;EACA,aAAA;EACA,kBAAA;AR2iLJ;AQziLE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AR2iLJ;AQxiLI;EACE,cP/CI;ADylLV;AQviLI;EACE;IACE,WAAA;IACA,yBPrDE;ED8lLR;EQviLI;IACE,WAAA;ERyiLN;AACF;AQpiLM;EACE,WAAA;ARsiLR;AQpiLM;EACE,WAAA;ARsiLR;AQjiLI;EACE,WAAA;ARmiLN;AQjiLI;EACE,WAAA;ARmiLN;;AQ7hLE;EACE,yBPpFI;EOqFJ,mDAAA;ARgiLJ;AQ7hLE;EACE,aAAA;EACA,mBAAA;AR+hLJ;AQ9hLI;EACE,iBAAA;ARgiLN;AQ7hLM;EACE,kBAAA;AR+hLR;;AQzhLA;EACE,eAAA;EACA,gBAAA;AR4hLF;;AQzhLA;EACE,gCAAA;AR4hLF;AQ1hLE;EACE,aAAA;EACA,mBAAA;AR4hLJ;AQzhLE;EACE,iBAAA;AR2hLJ;AQxhLE;EACE,YAAA;EACA,yBPzHI;ADmpLR;;AQvhLA;EACE,eAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,yBAAA;EACA,yBAAA;EACA,UAAA;EACA,kBAAA;AR0hLF;AQzhLE;EACE,UAAA;EACA,mBAAA;AR2hLJ;;AQvhLA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,uCAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;AR0hLF;;AQvhLA;EACE,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AR0hLF;AQzhLE;EACE,wBAAA;AR2hLJ;AQxhLI;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;AR0hLN;AQvhLE;EACE,yBPxKM;EOyKN,WAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;ARyhLJ;AQxhLI;EACE,yBPzKG;ADmsLT;AQvhLE;EACE,mBAAA;ARyhLJ;;AQthLA;EACE,YAAA;EACA,aAAA;EACA,6BAAA;EACA,eAAA;EACA,yBAAA;ARyhLF;AQxhLE;EACE,wBAAA;AR0hLJ;;AQvhLA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;AR0hLF;AQzhLE;EACE,UAAA;EACA,mBAAA;AR2hLJ;;AQxhLA;EACE,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,eAAA;AR2hLF;AQ1hLE;EACE,eAAA;AR4hLJ;AQ3hLI;EACE,mBAAA;EACA,4BAAA;EACA,eAAA;EACA,YAAA;AR6hLN;AQ5hLM;EALF;IAMI,4BAAA;IACA,eAAA;IACA,YAAA;ER+hLN;AACF;AQ7hLI;EACE,WAAA;AR+hLN;AQ9hLM;EAFF;IAGI,WAAA;ERiiLN;AACF;AQhiLM;EACE,WAAA;EACA,YAAA;ARkiLR;AQjiLQ;EAHF;IAII,WAAA;IACA,YAAA;ERoiLR;AACF;;AQ/hLA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;ARkiLF;AQjiLE;EAJF;IAKI,WAAA;ERoiLF;AACF;;AQliLA;EACE;IACE,eAAA;ERqiLF;EQjiLE;IACE,aAAA;ERmiLJ;AACF;AQ/hLA;EACE,SAAA;EACA,UAAA;EACA,gBAAA;ARiiLF;;AQ9hLA;EACE,0BAAA;EACA,WAAA;EACA,YAAA;ARiiLF;;AQ/hLA;EACE,0BAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;ARkiLF;AQjiLE;EACE,YAAA;ARmiLJ;AQjiLE;EACE,yBPzRM;AD4zLV;;AQ/hLA;EACE,iBAAA;EACA,UAAA;EACA,mBAAA;EACA,gDAAA;ARkiLF;;AQ/hLA;EACE,qBAAA;ARkiLF;;AQ/hLA;EAGM;IACE,cP5SE;ED40LR;EQ5hLA;IACE,kBAAA;ER8hLF;EQ5hLE;IACE,mBAAA;IACA,kBAAA;ER8hLJ;EQ1hLA;;IAEE,kBAAA;IACA,SAAA;IACA,QAAA;IACA,gCAAA;ER4hLF;EQxhLE;IACE,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,YAAA;IACA,WAAA;IACA,6BAAA;ER0hLJ;EQxhLE;IACE,YAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,eAAA;ER0hLJ;EQthLA;IACE,aAAA;IACA,mBAAA;IACA,YAAA;IACA,kBAAA;ERwhLF;EQthLE;IACE,wBAAA;IACA,eAAA;IACA,eAAA;ERwhLJ;EQthLI;IACE,kBAAA;IACA,eAAA;ERwhLN;EQthLM;IACE,eAAA;ERwhLR;EQrhLM;IACE,eAAA;IACA,oBAAA;IACA,kBAAA;IACA,eAAA;IACA,mBAAA;ERuhLR;EQphLM;IACE,OAAA;IACA,sBAAA;ERshLR;EQlhLQ;IACE,SAAA;IACA,UAAA;IACA,mBAAA;IACA,yBAAA;ERohLV;EQhhLQ;IACE,kBAAA;ERkhLV;EQjhLU;IACE,WAAA;IACA,qBAAA;IACA,WAAA;IACA,UAAA;IACA,8BAAA;IACA,wBAAA;IACA,cAAA;IACA,aAAA;IACA,gBAAA;IACA,kBAAA;IACA,SAAA;IACA,8BAAA;ERmhLZ;EQ7gLI;IACE,kBAAA;ER+gLN;EQ5gLI;IACE,YAAA;IACA,sBAAA;IACA,kBAAA;IACA,gDAAA;IACA,eAAA;IACA,YAAA;IACA,UAAA;IACA,kBAAA;IACA,yBAAA;IACA,mBAAA;IACA,oDAAA;IACA,yBAAA;ER8gLN;EQ1gLU;IACE,QAAA;ER4gLZ;EQzgLU;IACE,UAAA;IACA,mBAAA;IACA,yBAAA;ER2gLZ;EQtgLM;IACE,cAAA;IACA,oBAAA;IACA,kBAAA;ERwgLR;EQrgLM;IACE,SAAA;IACA,UAAA;ERugLR;EQlgLA;;IAEE,aAAA;ERogLF;EQhgLE;IACE,kBAAA;ERkgLJ;EQhgLE;IACE,uBAAA;IACA,OAAA;IACA,wBAAA;IACA,kBAAA;IACA,sBAAA;ERkgLJ;EQhgLI;IACE,iBAAA;ERkgLN;EQ//KI;IACE,SAAA;IACA,eAAA;ERigLN;EQ//KM;IACE,eAAA;IACA,gBAAA;IACA,oBAAA;ERigLR;EQhgLQ;IACE,6BAAA;ERkgLV;EQ9/KM;IACE,iBAAA;IACA,YAAA;IACA,UAAA;IACA,WAAA;IACA,gBAAA;IACA,6BAAA;ERggLR;EQ//KQ;IACE,yBAAA;ERigLV;EQhgLU;IACE,mBAAA;ERkgLZ;EQx/KQ;IACE,UAAA;IACA,mBAAA;ER0/KV;EQn/KA;IAME,kBAAA;ERg/KF;AACF;AQ7+KA;EACE;IACE,wBAAA;ER++KF;EQ5+KA;IACE,gBAAA;ER8+KF;EQ3+KA;IACE,eAAA;ER6+KF;AACF;AQ1+KA;EACE;IACE,sBAAA;ER4+KF;EQ3+KE;IACE,yBPvhBI;EDogMR;EQ1+KA;IACE,aAAA;ER4+KF;EQ1+KA;IACE,mBAAA;ER4+KF;EQ1+KA;IACE,eAAA;ER4+KF;EQ1+KA;IACE,sBAAA;ER4+KF;EQ1+KA;IACE,eAAA;ER4+KF;EQ1+KA;IACE,kBAAA;IACA,YAAA;IACA,WAAA;IACA,MAAA;IACA,SAAA;IACA,aAAA;IACA,mBAAA;IACA,yBAAA;IACA,kBAAA;IACA,eAAA;IACA,UAAA;ER4+KF;EQ1+KE;IACE,cAAA;IACA,kBAAA;IACA,YAAA;IACA,WAAA;IACA,kBAAA;ER4+KJ;EQ3+KI;IAEE,WAAA;IACA,cAAA;IACA,kBAAA;IACA,SAAA;IACA,QAAA;IACA,gCAAA;IACA,WAAA;IACA,WAAA;IACA,8BAAA;IACA,yBAAA;ER4+KN;EQz+KI;IACE,8CAAA;ER2+KN;EQr+KM;IACE,6CAAA;ERu+KR;EQh+KI;IACE,kBAAA;ERk+KN;EQ99KA;IACE,kBAAA;IACA,YAAA;ERg+KF;EQ79KE;IACE,eAAA;IACA,YAAA;IACA,YAAA;IACA,sBAAA;IACA,cPxmBI;IOymBJ,eAAA;IACA,SAAA;IACA,cAAA;IACA,0BAAA;IACA,kBAAA;IACA,yBAAA;ER+9KJ;EQ99KI;IACE,SAAA;ERg+KN;EQ79KI;IACE,kBAAA;IACA,aAAA;ER+9KN;EQ59KI;IACE,cAAA;IACA,kBAAA;IACA,iBAAA;ER89KN;EQ39KM;IACE,eAAA;IACA,kBAAA;ER69KR;EQx9KE;IACE,kBAAA;ER09KJ;EQt9KA,qBAAA;EACA;IACE,qBAAA;IACA,WAAA;IACA,YAAA;IACA,eAAA;IACA,kBAAA;IACA,SAAA;IACA,WAAA;IACA,cPnpBM;ED2mMR;EQt9KE;;;IAGE,WAAA;IACA,WAAA;IACA,8BAAA;IACA,cAAA;IACA,kBAAA;ERw9KJ;EQr9KE;IACE,cAAA;IACA,kBAAA;IACA,SAAA;IACA,uBAAA;IACA,sBAAA;ERu9KJ;EQr9KI;IACE,WAAA;IACA,kBAAA;IACA,gBAAA;IACA,sCAAA;IACA,yBAAA;IACA,0BAAA;ERu9KN;EQp9KI;IACE,WAAA;IACA,kBAAA;IACA,eAAA;IACA,sCAAA;IACA,yBAAA;IACA,0BAAA;ERs9KN;EQj9KA;IACE,QAAA;IACA,UAAA;IACA,iBAAA;ERm9KF;EQ/8KE;IACE,kCAAA;IACA,sBAAA;ERi9KJ;EQ/8KI;IACE,aAAA;IACA,wBAAA;IACA,0BAAA;ERi9KN;EQ98KI;IACE,aAAA;IACA,yBAAA;IACA,0BAAA;ERg9KN;EQ38KA;IACE,kBAAA;ER68KF;EQ18KA;IACE,YAAA;ER48KF;EQz8KA;IACE,aAAA;ER28KF;EQx8KE;IACE,kBAAA;IACA,SAAA;IACA,QAAA;IACA,2BAAA;ER08KJ;EQv8KA;IACE,MAAA;ERy8KF;EQt8KA;IACE,aAAA;ERw8KF;AACF;AQr8KA;EACE;IACE,eAAA;ERu8KF;EQp8KE;IACE,kBAAA;ERs8KJ;AACF;AQn8KA;EACE;IACE,gBAAA;ERq8KF;AACF;AQn8KA,kBAAA;AACA;EACE;IACE,aAAA;IACA,wBAAA;IACA,kBAAA;IACA,aAAA;IACA,SAAA;IACA,2BAAA;IACA,eAAA;IACA,UAAA;ERq8KF;EQp8KE;IACE,aAAA;ERs8KJ;EQp8KE;IACE,kBAAA;IACA,oDAAA;IACA,yCAAA;ERs8KJ;EQp8KE;IACE,cAAA;IAEA,eAAA;IACA,cAAA;IACA,mBAAA;ERq8KJ;EQn8KE;IACE,wBAAA;ERq8KJ;AACF;AQl8KA;EACE;IACE,wBAAA;ERo8KF;AACF;AQl8KA,gBAAA;AAEE;EACE,sBAAA;ARm8KJ;AQh8KI;EADF;IAEI,iBAAA;IACA,eAAA;ERm8KJ;EQl8KI;IACE,aAAA;ERo8KN;AACF;AQl8KI;EARF;IASI,aAAA;ERq8KJ;AACF;;AS3vMA;;iEAAA;AAGA;EACE,kBAAA;AT8vMF;AS7vME;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,sBAAA;AT+vMJ;;AS5vMA;EACE,mBAAA;EACA,gBAAA;EACA,qDAAA;EACA,aAAA;EACA,oBAAA;EACA,8BAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AT+vMF;AS9vME;EAXF;IAYI,mBAAA;ETiwMF;AACF;AShwME;EAdF;IAeI,aAAA;ETmwMF;AACF;ASlwME;EAjBF;IAkBI,kBAAA;ETqwMF;ESpwME;IACE,aAAA;ETswMJ;AACF;ASpwME;EAvBF;IAwBI,sBAAA;IACA,uBAAA;ETuwMF;ESrwMI;IACE,aAAA;ETuwMN;AACF;ASpwME;EACE,eAAA;EACA,mBAAA;ATswMJ;ASpwME;EACE,cR/CM;EQgDN,SAAA;ATswMJ;ASpwME;EACE,gBAAA;ATswMJ;ASrwMI;EACE,mBAAA;ATuwMN;ASrwMI;EALF;IAMI,gBAAA;ETwwMJ;AACF;ASvwMI;EARF;IASI,eAAA;ET0wMJ;AACF;;ASnwME;;;;EACE,kBAAA;ATywMJ;ASvwME;;;;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;AT4wMJ;AS3wMI;EALF;;;;IAMI,UAAA;ETixMJ;AACF;AS/wME;;;;EACE,oBAAA;AToxMJ;ASnxMI;EAFF;;;;IAGI,oBAAA;ETyxMJ;AACF;ASxxMI;EALF;;;;IAMI,oBAAA;IACA,kBAAA;ET8xMJ;AACF;AS7xMI;EATF;;;;IAUI,oBAAA;ETmyMJ;AACF;ASjyME;EACE;;;;IACE,mBAAA;ETsyMJ;AACF;ASpyME;EACE;;;;IACE,kBAAA;ETyyMJ;AACF;ASvyME;EACE;;;;IACE,kBAAA;ET4yMJ;AACF;;ASxyME;EACE,oBAAA;AT2yMJ;;ASxyMA;EACE,kBAAA;AT2yMF;AS1yME;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,sBAAA;AT4yMJ;;ASzyMA;EACE,mBAAA;EACA,6DAAA;EACA,qDAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;AT4yMF;AS3yME;EAPF;IAQI,aAAA;ET8yMF;AACF;AS7yME;EACE,kBAAA;EACA,YAAA;EACA,YAAA;AT+yMJ;AS9yMI;EAJF;IAKI,YAAA;ETizMJ;AACF;AShzMI;EAPF;IAQI,aAAA;ETmzMJ;AACF;ASjzME;EACE,8BAAA;ATmzMJ;ASlzMI;EAFF;IAGI,8BAAA;ETqzMJ;AACF;ASpzMI;EALF;IAMI,4BAAA;ETuzMJ;AACF;AStzMI;EARF;IASI,4BAAA;ETyzMJ;AACF;ASvzME;EACE,gBAAA;ATyzMJ;ASvzME;EACE,mBAAA;ATyzMJ;ASxzMI;EAFF;IAGI,mBAAA;ET2zMJ;AACF;ASzzME;EACE,mBAAA;AT2zMJ;;ASxzMA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,6BAAA;AT2zMF;AS1zME;EANF;IAOI,sBAAA;IACA,uBAAA;IACA,SAAA;ET6zMF;AACF;AS5zME;EACE;IACE,aAAA;ET8zMJ;AACF;AS5zME;EACE,gBAAA;EACA,WAAA;AT8zMJ;AS5zME;EACE,sCAAA;EACA,WAAA;AT8zMJ;AS7zMI;EACE,sCAAA;AT+zMN;AS7zMI;EACE,+BAAA;AT+zMN;AS5zMI;EACE,+BAAA;AT8zMN;AS3zME;EACE,cRzMK;ADsgNT;AS5zMI;EACE,gBAAA;AT8zMN;AS5zMI;EACE,gBAAA;AT8zMN;AS5zMI;EACE,eAAA;AT8zMN;AS3zME;EACE,eAAA;EACA,gBAAA;AT6zMJ;AS5zMI;EAHF;IAII,eAAA;ET+zMJ;AACF;AS7zME;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AT+zMJ;AS7zMI;EALF;IAMI,sBAAA;IACA,uBAAA;IACA,SAAA;ETg0MJ;AACF;;AS7zMA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;ATg0MF;AS/zME;EACE,eAAA;EACA,gBAAA;EACA,SAAA;ATi0MJ;;AS9zMA;EACE,aAAA;EACA,eAAA;EACA,SAAA;ATi0MF;ASh0ME;EACE,YAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,0CAAA;EACA,cR7PK;EQ8PL,eAAA;EACA,uBAAA;ATk0MJ;ASj0MI;EACE,qBAAA;EACA,sBAAA;ATm0MN;;AS/zMA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;ATk0MF;ASj0ME;EAPF;IAQI,sBAAA;IACA,kBAAA;ETo0MF;AACF;;ASl0MA;EACE,+BAAA;ATq0MF;;ASn0MA;EACE,kBAAA;EACA,iBAAA;ATs0MF;ASr0ME;EAHF;IAII,iBAAA;ETw0MF;AACF;ASv0ME;EACE,kBAAA;EACA,0BAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA,+BAAA;EACA,sBAAA;ATy0MJ;ASx0MI;EARF;IASI,0BAAA;ET20MJ;AACF;ASz0ME;EACE,aAAA;EACA,YAAA;EACA,4BAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,2BAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;AT20MJ;AS10MI;EACE,2CAAA;AT40MN;AS10MI;EAjBF;IAkBI,aAAA;IACA,YAAA;IACA,WAAA;ET60MJ;AACF;AS30ME;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AT60MJ;AS50MI;EALF;IAMI,eAAA;ET+0MJ;AACF;AS70ME;EACE,gBAAA;AT+0MJ;AS70ME;EACE,eAAA;AT+0MJ;AS50MI;EACE,oBAAA;AT80MN;;AS10MA;EACE,aAAA;AT60MF;;AS10ME;EACE,aAAA;EACA,8BAAA;EACA,cAAA;EACA,oBAAA;AT60MJ;AS50MI;EALF;IAMI,sBAAA;IACA,MAAA;ET+0MJ;AACF;AS70ME;EACE,kBAAA;EACA,8CAAA;EACA,eAAA;AT+0MJ;AS70ME;EACE,sBAAA;EACA,uBAAA;AT+0MJ;AS70ME;EACE,sBAAA;EACA,cR5WK;AD2rNT;AS50MI;EACE,gBAAA;AT80MN;AS50MI;EACE,gBAAA;AT80MN;AS10MI;EACE,gBAAA;AT40MN;ASv0MM;EACE,WAAA;EACA,YAAA;ATy0MR;;ASp0MA;;EAEE,kBAAA;EACA,UAAA;ATu0MF;;ASr0MA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;ATw0MF;ASv0ME;EACE,SAAA;ATy0MJ;;ASt0MA;EACE,gBAAA;EACA,UAAA;EACA,SAAA;ATy0MF;ASx0ME;EACE,aAAA;EACA,uBAAA;AT00MJ;ASz0MI;EACE,mBAAA;AT20MN;ASx0ME;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AT00MJ;;ASr0MI;EACE,mBAAA;ATw0MN;;ASn0MA;EACE,eAAA;ATs0MF;ASr0ME;EAFF;IAGI,eAAA;ETw0MF;AACF;;ASt0MA;EACE,WAAA;EACA,aAAA;ATy0MF;;ASv0MA;EACE;IACE,wCAAA;ET00MF;ESv0MA;IACE,0CAAA;ETy0MF;ESv0MA;IACE,0CAAA;ETy0MF;AACF;ASt0ME;EACE,YAAA;EACA,eAAA;EACA,mEAAA;ATw0MJ;ASt0ME;EACE,cRndM;AD2xNV;;AUhyNA;;iEAAA;AAGA;EACE,mBAAA;AVmyNF;AUlyNE;EAFF;IAGI,kBAAA;EVqyNF;AACF;AUpyNE;EALF;IAMI,iBAAA;EVuyNF;AACF;AUtyNE;EACE;IACE,kBAAA;EVwyNJ;AACF;AUtyNE;EAbF;IAcI,iBAAA;EVyyNF;AACF;;AUvyNA;EACE,kBAAA;EACA,sBAAA;EACA,oDAAA;EACA,aAAA;AV0yNF;AUzyNE;EALF;IAMI,kBAAA;EV4yNF;AACF;AU3yNE;EARF;IASI,kBAAA;EV8yNF;AACF;AU7yNE;EACE,mBAAA;AV+yNJ;AU9yNI;EAFF;IAGI,mBAAA;EVizNJ;AACF;;AU7yNE;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;EACA,cTnCK;ESoCL,gBAAA;AVgzNJ;AU/yNI;EARF;IASI,eAAA;EVkzNJ;AACF;AUjzNI;EACE,kBAAA;EACA,kBAAA;AVmzNN;AUlzNM;EACE,mBAAA;AVozNR;AUnzNQ;EAFF;IAGI,mBAAA;EVszNR;AACF;AUpzNM;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,yDAAA;EACA,wBAAA;EACA,2BAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;AVszNR;;AUjzNA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AVozNF;AUnzNE;EALF;IAMI,eAAA;IACA,mBAAA;EVszNF;AACF;;AUpzNA;EACE,gBAAA;EACA,UAAA;EACA,SAAA;AVuzNF;AUrzNI;EACE,mBAAA;AVuzNN;AUtzNM;EAFF;IAGI,mBAAA;EVyzNN;AACF;;AUpzNA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cT5FO;ES6FP,mBAAA;AVuzNF;AUtzNE;EANF;IAOI,eAAA;IACA,mBAAA;EVyzNF;AACF;AUvzNI;EACE,0BAAA;AVyzNN;;AUpzNA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;AVuzNF;AUtzNE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AVwzNJ;AUtzNM;EACE,cT5HE;ADo7NV;AUvzNQ;EACE,cTzHD;ADk7NT;;AW57NA;;iEAAA;AAGA;EACE,yBAAA;AX+7NF;;AW57NA;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;AX+7NF;AW77NE;EACE,eAAA;EACA,mBAAA;AX+7NJ;;AW57NA;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;AX+7NF;AW77NE;EACE,eAAA;EACA,mBAAA;AX+7NJ;;AW57NA;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;AX+7NF;AW77NE;EACE,eAAA;EACA,mBAAA;AX+7NJ;;AW57NA;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;AX+7NF;AW77NE;EACE,eAAA;EACA,mBAAA;AX+7NJ;;AW37NA;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;AX87NF;AW57NE;EACE,eAAA;EACA,mBAAA;AX87NJ;;AW17NA;;EAEE,iBAAA;AX67NF;;AW17NA;;EAEE,UAAA;AX67NF;;AW17NA;;EAEE,UAAA;AX67NF;;AW17NA;;EAEE,iBAAA;AX67NF;;AW17NA;;EAEE,UAAA;AX67NF;;AW17NA;;EAEE,WAAA;AX67NF;;AW17NA;EACE,iBAAA;AX67NF;;AW17NA;;;;;EAKE,UAAA;AX67NF;;AW17NA;;;;;EAKE,UAAA;AX67NF;;AW17NA;;;;;EAKE,iBAAA;AX67NF;;AW17NA;;;;;EAKE,UAAA;AX67NF;;AW17NA;;;;;EAKE,iBAAA;AX67NF;;AW17NA;;;;;EAKE,WAAA;AX67NF;;AW17NA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;AX67NF;AW57NE;EAJF;IAKI,cAAA;EX+7NF;AACF;AW97NE;EAPF;IAQI,sBAAA;IACA,uBAAA;EXi8NF;AACF;AWh8NE;EACE,aAAA;EACA,eAAA;EACA,cAAA;AXk8NJ;AWj8NI;EAJF;IAKI,SAAA;EXo8NJ;AACF;AWn8NI;EAPF;IAQI,SAAA;EXs8NJ;AACF;AWr8NI;;EAEE,yBAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,cVnKI;EUoKJ,kBAAA;EACA,yBAAA;AXu8NN;AWt8NM;EATF;;IAUI,iBAAA;EX08NN;AACF;AWz8NM;;EACE,wCAAA;EACA,cVtKC;ADknOT;AWx8NM;;EAEE,WAAA;EACA,yBV7KC;ADunOT;;AWr8NA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AXw8NF;;AWt8NA;EACE,aAAA;EACA,SAAA;AXy8NF;AWx8NE;EACE,UAAA;EACA,YAAA;EACA,6BAAA;EACA,yBAAA;EACA,YAAA;AX08NJ;AWz8NI;EACE,UAAA;AX28NN;AWz8NI;EACE,UAAA;EACA,cVrMG;ADgpOT;;AWv8NA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;AX08NF;;AWx8NA;EACE;IACE,eAAA;IACA,mBAAA;EX28NF;EWx8NA;IACE,kBAAA;IACA,mBAAA;IACA,oBAAA;EX08NF;EWx8NA;IACE,kBAAA;IACA,mBAAA;IACA,oBAAA;EX08NF;EWx8NE;IACE,eAAA;IACA,mBAAA;EX08NJ;EWv8NA;;IAEE,iBAAA;EXy8NF;AACF;AWt8NA;EACE;;IAEE,UAAA;EXw8NF;EWr8NA;IACE,WAAA;EXu8NF;EWp8NA;;IAEE,UAAA;EXs8NF;EWn8NA;;IAEE,WAAA;EXq8NF;AACF;AWl8NA;EACE;;;;;;;;;;IAUE,WAAA;EXo8NF;EWj8NA;;IAEE,WAAA;EXm8NF;EWh8NA;;IAEE,WAAA;EXk8NF;EW/7NA;;IAEE,WAAA;EXi8NF;EW97NA;;IAEE,WAAA;EXg8NF;AACF;AY1uOA;;iEAAA;AAIA;EACE,cAAA;EACA,qBAAA;EACA,kBAAA;AZ2uOF;AY1uOE;EAJF;IAKI,cAAA;EZ6uOF;AACF;AY5uOE;EAPF;IAQI,cAAA;EZ+uOF;AACF;AY9uOE;EAVF;IAWI,aAAA;EZivOF;AACF;AYhvOE;EAbF;IAcI,cAAA;EZmvOF;AACF;AYlvOE;EAhBF;IAiBI,eAAA;EZqvOF;AACF;AYpvOE;EACE,kBAAA;EACA,UAAA;AZsvOJ;AYpvOE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AZsvOJ;AYrvOI;EALF;IAMI,kBAAA;EZwvOJ;AACF;AYvvOI;EARF;IASI,kBAAA;EZ0vOJ;AACF;AYzvOI;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AZ2vON;AYxvOE;EACE,mBAAA;EACA,gBAAA;AZ0vOJ;AYzvOI;EAHF;IAII,gBAAA;EZ4vOJ;AACF;AY3vOI;EANF;IAOI,gBAAA;EZ8vOJ;AACF;AY7vOI;EATF;IAUI,mBAAA;EZgwOJ;AACF;AY9vOE;EACE,gBAAA;EACA,oBAAA;AZgwOJ;AY/vOI;EAHF;IAII,gBAAA;EZkwOJ;AACF;AYjwOI;EANF;IAOI,gBAAA;EZowOJ;AACF;AYnwOI;EATF;IAUI,mBAAA;EZswOJ;AACF;AYnwOE;EACE,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;AZqwOJ;AYpwOI;EAVF;IAWI,aAAA;EZuwOJ;AACF;AYtwOI;EAbF;IAcI,kBAAA;IACA,SAAA;EZywOJ;AACF;AYxwOI;EAjBF;IAkBI,uBAAA;EZ2wOJ;AACF;AY1wOI;EApBF;IAqBI,8BAAA;EZ6wOJ;AACF;AY5wOI;EAvBF;IAwBI,sBAAA;IACA,uBAAA;IACA,kBAAA;EZ+wOJ;AACF;AY7wOE;EACE,eAAA;EACA,kBAAA;EACA,kBAAA;AZ+wOJ;AY7wOE;EACE,kBAAA;EACA,SAAA;AZ+wOJ;AY7wOE;EACE,YAAA;EACA,WAAA;EACA,aAAA;AZ+wOJ;AY9wOI;EAJF;IAKI,YAAA;IACA,WAAA;IACA,aAAA;EZixOJ;AACF;AYhxOI;EACE,+BAAA;AZkxON;AY/wOE;EACE,SAAA;AZixOJ;AYhxOI;EAFF;IAGI,SAAA;EZmxOJ;AACF;AYjxOE;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;AZmxOJ;AYlxOI;EALF;IAMI,SAAA;IACA,eAAA;EZqxOJ;AACF;AYpxOI;EATF;IAUI,SAAA;EZuxOJ;AACF;AYtxOI;EAZF;IAaI,eAAA;IACA,QAAA;EZyxOJ;AACF;AYxxOI;EAhBF;IAiBI,eAAA;EZ2xOJ;AACF;AY1xOI;EAnBF;IAoBI,gBAAA;IACA,iBAAA;IACA,qBAAA;IACA,gBAAA;EZ6xOJ;AACF;AY5xOI;EAzBF;IA0BI,oBAAA;EZ+xOJ;AACF;AY7xOE;EACE,kBAAA;EACA,WAAA;EACA,UAAA;AZ+xOJ;AY9xOI;EAJF;IAKI,SAAA;EZiyOJ;AACF;;AY9xOA;EACE,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;AZiyOF;AYhyOE;EAXF;IAYI,kBAAA;EZmyOF;AACF;AYlyOE;EAdF;IAeI,kBAAA;EZqyOF;AACF;AYpyOE;EAjBF;IAkBI,mBAAA;IACA,eAAA;IACA,mBAAA;IACA,kBAAA;EZuyOF;AACF;AYtyOE;EACE,kBAAA;EACA,UAAA;AZwyOJ;AYvyOI;EAHF;IAII,mBAAA;EZ0yOJ;AACF;AYzyOI;EANF;IAOI,mBAAA;EZ4yOJ;AACF;AYzyOI;EACE,SAAA;EACA,kBAAA;AZ2yON;AYxyOE;EACE,aAAA;EACA,WAAA;EACA,iBAAA;AZ0yOJ;AYzyOI;EAJF;IAKI,sBAAA;IACA,WAAA;EZ4yOJ;AACF;AY1yOE;EACE,UAAA;EACA,YAAA;AZ4yOJ;AY3yOI;EAHF;IAII,YAAA;EZ8yOJ;AACF;AY5yOE;EACE,gBAAA;EACA,mBAAA;AZ8yOJ;AY7yOI;EAHF;IAII,mBAAA;EZgzOJ;AACF;AY/yOI;EANF;IAOI,mBAAA;EZkzOJ;AACF;AYhzOE;EACE,aAAA;EACA,cAAA;AZkzOJ;AYjzOI;EAHF;IAII,8BAAA;EZozOJ;AACF;AYlzOE;EACE,SAAA;EACA,gBAAA;AZozOJ;AYlzOE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;EACA,0DAAA;AZozOJ;AYnzOI;EANF;IAOI,UAAA;EZszOJ;AACF;AYrzOI;EATF;IAUI,aAAA;EZwzOJ;AACF;AYtzOE;EACE,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,8BAAA;EACA,yBAAA;AZwzOJ;AYvzOI;EARF;IASI,WAAA;IACA,yBAAA;EZ0zOJ;AACF;AYzzOI;EAZF;IAaI,yBAAA;EZ4zOJ;AACF;AY3zOI;EAfF;IAgBI,eAAA;IACA,aAAA;IACA,yBAAA;EZ8zOJ;AACF;AY7zOI;EApBF;IAqBI,eAAA;EZg0OJ;AACF;AY/zOI;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,+BAAA;EACA,oCAAA;EACA,6BAAA;EACA,oDAAA;AZi0ON;AY/zOI;EACE,kBAAA;AZi0ON;AY/zOI;EACE,kBAAA;EACA,UAAA;AZi0ON;AYh0OM;EAHF;IAII,UAAA;IACA,eAAA;EZm0ON;AACF;AYl0OM;EACE;IACE,eAAA;EZo0OR;AACF;AY/zOI;EACE,WAAA;AZi0ON;;AY7zOA;EACE,iFAAA;AZg0OF;AY3zOE;EACE,uCAAA;EACA,WAAA;EACA,4BAAA;EACA,WAAA;EACA,0CAAA;EACA,gBAAA;EACA,gCAAA;AZ6zOJ;AY5zOI;EARF;IASI,4BAAA;EZ+zOJ;AACF;AY9zOI;EAXF;IAYI,4BAAA;EZi0OJ;AACF;AYh0OI;EAdF;IAeI,0BAAA;IACA,aAAA;EZm0OJ;AACF;AYl0OI;EACE,aAAA;AZo0ON;AYj0OE;EACE,iBAAA;AZm0OJ;AYl0OI;EAFF;IAGI,iBAAA;EZq0OJ;AACF;AYp0OI;EALF;IAMI,gBAAA;EZu0OJ;AACF;AYt0OI;EACE;IACE,cAAA;EZw0ON;AACF;AYr0OE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,OAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;AZu0OJ;AYt0OI;EAbF;IAcI,UAAA;EZy0OJ;AACF;AYx0OI;EAhBF;IAiBI,WAAA;IACA,iBAAA;IACA,gBAAA;IACA,cAAA;EZ20OJ;AACF;AY10OI;EACE,gBAAA;AZ40ON;AYz0OE;EACE,UAAA;AZ20OJ;AYx0OI;EACE,cXzXG;ADmsPT;;AYt0OA;EACE,2BAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AZy0OF;AYx0OE;EAPF;IAQI,kBAAA;EZ20OF;AACF;AY10OE;EAVF;IAWI,kBAAA;IACA,qBAAA;IACA,+BAAA;IACA,mBAAA;IACA,eAAA;EZ60OF;AACF;AY50OE;EAjBF;IAkBI,aAAA;IACA,mBAAA;EZ+0OF;AACF;AY90OE;EArBF;IAsBI,kBAAA;IACA,mBAAA;IACA,mBAAA;IACA,eAAA;EZi1OF;EYh1OE;IACE,eAAA;EZk1OJ;AACF;AYh1OE;EACE,kBAAA;EACA,0BAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,aAAA;EACA,qBAAA;AZk1OJ;AYj1OI;EARF;IASI,0BAAA;EZo1OJ;AACF;AYl1OE;EACE,kBAAA;EACA,UAAA;AZo1OJ;AYl1OE;EACE,iBAAA;EACA,mBAAA;AZo1OJ;AYn1OI;EAHF;IAII,gBAAA;EZs1OJ;AACF;AYr1OI;EANF;IAOI,gBAAA;EZw1OJ;AACF;AYv1OI;EATF;IAUI,mBAAA;EZ01OJ;AACF;AYx1OE;EACE,gBAAA;AZ01OJ;AYx1OE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;AZ01OJ;AYz1OI;EAJF;IAKI,UAAA;IACA,WAAA;IACA,gBAAA;EZ41OJ;AACF;AY31OI;EATF;IAUI,WAAA;IACA,iBAAA;IACA,gBAAA;EZ81OJ;AACF;AY71OI;EAdF;IAeI,aAAA;EZg2OJ;AACF;AY91OE;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,2DAAA;AZg2OJ;AY/1OI;EALF;IAMI,QAAA;EZk2OJ;AACF;AYj2OI;EARF;IASI,aAAA;EZo2OJ;AACF;AYl2OE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,0DAAA;AZo2OJ;AYn2OI;EALF;IAMI,UAAA;EZs2OJ;AACF;AYr2OI;EARF;IASI,QAAA;EZw2OJ;AACF;AYv2OI;EAXF;IAYI,QAAA;IACA,UAAA;EZ02OJ;AACF;AYz2OI;EAfF;IAgBI,aAAA;EZ42OJ;AACF;AY12OE;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,6DAAA;AZ42OJ;AY32OI;EALF;IAMI,aAAA;EZ82OJ;AACF;AY52OE;EACE,qBAAA;EACA,mBAAA;EACA,6DAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;AZ82OJ;AY72OI;EARF;IASI,WAAA;IACA,kBAAA;EZg3OJ;AACF;AY/2OI;EACE;IACE,eAAA;EZi3ON;EY/2OI;IACE,QAAA;EZi3ON;AACF;AY92OE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AZg3OJ;AY/2OI;EACE,UAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AZi3ON;AYh3OM;EAPF;IAQI,WAAA;IACA,YAAA;EZm3ON;AACF;AYh3OE;EACE,gBAAA;EACA,SAAA;EACA,UAAA;AZk3OJ;AYj3OI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AZm3ON;AYl3OM;EACE,kBAAA;AZo3OR;AYj3OI;EACE,gBAAA;AZm3ON;AYh3OE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AZk3OJ;AYj3OI;EAJF;IAKI,sBAAA;EZo3OJ;AACF;AYl3OI;EACE,YAAA;AZo3ON;AYn3OM;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,0EAAA;AZq3OR;;AY52OA;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;AZ+2OF;AY92OE;EAJF;IAKI,kBAAA;EZi3OF;AACF;AYh3OE;EAPF;IAQI,kBAAA;EZm3OF;AACF;AYl3OE;EACE,gBAAA;EACA,kBAAA;EACA,UAAA;AZo3OJ;AYl3OE;EACE,mBAAA;AZo3OJ;AYn3OI;EAFF;IAGI,mBAAA;EZs3OJ;AACF;AYp3OE;EACE,gBAAA;EACA,oBAAA;AZs3OJ;AYr3OI;EAHF;IAII,mBAAA;EZw3OJ;AACF;AYt3OE;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,0DAAA;AZw3OJ;AYv3OI;EALF;IAMI,aAAA;EZ03OJ;AACF;AYx3OE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,2DAAA;AZ03OJ;AYz3OI;EALF;IAMI,aAAA;EZ43OJ;AACF;AY13OE;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,6DAAA;AZ43OJ;AY33OI;EALF;IAMI,aAAA;EZ83OJ;AACF;;AangQA;;iEAAA;AAGA;EACE,4BAAA;EACA,YAAA;AbsgQF;AargQE;EAHF;IAII,4BAAA;EbwgQF;AACF;AavgQE;EANF;IAOI,4BAAA;Eb0gQF;AACF;AazgQE;EACE;IACE,eAAA;Eb2gQJ;AACF;AazgQE;EACE;IACE,eAAA;Eb2gQJ;AACF;AazgQE;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;Ab2gQJ;Aa1gQI;EAPF;IAQI,YAAA;IACA,WAAA;IACA,aAAA;Eb6gQJ;AACF;Aa5gQI;EACE,gBAAA;Ab8gQN;Aa5gQI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;EACA,6EAAA;EAKA,wBAAA;EACA,UAAA;Ab0gQN;AargQM;EACE,qBAAA;AbugQR;AangQE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;AbqgQJ;AapgQI;EANF;IAOI,SAAA;IACA,mBAAA;EbugQJ;EatgQI;IACE,kBAAA;EbwgQN;AACF;AatgQI;EAbF;IAcI,mBAAA;EbygQJ;AACF;AavgQE;EACE,kBAAA;EACA,SAAA;AbygQJ;AaxgQI;EAHF;IAII,eAAA;Eb2gQJ;AACF;;AavgQA;EACE;IACE,UAAA;Eb0gQF;AACF;AavgQA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AbygQF;AaxgQE;EAVF;IAWI,iBAAA;IACA,SAAA;IACA,aAAA;IACA,mBAAA;Eb2gQF;AACF;Aa1gQE;EAhBF;IAiBI,iBAAA;IACA,mBAAA;Eb6gQF;AACF;Aa5gQE;EApBF;IAqBI,iBAAA;IACA,SAAA;IACA,aAAA;Eb+gQF;AACF;Aa9gQE;EACE,yBAAA;AbghQJ;Aa9gQE;EACE,yBAAA;EACA,cZjHK;ADioQT;Aa/gQI;EAHF;IAII,eAAA;EbkhQJ;AACF;AahhQE;EACE,UAAA;AbkhQJ;AahhQE;EACE,yBZ1HK;EY2HL,mDAAA;AbkhQJ;AajhQI;EACE,WAAA;AbmhQN;AajhQI;EACE,+BAAA;AbmhQN;;Aa/gQA;EACE,aAAA;EACA,kBAAA;AbkhQF;AajhQE;EAHF;IAII,WAAA;EbohQF;AACF;AanhQE;EANF;IAOI,sBAAA;EbshQF;AACF;AarhQE;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,yBAAA;EACA,yBZlJK;EYmJL,SAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,UAAA;AbuhQJ;AathQI;EAXF;IAYI,aAAA;EbyhQJ;AACF;AathQE;;EAEE,UAAA;EACA,UAAA;AbwhQJ;AavhQI;EAJF;;IAKI,cAAA;IACA,aAAA;Eb2hQJ;AACF;AazhQE;EACE,oBAAA;Ab2hQJ;Aa1hQI;EAFF;IAGI,gBAAA;IACA,iBAAA;Eb6hQJ;AACF;Aa3hQE;EACE,mBAAA;EACA,kBAAA;Ab6hQJ;Aa5hQI;EACE;IACE,aAAA;Eb8hQN;AACF;Aa5hQI;EARF;IASI,eAAA;Eb+hQJ;AACF;Aa7hQE;EACE,eAAA;EACA,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;Ab+hQJ;Aa9hQI;EAPF;IAQI,iBAAA;IACA,eAAA;IACA,mBAAA;EbiiQJ;AACF;AahiQI;EAZF;IAaI,aAAA;EbmiQJ;AACF;AajiQE;EACE,aAAA;EACA,YAAA;EACA,kCAAA;EACA,iBAAA;EACA,yBAAA;EACA,aAAA;AbmiQJ;AaliQI;EAPF;IAQI,aAAA;IACA,YAAA;EbqiQJ;AACF;AapiQI;EAXF;IAYI,YAAA;IACA,WAAA;IACA,oBAAA;IACA,aAAA;IACA,mBAAA;EbuiQJ;AACF;AariQE;EACE,mBAAA;AbuiQJ;AatiQI;EAFF;IAGI,mBAAA;EbyiQJ;AACF;AatiQI;EACE,UAAA;AbwiQN;AatiQI;EACE,yBZvOG;AD+wQT;;AapiQA;EACE,kBAAA;AbuiQF;AatiQE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,MAAA;EACA,YAAA;EACA,UAAA;EACA,yBZzPM;ADiyQV;AaviQI;EARF;IASI,aAAA;Eb0iQJ;AACF;AaviQI;EACE,oBAAA;AbyiQN;AaxiQM;EAFF;IAGI,mBAAA;Eb2iQN;AACF;AaziQI;EACE,2BAAA;Ab2iQN;Aa1iQM;EAFF;IAGI,mBAAA;Eb6iQN;AACF;Aa5iQM;EALF;IAMI,sBAAA;Eb+iQN;AACF;Aa9iQM;EACE,kBAAA;EACA,mBAAA;AbgjQR;Aa/iQQ;EAHF;IAII,eAAA;EbkjQR;AACF;AahjQM;EACE,oBAAA;EACA,eAAA;EACA,iBAAA;AbkjQR;AajjQQ;EAJF;IAKI,gBAAA;IACA,gBAAA;EbojQR;AACF;AaljQM;EACE,oBAAA;AbojQR;AaljQM;EACE,aAAA;EACA,WAAA;AbojQR;;Aa/iQA;;EAEE,mBAAA;EACA,gBAAA;EACA,oDAAA;EACA,yBAAA;EACA,kBAAA;AbkjQF;AajjQE;;EACE,WAAA;EACA,YAAA;EACA,uCAAA;EACA,4BAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;AbojQJ;AanjQI;EATF;;IAUI,WAAA;IACA,YAAA;EbujQJ;AACF;AatjQI;;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,yBAAA;AbyjQN;AavjQM;;EACE,UAAA;Ab0jQR;AavjQI;;EACE,yBZlUG;AD43QT;AapjQQ;;EACE,UAAA;AbujQV;AarjQQ;;EACE,SAAA;AbwjQV;;AaljQA;EACE,6BAAA;EACA,mBAAA;AbqjQF;AapjQE;EAHF;IAII,4BAAA;EbujQF;AACF;AatjQE;EANF;IAOI,4BAAA;EbyjQF;AACF;AaxjQE;EATF;IAUI,4BAAA;Eb2jQF;AACF;Aa1jQE;EACE,mBAAA;EACA,gBAAA;Ab4jQJ;Aa3jQI;EAHF;IAII,mBAAA;Eb8jQJ;AACF;Aa5jQE;EACE;IACE,kBAAA;Eb8jQJ;AACF;Aa3jQE;EACE,YAAA;EACA,WAAA;EACA,mBAAA;Ab6jQJ;;Aa1jQA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,oDAAA;EACA,kBAAA;Ab6jQF;Aa5jQE;EANF;IAOI,aAAA;IACA,SAAA;Eb+jQF;Ea9jQE;IACE,kBAAA;EbgkQJ;AACF;Aa9jQE;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;AbgkQJ;Aa/jQI;EAPF;IAQI,WAAA;IACA,YAAA;IACA,aAAA;EbkkQJ;AACF;AajkQI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;EACA,6EAAA;EAKA,wBAAA;EACA,UAAA;Ab+jQN;Aa1jQM;EACE,qBAAA;Ab4jQR;;AatjQE;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;AbyjQJ;AaxjQI;EACE,gBAAA;Ab0jQN;AavjQE;EACE,mBAAA;AbyjQJ;AavjQE;EACE;IACE,aAAA;EbyjQJ;AACF;;AatjQA;EACE,6BAAA;EACA,mBAAA;AbyjQF;AaxjQE;EAHF;IAII,6BAAA;Eb2jQF;AACF;Aa1jQE;EANF;IAOI,6BAAA;Eb6jQF;AACF;Aa5jQE;EATF;IAUI,mBAAA;IACA,6BAAA;Eb+jQF;AACF;Aa9jQE;EACE,mBAAA;AbgkQJ;Aa9jQE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;AbgkQJ;Aa/jQI;EAJF;IAKI,SAAA;IACA,UAAA;IACA,eAAA;EbkkQJ;AACF;AajkQI;EATF;IAUI,SAAA;EbokQJ;AACF;AalkQE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,6DAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,UAAA;AbokQJ;AalkQE;;EAEE,kBAAA;EACA,UAAA;AbokQJ;AajkQI;EACE,UAAA;AbmkQN;;Aa/jQA;EACE,uBAAA;EACA,yBAAA;AbkkQF;AajkQE;EAHF;IAII,uBAAA;EbokQF;AACF;AankQE;EANF;IAOI,kBAAA;EbskQF;AACF;AapkQE;EACE,mBAAA;EACA,WAAA;EACA,yBAAA;AbskQJ;AapkQE;EACE,WAAA;EACA,yBAAA;AbskQJ;AapkQE;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AbskQJ;AapkQE;EACE,sBAAA;EACA,qDAAA;EACA,4BAAA;AbskQJ;AarkQI;;EAEE,cZhhBI;ADulRV;;AankQA;EACE,6DAAA;AbskQF;AarkQE;EAFF;IAGI,kBAAA;EbwkQF;AACF;;AatkQA;EACE,6DAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AbykQF;AaxkQE;EAVF;IAWI,iBAAA;IACA,kBAAA;Eb2kQF;AACF;Aa1kQE;EAdF;IAeI,iBAAA;IACA,kBAAA;Eb6kQF;AACF;Aa5kQE;EACE,sBAAA;Ab8kQJ;Aa5kQE;EACE,gBAAA;Ab8kQJ;;Aa3kQA;EACE,kBAAA;EACA,oDAAA;EACA,yBAAA;Ab8kQF;Aa7kQE;EACE,4BAAA;EACA,qDAAA;Ab+kQJ;Aa7kQE;EACE,mBAAA;Ab+kQJ;Aa7kQE;EACE,aAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;Ab+kQJ;Aa7kQE;EApBF;IAqBI,kBAAA;EbglQF;AACF;Aa/kQE;EAvBF;IAwBI,kBAAA;EbklQF;AACF;;AahlQA;EACE,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,SAAA;AbmlQF;AallQE;EANF;IAOI,aAAA;IACA,SAAA;EbqlQF;AACF;AaplQE;EAVF;IAWI,kBAAA;IACA,SAAA;EbulQF;AACF;AatlQE;EAdF;IAeI,kBAAA;IACA,SAAA;EbylQF;AACF;AaxlQE;EACE,UAAA;Ab0lQJ;AazlQI;EAFF;IAGI,eAAA;Eb4lQJ;AACF;Aa3lQI;EALF;IAMI,eAAA;Eb8lQJ;AACF;Aa7lQI;EARF;IASI,eAAA;EbgmQJ;AACF;Aa9lQE;EACE,SAAA;AbgmQJ;;Aa7lQA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AbgmQF;Aa/lQE;EALF;IAMI,SAAA;EbkmQF;AACF;AajmQE;EARF;IASI,8BAAA;IACA,uBAAA;IACA,SAAA;EbomQF;AACF;AanmQE;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,yBAAA;AbqmQJ;AapmQI;EACE,+BAAA;AbsmQN;AapmQI;EAXF;IAYI,YAAA;IACA,aAAA;IACA,aAAA;EbumQJ;AACF;AatmQI;EAhBF;IAiBI,WAAA;IACA,YAAA;IACA,aAAA;EbymQJ;AACF;AavmQE;EACE,cAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AbymQJ;AaxmQI;EANF;IAOI,mBAAA;Eb2mQJ;AACF;Aa1mQI;EATF;IAUI,aAAA;Eb6mQJ;AACF;Aa3mQE;EACE,mBAAA;Ab6mQJ;Aa5mQI;EAFF;IAGI,kBAAA;Eb+mQJ;AACF;Aa7mQE;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;Ab+mQJ;Aa9mQI;EAJF;IAKI,aAAA;EbinQJ;AACF;AahnQI;EAPF;IAQI,YAAA;IACA,gBAAA;EbmnQJ;AACF;AahnQI;EACE,yBZ/qBG;ADiyRT;AahnQI;EACE;IACE,sBAAA;IACA,qDAAA;EbknQN;AACF;;Aa9mQA;EACE,aAAA;EACA,qCAAA;EACA,WAAA;AbinQF;AahnQE;EAJF;IAKI,qCAAA;EbmnQF;AACF;AalnQE;EAPF;IAQI,SAAA;EbqnQF;AACF;AapnQE;EACE,aAAA;EACA,mBAAA;AbsnQJ;AarnQI;EACE,WAAA;AbunQN;AapnQM;EACE,2BAAA;AbsnQR;AarnQQ;EAFF;IAGI,8BAAA;EbwnQR;AACF;;AannQA;EACE,sBAAA;EACA,oDAAA;EACA,gBAAA;EACA,sBAAA;AbsnQF;AarnQE;EACE,mBAAA;AbunQJ;AarnQE;EACE,kBAAA;EACA,sBAAA;EACA,oDAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AbunQJ;AarnQE;EACE,YAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;AbunQJ;;Ac52RA;;iEAAA;AAGA;EACE,oDAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;Ad+2RF;Ac72RE;EACE,4BAAA;EACA,qDAAA;Ad+2RJ;Ac72RE;EACE,cAAA;EACA,WAAA;Ad+2RJ;Ac92RI;EACE,WAAA;EACA,mBAAA;Adg3RN;Ac72RE;EACE,uBAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;Ad+2RJ;Ac92RI;EANF;IAOI,uBAAA;Edi3RJ;AACF;Ac/2RE;EACE,aAAA;EACA,SAAA;Adi3RJ;Ach3RI;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,cbhCG;EaiCH,eAAA;Adk3RN;Acj3RM;EACE,yBbnCC;EaoCD,WAAA;Adm3RR;Ac/2RE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;Adi3RJ;Ac/2RE;EACE,mBAAA;Adi3RJ;Ac/2RE;EACE,qBAAA;Adi3RJ;Ac/2RI;EACE,0BAAA;Adi3RN;Ac92RE;EACE,oBAAA;Adg3RJ;Ac/2RI;EAFF;IAGI,oBAAA;Edk3RJ;AACF;Acj3RI;EACE,SAAA;Adm3RN;Acj3RI;EACE,uBAAA;Adm3RN;Acl3RM;EAFF;IAGI,2BAAA;Edq3RN;AACF;Acl3RE;EACE,eAAA;EACA,cAAA;Ado3RJ;Acl3RM;EACE,4BAAA;Ado3RR;Acj3RI;EACE,mBAAA;Adm3RN;Acj3RI;EACE,uBAAA;Adm3RN;Acl3RM;EACE,aAAA;EACA,8BAAA;Ado3RR;Acl3RM;EANF;IAOI,kBAAA;Edq3RN;AACF;Acn3RI;EACE,gBAAA;Adq3RN;Acn3RI;EACE,aAAA;Adq3RN;Acp3RM;EAFF;IAGI,aAAA;Edu3RN;AACF;Act3RM;EALF;IAMI,eAAA;Edy3RN;AACF;Acx3RM;EACE,YAAA;EACA,WAAA;EACA,iBAAA;Ad03RR;;Acr3RA;EACE,aAAA;EACA,oDAAA;EACA,yBAAA;Adw3RF;Acv3RE;EACE,sBAAA;Ady3RJ;Acv3RE;EAPF;IAQI,sBAAA;Ed03RF;AACF;Act3RE;EACE,mBAAA;Adw3RJ;Act3RE;EACE,4BAAA;EACA,aAAA;EACA,mBAAA;Adw3RJ;Acv3RI;EAJF;IAKI,kBAAA;Ed03RJ;AACF;Acz3RI;EAPF;IAQI,kBAAA;Ed43RJ;AACF;Ac13RE;EACE,UAAA;EACA,YAAA;EACA,iBAAA;Ad43RJ;Ac33RI;EACE,YAAA;EACA,WAAA;EACA,iBAAA;Ad63RN;Ac33RI;EATF;IAUI,YAAA;IACA,iBAAA;Ed83RJ;AACF;Ac73RI;EAbF;IAcI,aAAA;IACA,YAAA;IACA,yBAAA;IACA,gBAAA;Edg4RJ;AACF;;Ac73RA;EACE,yBAAA;Adg4RF;Ac/3RE;EACE,oDAAA;Adi4RJ;Ac/3RE;EACE,cAAA;Adi4RJ;Ac/3RE;EACE,oBAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;Adi4RJ;Ach4RI;EACE,yBb9KG;Ea+KH,WAAA;Adk4RN;Ac/3RE;EACE,mBAAA;Adi4RJ;Ac/3RE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cb9LM;AD+jSV;Ach4RI;EACE,eAAA;EACA,cb5LG;Ea6LH,aAAA;Adk4RN;Ac/3RE;EACE,kBAAA;Adi4RJ;Ach4RI;EAFF;IAGI,kBAAA;Edm4RJ;AACF;;AejlSA;;iEAAA;AAGA;EACE,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;AfolSF;AenlSE;EALF;IAMI,gBAAA;EfslSF;AACF;AerlSE;EARF;IASI,eAAA;EfwlSF;AACF;AevlSE;EAXF;IAYI,kBAAA;Ef0lSF;AACF;AezlSE;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;Af2lSJ;Ae1lSI;EALF;IAMI,gBAAA;Ef6lSJ;AACF;Ae3lSE;EACE,gBAAA;EACA,kBAAA;EACA,UAAA;Af6lSJ;Ae3lSE;EACE,kBAAA;EACA,aAAA;EACA,YAAA;Af6lSJ;Ae5lSI;EAJF;IAKI,gBAAA;Ef+lSJ;AACF;Ae9lSI;EAPF;IAQI,gBAAA;IACA,SAAA;EfimSJ;AACF;AehmSI;EAXF;IAYI,aAAA;EfmmSJ;AACF;;AehmSA;EACE,2BAAA;AfmmSF;AelmSE;EAFF;IAGI,2BAAA;EfqmSF;AACF;AepmSE;EALF;IAMI,2BAAA;EfumSF;AACF;AetmSE;EARF;IASI,2BAAA;EfymSF;AACF;AexmSE;EAXF;IAYI,2BAAA;Ef2mSF;AACF;Ae1mSE;EAdF;IAeI,kBAAA;IACA,iCAAA;Ef6mSF;Ee5mSE;IACE,aAAA;Ef8mSJ;AACF;;Ae3mSA;;EAEE,sBAAA;EACA,iBAAA;EACA,kBAAA;Af8mSF;Ae7mSE;EALF;;IAMI,iBAAA;EfinSF;AACF;AehnSE;EARF;;IASI,iBAAA;IACA,sBAAA;EfonSF;EennSE;;IACE,eAAA;EfsnSJ;AACF;AepnSE;EAfF;;IAgBI,sBAAA;IACA,kBAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;EfwnSF;EevnSE;;IACE,gBAAA;Ef0nSJ;AACF;AexnSE;EACE;;IACE,gBAAA;Ef2nSJ;AACF;AexnSE;;EACE,mBAAA;Af2nSJ;Ae1nSI;EAFF;;IAGI,eAAA;Ef8nSJ;AACF;Ae7nSI;EALF;;IAMI,eAAA;EfioSJ;AACF;Ae/nSE;;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,kBAAA;AfkoSJ;AejoSI;;EACE,gBAAA;AfooSN;AeloSI;EAXF;;IAYI,aAAA;EfsoSJ;AACF;AepoSE;;EACE,kBAAA;EACA,UAAA;EACA,UAAA;AfuoSJ;AetoSI;EAJF;;IAKI,WAAA;Ef0oSJ;AACF;AevoSE;EACE;;IACE,eAAA;Ef0oSJ;AACF;AexoSE;EACE;;IACE,eAAA;Ef2oSJ;AACF;AezoSE;EACE;;IACE,aAAA;Ef4oSJ;AACF;;AexoSE;EACE,OAAA;EACA,UAAA;EACA,gBAAA;EACA,mBAAA;Af2oSJ;Ae1oSI;EALF;IAMI,kBAAA;Ef6oSJ;AACF;Ae3oSE;EACE,gBAAA;Af6oSJ;Ae5oSI;EAFF;IAGI,iBAAA;IACA,kBAAA;Ef+oSJ;AACF;Ae7oSE;EACE;IACE,iBAAA;Ef+oSJ;AACF;;Ae5oSA;EACE,kBAAA;EACA,qDAAA;EACA,0BAAA;EACA,4BAAA;Af+oSF;Ae9oSE;EALF;IAMI,0BAAA;EfipSF;AACF;AehpSE;EARF;IASI,yBAAA;EfmpSF;AACF;AelpSE;EACE;IACE,aAAA;EfopSJ;AACF;AelpSE;EACE,kBAAA;EACA,UAAA;AfopSJ;AelpSE;EACE,mBAAA;AfopSJ;;AehpSE;EACE,QAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;AfmpSJ;AelpSI;EALF;IAMI,mBAAA;EfqpSJ;AACF;AeppSI;EARF;IASI,UAAA;EfupSJ;AACF;;AehoSA;EACE,kBAAA;EACA,8BAAA;EACA,qDAAA;EACA,iBAAA;AfmoSF;AeloSE;EALF;IAMI,gBAAA;EfqoSF;AACF;AepoSE;EARF;IASI,4BAAA;IACA,aAAA;EfuoSF;AACF;AetoSE;EAZF;IAaI,4BAAA;EfyoSF;AACF;AexoSE;EAfF;IAgBI,6BAAA;Ef2oSF;AACF;Ae1oSE;EACE;IACE,aAAA;Ef4oSJ;AACF;Ae1oSE;EACE,mBAAA;EACA,kBAAA;EACA,UAAA;Af4oSJ;Ae1oSE;EACE,kBAAA;EACA,UAAA;Af4oSJ;Ae1oSE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;Af4oSJ;Ae3oSI;EAJF;IAKI,gBAAA;Ef8oSJ;AACF;Ae7oSI;EAPF;IAQI,gBAAA;IACA,YAAA;EfgpSJ;AACF;Ae/oSI;EAXF;IAYI,gBAAA;IACA,YAAA;EfkpSJ;AACF;AejpSI;EAfF;IAgBI,aAAA;EfopSJ;AACF;;AejpSA;EACE,wBAAA;EACA,qDAAA;EACA,kBAAA;EACA,iBAAA;AfopSF;AenpSE;EALF;IAMI,wBAAA;IACA,iBAAA;EfspSF;AACF;AerpSE;EATF;IAUI,aAAA;EfwpSF;EevpSE;IACE,aAAA;EfypSJ;AACF;AevpSE;EACE,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,WAAA;AfypSJ;AexpSI;EANF;IAOI,WAAA;Ef2pSJ;AACF;Ae1pSI;EATF;IAUI,aAAA;Ef6pSJ;AACF;;Ae1pSA;EACE,kBAAA;Af6pSF;Ae5pSE;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;Af8pSJ;;Ae3pSA;EACE,kBAAA;EACA,0BAAA;EACA,UAAA;EACA,gBAAA;Af8pSF;Ae7pSE;EALF;IAMI,aAAA;IACA,yBAAA;EfgqSF;AACF;Ae/pSE;EATF;IAUI,aAAA;IACA,uBAAA;EfkqSF;AACF;AejqSE;EAbF;IAcI,uBAAA;EfoqSF;AACF;AenqSE;EACE,mBAAA;AfqqSJ;AenqSE;EACE,gBAAA;EACA,kBAAA;EACA,UAAA;AfqqSJ;AenqSE;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;AfqqSJ;AepqSI;EALF;IAMI,UAAA;EfuqSJ;AACF;AetqSI;EARF;IASI,UAAA;EfyqSJ;AACF;AexqSI;EAXF;IAYI,UAAA;Ef2qSJ;AACF;Ae1qSI;EAdF;IAeI,aAAA;Ef6qSJ;AACF;;Ae1qSA;EACE,kBAAA;EACA,qDAAA;EACA,4BAAA;EACA,iBAAA;Af6qSF;Ae5qSE;EALF;IAMI,4BAAA;IACA,gBAAA;Ef+qSF;AACF;Ae9qSE;EATF;IAUI,2BAAA;IACA,aAAA;EfirSF;AACF;AehrSE;EAbF;IAcI,2BAAA;EfmrSF;AACF;AelrSE;EACE;IACE,aAAA;EforSJ;AACF;AelrSE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;AforSJ;AenrSI;EAJF;IAKI,gBAAA;EfsrSJ;AACF;AerrSI;EAPF;IAQI,gBAAA;EfwrSJ;AACF;AevrSI;EAVF;IAWI,aAAA;Ef0rSJ;AACF;AexrSE;EACE,mBAAA;Af0rSJ;AexrSE;EACE,6BAAA;EACA,SAAA;Af0rSJ;AezrSI;EAHF;IAII,4BAAA;Ef4rSJ;AACF;Ae3rSI;EANF;IAOI,6BAAA;Ef8rSJ;AACF;Ae7rSI;EACE,cAAA;EACA,OAAA;EACA,cAAA;Af+rSN;;AgB/lTA;;iEAAA;AAGA;EACE,mBAAA;EACA,kBAAA;AhBkmTF;AgBjmTE;EACE,kBAAA;EACA,WAAA;EACA,UAAA;AhBmmTJ;AgBlmTI;EAJF;IAKI,UAAA;IACA,WAAA;EhBqmTJ;AACF;AgBnmTE;EACE,mBAAA;AhBqmTJ;;AgBjmTE;EACE,6BAAA;EACA,kBAAA;AhBomTJ;AgBnmTI;EAHF;IAII,6BAAA;EhBsmTJ;AACF;AgBrmTI;EANF;IAOI,4BAAA;EhBwmTJ;AACF;AgBvmTI;EACE,mBAAA;AhBymTN;AgBnnTE;EAYE,mBAAA;AhB0mTJ;AgBxmTE;EACE,kBAAA;EACA,UAAA;EACA,SAAA;AhB0mTJ;AgBzmTI;EAJF;IAKI,UAAA;EhB4mTJ;AACF;AgB3mTI;EAPF;IAQI,UAAA;IACA,SAAA;EhB8mTJ;AACF;AgB5mTE;EACE,aAAA;EACA,cAAA;EACA,mBAAA;AhB8mTJ;AgB7mTI;EAJF;IAKI,SAAA;EhBgnTJ;AACF;AgB9mTE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AhBgnTJ;AgB/mTI;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,sBAAA;AhBinTN;;AgB7mTA;EACE,sBAAA;EACA,gBAAA;AhBgnTF;AgB/mTE;EAHF;IAII,sBAAA;EhBknTF;AACF;AgBjnTE;EACE,aAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AhBmnTJ;AgBjnTE;EACE,mBAAA;AhBmnTJ;AgBjnTE;EACE,gBAAA;AhBmnTJ;AgBjnTE;EACE,iBAAA;EACA,kBAAA;AhBmnTJ;;AgBhnTA;EACE,sBAAA;EACA,kBAAA;EACA,oDAAA;EACA,kBAAA;AhBmnTF;AgBlnTE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AhBonTJ;AgBlnTE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;AhBonTJ;AgBnnTI;EACE,YAAA;EACA,WAAA;EACA,iBAAA;AhBqnTN;AgBlnTE;EACE,mBAAA;AhBonTJ;AgBlnTE;EACE,gBAAA;AhBonTJ;;AgBhnTE;EACE,WAAA;AhBmnTJ;AgBlnTI;EAFF;IAGI,WAAA;EhBqnTJ;AACF;AgBpnTI;EALF;IAMI,WAAA;EhBunTJ;AACF;AgBpnTE;EACE,gBAAA;AhBsnTJ;AgBrnTI;EAFF;IAGI,gBAAA;EhBwnTJ;AACF;AgBtnTE;EACE,iBAAA;EACA,oBAAA;EACA,iBAAA;EACA,oBAAA;EACA,wDAAA;EACA,mBAAA;AhBwnTJ;AgBtnTE;EACE,yBAAA;EACA,aAAA;AhBwnTJ;;AiB3wTA;;iEAAA;AAGA;EACE,aAAA;AjB8wTF;AiB7wTE;EAFF;IAGI,aAAA;EjBgxTF;AACF;AiB/wTE;EACE,YAAA;EACA,sBAAA;EACA,kBAAA;AjBixTJ;AiBhxTI;EACE,WAAA;EACA,mBhBJG;EgBKH,kBAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,yBAAA;AjBkxTN;AiB/wTE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,mBhBrBK;EgBsBL,4BAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,UAAA;EACA,yBAAA;EACA,eAAA;AjBixTJ;AiBhxTI;EACE,chB9BG;EgB+BH,sBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,oCAAA;EACA,yBAAA;AjBkxTN;AiB9wTI;EACE,UAAA;EACA,QAAA;AjBgxTN;AiB/wTM;EACE,UAAA;EACA,gCAAA;EACA,uBAAA;AjBixTR;AiB7wTM;EACE,YAAA;AjB+wTR;AiB3wTE;EACE,aAAA;AjB6wTJ;AiB5wTI;EAFF;IAGI,aAAA;EjB+wTJ;AACF;;AkBz1TA;;iEAAA;AAGA;EACE,aAAA;EACA,qCAAA;EACA,cAAA;AlB41TF;AkB31TE;EAJF;IAKI,eAAA;ElB81TF;AACF;AkB71TE;EAPF;IAQI,cAAA;ElBg2TF;AACF;AkB/1TE;EAVF;IAWI,qCAAA;ElBk2TF;AACF;AkBj2TE;EAbF;IAcI,qCAAA;ElBo2TF;AACF;AkBn2TE;EAhBF;IAiBI,cAAA;ElBs2TF;AACF;;AkBp2TA;EACE,eAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AlBu2TF;;AkBr2TA;EACE,aAAA;EACA,6BAAA;EACA,eAAA;EACA,cAAA;EACA,sBAAA;EACA,oDAAA;EACA,aAAA;AlBw2TF;AkBv2TE;EARF;IASI,uBAAA;ElB02TF;AACF;AkBz2TE;EAXF;IAYI,SAAA;IACA,kBAAA;ElB42TF;AACF;;AmBz5TA;;iEAAA;AAIE;EACE,mBAAA;EACA,yBAAA;EACA,+BAAA;EACA,yBAAA;EACA,WAAA;AnB25TJ;AmB15TI;EANF;IAOI,mBAAA;EnB65TJ;AACF;AmB55TI;EACE,mBAAA;AnB85TN;AmB55TI;EACE,yBAAA;EACA,iBAAA;AnB85TN;AmB75TM;EAHF;IAII,cAAA;EnBg6TN;AACF;AmB/5TM;EACE,yBAAA;AnBi6TR;AmB75TE;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AnB+5TJ;AmB95TI;EAXF;IAYI,WAAA;IACA,SAAA;EnBi6TJ;AACF;AmBh6TI;EAfF;IAgBI,WAAA;IACA,SAAA;EnBm6TJ;AACF;AmBj6TE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,4BAAA;EACA,SAAA;AnBm6TJ;AmBl6TI;EARF;IASI,4BAAA;EnBq6TJ;AACF;AmBp6TI;EAXF;IAYI,eAAA;IACA,4BAAA;EnBu6TJ;AACF;AmBr6TE;EACE,yBAAA;AnBu6TJ;AmBt6TI;EAFF;IAGI,yBAAA;EnBy6TJ;AACF;AmBx6TI;EALF;IAMI,yBAAA;EnB26TJ;AACF;AmB16TI;EACE,SAAA;AnB46TN;AmBx6TI;EACE,oDAAA;EACA,yBAAA;EACA,sBAAA;AnB06TN;AmBx6TI;EACE,kBAAA;AnB06TN;AmBz6TM;EAFF;IAGI,cAAA;EnB46TN;AACF;AmB36TM;EACE,qDAAA;EACA,sBAAA;AnB66TR;AmBx6TI;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,qBlBvFG;EkBwFH,mBAAA;AnB06TN;AmBz6TM;EACE,6BAAA;EACA,cAAA;AnB26TR;AmBz6TM;EACE,cAAA;EACA,UAAA;EACA,SAAA;AnB26TR;AmBx6TI;EACE,4BAAA;AnB06TN;AmBx6TI;EACE,yBAAA;AnB06TN;AmBt6TI;EACE,qBlB5GG;EkB6GH,mBAAA;AnBw6TN;AmBv6TM;EACE,gBAAA;EACA,6BAAA;AnBy6TR;AmBx6TQ;EACE,mEAAA;EACA,gCAAA;EACA,4BAAA;AnB06TV;AmBt6TI;EACE,eAAA;EACA,4BAAA;AnBw6TN;AmBv6TM;EAHF;IAII,4BAAA;EnB06TN;AACF;AmBz6TM;EANF;IAOI,eAAA;EnB46TN;AACF;AmB16TI;EACE,WAAA;EACA,SAAA;AnB46TN;AmB36TM;EAHF;IAII,WAAA;IACA,SAAA;EnB86TN;AACF;AmB76TM;EAPF;IAQI,SAAA;EnBg7TN;AACF;AmB96TI;EACE,kBAAA;AnBg7TN;AmB/6TM;EAFF;IAGI,kBAAA;EnBk7TN;AACF;;AoB7kUA;;iEAAA;AAGA;EACE,kBAAA;EACA,kBAAA;ApBglUF;AoB/kUE;EACE,kBAAA;EACA,UAAA;EACA,eAAA;ApBilUJ;AoBhlUI;EAJF;IAKI,eAAA;EpBmlUJ;AACF;AoBllUI;EACE;IACE,aAAA;EpBolUN;AACF;AoBjlUE;EACE,kBAAA;EACA,UAAA;ApBmlUJ;AoBjlUE;EACE,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;ApBmlUJ;AoBllUI;EATF;IAUI,aAAA;EpBqlUJ;AACF;AoBplUI;EAZF;IAaI,iBAAA;EpBulUJ;AACF;AoBtlUI;EACE,4BAAA;EACA,yBnB9BG;ADsnUT;AoBvlUM;EACE,+BAAA;ApBylUR;AoBvlUM;EACE,WAAA;ApBylUR;AoBrlUE;EACE,yBAAA;ApBulUJ;AoBrlUE;EACE,gBAAA;EACA,yBAAA;ApBulUJ;AoBrlUE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,0BAAA;ApBulUJ;;AqBppUA;;iEAAA;AAIE;EACE,kBAAA;ArBspUJ;AqBrpUI;EAFF;IAGI,mBAAA;ErBwpUJ;AACF;AqBtpUE;EACE,gBAAA;EACA,UAAA;EACA,SAAA;ArBwpUJ;AqBvpUI;EACE,kBAAA;EACA,kBAAA;ArBypUN;AqBxpUM;EACE,mBAAA;ArB0pUR;AqBxpUM;EACE,kBAAA;EACA,OAAA;EACA,QAAA;ArB0pUR;AqBzpUQ;EAJF;IAKI,QAAA;ErB4pUR;AACF;AqB1pUM;EACE,mBAAA;ArB4pUR;AqBxpUE;EACE,kBAAA;EACA,UAAA;EACA,UAAA;ArB0pUJ;AqBxpUE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;ArB0pUJ;AqBxpUE;EACE,wCAAA;ArB0pUJ;AqBvpUI;EACE,cAAA;EACA,QAAA;EACA,SAAA;ArBypUN;AqBtpUM;EADF;IAEI,aAAA;ErBypUN;AACF;AqBtpUE;EACE,mBAAA;ArBwpUJ;AqBvpUI;EAFF;IAGI,kBAAA;ErB0pUJ;AACF;AqBzpUI;EALF;IAMI,iBAAA;ErB4pUJ;AACF;AqB3pUI;EACE,QAAA;EACA,cAAA;EACA,SAAA;EACA,gCAAA;ArB6pUN;AqB3pUI;EACE,gBAAA;EACA,kBAAA;ArB6pUN;;AqBzpUA;EACE;IACE,uBAAA;ErB4pUF;EqB1pUA;IACE,yBAAA;ErB4pUF;AACF;AqBzpUE;EACE,kBAAA;ArB2pUJ;AqB1pUI;EAFF;IAGI,eAAA;ErB6pUJ;AACF;AqB1pUI;EACE,gBAAA;ArB4pUN;;AqBxpUA;EACE,mEAAA;ArB2pUF;AqB1pUE;EACE,mBAAA;ArB4pUJ;AqB3pUI;EAFF;IAGI,8BAAA;ErB8pUJ;AACF;AqB7pUI;EALF;IAMI,4BAAA;ErBgqUJ;AACF;AqB/pUI;EARF;IASI,4BAAA;ErBkqUJ;AACF;AqBhqUE;EACE,YAAA;ArBkqUJ;AqBjqUI;EAFF;IAGI,eAAA;ErBoqUJ;AACF;AqBlqUE;EACE,YAAA;ArBoqUJ;AqBnqUI;EACE,YAAA;EACA,WAAA;EACA,iBAAA;ArBqqUN;AqBlqUE;EACE,gBAAA;ArBoqUJ;AqBlqUE;EACE,mBAAA;EACA,sBAAA;EACA,sBAAA;EACA,qDAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;ArBoqUJ;AqBnqUI;EACE,UAAA;ArBqqUN;AqBnqUI;EAfF;IAgBI,WAAA;IACA,YAAA;ErBsqUJ;AACF;AqBrqUI;EAnBF;IAoBI,iBAAA;IACA,iBAAA;IACA,kBAAA;IACA,mBAAA;ErBwqUJ;AACF;AqBxqUM;EAxBJ;IAyBM,iBAAA;IACA,kBAAA;IACA,mBAAA;IACA,kBAAA;ErB2qUN;AACF;;AsB30UA;;iEAAA;AAGA;EACE,mBAAA;EACA,iGAAA;EAKA,mBAAA;EACA,yBAAA;AtB00UF;AsBz0UE;EACE,qDAAA;AtB20UJ;AsBz0UE;EACE,kBAAA;AtB20UJ;AsB10UI;EAFF;IAGI,kBAAA;EtB60UJ;AACF;AsB30UE;EACE,kBAAA;AtB60UJ;AsB30UE;EACE,kBAAA;AtB60UJ;AsB30UE;EACE,mBAAA;AtB60UJ;AsB30UE;EACE,uBAAA;AtB60UJ;AsB50UI;EACE,YAAA;EACA,WAAA;EACA,uCAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AtB80UN;AsB70UM;EACE,yBrB9BC;AD62UT;AsB30UE;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;AtB60UJ;AsB30UE;EACE,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AtB60UJ;AsB50UI;EACE,kBAAA;AtB80UN;AsB30UE;EACE,oDAAA;EACA,kBAAA;AtB60UJ;AsB50UI;EACE,kBAAA;AtB80UN;AsB50UI;EACE,kBAAA;AtB80UN;AsB50UI;;EAEE,mBAAA;AtB80UN;AsB50UI;EACE,uBAAA;AtB80UN;AsB70UM;EAFF;IAGI,uBAAA;EtBg1UN;AACF;AsB/0UM;EALF;IAMI,uBAAA;EtBk1UN;AACF;;AsB90UA;EAEI;IACE,aAAA;EtBg1UJ;EsB/0UI;IACE,kBAAA;IACA,UAAA;IACA,YAAA;EtBi1UN;EsB/0UI;IACE,iBAAA;IACA,WAAA;IACA,kBAAA;IACA,gBAAA;IACA,kBAAA;EtBi1UN;EsB/0UI;IACE,aAAA;IACA,sBAAA;IACA,gBAAA;IACA,uBAAA;IACA,kBAAA;EtBi1UN;AACF;AsBj1UQ;EANF;IAOI,kBAAA;EtBo1UR;AACF;AsBn1UQ;EATF;IAUI,mBAAA;EtBs1UR;AACF;AsBj3UA;EA6BM;IACE,2BAAA;EtBu1UN;AACF;AuB78UA;;iEAAA;AAGA;EACE,aAAA;EACA,uBAAA;EACA,eAAA;EACA,uBAAA;AvB+8UF;AuB98UE;EALF;IAMI,uBAAA;EvBi9UF;AACF;;AuB/8UA;EACE,cAAA;EACA,kBAAA;AvBk9UF;AuBj9UE;EAHF;IAII,kBAAA;EvBo9UF;AACF;AuBn9UE;EANF;IAOI,kBAAA;IACA,qBAAA;EvBs9UF;AACF;AuBr9UE;EAVF;IAWI,kBAAA;IACA,cAAA;EvBw9UF;AACF;AuBv9UE;EAdF;IAeI,eAAA;IACA,eAAA;EvB09UF;AACF;AuB3+UA;EAkBE,UAAA;AvB49UF;AuB39UE;EACE,kBAAA;AvB69UJ;;AwB7/UA;EACE,6BAAA;AxBggVF;AwB//UE;EAFF;IAGI,4BAAA;ExBkgVF;AACF;AwBjgVE;EALF;IAMI,4BAAA;ExBogVF;AACF;AwBngVE;EARF;IASI,wBAAA;ExBsgVF;AACF;AwBrgVE;;EAEE,mBAAA;AxBugVJ;AwBrgVE;EACE,gBAAA;AxBugVJ;;AyBvhVA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AzB0hVF;AyBzhVE;EACE,uBAAA;AzB2hVJ;AyB1hVI;EAFF;IAGI,uBAAA;EzB6hVJ;AACF;AyB5hVI;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mEAAA;AzB8hVN;AyB7hVM;EACE,oBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;AzB+hVR;AyB9hVQ;EACE,oBAAA;EACA,sBAAA;EACA,YAAA;AzBgiVV;AyB5hVI;EACE,gBAAA;EACA,gBAAA;AzB8hVN;AyB5hVI;EACE,gBAAA;AzB8hVN;AyB3hVE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,uBAAA;EACA,yBAAA;EACA,aAAA;EACA,4BAAA;EACA,SAAA;AzB6hVJ;AyB5hVI;EAVF;IAWI,uBAAA;EzB+hVJ;AACF;AyB7hVE;EACE,gBAAA;EACA,UAAA;EACA,SAAA;AzB+hVJ;AyB9hVI;EACE,kBAAA;EACA,kBAAA;AzBgiVN;AyB/hVM;EACE,mBAAA;AzBiiVR;AyB9hVI;EACE,kBAAA;EACA,OAAA;EACA,cxBrDG;ADqlVT;;A0B/lVA;EACE,sBAAA;A1BkmVF;;A0BhmVA;EACE,yBAAA;A1BmmVF;;A0BjmVA;;EAEE,WAAA;A1BomVF;;A0BlmVA;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;A1BqmVF;;A0BnmVA;EACE,eAAA;A1BsmVF;;A0BnmVE;;;EAGE,kBAAA;EACA,UAAA;A1BsmVJ;A0BnmVE;EACE,iBAAA;EACA,gBAAA;A1BqmVJ;;A0BlmVA;EACE,gBAAA;EACA,yBAAA;A1BqmVF;;A0BnmVA;EACE,eAAA;A1BsmVF;;A0BnmVE;EACE,aAAA;A1BsmVJ;;A0BnmVA;EACE,QAAA;A1BsmVF;;A0BnmVE;;EAEE,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,2BAAA;EACA,sBAAA;EACA,WAAA;EACA,oDAAA;EACA,kBAAA;EACA,QAAA;EACA,wBAAA;EACA,UAAA;A1BsmVJ;A0BrmVI;EAfF;;IAgBI,UAAA;E1BymVJ;AACF;A0BvmVE;EACE,YAAA;A1BymVJ;A0BvmVE;EACE,WAAA;A1BymVJ;A0BtmVI;;EAEE,UAAA;A1BwmVN;;A0BnmVE;;EAEE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,wBAAA;EACA,SAAA;A1BsmVJ;A0BpmVE;EACE,QAAA;A1BsmVJ;A0BpmVE;EACE,WAAA;A1BsmVJ;;A0BlmVE;;EAEE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,wBAAA;EACA,kBAAA;EACA,WAAA;A1BqmVJ;A0BpmVI;EAZF;;IAaI,WAAA;IACA,YAAA;IACA,WAAA;E1BwmVJ;AACF;A0BvmVI;EAjBF;;IAkBI,wBAAA;E1B2mVJ;AACF;A0B1mVI;;EACE,mBAAA;A1B6mVN;A0B3mVI;;EACE,yBzBrHG;ADmuVT;A0B7mVM;;EACE,+BAAA;A1BgnVR;A0B5mVE;EACE,QAAA;A1B8mVJ;A0B5mVE;EACE,YAAA;A1B8mVJ;A0B7mVI;EAFF;IAGI,YAAA;E1BgnVJ;AACF;A0B9mVE;EACE,wBAAA;A1BgnVJ;A0B/mVI;EAFF;IAGI,wBAAA;E1BknVJ;AACF;;A0B/mVA;EACE,oBAAA;A1BknVF;A0BjnVE;EAFF;IAGI,oBAAA;E1BonVF;AACF;A0BnnVE;EACE,YAAA;A1BqnVJ;;A0BlnVA;EACE,aAAA;EACA,cAAA;EACA,qCAAA;A1BqnVF;A0BpnVE;EAJF;IAKI,qCAAA;E1BunVF;E0BrnVI;IACE,aAAA;E1BunVN;AACF;A0BpnVE;EAZF;IAaI,aAAA;IACA,sBAAA;IACA,SAAA;E1BunVF;AACF;A0BtnVE;EACE,iBAAA;A1BwnVJ;A0BvnVI;EAFF;IAGI,iBAAA;E1B0nVJ;AACF;A0BznVI;EALF;IAMI,mBAAA;E1B4nVJ;AACF;A0BznVI;EACE,mBAAA;A1B2nVN;A0BznVI;EACE;IACE,mBAAA;E1B2nVN;AACF;A0BvnVM;EACE,aAAA;EACA,kBAAA;A1BynVR;A0BxnVQ;EAHF;IAII,aAAA;IACA,kBAAA;E1B2nVR;AACF;A0B1nVQ;EAPF;IAQI,aAAA;IACA,aAAA;E1B6nVR;AACF;A0B3nVM;EAbF;IAcI,mBAAA;E1B8nVN;AACF;A0B7nVM;EAhBF;IAiBI,oBAAA;E1BgoVN;AACF;A0B7nVE;EACE;IACE,aAAA;E1B+nVJ;AACF;;A0B5nVA;EACE,aAAA;EACA,cAAA;EACA,qCAAA;A1B+nVF;A0B9nVE;EAJF;IAKI,qCAAA;E1BioVF;AACF;A0BhoVE;EAPF;IAQI,qCAAA;IACA,kBAAA;E1BmoVF;AACF;A0BhoVI;EACE;IACE,mBAAA;E1BkoVN;AACF;A0B/nVI;EACE;IACE,mBAAA;E1BioVN;AACF;A0B9nVE;EACE;IACE,aAAA;E1BgoVJ;AACF;A0B9nVE;EACE;IACE,aAAA;E1BgoVJ;AACF;;A0B7nVA;EACE,eAAA;EACA,YAAA;EACA,OAAA;EAEA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,UAAA;A1BgoVF;;A0B9nVA;EACE,aAAA;EACA,mBAAA;EACA,qCAAA;A1BioVF;A0BhoVE;EAJF;IAKI,qCAAA;IACA,mBAAA;E1BmoVF;AACF;A0BloVE;EARF;IASI,qCAAA;IACA,mBAAA;E1BqoVF;AACF;A0BpoVE;EACE,qCAAA;A1BsoVJ;A0BnoVI;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;A1BqoVN;;A0BjoVA;EACE,0BAAA;A1BooVF;;A0BjoVE;;EAEE,YAAA;A1BooVJ;A0BnoVI;;EACE,czBlSG;ADw6VT;A0BnoVE;EACE,6BAAA;A1BqoVJ;;A0BloVA;EACE,qBAAA;A1BqoVF;;A0BnoVA;EACE,wBAAA;A1BsoVF;;A0BpoVA;EACE,cAAA;A1BuoVF;;A0BroVA;EACE,aAAA;EACA,oBAAA;EACA,qCAAA;A1BwoVF;A0BvoVE;EAJF;IAKI,mBAAA;E1B0oVF;AACF;A0BzoVE;EAPF;IAQI,cAAA;E1B4oVF;AACF;A0B3oVE;EAVF;IAWI,qCAAA;E1B8oVF;AACF;A0B7oVE;EACE;IACE,mBAAA;E1B+oVJ;E0B9oVI;IACE,gBAAA;E1BgpVN;AACF;;A0B5oVA;EACE,eAAA;EACA,iBAAA;A1B+oVF;;A0B7oVA;EACE,cAAA;A1BgpVF;;A0B9oVA;;;;EAIE,aAAA;EACA,wBAAA;A1BipVF;;A0B9oVA,6BAAA;AACA;EACE,4BAAA;EACA,gBAAA;EACA,czB3VO;AD4+VT;;A0B9oVA;EACE;IACE,UAAA;E1BipVF;E0B/oVA;IACE,UAAA;E1BipVF;AACF;A0B9oVA,uBAAA;AACA;EACE,qCAAA;EACA,gBAAA;EACA,czB3WO;EyB4WP,kBAAA;A1BgpVF;;A0B7oVA;EACE;IACE,UAAA;E1BgpVF;AACF;A0B5oVE;EACE,kBAAA;EACA,czBxXK;ADsgWT;;A0B1oVA,6BAAA;AACA;EACE,kBAAA;EACA,qBAAA;A1B6oVF;;A0B1oVA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,uBAAA;EACA,0CAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;A1B6oVF;A0B3oVE;EACE,oCAAA;EACA,sCAAA;A1B6oVJ;;A0BzoVA;EACE,eAAA;EACA,cAAA;A1B4oVF;;A0BzoVA;EACE,gBAAA;EACA,qBAAA;A1B4oVF;;A0BzoVA;EACE,+BAAA;A1B4oVF;A0B1oVE;EACE,yBAAA;A1B4oVJ;;A0BxoVA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,0CAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;A1B2oVF;;A0BxoVA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,sCAAA;EACA,eAAA;EACA,gBAAA;A1B2oVF;A0BzoVE;EACE,mBAAA;A1B2oVJ;A0BxoVE;EACE,mBzBxcK;EyBycL,WAAA;A1B0oVJ;;A0BtoVA,uBAAA;AAEE;EACE,sCAAA;EACA,WAAA;A1BwoVJ;A0BtoVI;EACE,oCAAA;EACA,sCAAA;A1BwoVN;;A0BnoVA,6CAAA;AACA;EACE;IACE,kBAAA;E1BsoVF;E0BnoVA;IACE,kBAAA;IACA,SAAA;IACA,2BAAA;E1BqoVF;AACF;A0BloVA,2BAAA;AACA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,8CAAA;EACA,yBAAA;EACA,aAAA;A1BooVF;A0BloVE;EACE,qBAAA;EACA,8CAAA;A1BooVJ;A0BjoVE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;A1BmoVJ;;A0B/nVA,0BAAA;AACA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;A1BkoVF;;A0B/nVA;EACE,iBAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,0CAAA;A1BkoVF;;A0B/nVA;EACE,mBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;A1BkoVF;A0BhoVE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;A1BkoVJ;;A0B9nVA;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sCAAA;A1BioVF;A0B/nVE;EACE,oCAAA;A1BioVJ;;A0B7nVA;EACE,aAAA;A1BgoVF;A0B9nVE;EACE,mBAAA;A1BgoVJ;A0B9nVI;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;A1BgoVN;A0B7nVI;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,kCAAA;A1B+nVN;A0B7nVM;EACE,aAAA;EACA,qBAAA;A1B+nVR;A0B5nVM;EACE,WAAA;A1B8nVR;;A0BxnVA;EACE,WAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,sCAAA;A1B2nVF;A0BznVE;EACE,mBAAA;A1B2nVJ;A0BxnVE;EACE,0BAAA;A1B0nVJ;;A0BtnVA,eAAA;AACA;EACE;IACE,YAAA;IACA,WAAA;IACA,WAAA;IACA,YAAA;E1BynVF;E0BvnVE;IACE,WAAA;IACA,YAAA;E1BynVJ;E0BrnVA;IACE,UAAA;IACA,YAAA;E1BunVF;E0BpnVA;IACE,aAAA;E1BsnVF;AACF","sourcesContent":["/*--------------------------------------------------------------\n>> TABLE OF CONTENTS:\n----------------------------------------------------------------\n1. Typography\n2. Preloader\n3. Spacing\n4. General\n5. Slider\n6. Video Popup\n7. Header\n8. Footer\n9. Sidebar\n10. Isotope\n11. Hero\n12. Iconbox\n13. Posts\n14. Banner\n15. Testimonial\n16. Portfolio\n17. Brands\n18. Accordians\n19. Departments\n20. About\n21. Team\n22. Funfact\n---------------------------------------------------------------*/\n@import 'default/color_variable';\n@import 'default/typography';\n@import 'common/preloader';\n@import 'common/spacing';\n@import 'common/general';\n@import 'common/slider';\n@import 'common/video-modal';\n@import 'common/header';\n@import 'common/footer';\n@import 'common/sidebar';\n@import 'common/isotope';\n@import 'shortcode/hero';\n@import 'shortcode/iconbox';\n@import 'shortcode/post';\n@import 'shortcode/banner';\n@import 'shortcode/testimonial';\n@import 'shortcode/portfolio';\n@import 'shortcode/brands';\n@import 'shortcode/accordion';\n@import 'shortcode/department';\n@import 'shortcode/about';\n@import 'shortcode/team';\n@import 'shortcode/funfact';\n@import 'shortcode/cta';\n@import 'shortcode/pricing_card';\n@import 'custom';\n","/*--------------------------------------------------------------\n## Color Variable\n----------------------------------------------------------------*/\n$white: #ffffff;\n$black: #000;\n$primary: #0171CE;\n$secondary: rgba($primary, 0.52);\n$ternary: #b7b7b7;\n$border: #eaeaea;\n$gray: #fafafa;\n$accent: #01AE42;\n","/*--------------------------------------------------------------\n1. Typography\n----------------------------------------------------------------*/\n// Google Fonts\n@import url('https://fonts.googleapis.com/css2?family=Figtree:wght@400;500;600;700&family=Poppins:wght@400;500;600;700&display=swap');\n\nbody,\nhtml {\n  color: $secondary;\n  font-family: 'Poppins', sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.625em;\n  overflow-x: hidden !important;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  clear: both;\n  color: $primary;\n  padding: 0;\n  margin: 0 0 20px 0;\n  font-weight: 700;\n  line-height: 1.2em;\n  font-family: 'Figtree', sans-serif;\n}\n\n.cs_primary_font,\n.cs_btn {\n  font-family: 'Figtree', sans-serif;\n}\n\n.cs_secondary_font {\n  font-family: 'Poppins', sans-serif;\n}\n\nh1 {\n  font-size: 56px;\n}\n\nh2 {\n  font-size: 42px;\n}\n\nh3 {\n  font-size: 30px;\n}\n\nh4 {\n  font-size: 24px;\n}\n\nh5 {\n  font-size: 18px;\n}\n\nh6 {\n  font-size: 16px;\n}\n\np {\n  margin-bottom: 15px;\n}\n\nul {\n  margin: 0 0 25px 0;\n  padding-left: 20px;\n  list-style: square outside none;\n}\n\nol {\n  padding-left: 20px;\n  margin-bottom: 25px;\n}\n\ndfn,\ncite,\nem,\ni {\n  font-style: italic;\n}\n\nblockquote {\n  margin: 0 15px;\n  font-style: italic;\n  font-size: 20px;\n  line-height: 1.6em;\n  margin: 0;\n}\n\naddress {\n  margin: 0 0 15px;\n}\n\nimg {\n  border: 0;\n  max-width: 100%;\n  height: auto;\n}\n\na {\n  color: inherit;\n  text-decoration: none;\n  transition: all 0.3s ease;\n}\n\nbutton {\n  color: inherit;\n  transition: all 0.3s ease;\n}\n\na:hover {\n  text-decoration: none;\n  color: $accent;\n}\n\ntable {\n  width: 100%;\n  margin-bottom: 25px;\n\n  th {\n    font-weight: 600;\n    color: $secondary;\n  }\n\n  td,\n  th {\n    border-top: 1px solid $border;\n    padding: 11px 10px;\n  }\n}\n\ndl {\n  margin-bottom: 25px;\n\n  dt {\n    font-weight: 600;\n  }\n}\n\nb,\nstrong {\n  font-weight: bold;\n}\n\npre {\n  color: $secondary;\n  border: 1px solid $border;\n  font-size: 18px;\n  padding: 25px;\n  border-radius: 5px;\n}\n\nkbd {\n  font-size: 100%;\n  background-color: $secondary;\n  border-radius: 5px;\n}\n\n@media screen and (max-width: 991px) {\n  body,\n  html {\n    font-size: 16px;\n    line-height: 1.6em;\n  }\n  h2 {\n    font-size: 36px;\n    margin-bottom: 10px;\n  }\n}\ninput,\ntextarea {\n  color: $primary;\n}\n","/*--------------------------------------------------------------\n2. Preloader\n----------------------------------------------------------------*/\n.cs_perloader {\n  position: fixed;\n  height: 100vh;\n  width: 100vw;\n  z-index: 99999;\n  left: 0;\n  top: 0;\n  background-color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  .cs_perloader_in {\n    position: relative;\n\n    svg {\n      width: 110px;\n      height: 110px;\n    }\n  }\n\n  .cs_wave_first {\n    svg {\n      fill: rgba($accent, 0.15);\n    }\n  }\n\n  .cs_wave_second {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    overflow: hidden;\n    animation: spark 1.25s linear infinite;\n\n    svg {\n      fill: $accent;\n    }\n  }\n}\n\n@keyframes spark {\n  0% {\n    max-width: 0;\n  }\n\n  100% {\n    max-width: 100%;\n  }\n}\n","/*--------------------------------------------------------------\n3. Spacing\n----------------------------------------------------------------*/\n@for $i from 0 through 200 {\n  .cs_height_#{$i} {\n    height: $i + px;\n  }\n}\n\n@media screen and (max-width: 1700px) {\n  @for $i from 0 through 200 {\n    .cs_height_xl_#{$i} {\n      height: $i + px;\n    }\n  }\n}\n@media screen and (max-width: 991px) {\n  @for $i from 0 through 200 {\n    .cs_height_lg_#{$i} {\n      height: $i + px;\n    }\n  }\n}\n","/*--------------------------------------------------------------\n4. General\n----------------------------------------------------------------*/\n.cs_gap_y_24 {\n  gap: 24px 0;\n}\n.cs_gap_y_40 {\n  gap: 40px 0;\n}\n.cs_gap_y_30 {\n  gap: 30px 0;\n}\n.cs_gap_y_50 {\n  gap: 50px 0;\n}\n.cs_row_gap_50 {\n  gap: 50px 0;\n  @media (max-width: 991px) {\n    gap: 30px 0;\n  }\n}\n.cs_pr_95 {\n  padding-right: 95px;\n  @media (max-width: 1700px) {\n    padding-right: 45px;\n  }\n  @media (max-width: 1400px) {\n    padding-right: 25px;\n  }\n  @media (max-width: 1199px) {\n    padding-right: 0;\n    padding-top: 10px;\n  }\n}\n.cs_gap_40 {\n  gap: 40px;\n}\n.cs_post_pr_136 {\n  padding-right: 136px;\n  @media (max-width: 1700px) {\n    padding-right: 50px;\n  }\n  @media (max-width: 1199px) {\n    padding-right: 0px;\n  }\n}\n.cs_mt_minus_110 {\n  margin-top: -110px;\n  position: relative;\n  z-index: 5;\n  @media (max-width: 991px) {\n    margin-top: 110px;\n  }\n}\n.cs_fs_94 {\n  font-size: 94px;\n  line-height: 1.1em;\n  @media (max-width: 1700px) {\n    font-size: 72px;\n  }\n  @media (max-width: 1199px) {\n    font-size: 60px;\n  }\n  @media (max-width: 400px) {\n    font-size: 42px;\n  }\n}\n.cs_fs_84 {\n  font-size: 84px;\n  line-height: 1.12em;\n  @media (max-width: 1700px) {\n    font-size: 68px;\n  }\n  @media (max-width: 767px) {\n    font-size: 56px;\n  }\n  @media (max-width: 400px) {\n    font-size: 48px;\n  }\n}\n.cs_fs_72 {\n  font-size: 72px;\n  line-height: 1.14em;\n  @media (max-width: 1700px) {\n    font-size: 56px;\n  }\n  @media (max-width: 991px) {\n    font-size: 50px;\n  }\n  @media (max-width: 575px) {\n    font-size: 48px;\n  }\n  @media (max-width: 350px) {\n    font-size: 42px;\n  }\n}\n.cs_fs_48 {\n  font-size: 48px;\n  line-height: 1.04em;\n  @media (max-width: 1700px) {\n    font-size: 36px;\n  }\n  @media (max-width: 991px) {\n    font-size: 26px;\n  }\n}\n.cs_fs_40 {\n  font-size: 40px;\n  line-height: 1.25em;\n  @media (max-width: 1700px) {\n    font-size: 32px;\n  }\n  @media (max-width: 991px) {\n    font-size: 28px;\n  }\n}\n.cs_fs_32 {\n  font-size: 32px;\n  line-height: 1.31em;\n  @media (max-width: 1700px) {\n    font-size: 26px;\n  }\n  @media (max-width: 991px) {\n    font-size: 24px;\n  }\n  @media (max-width: 350px) {\n    font-size: 21px;\n  }\n}\n.cs_fs_24 {\n  font-size: 24px;\n  line-height: 1.41em;\n  @media (max-width: 1700px) {\n    font-size: 22px;\n  }\n}\n.cs_fs_20 {\n  font-size: 20px;\n  line-height: 1.5em;\n  @media (max-width: 991px) {\n    font-size: 18px;\n  }\n}\n.cs_fs_18 {\n  font-size: 18px;\n  line-height: 1.5em;\n}\n\n.cs_img_filed {\n  height: 100%;\n  > img {\n    height: 100%;\n    width: 100%;\n    object-fit: cover;\n  }\n}\n\n.cs_light {\n  font-weight: 300;\n}\n\n.cs_normal {\n  font-weight: 400;\n}\n\n.cs_medium {\n  font-weight: 500;\n}\n\n.cs_semibold {\n  font-weight: 600;\n}\n\n.cs_bold {\n  font-weight: 700;\n}\n\n.cs_extra_bold {\n  font-weight: 800;\n}\n\n.cs_black {\n  font-weight: 900;\n}\n\n.cs_radius_3 {\n  border-radius: 3px;\n}\n\n.cs_radius_5 {\n  border-radius: 5px;\n}\n\n.cs_radius_7 {\n  border-radius: 7px;\n}\n\n.cs_radius_10 {\n  border-radius: 10px;\n}\n\n.cs_radius_15 {\n  border-radius: 15px;\n}\n.cs_radius_20 {\n  border-radius: 20px;\n}\n.cs_radius_25 {\n  border-radius: 25px;\n}\n.cs_radius_30 {\n  border-radius: 30px;\n}\n\n.cs_mp0 {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.cs_m0 {\n  margin: 0;\n}\n\nhr {\n  margin: 0;\n  padding: 0;\n  border: none;\n  border-top: 1px solid #bcbcbc;\n  opacity: 1;\n}\n\n.cs_vertical_middle {\n  display: flex;\n  align-items: center;\n  min-height: 100%;\n}\n\n.cs_vertical_middle_in {\n  flex: none;\n  width: 100%;\n}\n\n.cs_center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.cs_bg_filed {\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n.cs_heading_color {\n  color: $primary;\n}\n.cs_body_color {\n  color: $secondary;\n}\n.cs_accent_color {\n  color: $accent;\n}\n.cs_white_color {\n  color: #fff;\n}\n.cs_white_bg {\n  background-color: $white;\n}\n.cs_accent_bg {\n  background-color: $accent;\n}\n.cs_gray_bg_1 {\n  background-color: rgba(210, 234, 239, 0.2);\n}\n.cs_half_bg,\n.cs_half_bg_2 {\n  position: relative;\n  &::before {\n    content: '';\n    position: absolute;\n    height: 60%;\n    width: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    background-color: #fff;\n  }\n  > * {\n    position: relative;\n    z-index: 2;\n  }\n}\n.cs_half_bg_2 {\n  &::before {\n    height: 50%;\n    top: initial;\n    bottom: 0;\n  }\n}\n@media (min-width: 1701px) {\n  .container {\n    max-width: 1650px;\n  }\n}\n\n.cs_shadow_1 {\n  box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);\n}\n.cs_shadow_2 {\n  box-shadow: 6px 4px 70px 8px rgba(48, 123, 196, 0.09);\n}\n.cs_btn.cs_style_1 {\n  border-radius: 24px;\n  box-shadow: 0px 4px 20px 0px rgba(39, 71, 96, 0.17);\n  font-weight: 500;\n  color: #fff;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 40px;\n  outline: none;\n  border: none;\n  position: relative;\n  background: transparent;\n  @media (max-width: 991px) {\n    padding: 12px 30px;\n  }\n  span {\n    position: relative;\n    z-index: 2;\n  }\n  i {\n    display: inline-block;\n    position: relative;\n    overflow: hidden;\n    width: 15px;\n    height: 11px;\n    z-index: 2;\n    transition: all 0.4s ease-in-out;\n  }\n  img {\n    width: inherit;\n    height: inherit;\n    position: absolute;\n    top: 0;\n    transition: all 0.4s ease-in-out;\n    filter: brightness(0) invert(1);\n    &:first-child {\n      left: -20px;\n    }\n    &:last-child {\n      left: 0;\n    }\n  }\n  &::before,\n  &::after {\n    content: '';\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    border-radius: inherit;\n    left: 0;\n    top: 0;\n    transition: all 0.4s ease-in-out;\n  }\n  &::before {\n    background-image: linear-gradient(134deg, #307bc4 0%, #274760 100%);\n  }\n  &::after {\n    background-image: linear-gradient(270deg, #307bc4 0%, #274760 100%);\n    opacity: 0;\n  }\n  &:hover {\n    &::before {\n      opacity: 1;\n    }\n    &::after {\n      opacity: 1;\n    }\n    img {\n      &:first-child {\n        left: 0px;\n      }\n      &:last-child {\n        left: 20px;\n      }\n    }\n  }\n}\n.cs_text_btn {\n  display: inline-flex;\n  position: relative;\n  padding-bottom: 5px;\n  &::before {\n    content: '';\n    position: absolute;\n    height: 1px;\n    width: 100%;\n    background-color: currentColor;\n    right: 0;\n    bottom: 0;\n    transition: all 0.4s ease;\n  }\n  &:hover {\n    color: #fff;\n    &::before {\n      width: 60%;\n    }\n  }\n}\n.cs_text_btn_2 {\n  display: inline-flex;\n  align-items: center;\n  gap: 14px;\n  .cs_text_btn_text {\n    display: inline-block;\n    position: relative;\n    &::before {\n      content: '';\n      position: absolute;\n      height: 2px;\n      width: 100%;\n      bottom: 0;\n      left: 0;\n      background-color: currentColor;\n      transform: scaleX(0);\n      transform-origin: 0 50%;\n      transition-property: transform;\n      transition-property: transform, -webkit-transform;\n      transition-duration: 0.6s;\n      transition-timing-function: ease-out;\n    }\n  }\n  .cs_text_btn_icon {\n    transition: all 0.4s ease-in-out;\n  }\n  &:hover {\n    .cs_text_btn_text {\n      &::before {\n        transform: scaleX(1);\n        transition-timing-function: cubic-bezier(0.52, 1.64, 0.37, 0.66);\n      }\n    }\n    .cs_text_btn_icon {\n      transform: scale(1.1);\n    }\n  }\n}\n.cs_input_label {\n  margin-bottom: 12px;\n  @media (max-width: 1700px) {\n    margin-bottom: 10px;\n  }\n}\n.cs_form_field,\n.react-datepicker-wrapper input {\n  display: block;\n  width: 100%;\n  border-radius: 30px;\n  outline: none;\n  transition: all 0.3s ease;\n  border: 1px solid rgba($accent, 0.5);\n  padding: 26px 30px;\n  background-color: transparent;\n  &:focus {\n    border-color: $accent;\n  }\n  @media (max-width: 1700px) {\n    padding: 16px 20px;\n    border-radius: 15px;\n  }\n}\n.cs_form_field_2 {\n  width: 100%;\n  display: block;\n  border: 1px solid #636363;\n  outline: none;\n  border-radius: 6px;\n  padding: 13px 20px;\n  transition: all 0.3s ease;\n  &:focus {\n    border-color: $accent;\n  }\n}\ntextarea.cs_form_field {\n  resize: none;\n}\ntextarea::placeholder,\ninput::placeholder,\n.cs_form_field::placeholder,\n.cs_form_field_2::placeholder {\n  color: $secondary;\n}\n\ntextarea:-ms-input-placeholder,\ninput:-ms-input-placeholder,\n.cs_form_field:-ms-input-placeholder,\n.cs_form_field_2:-ms-input-placeholder {\n  color: $secondary;\n}\n\ntextarea::-ms-input-placeholder,\ninput::-ms-input-placeholder,\n.cs_form_field::-ms-input-placeholder,\n.cs_form_field_2::-ms-input-placeholder {\n  color: $secondary;\n}\n.cs_with_icon_input {\n  position: relative;\n  i {\n    position: absolute;\n    top: 30px;\n    right: 30px;\n    color: $accent;\n    font-size: 20px;\n    pointer-events: none;\n    display: flex;\n    @media (max-width: 1700px) {\n      top: 20px;\n      left: 20px;\n    }\n  }\n}\n\n.cs_random_features {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 15px 110px;\n  justify-content: center;\n  @media (max-width: 1700px) {\n    gap: 15px 60px;\n  }\n  @media (max-width: 1380px) {\n    gap: 15px 24px;\n  }\n  @media (max-width: 1121px) {\n    gap: 24px;\n    align-items: initial;\n  }\n  .cs_random_features_col {\n    padding-top: 55px;\n    @media (max-width: 1700px) {\n      padding-top: 45px;\n    }\n    @media (max-width: 1380px) {\n      padding-top: 25px;\n    }\n    @media (max-width: 1121px) {\n      padding-top: 0px;\n    }\n    @media (max-width: 767px) {\n      width: 100%;\n    }\n    &:nth-child(2) {\n      padding-top: 0;\n    }\n  }\n  @media (min-width: 992px) {\n    .cs_iconbox.cs_style_13 {\n      max-width: 390px;\n    }\n  }\n}\n.cs_feature.cs_style_1 {\n  max-width: 420px;\n  width: 100%;\n  height: 100%;\n  flex: none;\n  padding: 70px 50px;\n  @media (max-width: 1700px) {\n    max-width: 390px;\n    padding: 50px 30px;\n  }\n  @media (max-width: 1380px) {\n    max-width: 350px;\n  }\n  @media (max-width: 767px) {\n    max-width: 100%;\n  }\n  @media (max-width: 575px) {\n    padding: 30px 20px;\n  }\n  .cs_feature_icon {\n    height: 45px;\n    width: 45px;\n    flex: none;\n    padding: 9px;\n    img {\n      filter: brightness(0) invert(1);\n    }\n  }\n  .cs_feature_title {\n    gap: 15px 18px;\n    margin-bottom: 35px;\n    position: relative;\n    @media (max-width: 1700px) {\n      gap: 15px;\n    }\n    > * {\n      position: relative;\n      z-index: 2;\n    }\n    &::before {\n      content: '';\n      position: absolute;\n      height: calc(100% + 42px);\n      width: calc(100% + 160px);\n      left: 50%;\n      top: 50%;\n      transform: translate(-50%, -50%) scale(0.5);\n      opacity: 0;\n      border-radius: 30px;\n      background-color: #86bbf1;\n      transition: all 0.4s ease;\n      @media (max-width: 1700px) {\n        width: calc(100% + 100px);\n      }\n    }\n  }\n  &:hover {\n    .cs_feature_title {\n      &::before {\n        opacity: 1;\n        transform: translate(-50%, -50%) scale(1);\n      }\n    }\n  }\n}\n.cs_tab {\n  display: none;\n  &.active {\n    display: block;\n  }\n}\n\n.cs_tabs.cs_style1 {\n  display: flex;\n  align-items: center;\n\n  @media (max-width: 991px) {\n    gap: 45px;\n    flex-direction: column-reverse;\n  }\n  .cs_tab_body {\n    padding-left: 210px;\n    position: relative;\n    flex: none;\n    width: 50%;\n    padding-right: 7%;\n    @media (max-width: 1700px) {\n      padding-right: 0;\n      padding-left: 160px;\n    }\n    @media (max-width: 991px) {\n      width: 100%;\n      padding-left: 75px;\n    }\n  }\n  .cs_tab_links {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    border-right: 1px solid $accent;\n    width: 50%;\n    flex: none;\n    @media (max-width: 991px) {\n      width: 100%;\n      display: flex;\n      justify-content: center;\n      border-top: 1px solid $accent;\n      border-right: 0;\n      .cs_testimonial_1_avatar_right {\n        display: none;\n      }\n    }\n    li {\n      position: relative;\n      @media (max-width: 991px) {\n        padding-top: 30px;\n      }\n      &::before {\n        content: '';\n        position: absolute;\n        height: 10px;\n        width: 10px;\n        border-radius: 50%;\n        right: -5px;\n        top: 50%;\n        margin-top: -5px;\n        background-color: $accent;\n        transition: all 0.4s ease;\n        @media (max-width: 991px) {\n          right: initial;\n          top: 0;\n          left: 50%;\n        }\n      }\n      &:not(:last-child) {\n        margin-bottom: 35px;\n        @media (max-width: 991px) {\n          margin-bottom: 0;\n        }\n      }\n      &:nth-child(even) {\n        padding-left: 110px;\n        @media (max-width: 991px) {\n          padding-left: 0;\n        }\n      }\n      &.active {\n        &::before {\n          transform: scale(1.8);\n        }\n        .cs_tab_link_in {\n          box-shadow: 6px 4px 70px 8px rgba(48, 123, 196, 0.09);\n        }\n      }\n    }\n    .cs_tab_link_in {\n      position: relative;\n      display: inline-flex;\n      padding: 22px 50px;\n      border-radius: 25px;\n      transition: all 0.4s ease;\n      @media (max-width: 1700px) {\n        padding: 20px 35px;\n        margin-right: 60px;\n      }\n      @media (max-width: 991px) {\n        padding: 20px 35px;\n        margin-right: 0px;\n      }\n      @media (max-width: 575px) {\n        padding: 15px;\n        border-radius: 15px;\n      }\n      > a {\n        position: absolute;\n        height: 100%;\n        width: 100%;\n        z-index: 1;\n        top: 0;\n        left: 0;\n      }\n    }\n    .cs_testimonial_1_avatar {\n      display: inline-flex;\n      align-items: center;\n      gap: 20px 40px;\n      @media (max-width: 1700px) {\n        gap: 20px;\n      }\n      img {\n        border-radius: 50%;\n        height: 126px;\n        width: 126px;\n        object-fit: cover;\n        @media (max-width: 1700px) {\n          height: 80px;\n          width: 80px;\n        }\n        @media (max-width: 575px) {\n          height: 60px;\n          width: 60px;\n        }\n      }\n      p {\n        line-height: 1.6em;\n      }\n    }\n  }\n}\n\n.cs_rating {\n  width: 99px;\n  position: relative;\n  font-size: 16px;\n  .cs_rating_bg {\n    display: flex;\n    gap: 2px;\n  }\n  .cs_rating_percentage {\n    display: flex;\n    gap: 2px;\n    position: absolute;\n    top: 0;\n    left: 0;\n    overflow: hidden;\n    z-index: 1;\n  }\n}\n\n.cs_radio_wrap {\n  position: relative;\n  .cs_radio_input {\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    z-index: 1;\n    opacity: 0;\n    cursor: pointer;\n    &:checked {\n      + .cs_radio_label {\n        &::after {\n          transform: scale(1);\n        }\n      }\n    }\n  }\n  .cs_radio_label {\n    display: block;\n    padding-left: 32px;\n    &::before {\n      content: '';\n      height: 20px;\n      width: 20px;\n      border: 1px solid $accent;\n      border-radius: 50%;\n      position: absolute;\n      top: 3px;\n      left: 0;\n    }\n    &::after {\n      content: '';\n      height: 14px;\n      width: 14px;\n      background-color: $accent;\n      border-radius: 50%;\n      position: absolute;\n      top: 6px;\n      left: 3px;\n      transition: all 0.3s ease;\n      transform: scale(0);\n    }\n  }\n}\n.cs_radio_group {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px 42px;\n  @media (max-width: 1700px) {\n    gap: 10px 30px;\n  }\n}\n.cs_shape_wrap {\n  position: relative;\n  .cs_shape_1 {\n    width: 1884px;\n    height: 1884px;\n    border-radius: 50%;\n    opacity: 0.6;\n    background: radial-gradient(\n      42.35% 42.35% at 50% 50%,\n      rgba(134, 187, 241, 0.38) 0%,\n      rgba(134, 187, 241, 0) 100%\n    );\n    position: absolute;\n    top: 31%;\n    right: -37%;\n    z-index: -1;\n    &.cs_position_1 {\n      right: initial;\n      left: -38%;\n      top: -59%;\n    }\n    &.cs_position_2 {\n      right: 38%;\n      top: 39%;\n    }\n    &.cs_position_3 {\n      right: 42%;\n      top: 22%;\n    }\n    &.cs_position_4 {\n      right: -35%;\n      top: initial;\n      bottom: -10%;\n    }\n    &.cs_position_5 {\n      right: -30%;\n      top: -8%;\n    }\n  }\n  .cs_shape_2 {\n    position: absolute;\n    left: 52%;\n    top: 13%;\n    z-index: -1;\n  }\n  .cs_shape_3 {\n    position: absolute;\n    right: 0;\n    top: -41%;\n    z-index: -1;\n  }\n}\n.cs_appointment_section_1 {\n  .container {\n    position: relative;\n  }\n  .cs_appointment_img {\n    position: absolute;\n    bottom: 0;\n    left: -9.5%;\n    width: 55%;\n    @media (max-width: 1400px) {\n      left: -16%;\n      width: 63%;\n    }\n    @media (max-width: 1199px) {\n      left: -24%;\n      width: 72%;\n    }\n    @media (max-width: 991px) {\n      display: none;\n    }\n  }\n}\n\n.cs_iconbox_carousel_1 {\n  .cs_slider_activate {\n    width: 65.5vw;\n    padding-left: 55px;\n    padding-right: 55px;\n    @media (max-width: 1700px) {\n      width: 64vw;\n    }\n    @media (max-width: 1500px) {\n      width: 66vw;\n    }\n    @media (max-width: 991px) {\n      width: 100%;\n      padding-left: 30px;\n      padding-right: 30px;\n    }\n    @media (max-width: 480px) {\n      padding-left: 20px;\n      padding-right: 20px;\n      width: 100%;\n    }\n    &::before {\n      content: '';\n      position: absolute;\n      height: 60%;\n      top: 0;\n      left: 0;\n      width: 100%;\n      border-radius: 20px 0px 0px 20px;\n      background: linear-gradient(154deg, #d2eaef 0%, #86bbf1 100%);\n      @media (max-width: 991px) {\n        width: 100%;\n        border-radius: 20px 20px 0px 0px;\n      }\n    }\n  }\n  // .slick-slider {\n  //   width: 64vw;\n  //   @media (max-width: 991px) {\n  //     width: 88vw;\n  //   }\n  // }\n  .slick-list {\n    position: relative;\n    z-index: 2;\n    padding-bottom: 40px;\n    padding-top: 80px;\n    margin-bottom: -40px;\n    // overflow: initial;\n    @media (max-width: 991px) {\n      padding-top: 40px;\n    }\n    @media (max-width: 480px) {\n      padding-top: 20px;\n    }\n  }\n\n  // .slick-slide {\n  //   opacity: 0;\n  //   transition: all 0.3s ease;\n  //   &.slick-active {\n  //     opacity: 1;\n  //   }\n  // }\n}\n.cs_pagination_box {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 25px;\n  @media (max-width: 991px) {\n    gap: 15px;\n  }\n  .cs_pagination_item {\n    border-radius: 10px;\n    background: #fff;\n    box-shadow: 0px 4px 20px 0px rgba(21, 32, 70, 0.07);\n    height: 45px;\n    width: 45px;\n    color: $primary;\n    &.active {\n      background-color: $accent;\n      color: #fff;\n      pointer-events: none;\n    }\n  }\n  a.cs_pagination_item:hover {\n    background-color: $accent;\n    color: #fff;\n  }\n  .cs_pagination_arrow {\n    transition: all 0.4s ease;\n    img {\n      width: 16px;\n    }\n    &:hover {\n      transform: scale(1.2);\n    }\n  }\n}\n\n.cs_appointment_form.cs_style_1 {\n  background-color: #fff;\n  box-shadow: 6px 4px 70px 8px rgba(48, 123, 196, 0.09);\n  padding: 60px 90px;\n  @media (max-width: 1700px) {\n    padding: 60px 50px;\n  }\n  @media (max-width: 575px) {\n    padding: 50px 25px;\n  }\n  .cs_appointment_categories {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 15px 70px;\n    @media (max-width: 1700px) {\n      gap: 15px 30px;\n    }\n  }\n  .cs_appointment_form_head {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 80px;\n    gap: 25px;\n    flex-wrap: wrap;\n    @media (max-width: 1400px) {\n      margin-bottom: 40px;\n      > h2 {\n        width: 100%;\n      }\n    }\n    @media (max-width: 991px) {\n      margin-bottom: 30px;\n      gap: 20px;\n      > * {\n        width: 100%;\n      }\n    }\n  }\n  .cs_appointment_form_icon {\n    flex: none;\n    height: 70px;\n    width: 70px;\n    padding: 18px;\n  }\n  label {\n    display: block;\n    color: $primary;\n    font-weight: 500;\n    margin-bottom: 5px;\n    margin-top: -5px;\n  }\n  input,\n  textarea {\n    border: 0;\n    border-bottom: 1px solid $ternary;\n    display: block;\n    width: 100%;\n    padding: 0;\n    outline: none;\n    transition: all 0.3s ease;\n    &:focus {\n      border-color: $accent;\n    }\n  }\n  .cs_appointment_form_field {\n    display: flex;\n    align-items: center;\n    gap: 25px;\n    width: 300px;\n    flex: none;\n    @media (max-width: 991px) {\n      gap: 15px;\n      width: 280px;\n    }\n    @media (max-width: 767px) {\n      width: 100%;\n    }\n  }\n  .cs_appointment_form_field_right {\n    flex: 1;\n  }\n  .cs_appointment_form_fields {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 60px 100px;\n    justify-content: space-between;\n    @media (max-width: 1400px) {\n      gap: 40px 30px;\n    }\n    @media (max-width: 991px) {\n      gap: 25px;\n    }\n    @media (max-width: 767px) {\n      flex-direction: column;\n    }\n  }\n  .cs_appointment_category {\n    position: relative;\n    span {\n      display: inline-block;\n      position: relative;\n      transition: all 0.3s ease;\n      &::before {\n        content: '';\n        position: absolute;\n        height: 1px;\n        width: 0%;\n        bottom: -5px;\n        left: 50%;\n        transform: translateX(-50%);\n        background-color: $accent;\n        transition: all 0.3s ease;\n      }\n    }\n    input {\n      position: absolute;\n      height: 100%;\n      width: 100%;\n      left: 0;\n      top: 0;\n      z-index: 2;\n      opacity: 0;\n      cursor: pointer;\n      &:checked {\n        + span {\n          color: $primary;\n          &::before {\n            width: 100%;\n          }\n        }\n      }\n    }\n  }\n  &.cs_type_1 {\n    border-radius: 25px 25px 0px 0px;\n    border: 1px solid #fff;\n    border-bottom: 0;\n    background: rgba(255, 255, 255, 0.1);\n    backdrop-filter: blur(21.5px);\n    max-width: 670px;\n    width: 100%;\n    padding: 45px 50px;\n    position: relative;\n    z-index: 2;\n    @media (max-width: 991px) {\n      padding: 30px 25px;\n    }\n    .cs_down_btn {\n      height: 60px;\n      width: 60px;\n      position: absolute;\n      right: -30px;\n      top: -30px;\n      background-color: #fff;\n      color: $accent;\n      &:hover {\n        transform: rotate(-20deg);\n      }\n      @media (max-width: 575px) {\n        right: 5px;\n        top: 5px;\n        transform: scale(0.6);\n        &:hover {\n          transform: scale(0.6) rotate(-20deg);\n        }\n      }\n    }\n    label {\n      color: #fff;\n    }\n    .cs_appointment_form_field {\n      width: 100%;\n      margin-bottom: 35px;\n      @media (max-width: 991px) {\n        margin-bottom: 25px;\n      }\n      input,\n      textarea {\n        background-color: transparent;\n        border-color: rgba(255, 255, 255, 0.5);\n        color: #fff;\n        padding-bottom: 4px;\n        &::placeholder {\n          color: rgba(255, 255, 255, 0.6);\n        }\n        &::-ms-input-placeholder {\n          color: rgba(255, 255, 255, 0.6);\n        }\n        &:focus {\n          border-color: #fff;\n        }\n      }\n    }\n  }\n}\n.cs_page_heading {\n  background: #fff;\n  box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);\n}\n.cs_page_heading_in {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 20px;\n  padding: 25px 0;\n}\n.breadcrumb {\n  margin: 0;\n  font-size: 20px;\n}\n.breadcrumb-item.active {\n  color: $ternary;\n}\n.breadcrumb-item + .breadcrumb-item::before {\n  color: $secondary;\n}\n.cs_search_form {\n  max-width: 360px;\n  width: 100%;\n  position: relative;\n  input {\n    width: 100%;\n    border: 1px solid $accent;\n    height: 50px;\n    border-radius: 20px;\n    padding: 5px 20px;\n    outline: none;\n  }\n  .cs_search_btn {\n    position: absolute;\n  }\n  .cs_search_btn {\n    position: absolute;\n    right: 0;\n    top: 0;\n    height: 100%;\n    width: 50px;\n    border: none;\n    background-color: transparent;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    color: #274760;\n    &:hover {\n      color: $accent;\n    }\n  }\n}\n.cs_related_doctor_title {\n  position: absolute;\n  z-index: 1;\n  left: 50%;\n  width: 50%;\n  top: 80px;\n  margin-bottom: 0;\n  @media (max-width: 1700px) {\n    top: 50px;\n    padding-left: 80px;\n  }\n  @media (max-width: 1199px) {\n    top: 30px;\n    padding-left: 50px;\n  }\n  @media (max-width: 991px) {\n    position: initial;\n    padding-left: 0px;\n    padding-bottom: 50px;\n  }\n}\n.cs_doctor_profile.cs_style_1 {\n  display: flex;\n  align-items: flex-end;\n  @media (max-width: 991px) {\n    flex-direction: column;\n  }\n  .cs_doctor_info {\n    margin-left: -180px;\n    box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);\n    @media (max-width: 991px) {\n      margin-left: 0px;\n    }\n  }\n\n  .cs_doctor_profile_right {\n    flex: 1;\n    padding: 180px 85px 100px 0px;\n    @media (max-width: 1700px) {\n      padding: 150px 85px 70px 0px;\n    }\n    @media (max-width: 1400px) {\n      padding: 150px 0px 70px 0px;\n    }\n    @media (max-width: 1199px) {\n      padding: 150px 0px 0px 0px;\n    }\n    @media (max-width: 991px) {\n      padding: 25px 0px 0px 0px;\n      width: 100%;\n    }\n  }\n  .cs_social_links a {\n    height: 30px;\n    width: 30px;\n    background-color: $accent;\n    color: #fff;\n    font-size: 14px;\n  }\n  .cs_doctor_info_in {\n    padding: 50px 95px 46px;\n    @media (max-width: 1700px) {\n      padding: 40px 50px 40px;\n    }\n    @media (max-width: 767px) {\n      padding: 30px;\n    }\n    @media (max-width: 480px) {\n      br {\n        display: none;\n      }\n    }\n  }\n  .cs_doctor_meta {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 37px 95px;\n    @media (max-width: 1700px) {\n      padding: 30px 50px;\n    }\n    @media (max-width: 1400px) {\n      padding: 20px 50px;\n    }\n    @media (max-width: 767px) {\n      padding: 20px 30px;\n    }\n    @media (max-width: 480px) {\n      flex-direction: column;\n      gap: 6px 0;\n      padding: 20px 15px;\n    }\n  }\n  .cs_doctor_meta_left {\n    display: flex;\n    align-items: center;\n    gap: 20px 70px;\n    @media (max-width: 1700px) {\n      gap: 15px 40px;\n    }\n    @media (max-width: 575px) {\n      gap: 15px 20px;\n    }\n    a {\n      display: flex;\n      align-items: center;\n      gap: 15px;\n      @media (max-width: 991px) {\n        gap: 10px;\n      }\n      &:hover {\n        color: rgba($white, 0.5);\n      }\n    }\n  }\n  .cs_doctor_meta_right {\n    a {\n      display: flex;\n      gap: 11px;\n      align-items: center;\n      span {\n        position: relative;\n        &::before {\n          content: '';\n          position: absolute;\n          height: 1px;\n          width: 100%;\n          background-color: #fff;\n          bottom: 3px;\n          right: 0;\n          transition: all 0.3s ease;\n        }\n      }\n      &:hover {\n        color: $white;\n        span {\n          &::before {\n            width: 60%;\n          }\n        }\n      }\n    }\n  }\n  .cs_doctor_img {\n    max-width: 45%;\n    @media (max-width: 1700px) {\n      max-width: 50%;\n    }\n    @media (max-width: 991px) {\n      max-width: 100%;\n    }\n  }\n}\n.cs_single_doctor {\n  box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);\n  h3 {\n    padding: 23px 15px;\n    margin-top: -35px;\n    position: relative;\n    z-index: 1;\n  }\n}\n.cs_list.cs_style_1,\n.cs_list.cs_style_2,\n.cs_list.cs_style_3 {\n  .cs_list_title {\n    padding-left: 50px;\n    position: relative;\n    margin-bottom: 25px;\n    svg,\n    img {\n      position: absolute;\n      left: 0;\n      top: 4px;\n    }\n  }\n}\n.cs_list.cs_style_1 {\n  p + p {\n    margin-top: 4px;\n  }\n  ul {\n    list-style: none;\n    padding-left: 50px;\n    margin: 0;\n    li {\n      position: relative;\n      padding-left: 28px;\n      &::before {\n        content: '';\n        height: 10px;\n        width: 10px;\n        border-radius: 50%;\n        background-color: $accent;\n        position: absolute;\n        left: 0;\n        top: 8px;\n      }\n      &:not(:last-child) {\n        margin-bottom: 24px;\n      }\n    }\n  }\n}\n.cs_list.cs_style_2 {\n  ul {\n    li {\n      position: relative;\n      padding-left: 22px;\n      svg,\n      img {\n        position: absolute;\n        left: 0;\n        top: 8px;\n      }\n      &:not(:last-child) {\n        margin-bottom: 20px;\n      }\n    }\n  }\n}\n.cs_list.cs_style_3 {\n  ul {\n    box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);\n    padding: 35px 45px;\n    max-width: 454px;\n    li {\n      display: flex;\n      justify-content: space-between;\n      &:not(:last-child) {\n        margin-bottom: 24px;\n      }\n      span {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        min-width: 120px;\n        i {\n          color: $accent;\n        }\n      }\n    }\n  }\n}\n.cs_doctor_details {\n  position: relative;\n  .cs_doctor_details_bg {\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 490px;\n    width: 100%;\n    z-index: -1;\n    display: flex;\n    align-items: flex-end;\n    justify-content: center;\n    @media (max-width: 1700px) {\n      height: 420px;\n    }\n    @media (max-width: 1199px) {\n      height: 467px;\n    }\n    @media (max-width: 575px) {\n      height: 280px;\n    }\n  }\n  .cs_social_links {\n    padding: 23px 40px;\n    display: inline-flex;\n    position: absolute;\n    top: 368px;\n    right: 12px;\n    z-index: 2;\n    @media (max-width: 1700px) {\n      top: 298px;\n    }\n    @media (max-width: 1199px) {\n      top: 342px;\n    }\n    @media (max-width: 991px) {\n      position: initial;\n      margin-top: 35px;\n      padding: 15px 30px;\n    }\n    a {\n      height: 30px;\n      width: 30px;\n      background-color: #fff;\n      color: $accent;\n      font-size: 16px;\n    }\n  }\n}\n.cs_contact_info.cs_style_1 {\n  li {\n    &:not(:last-child) {\n      margin-bottom: 42px;\n      @media (max-width: 1700px) {\n        margin-bottom: 25px;\n      }\n      @media (max-width: 991px) {\n        margin-bottom: 25px;\n      }\n    }\n  }\n}\n.cs_timetable {\n  height: 1950px;\n  padding-left: 110px;\n  position: relative;\n  padding-right: 10px;\n  margin-top: 15px;\n  &::before,\n  &::after {\n    content: '';\n    height: calc(100% - 40px);\n    width: 10px;\n    background-color: #fff;\n    position: absolute;\n    top: 20px;\n    z-index: 2;\n  }\n  &::before {\n    left: 100px;\n  }\n  &::after {\n    left: 100%;\n    width: 15vw;\n    top: 0;\n    height: 100%;\n  }\n  @media (max-width: 1199px) {\n    width: 1230px;\n  }\n}\n\n.cs_timetable_vertical {\n  position: absolute;\n  left: 0;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  > div {\n    position: relative;\n    &::before {\n      content: '';\n      position: absolute;\n      height: 1px;\n      width: 100vw;\n      left: 100px;\n      top: 12px;\n      background-color: rgba($accent, 0.5);\n    }\n    &:first-child,\n    &:last-child {\n      &::before {\n        background-color: $accent;\n      }\n    }\n  }\n}\n\n.cs_timetable_in {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  border: 1px solid $accent;\n  border-top: none;\n  border-bottom: none;\n  &::before,\n  &::after {\n    content: '';\n    position: absolute;\n    height: 12px;\n    width: calc(100% - 130px);\n    right: 14px;\n    background-color: #fff;\n    z-index: 1;\n  }\n  &::before {\n    top: 0;\n  }\n  &::after {\n    bottom: 0;\n    height: 13px;\n  }\n  > div {\n    flex: 1;\n    border-right: 1px solid rgba($accent, 0.5);\n    position: relative;\n    padding: 12px 0;\n    &:last-child {\n      border-right: 0;\n    }\n    > div {\n      padding: 8px;\n    }\n    .cs_timetable_date {\n      position: absolute;\n      top: -20px;\n      z-index: 1;\n      padding: 0 !important;\n      width: 100%;\n      text-align: center;\n    }\n  }\n}\n@for $i from 1 through 13 {\n  .cs_hour_#{$i} {\n    height: (148 * $i) + px !important;\n  }\n}\n.cs_table_doctor {\n  border-radius: 10px;\n  border: 1.5px solid $accent;\n  background-color: #d2eaef;\n  height: 100%;\n  padding: 28px 20px;\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  p {\n    margin-bottom: 0;\n    &:not(:last-child) {\n      border-bottom: 1px solid $accent;\n      padding-bottom: 10px;\n      margin-bottom: 10px;\n    }\n  }\n  @media (max-width: 1700px) {\n    padding: 15px 12px;\n  }\n}\n.cs_contact_form.cs_style_1 {\n  padding: 83px 21.5%;\n  box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);\n  @media (max-width: 991px) {\n    padding: 50px;\n  }\n  @media (max-width: 400px) {\n    padding: 50px 25px;\n  }\n}\n\n.cs_map {\n  height: 650px;\n  @media (max-width: 1700px) {\n    height: 550px;\n  }\n  @media (max-width: 1400px) {\n    height: 450px;\n  }\n  @media (max-width: 575px) {\n    height: 350px;\n  }\n  iframe {\n    height: 100%;\n    width: 100%;\n    border: none;\n    filter: grayscale(100%);\n    border-radius: 30px;\n  }\n}\n.cs_blog_details_info {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px 30px;\n  .cs_social_links {\n    a {\n      height: 42px;\n      width: 42px;\n      border: 1px solid $accent;\n      color: $accent;\n      font-size: 18px;\n      &:hover {\n        background-color: $accent;\n        color: #fff;\n        transform: initial;\n      }\n    }\n  }\n}\n.cs_blog_details_info_left {\n  display: flex;\n  align-items: center;\n  gap: 20px 40px;\n  @media (max-width: 1199px) {\n    flex-direction: column-reverse;\n    align-items: flex-start;\n  }\n}\n.cs_blog_details_tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  @media (max-width: 991px) {\n    gap: 12px;\n  }\n  a {\n    padding: 11px 24px;\n    border: 1px solid $accent;\n    border-radius: 20px;\n    color: $primary;\n    @media (max-width: 991px) {\n      padding: 7px 15px;\n      border-radius: 15px;\n    }\n    &:hover {\n      background-color: $accent;\n      color: #fff;\n    }\n  }\n}\n.cs_blog_details {\n  font-size: 18px;\n  line-height: 1.55em;\n  color: $primary;\n  h2 {\n    font-size: 32px;\n    font-weight: 600;\n    margin-bottom: 20px;\n    line-height: 1.31em;\n    @media (max-width: 991px) {\n      font-size: 28px;\n    }\n  }\n  p {\n    margin-bottom: 34px;\n  }\n  ol {\n    margin-bottom: 60px;\n    li {\n      &:not(:last-child) {\n        margin-bottom: 20px;\n      }\n    }\n  }\n  blockquote {\n    min-height: 645px;\n    border-radius: 20px;\n    background-size: cover;\n    background-position: center;\n    margin: 75px 0;\n    padding: 100px 146px 0 0;\n    display: flex;\n    align-items: flex-end;\n    font-size: 32px;\n    line-height: 1.31em;\n    color: #fff;\n    font-weight: 600;\n    font-style: normal;\n    @media (max-width: 1400px) {\n      padding: 100px 100px 0 0;\n    }\n    @media (max-width: 991px) {\n      font-size: 24px;\n    }\n    @media (max-width: 575px) {\n      padding: 50px 30px 0 0;\n      min-height: 450px;\n    }\n    @media (max-width: 400px) {\n      padding-right: 0;\n    }\n    p {\n      margin: 0;\n      width: 100%;\n      background-color: $accent;\n      padding: 40px 70px 40px 120px;\n      position: relative;\n      border-radius: 0 20px 0 0;\n      @media (max-width: 1400px) {\n        padding: 40px 40px 40px 120px;\n      }\n      @media (max-width: 575px) {\n        padding: 40px 30px 40px 80px;\n      }\n      &::before {\n        content: '“';\n        position: absolute;\n        left: 48px;\n        top: 55px;\n        font-size: 80px;\n        color: rgba($white, 0.3);\n        @media (max-width: 575px) {\n          left: 25px;\n        }\n        @media (max-width: 400px) {\n          display: none;\n        }\n      }\n    }\n  }\n  h3 {\n    font-size: 24px;\n    font-weight: 600;\n    line-height: 1.41em;\n    margin-bottom: 15px;\n  }\n  ul {\n    list-style: none;\n    padding: 0;\n    margin: 55px 0 86px 0;\n    li {\n      &:not(:last-child) {\n        margin-bottom: 55px;\n      }\n    }\n  }\n  > *:last-child {\n    margin-bottom: 0;\n  }\n}\n.cs_author {\n  display: flex;\n  gap: 44px;\n  padding: 58px 0;\n  border-top: 1px solid #aaa;\n  border-bottom: 1px solid #aaa;\n  @media (max-width: 1700px) {\n    gap: 30px;\n  }\n  @media (max-width: 575px) {\n    flex-direction: column;\n    gap: 20px;\n  }\n  .cs_author_img {\n    flex: none;\n    height: 100px;\n    width: 100px;\n    border-radius: 50%;\n    overflow: hidden;\n    img {\n      height: 100%;\n      width: 100%;\n      object-fit: cover;\n      border-radius: inherit;\n    }\n  }\n  h3 {\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 1.6em;\n    margin-bottom: 15px;\n    @media (max-width: 575px) {\n      margin-bottom: 5px;\n    }\n  }\n}\n.form-check {\n  padding-left: 38px;\n  margin-bottom: 0;\n  color: $primary;\n  font-size: 18px;\n  line-height: 1.5em;\n  .form-check-input {\n    margin-left: -38px;\n    width: 24px;\n    height: 24px;\n    margin-top: 2px;\n    &:checked {\n      background-color: $accent;\n      border-color: $accent;\n    }\n  }\n}\n\n.cs_newsletter.cs_style_1 {\n  .cs_newsletter_title {\n    font-size: 42px;\n    font-weight: 700;\n    margin-bottom: 11px;\n    @media (max-width: 1700px) {\n      font-size: 34px;\n    }\n    @media (max-width: 991px) {\n      font-size: 30px;\n    }\n  }\n  .cs_newsletter_form {\n    position: relative;\n    margin-top: 25px;\n  }\n  // .cs_newsletter_input {\n  //   width: 100%;\n  //   border-radius: 2.6em;\n  //   border: 1px solid rgb($accent, 0.5);\n  //   background: transparent;\n  //   display: block;\n  //   height: 80px;\n  //   padding: 15px 185px 15px 32px;\n  //   outline: none;\n  //   transition: all 0.3s ease;\n  //   @media (max-width: 1700px) {\n  //     height: 70px;\n  //     padding: 10px 175px 10px 32px;\n  //   }\n  //   &:focus {\n  //     border-color: $accent;\n  //   }\n  // }\n  .cs_btn.cs_style_1 {\n    position: absolute;\n    right: 15px;\n    top: 15px;\n    @media (max-width: 1700px) {\n      top: 10px;\n      right: 10px;\n    }\n  }\n}\n\n.cs_newsletter.cs_style_5 {\n  text-align: center;\n  .cs_newsletter_title {\n    font-size: 28px;\n    font-weight: 600;\n    line-height: 1.5em;\n    margin-bottom: 30px;\n    @media (max-width: 1700px) {\n      font-size: 24px;\n    }\n  }\n  .cs_form_field {\n    border-color: #636363;\n    font-size: 20px;\n    line-height: 1.5em;\n    padding: 19px 25px;\n    border-radius: 7px;\n    margin-bottom: 28px;\n    @media (max-width: 1700px) {\n      font-size: 18px;\n      padding: 13px 20px;\n      margin-bottom: 20px;\n    }\n  }\n}\n\n/* Start Comment */\n.comments-area {\n  background-color: #f3f5f6;\n  border-radius: 10px;\n  padding: 40px 50px;\n  @media (max-width: 1199px) {\n    padding: 35px 25px;\n  }\n}\n.comment-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  > .comment {\n    padding: 0px 15px;\n    margin-bottom: 45px;\n    @media (max-width: 575px) {\n      padding: 0;\n    }\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n  .children {\n    margin-top: 45px;\n    .comment {\n      &:not(:first-child) {\n        border-width: 1px 0 0;\n        border-style: solid;\n        margin-top: 30px;\n        padding-top: 30px;\n      }\n    }\n  }\n  .bypostauthor {\n    &:not(:last-child) {\n      border-bottom: 1px solid $border;\n      margin-bottom: 50px;\n    }\n  }\n  .comment-body {\n    padding-left: 90px;\n    padding-top: 0;\n    position: relative;\n    padding-right: 150px;\n    @media (max-width: 1199px) {\n      padding-right: 120px;\n    }\n    @media (max-width: 575px) {\n      padding-right: 0;\n      padding-bottom: 40px;\n      padding-left: 70px;\n    }\n  }\n  ol {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n  }\n  .avatar {\n    position: absolute;\n    left: 0;\n    top: 0;\n    border-radius: 50%;\n    height: 60px;\n    width: 60px;\n  }\n  .comment-author {\n    .says {\n      display: none;\n    }\n  }\n  .fn {\n    font-style: initial;\n    font-weight: 500;\n    color: $primary;\n    display: inline-block;\n    font-size: 18px;\n    margin-bottom: 0px;\n    line-height: 1.2em;\n  }\n  .comment-meta {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n    margin-bottom: 20px;\n    margin-top: 5px;\n    color: $ternary;\n  }\n  .comment-meta {\n    a {\n      display: inline-flex;\n      position: relative;\n      align-items: center;\n      gap: 10px;\n      &:hover {\n        color: $primary;\n      }\n    }\n  }\n  .comment-meta + p,\n  .comment-meta + p + p {\n    font-size: 18px;\n    line-height: 1.55em;\n    margin-bottom: 0;\n    margin-left: -90px;\n    @media (max-width: 1700px) {\n      font-size: 16px;\n    }\n    @media (max-width: 575px) {\n      margin-left: -70px;\n    }\n  }\n  .reply {\n    line-height: 1.6em;\n    font-size: 18px;\n    font-weight: 600;\n    position: absolute;\n    bottom: 2px;\n    right: 0;\n    color: #636363;\n    padding-left: 40px;\n    @media (max-width: 1700px) {\n      font-size: 16px;\n    }\n    a {\n      display: inline-block;\n      position: relative;\n      &::before {\n        content: '';\n        position: absolute;\n        height: 1px;\n        width: 100%;\n        background-color: currentColor;\n        right: 0;\n        bottom: 2px;\n        transition: all 0.4s ease;\n      }\n      &:hover {\n        &::before {\n          width: 60%;\n        }\n      }\n    }\n    &::before {\n      content: '';\n      position: absolute;\n      width: 27px;\n      height: 22px;\n      background-image: url(../../../public/images/icons/reply.svg);\n      left: 0;\n      background-size: contain;\n      background-position: center;\n      top: 2px;\n    }\n  }\n  .bypostauthor {\n    .comment-body:last-child {\n      margin-bottom: 0;\n    }\n  }\n}\n\n.url {\n  font-weight: 600;\n  font-size: 20px;\n  color: $primary;\n  display: inline-block;\n  line-height: 1.5em;\n  @media (max-width: 1700px) {\n    font-size: 18px;\n  }\n}\n\n#commentform p.logged-in-as {\n  font-size: 16px;\n  margin-top: -5px;\n}\n\n#commentform p.logged-in-as a:hover {\n  text-decoration: underline;\n}\n\n.comment-reply-title small {\n  margin-left: 15px;\n  font-size: 16px;\n  font-weight: 500;\n  color: red;\n}\n\n.comment-reply-title small a:hover {\n  text-decoration: underline;\n}\n/* End Comment */\n\n/* Start Time Picker */\n.ui-timepicker-standard {\n  border: 1px solid $accent;\n  border-radius: 20px;\n  padding: 10px;\n  margin-top: 5px;\n  color: $primary;\n  font-family: inherit;\n  .ui-state-hover {\n    color: $primary;\n    border-color: rgba($accent, 0.3);\n    background-color: rgba($accent, 0.15);\n    border-radius: 10px;\n    color: $accent;\n  }\n  a {\n    cursor: pointer;\n    font-size: 16px;\n    line-height: 1.2em;\n    padding: 9px 15px;\n  }\n  .ui-timepicker-viewport {\n    padding-right: 0 !important;\n  }\n  .ui-widget.ui-widget-content {\n    border: none;\n  }\n}\n.ui-widget-content a {\n  color: $primary;\n}\n\n/* End Time Picker */\n/* Start Date Picker */\n.ui-datepicker.ui-widget.ui-widget-content {\n  border-color: $accent;\n  border-radius: 20px;\n  margin: 5px 0;\n  color: $primary;\n}\n.ui-state-default,\n.ui-widget-content .ui-state-default,\n.ui-widget-header .ui-state-default,\n.ui-button,\nhtml .ui-button.ui-state-disabled:hover,\nhtml .ui-button.ui-state-disabled:active {\n  border: none;\n  color: $primary;\n  background: transparent;\n  text-align: center;\n}\n.ui-widget {\n  font-family: inherit;\n}\n.ui-datepicker table {\n  font-size: 16px;\n  margin: 0 0 4px;\n}\n.ui-widget-header {\n  background: transparent;\n  border: none;\n}\n.ui-datepicker {\n  width: 388px;\n  padding: 5px;\n}\n\n.ui-state-highlight,\n.ui-widget-content .ui-state-highlight,\n.ui-widget-header .ui-state-highlight {\n  color: $accent;\n  font-weight: 500;\n}\n.ui-state-hover,\n.ui-widget-content .ui-state-hover,\n.ui-widget-header .ui-state-hover,\n.ui-state-focus,\n.ui-widget-content .ui-state-focus,\n.ui-widget-header .ui-state-focus,\n.ui-button:hover,\n.ui-button:focus {\n  color: $accent;\n}\n.ui-state-active,\n.ui-widget-content .ui-state-active,\n.ui-widget-header .ui-state-active,\na.ui-button:active,\n.ui-button:active,\n.ui-button.ui-state-active:hover {\n  background-color: rgba($accent, 0.15);\n  color: $accent;\n  border: 1px solid rgba($accent, 0.3);\n  border-radius: 7px;\n  font-weight: 500;\n}\n.ui-widget-header {\n  color: $primary;\n  font-weight: 600;\n  font-weight: 16px;\n}\n.ui-datepicker th {\n  color: $primary;\n  font-weight: 500;\n  font-size: 16px;\n}\n/* End Date Picker */\n/* Start Select Two */\n.select2-container {\n  width: 100% !important;\n  .select2-selection--single {\n    height: 78px;\n    @media (max-width: 1700px) {\n      height: 60px;\n    }\n  }\n}\n.select2-container--default .select2-selection--single {\n  border-color: rgb($accent, 0.5);\n  border-radius: 30px;\n  background-color: transparent;\n  @media (max-width: 1700px) {\n    border-radius: 15px;\n  }\n}\n.select2-container .select2-selection--single .select2-selection__rendered {\n  display: block;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  padding: 15px 30px;\n  color: $primary;\n  line-height: 1.5em;\n  @media (max-width: 1700px) {\n    padding: 15px 20px;\n  }\n}\n.select2-container--default\n  .select2-selection--single\n  .select2-selection__placeholder {\n  color: $secondary;\n}\n.select2-container--default\n  .select2-selection--single\n  .select2-selection__arrow {\n  top: 26px;\n  right: 15px;\n  width: 20px;\n  transform: scale(1.3);\n  @media (max-width: 1700px) {\n    top: 17px;\n  }\n}\n.select2-dropdown {\n  border-color: rgba($accent, 0.5);\n  border-radius: 30px;\n  @media (max-width: 1700px) {\n    border-radius: 15px;\n  }\n}\n.select2-search--dropdown {\n  padding: 20px 20px 10px 20px;\n}\n.select2-results__option {\n  padding: 7px 20px;\n}\n.select2-container--default .select2-search--dropdown .select2-search__field {\n  border-color: rgba($accent, 0.5);\n  border-radius: 10px;\n}\n.select2-search--dropdown .select2-search__field {\n  padding: 9px 15px;\n  outline: none;\n}\n.select2-results__option {\n  padding: 10px 20px;\n  margin: 0 20px;\n  border-radius: 10px;\n}\n.select2-container--default\n  .select2-results__option--highlighted[aria-selected] {\n  background-color: rgba($accent, 0.15);\n  color: $accent;\n}\n.select2-container--default .select2-results__option[aria-selected='true'] {\n  background-color: $accent;\n  color: white;\n}\n.select2-container--default .select2-results > .select2-results__options {\n  padding-bottom: 10px;\n  color: $primary;\n}\n\n/* End Select Two */\n/* Start Scroll Up */\n.cs_scrollup {\n  position: fixed;\n  bottom: -60px;\n  right: 40px;\n  color: $accent;\n  padding: 5px;\n  height: 50px;\n  width: 50px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  transition: all 0.4s ease;\n  z-index: 10;\n  background-color: $white;\n  box-shadow: 0px 4px 20px 0px rgba(39, 71, 96, 0.17);\n  border-radius: 50%;\n  font-size: 22px;\n  &:hover {\n    background-color: $primary;\n    color: $white;\n  }\n  @media (max-width: 575px) {\n    right: 20px;\n  }\n}\n\n.cs_scrollup.cs_scrollup_show {\n  bottom: 50px;\n  @media (max-width: 575px) {\n    bottom: 30px;\n  }\n}\n/* End Scroll Up */\n/* Start New Animations */\n@keyframes particalAnimation {\n  0%,\n  100% {\n    transform: translate(0px, 0px);\n  }\n\n  20% {\n    transform: translate(80px, -10px);\n  }\n\n  40% {\n    transform: translate(140px, 70px);\n  }\n\n  60% {\n    transform: translate(90px, 130px);\n  }\n\n  80% {\n    transform: translate(-40px, 80px);\n  }\n\n  100% {\n    transform: translate(0px, 0px);\n  }\n}\n\n@keyframes animo-x {\n  50% {\n    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n    transform: translateX(44px);\n  }\n}\n\n@keyframes anim-y {\n  50% {\n    animation-timing-function: cubic-bezier(0.55, 0, 0.2, 1);\n    transform: translateY(-25px);\n  }\n}\n\n@keyframes rotate-anim {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes semi-rotate-anim {\n  50% {\n    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n    transform: translateY(25px) rotate(-53deg);\n  }\n}\n\n@keyframes up-down-anim {\n  40% {\n    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n    transform: translateY(40px) rotate(-1deg);\n  }\n}\n\n@keyframes swing-anim {\n  65% {\n    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n    transform: translateY(-48px) rotate(-75deg);\n  }\n}\n@keyframes zoom-anim {\n  50% {\n    transform: scale(0.7);\n    // opacity: 0.5;\n  }\n}\n/* End New Animations */\n.cursor {\n  position: fixed;\n  left: 0;\n  pointer-events: none;\n  font-weight: 500;\n  font-size: 24px;\n  line-height: 23px;\n  color: $accent;\n  background-color: #fff;\n  text-transform: capitalize;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 80px;\n  height: 80px;\n  border-radius: 100%;\n  transform: translate(-50%, -50%);\n  z-index: 999;\n  opacity: 0;\n  transition: 0.15s;\n  box-shadow: 0px 4px 20px 0px rgba(39, 71, 96, 0.17);\n}\n\n.cs_cursor_lg,\n.cs_cursor_sm {\n  position: fixed;\n  border-radius: 50%;\n  transform: translate(-50%, -50%);\n  // mix-blend-mode: difference;\n  z-index: 9999;\n  @media (max-width: 991px) {\n    display: none !important;\n  }\n}\n.cs_cursor_lg {\n  width: 40px;\n  height: 40px;\n  // border: 1px solid #ff4a17;\n  background-color: rgba($accent, 0.15);\n  left: 0;\n  top: 0;\n  pointer-events: none;\n  transition: 0.15s;\n}\n.cs_cursor_sm {\n  width: 8px;\n  height: 8px;\n  background-color: $accent;\n  left: 0;\n  top: 0;\n  pointer-events: none;\n  transition: 0.2s;\n}\n.cs_section_heading.cs_style_1 {\n  @media (max-width: 991px) {\n    .cs_section_title {\n      br {\n        display: none;\n      }\n    }\n  }\n}\n.cs_section_wrap_1 {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n  gap: 50px;\n  @media (max-width: 991px) {\n    .cs_avatar_card {\n      margin-bottom: -60px;\n    }\n  }\n}\n.cs_avatar_card {\n  .cs_avatar_card_title {\n    margin-bottom: 24px;\n  }\n}\n.cs_avatar_group {\n  display: flex;\n  padding-left: 30px;\n  .cs_avatar_item {\n    flex: none;\n    height: 106px;\n    width: 106px;\n    border-radius: 50%;\n    padding: 5px;\n    margin-left: -30px;\n    background-color: #fff;\n    @media (max-width: 1400px) {\n      height: 80px;\n      width: 80px;\n      padding: 4px;\n    }\n    @media (max-width: 991px) {\n      height: 60px;\n      width: 60px;\n      padding: 1px;\n      svg {\n        width: 24px;\n        height: 24px;\n      }\n    }\n    img {\n      height: 100%;\n      width: 100%;\n      object-fit: cover;\n    }\n    @media (max-width: 420px) {\n      display: none;\n      &:nth-child(2),\n      &:first-child,\n      &:last-child {\n        display: flex;\n      }\n    }\n  }\n}\n","/*--------------------------------------------------------------\n5. Slider\n----------------------------------------------------------------*/\n.slick-initialized .slick-slide > div {\n  display: flex;\n  > * {\n    width: 100%;\n  }\n}\n.cs_gap_20 {\n  .slick-slide {\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n  .slick-list {\n    margin-left: -10px;\n    margin-right: -10px;\n  }\n}\n\n.cs_slider_navigation.cs_style_1 {\n  display: flex;\n  gap: 25px;\n  @media (max-width: 1700px) {\n    gap: 15px;\n  }\n  .cs_slider_prev,\n  .cs_slider_next {\n    width: 90px;\n    height: 70px;\n    background-color: #fff;\n    border-radius: 10px;\n    padding: 5px;\n    transition: all 0.4s ease;\n    cursor: pointer;\n    @media (max-width: 1700px) {\n      width: 80px;\n      height: 60px;\n    }\n    img {\n      transition: inherit;\n    }\n    &:hover {\n      background-color: $accent;\n      img {\n        filter: brightness(0) invert(1);\n      }\n    }\n  }\n  @media (max-width: 575px) {\n    margin-top: 40px;\n  }\n}\n.cs_slider_navigation.cs_style_2 {\n  display: flex;\n  gap: 12px;\n  margin-top: 40px;\n  position: relative;\n  z-index: 5;\n  .cs_slider_prev,\n  .cs_slider_next {\n    height: 40px;\n    width: 40px;\n    border: 2px solid $accent;\n    border-radius: 50%;\n    padding: 8px;\n    transition: all 0.4s ease;\n    cursor: pointer;\n    img {\n      transition: inherit;\n    }\n    &:hover {\n      background-color: $accent;\n      img {\n        filter: brightness(0) invert(1);\n      }\n    }\n  }\n}\n.slick-dots {\n  display: flex !important;\n  justify-content: center;\n  gap: 10px 15px;\n  margin-top: 60px;\n  list-style: none;\n  padding: 0;\n  margin-bottom: 0;\n  @media (max-width: 991px) {\n    margin-top: 30px;\n  }\n  li {\n    height: 12px;\n    width: 12px;\n    background-color: #fff;\n    border: 2px solid $accent;\n    opacity: 1;\n    border-radius: 1.6em;\n    transition: all 0.4s ease;\n    overflow: hidden;\n    position: relative;\n    button {\n      position: absolute;\n      top: -10px;\n      left: -10px;\n      opacity: 0;\n      z-index: 1;\n    }\n    &.slick-active {\n      background-color: $accent;\n    }\n  }\n}\n.cs_slider_heading_1 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  @media (max-width: 991px) {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 50px;\n  }\n  @media (max-width: 575px) {\n    .cs_slider_navigation.cs_style_1 {\n      margin-top: 0;\n    }\n  }\n}\n.cs_related_doctor {\n  .cs_slider_navigation.cs_style_2 {\n    margin-top: 50px;\n    justify-content: flex-end;\n    max-width: 50%;\n    margin-left: auto;\n    @media (max-width: 991px) {\n      margin-top: 30px;\n      max-width: 100%;\n      justify-content: center;\n    }\n  }\n  .slick-dots {\n    position: absolute;\n    bottom: -76px;\n    margin-top: 0;\n    z-index: 6;\n    gap: 10px 18px;\n    z-index: 3;\n    @media (max-width: 991px) {\n      display: none !important;\n    }\n    li {\n      background-color: $accent;\n      &.slick-active {\n        transform: scale(1.3);\n      }\n    }\n  }\n  @media (max-width: 1400px) {\n    .slick-list {\n      overflow: initial;\n      .slick-slide {\n        opacity: 0;\n        transition: all 0.4s ease;\n        &.slick-current {\n          opacity: 1;\n        }\n      }\n    }\n  }\n}\n.cs_department_carousel {\n  position: relative;\n  .slick-list {\n    overflow: initial;\n  }\n  .slick-slide {\n    opacity: 0;\n    transition: all 0.3s ease;\n    &.slick-active {\n      opacity: 1;\n    }\n  }\n  .cs_slider_navigation.cs_style_1 {\n    .cs_slider_prev,\n    .cs_slider_next {\n      position: absolute;\n      top: 50%;\n      transform: translateY(-50%);\n      background-color: #fff;\n      width: 70px;\n      box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);\n      opacity: 0;\n      @media (max-width: 991px) {\n        opacity: 1;\n        width: 50px;\n        height: 50px;\n        padding: 12px;\n      }\n      img {\n        filter: initial;\n      }\n    }\n    .cs_slider_prev {\n      left: -35px;\n      @media (max-width: 991px) {\n        left: -15px;\n      }\n    }\n    .cs_slider_next {\n      right: -35px;\n      @media (max-width: 991px) {\n        right: -15px;\n      }\n    }\n  }\n  &:hover {\n    .cs_slider_navigation.cs_style_1 {\n      .cs_slider_next,\n      .cs_slider_prev {\n        opacity: 1;\n      }\n    }\n  }\n}\n","/*--------------------------------------------------------------\n6. Video Popup\n----------------------------------------------------------------*/\n.cs_pd_video .cs_video_open,\n.cs_sample_img .cs_video_open {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  color: #fff;\n  font-size: 68px;\n  transition: all 0.3s ease;\n  line-height: 48px;\n}\n\n.cs_pd_video .cs_video_open:hover,\n.cs_sample_img .cs_video_open:hover {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.cs_video_popup {\n  position: fixed;\n  z-index: 1000;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  left: -100%;\n  transition-delay: 0.3s;\n}\n\n.cs_video_popup.active {\n  left: 0;\n  transition-delay: 0s;\n  left: 0;\n}\n\n.cs_video_popup_overlay {\n  position: absolute;\n  left: 0;\n  right: 0;\n  background: #000;\n  transition: all 0.4s ease-out;\n  opacity: 0;\n}\n\n.cs_video_popup.active .cs_video_popup_overlay {\n  opacity: 0.8;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n}\n\n.cs_video_popup_content {\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  font-size: 0;\n  text-align: center;\n  transition: all 0.4s ease-out;\n  transform: translateY(100px);\n  opacity: 0;\n  visibility: hidden;\n  padding: 15px;\n}\n\n.cs_video_popup.active .cs_video_popup_content {\n  transform: translateY(0);\n  opacity: 1;\n  visibility: visible;\n}\n\n.cs_video_popup_content:after {\n  content: '';\n  display: inline-block;\n  height: 100%;\n  vertical-align: middle;\n}\n\n.cs_video_popup_container {\n  display: inline-block;\n  position: relative;\n  text-align: left;\n  background: #fff;\n  max-width: 1380px;\n  width: 100%;\n  vertical-align: middle;\n}\n\n.cs_video_popup_container .embed-responsive {\n  width: 100%;\n}\n\n.embed-responsive {\n  position: relative;\n  display: block;\n  height: 0;\n  padding: 0;\n  overflow: hidden;\n  height: 100%;\n}\n\n.embed-responsive-16by9::before {\n  display: block;\n  content: '';\n  padding-top: 56.25%;\n}\n\n.embed-responsive iframe,\n.embed-responsive video {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n}\n\n.cs_video_popup_close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 40px;\n  height: 40px;\n  background: #d90d0d;\n  cursor: pointer;\n  transition: all 0.4s ease-in-out;\n}\n\n.cs_video_popup iframe {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n}\n\n.cs_video_popup_close:before {\n  content: '';\n  display: block;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 20px;\n  height: 1px;\n  background: #fff;\n  margin-left: -10px;\n  transform: rotate(-45deg);\n  transition: all 0.4s ease-in-out;\n}\n\n.cs_video_popup_close:after {\n  content: '';\n  display: block;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 20px;\n  height: 1px;\n  background: #fff;\n  margin-left: -10px;\n  transform: rotate(45deg);\n  transition: all 0.4s ease-in-out;\n}\n\n.cs_video_popup_close:hover:before,\n.cs_video_popup_close:hover:after {\n  background: #000;\n}\n\n.cs_video_popup_layer {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.cs_video_popup_align {\n  overflow: hidden;\n}\n\n/*End Video Popup*/\n","/*--------------------------------------------------------------\n7. Header\n----------------------------------------------------------------*/\n\n.cs_site_header {\n  position: relative;\n  z-index: 101;\n}\n\n.cs_site-branding {\n  display: inline-block;\n  max-width: 180px;\n}\n.cs_site_header {\n  position: absolute;\n  width: 100%;\n  left: 0;\n  top: 0px;\n  transition: all 0.4s ease;\n}\n.cs_toolbox {\n  display: flex;\n  gap: 45px;\n  .cs_toolbox_btn {\n    border: none;\n    background-color: transparent;\n    display: flex;\n    padding: 0;\n    cursor: pointer;\n    transition: all 0.4s ease;\n    &:hover {\n      color: $accent;\n    }\n  }\n}\n.cs_site_header.cs_style1 {\n  .cs_main_header_in,\n  .cs_top_header_in {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    height: 100px;\n    position: relative;\n  }\n  .cs_main_header_right {\n    display: flex;\n    align-items: center;\n    height: 100%;\n  }\n  &.cs_white_color {\n    .cs_toolbox {\n      color: $primary;\n    }\n\n    @media (max-width: 1199px) {\n      .cs_nav .cs_nav_list {\n        color: #fff;\n        background-color: $primary;\n      }\n      .cs_menu_toggle.cs_toggle_active {\n        color: #fff;\n      }\n    }\n  }\n  &.cs_gescout_sticky {\n    &.cs_white_color {\n      .cs_toolbox {\n        color: #fff;\n      }\n      .cs_menu_toggle:not(.cs_toggle_active) span {\n        color: #fff;\n      }\n    }\n  }\n  &.cs_color_1 {\n    .cs_toolbox_btn {\n      color: #fff;\n    }\n    .cs_menu_toggle {\n      color: #fff;\n    }\n  }\n}\n\n.cs_site_header.cs_style1 {\n  &.cs_sticky_active {\n    background-color: $white;\n    box-shadow: 0 10px 10px -10px rgba(33, 43, 53, 0.1);\n  }\n\n  .cs_action_box {\n    display: flex;\n    align-items: center;\n    .cs_action_value {\n      margin-left: 15px;\n    }\n    > * {\n      &:not(:last-child) {\n        margin-right: 35px;\n      }\n    }\n  }\n}\n\n.cs_site_header_full_width .container {\n  max-width: 100%;\n  padding: 0 100px;\n}\n\n.cs_site_header_style1 {\n  border-bottom: 1px solid #1a188d;\n\n  .cs_main_header_right {\n    display: flex;\n    align-items: center;\n  }\n\n  .cs_nav + .cs_header_toolbox.cs_center {\n    margin-left: 35px;\n  }\n\n  .cs_nav .cs_nav_list > li.current-menu-item > a:before {\n    bottom: -4px;\n    background-color: $white;\n  }\n}\n.cs_sidenav {\n  position: fixed;\n  z-index: 1111;\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  justify-content: flex-end;\n  transition: all 0.4s ease;\n  opacity: 0;\n  visibility: hidden;\n  &.active {\n    opacity: 1;\n    visibility: visible;\n  }\n}\n\n.cs_sidenav_overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: rgba(11, 11, 11, 0.5);\n  height: 100%;\n  width: 100%;\n  cursor: zoom-out;\n}\n\n.cs_sidenav_in {\n  position: relative;\n  z-index: 2;\n  background-color: #fff;\n  width: 100%;\n  max-width: 620px;\n  padding: 60px 80px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  hr {\n    width: calc(100% + 80px);\n  }\n  .cs_newsletter.cs_style1 {\n    .cs_newsletter_title {\n      font-size: 28px;\n      line-height: 1.35em;\n      margin-bottom: 9px;\n    }\n  }\n  .cs_social_links a {\n    background-color: $primary;\n    color: #fff;\n    height: 30px;\n    width: 30px;\n    font-size: 14px;\n    &:hover {\n      background-color: $accent;\n    }\n  }\n  .cs_close {\n    margin-bottom: 52px;\n  }\n}\n.cs_close {\n  border: none;\n  outline: none;\n  background-color: transparent;\n  cursor: pointer;\n  transition: all 0.4s ease;\n  &:hover {\n    transform: rotate(90deg);\n  }\n}\n.cs_header_search {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 999;\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.4s ease;\n  &.active {\n    opacity: 1;\n    visibility: visible;\n  }\n}\n.cs_header_search_in {\n  position: relative;\n  z-index: 1;\n  background-color: #fff;\n  padding: 50px 0;\n  .cs_search_form {\n    max-width: 100%;\n    input {\n      border-radius: 40px;\n      padding: 10px 90px 10px 35px;\n      font-size: 20px;\n      height: 80px;\n      @media (max-width: 575px) {\n        padding: 10px 65px 10px 20px;\n        font-size: 18px;\n        height: 66px;\n      }\n    }\n    .cs_search_btn {\n      width: 80px;\n      @media (max-width: 575px) {\n        width: 60px;\n      }\n      svg {\n        width: 28px;\n        height: 28px;\n        @media (max-width: 575px) {\n          width: 24px;\n          height: 24px;\n        }\n      }\n    }\n  }\n}\n.cs_header_search_box {\n  display: flex;\n  align-items: center;\n  gap: 0 30px;\n  @media (max-width: 991px) {\n    gap: 0 15px;\n  }\n}\n@media screen and (max-width: 1199px) {\n  .cs_main_header .container {\n    max-width: 100%;\n  }\n\n  .cs_site_header.cs_style1 {\n    .cs_nav {\n      display: flex;\n    }\n  }\n}\n\n.cs_nav ul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.cs_sticky_header {\n  position: fixed !important;\n  width: 100%;\n  z-index: 999;\n}\n.cs_gescout_sticky {\n  position: fixed !important;\n  top: -110px;\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.4s ease;\n  background-color: #fff;\n  .cs_main_header_in {\n    height: 90px;\n  }\n  &.cs_white_color {\n    background-color: $primary;\n  }\n}\n\n.cs_gescout_show {\n  top: 0 !important;\n  opacity: 1;\n  visibility: visible;\n  box-shadow: 0px 1px 2px 0px rgba(2, 0, 181, 0.1);\n}\n\n.cs_site_branding {\n  display: inline-block;\n}\n\n@media screen and (min-width: 1200px) {\n  .cs_site_header.cs_style1.cs_white_color {\n    .menu-item-has-children {\n      ul {\n        color: $primary;\n      }\n    }\n  }\n  .cs_main_header {\n    position: relative;\n\n    .container-fluid {\n      padding-right: 40px;\n      padding-left: 40px;\n    }\n  }\n\n  .cs_main_header_center,\n  .cs_top_header_center {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n  }\n\n  .cs_site_header.cs_style1 {\n    .cs_main_header_center {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      height: 100%;\n      width: 100%;\n      max-width: calc(100% - 300px);\n    }\n    .cs_main_header_left {\n      height: 100%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      gap: 20px 124px;\n    }\n  }\n\n  .cs_nav {\n    display: flex;\n    align-items: center;\n    height: 100%;\n    line-height: 1.6em;\n\n    .cs_nav_list {\n      display: flex !important;\n      flex-wrap: wrap;\n      height: inherit;\n\n      > li {\n        margin-right: 50px;\n        height: inherit;\n\n        &:last-child {\n          margin-right: 0;\n        }\n\n        > a {\n          padding: 10px 0;\n          display: inline-flex;\n          position: relative;\n          height: inherit;\n          align-items: center;\n        }\n\n        > ul {\n          left: 0;\n          top: calc(100% + 15px);\n        }\n\n        &:hover {\n          > ul {\n            top: 100%;\n            opacity: 1;\n            visibility: visible;\n            transition: all 0.4s ease;\n          }\n        }\n        &.menu-item-has-children {\n          > a {\n            position: relative;\n            &::after {\n              content: '';\n              display: inline-block;\n              height: 6px;\n              width: 6px;\n              border: 2px solid currentColor;\n              transform: rotate(45deg);\n              border-left: 0;\n              border-top: 0;\n              margin-left: 6px;\n              position: relative;\n              top: -1px;\n              border-radius: 0px 0px 2px 0px;\n            }\n          }\n        }\n      }\n\n      li:not(.cs_mega_menu) {\n        position: relative;\n      }\n\n      ul {\n        width: 260px;\n        background-color: #fff;\n        position: absolute;\n        box-shadow: 0px 1px 2px 0px rgba(2, 0, 181, 0.1);\n        padding: 10px 0;\n        z-index: 100;\n        opacity: 0;\n        visibility: hidden;\n        display: block !important;\n        border-radius: 15px;\n        box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);\n        transition: all 0.1s ease;\n\n        li {\n          &:hover {\n            ul {\n              top: 0px;\n            }\n\n            > ul {\n              opacity: 1;\n              visibility: visible;\n              transition: all 0.4s ease;\n            }\n          }\n        }\n\n        a {\n          display: block;\n          line-height: inherit;\n          padding: 10px 20px;\n        }\n\n        ul {\n          top: 15px;\n          left: 100%;\n        }\n      }\n    }\n  }\n  .cs_menu_toggle,\n  .cs_munu_dropdown_toggle {\n    display: none;\n  }\n\n  .cs_nav .cs_nav_list {\n    .cs_mega_menu {\n      position: relative;\n    }\n    .cs_mega_wrapper {\n      width: 475px !important;\n      left: 0;\n      display: flex !important;\n      position: absolute;\n      padding: 5px 15px 10px;\n\n      a {\n        padding: 7px 10px;\n      }\n\n      > li {\n        flex: 1;\n        padding: 10px 0;\n\n        > a {\n          font-size: 18px;\n          font-weight: 600;\n          pointer-events: none;\n          &:hover {\n            background-color: transparent;\n          }\n        }\n\n        ul {\n          position: initial;\n          border: none;\n          padding: 0;\n          width: 100%;\n          box-shadow: none;\n          background-color: transparent;\n          a {\n            transition: all 0.4s ease;\n            &:hover {\n              letter-spacing: 1px;\n            }\n          }\n        }\n      }\n    }\n\n    .cs_mega_menu {\n      &:hover {\n        .cs_mega_wrapper {\n          li ul {\n            opacity: 1;\n            visibility: visible;\n          }\n        }\n      }\n    }\n  }\n\n  .cs_nav\n    .cs_nav_list\n    > li\n    ul:not(.cs_mega_wrapper)\n    .menu-item-has-children\n    > a {\n    position: relative;\n  }\n}\n\n@media screen and (max-width: 1400px) {\n  .cs_nav .cs_nav_list .cs_mega_wrapper {\n    width: 1116px !important;\n  }\n\n  .cs_site-branding {\n    max-width: 190px;\n  }\n\n  .cs_site_header_full_width .container {\n    max-width: 100%;\n  }\n}\n\n@media screen and (max-width: 1199px) {\n  .cs_site_header.cs_style1.cs_mobile_toggle_active {\n    background-color: #fff;\n    &.cs_white_color {\n      background-color: $primary;\n    }\n  }\n  .cs_toolbox .cs_sidebar_toggle_btn {\n    display: none;\n  }\n  .cs_site_header.cs_style1 .cs_main_header_right {\n    padding-right: 50px;\n  }\n  .cs_toolbox .cs_toolbox_btn {\n    max-width: 26px;\n  }\n  .cs_nav .cs_nav_list .cs_mega_wrapper {\n    width: 100% !important;\n  }\n  .cs_site_header_full_width .container {\n    padding: 0 15px;\n  }\n  .cs_munu_dropdown_toggle {\n    position: absolute;\n    height: 40px;\n    width: 100%;\n    top: 0;\n    left: 0px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    padding: 28px 18px;\n    cursor: pointer;\n    z-index: 3;\n\n    span {\n      display: block;\n      position: relative;\n      height: 10px;\n      width: 10px;\n      line-height: 1.2em;\n      &:before,\n      &:after {\n        content: '';\n        display: block;\n        position: absolute;\n        left: 50%;\n        top: 50%;\n        transform: translate(-50%, -50%);\n        height: 2px;\n        width: 10px;\n        background-color: currentColor;\n        transition: all 0.3s ease;\n      }\n\n      &:before {\n        transform: translate(-50%, -50%) rotate(90deg);\n      }\n    }\n\n    &.active {\n      span {\n        &:before {\n          transform: translate(-50%, -50%) rotate(0deg);\n        }\n      }\n    }\n  }\n  .menu-item-has-children {\n    .menu-item-has-children {\n      .cs_munu_dropdown_toggle {\n        padding: 20px 18px;\n      }\n    }\n  }\n  .cs_site_branding {\n    position: relative;\n    z-index: 101;\n  }\n  .cs_nav {\n    .cs_nav_list {\n      position: fixed;\n      width: 100vw;\n      left: -100vw;\n      background-color: #fff;\n      color: $primary;\n      padding: 10px 0;\n      top: 80px;\n      overflow: auto;\n      height: calc(100vh - 80px);\n      line-height: 1.6em;\n      transition: all 0.4s ease;\n      &.cs_active {\n        left: 0vw;\n      }\n\n      ul {\n        padding-left: 15px;\n        display: none;\n      }\n\n      a {\n        display: block;\n        padding: 12px 15px;\n        line-height: 16px;\n      }\n      > li {\n        > a {\n          font-size: 18px;\n          line-height: 1.4em;\n        }\n      }\n    }\n\n    .menu-item-has-children {\n      position: relative;\n    }\n  }\n\n  /*Mobile Menu Button*/\n  .cs_menu_toggle {\n    display: inline-block;\n    width: 30px;\n    height: 27px;\n    cursor: pointer;\n    position: absolute;\n    top: 27px;\n    right: 30px;\n    color: $primary;\n\n    span,\n    span:before,\n    span:after {\n      width: 100%;\n      height: 3px;\n      background-color: currentColor;\n      display: block;\n      border-radius: 5px;\n    }\n\n    span {\n      margin: 0 auto;\n      position: relative;\n      top: 12px;\n      transition-duration: 0s;\n      transition-delay: 0.2s;\n\n      &:before {\n        content: '';\n        position: absolute;\n        margin-top: -9px;\n        transition-property: margin, transform;\n        transition-duration: 0.2s;\n        transition-delay: 0.2s, 0s;\n      }\n\n      &:after {\n        content: '';\n        position: absolute;\n        margin-top: 9px;\n        transition-property: margin, transform;\n        transition-duration: 0.2s;\n        transition-delay: 0.2s, 0s;\n      }\n    }\n  }\n\n  .cs_site_header.cs_style1 .cs_menu_toggle {\n    top: 50%;\n    right: 0px;\n    margin-top: -13px;\n  }\n\n  .cs_toggle_active {\n    span {\n      background-color: rgba(0, 0, 0, 0);\n      transition-delay: 0.2s;\n\n      &:before {\n        margin-top: 0;\n        transform: rotate(45deg);\n        transition-delay: 0s, 0.2s;\n      }\n\n      &:after {\n        margin-top: 0;\n        transform: rotate(-45deg);\n        transition-delay: 0s, 0.2s;\n      }\n    }\n  }\n\n  .cs_nav .cs_nav_list a {\n    position: relative;\n  }\n\n  .cs_site_header.cs_style1 .cs_main_header_in {\n    height: 80px;\n  }\n\n  .cs_site_header .current-menu-item > a:before {\n    display: none;\n  }\n  .cs_site_header.cs_style1 .cs_main_header_center {\n    .cs_site_branding {\n      position: absolute;\n      left: 0px;\n      top: 50%;\n      transform: translateY(-50%);\n    }\n  }\n  .cs_site_header.cs_style1 {\n    top: 0;\n  }\n\n  .cs_has_main_nav {\n    display: none;\n  }\n}\n\n@media screen and (max-width: 991px) {\n  .cs_site_header .container {\n    max-width: 100%;\n  }\n  .cs_site_header.cs_style1 {\n    .cs_action_box > *:not(:last-child) {\n      margin-right: 25px;\n    }\n  }\n}\n@media screen and (max-width: 575px) {\n  .cs_site-branding {\n    max-width: 150px;\n  }\n}\n/*Start Demo Menu*/\n@media (min-width: 1200px) {\n  .cs_nav .cs_nav_list > li > ul.cs_demo_mega {\n    width: 1110px;\n    display: flex !important;\n    text-align: center;\n    padding: 15px;\n    left: 50%;\n    transform: translateX(-50%);\n    position: fixed;\n    top: 100px;\n    a {\n      padding: 10px;\n    }\n    img {\n      border-radius: 8px;\n      box-shadow: 0px 3px 18px 1px rgba(48, 123, 196, 0.1);\n      border: 1px solid rgba($primary, 0.06);\n    }\n    span {\n      display: block;\n      // font-weight: 500;\n      margin-top: 6px;\n      font-size: 90%;\n      margin-bottom: -8px;\n    }\n    + ul {\n      display: none !important;\n    }\n  }\n}\n@media (max-width: 1199px) {\n  .cs_nav .cs_nav_list > li > ul.cs_demo_mega {\n    display: none !important;\n  }\n}\n/*End Demo Menu*/\n.cs_site_header.cs_style1 {\n  &.cs_color_2 {\n    background-color: #fff;\n  }\n  .cs_btn.cs_style_1 {\n    @media (max-width: 420px) {\n      padding: 7px 15px;\n      font-size: 14px;\n      i {\n        display: none;\n      }\n    }\n    @media (max-width: 350px) {\n      display: none;\n    }\n  }\n}\n","/*--------------------------------------------------------------\n8. Footer\n----------------------------------------------------------------*/\n.cs_newsletter_1_wrap {\n  position: relative;\n  &::before {\n    content: '';\n    position: absolute;\n    width: 100%;\n    left: 0;\n    top: 0;\n    height: 70%;\n    background-color: #fff;\n  }\n}\n.cs_newsletter.cs_style_2 {\n  border-radius: 20px;\n  background: #fff;\n  box-shadow: 6px 4px 70px 8px rgba(48, 123, 196, 0.09);\n  display: flex;\n  padding: 107px 135px;\n  justify-content: space-between;\n  gap: 40px 40px;\n  align-items: center;\n  position: relative;\n  z-index: 1;\n  @media (max-width: 1400px) {\n    padding: 80px 100px;\n  }\n  @media (max-width: 1199px) {\n    padding: 70px;\n  }\n  @media (max-width: 575px) {\n    padding: 50px 25px;\n    br {\n      display: none;\n    }\n  }\n  @media (max-width: 991px) {\n    flex-direction: column;\n    align-items: flex-start;\n    .cs_newsletter_title {\n      br {\n        display: none;\n      }\n    }\n  }\n  .cs_newsletter_title {\n    font-size: 42px;\n    line-height: 1.23em;\n  }\n  p {\n    color: $primary;\n    margin: 0;\n  }\n  .cs_newsletter_right {\n    min-width: 500px;\n    p {\n      margin-bottom: 12px;\n    }\n    @media (max-width: 1400px) {\n      min-width: 400px;\n    }\n    @media (max-width: 575px) {\n      min-width: 100%;\n    }\n  }\n}\n.cs_newsletter.cs_style_1,\n.cs_newsletter.cs_style_2,\n.cs_newsletter.cs_style_3,\n.cs_newsletter.cs_style_4 {\n  .cs_newsletter_form {\n    position: relative;\n  }\n  .cs_btn.cs_style_1 {\n    position: absolute;\n    top: 50%;\n    right: 15px;\n    transform: translateY(-50%);\n    @media (max-width: 1700px) {\n      right: 5px;\n    }\n  }\n  .cs_form_field {\n    padding-right: 180px;\n    @media (max-width: 1700px) {\n      padding-right: 165px;\n    }\n    @media (max-width: 575px) {\n      padding-right: 135px;\n      padding-left: 15px;\n    }\n    @media (max-width: 350px) {\n      padding-right: 120px;\n    }\n  }\n  @media (max-width: 1700px) {\n    .cs_form_field {\n      border-radius: 30px;\n    }\n  }\n  @media (max-width: 575px) {\n    .cs_btn.cs_style_1 {\n      padding: 12px 25px;\n    }\n  }\n  @media (max-width: 350px) {\n    .cs_btn.cs_style_1 {\n      padding: 12px 18px;\n    }\n  }\n}\n.cs_newsletter.cs_style_1 {\n  .cs_form_field {\n    border-radius: 2.4em;\n  }\n}\n.cs_newsletter_2_wrap {\n  position: relative;\n  &::before {\n    content: '';\n    position: absolute;\n    width: 100%;\n    left: 0;\n    top: 0;\n    height: 50%;\n    background-color: #fff;\n  }\n}\n.cs_newsletter.cs_style_3 {\n  border-radius: 20px;\n  background: linear-gradient(154deg, #d2eaef 0%, #86bbf1 100%);\n  box-shadow: 6px 4px 70px 8px rgba(48, 123, 196, 0.09);\n  position: relative;\n  z-index: 2;\n  margin-top: 240px;\n  @media (max-width: 991px) {\n    margin-top: 0;\n  }\n  .cs_newsletter_img {\n    position: absolute;\n    bottom: -3px;\n    left: -115px;\n    @media (max-width: 1199px) {\n      left: -140px;\n    }\n    @media (max-width: 991px) {\n      display: none;\n    }\n  }\n  .cs_newsletter_in {\n    padding: 87px 80px 100px 500px;\n    @media (max-width: 1199px) {\n      padding: 87px 30px 100px 420px;\n    }\n    @media (max-width: 991px) {\n      padding: 75px 50px 80px 50px;\n    }\n    @media (max-width: 575px) {\n      padding: 55px 25px 60px 25px;\n    }\n  }\n  .cs_newsletter_form {\n    max-width: 560px;\n  }\n  .cs_newsletter_title {\n    margin-bottom: 50px;\n    @media (max-width: 575px) {\n      margin-bottom: 30px;\n    }\n  }\n  .cs_newsletter_subtitle {\n    margin-bottom: 13px;\n  }\n}\n.cs_newsletter.cs_style_4 {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 40px 0;\n  border-bottom: 1px solid #fff;\n  @media (max-width: 991px) {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 35px;\n  }\n  @media (max-width: 380px) {\n    br {\n      display: none;\n    }\n  }\n  .cs_newsletter_right {\n    max-width: 500px;\n    width: 100%;\n  }\n  .cs_form_field {\n    border-color: rgba(255, 255, 255, 0.5);\n    color: #fff;\n    &:focus {\n      border-color: rgba(255, 255, 255, 0.8);\n    }\n    &::placeholder {\n      color: rgba(255, 255, 255, 0.6);\n    }\n\n    &::-ms-input-placeholder {\n      color: rgba(255, 255, 255, 0.6);\n    }\n  }\n  .cs_btn.cs_style_1 {\n    color: $accent;\n    &:before {\n      background: #fff;\n    }\n    &:after {\n      background: #fff;\n    }\n    img {\n      filter: initial;\n    }\n  }\n  .cs_newsletter_title {\n    font-size: 42px;\n    margin-bottom: 0;\n    @media (max-width: 1199px) {\n      font-size: 36px;\n    }\n  }\n  .cs_newsletter_left {\n    display: flex;\n    align-items: center;\n    gap: 35px;\n\n    @media (max-width: 1400px) {\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 10px;\n    }\n  }\n}\n.cs_social_links_wrap {\n  display: flex;\n  align-items: center;\n  gap: 20px 30px;\n  h2 {\n    font-size: 16px;\n    font-weight: 400;\n    margin: 0;\n  }\n}\n.cs_social_links {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 15px;\n  a {\n    height: 20px;\n    width: 20px;\n    flex: none;\n    display: flex;\n    align-items: center;\n    border-radius: 50%;\n    background-color: rgba($white, 0.5);\n    color: $accent;\n    font-size: 12px;\n    justify-content: center;\n    &:hover {\n      transform: scale(1.2);\n      background-color: #fff;\n    }\n  }\n}\n.cs_footer_bottom_in {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px 30px;\n  flex-wrap: wrap;\n  padding: 37px 0;\n  @media (max-width: 575px) {\n    flex-direction: column;\n    text-align: center;\n  }\n}\n.cs_copyright {\n  color: rgba($white, 0.5);\n}\n.cs_footer.cs_style_1 {\n  position: relative;\n  margin-top: 305px;\n  @media (max-width: 991px) {\n    margin-top: 200px;\n  }\n  .cs_footer_logo_wrap {\n    position: absolute;\n    height: calc(100% + 200px);\n    width: 100%;\n    left: 0;\n    bottom: 0;\n    background-position: top center;\n    background-size: cover;\n    @media (max-width: 991px) {\n      height: calc(100% + 120px);\n    }\n  }\n  .cs_footer_brand {\n    height: 448px;\n    width: 426px;\n    background-position: 6px 0px;\n    position: absolute;\n    left: 50%;\n    top: -180px;\n    transform: translateX(-50%);\n    margin-left: 6px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    background-size: 100% 100%;\n    img {\n      animation: spinAnimaiton 6s linear infinite;\n    }\n    @media (max-width: 991px) {\n      height: 360px;\n      width: 360px;\n      top: -140px;\n    }\n  }\n  .cs_footer_brand_text {\n    font-size: 36px;\n    font-weight: 400;\n    color: #fff;\n    margin: 5px 0 0;\n    @media (max-width: 991px) {\n      font-size: 32px;\n    }\n  }\n  .cs_text_widget + .cs_contact_widget {\n    margin-top: 62px;\n  }\n  .cs_footer_main {\n    padding: 70px 0;\n  }\n  .cs_newsletter.cs_style_2 {\n    .cs_form_field {\n      border-radius: 2.4em;\n    }\n  }\n}\n.cs_footer_margin_0 + .cs_footer.cs_style_1 {\n  margin-top: 0;\n}\n.cs_footer.cs_style_2 {\n  .cs_footer_in {\n    display: flex;\n    justify-content: space-between;\n    gap: 40px 30px;\n    padding: 40px 0 50px;\n    @media (max-width: 991px) {\n      flex-direction: column;\n      gap: 0;\n    }\n  }\n  .cs_footer_bottom {\n    text-align: center;\n    border-top: 1px solid rgba($white, 0.2);\n    padding: 30px 0;\n  }\n  .cs_social_links_wrap {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .cs_contact_widget i {\n    background-color: #fff;\n    color: $accent;\n  }\n  .cs_text_widget {\n    img + p {\n      margin-top: 50px;\n    }\n    + .cs_contact_widget {\n      margin-top: 20px;\n    }\n  }\n  .cs_menu_widget {\n    + .cs_social_links_wrap {\n      margin-top: 80px;\n    }\n  }\n  .cs_menu_widget {\n    a {\n      &:hover {\n        color: #fff;\n        opacity: 0.6;\n      }\n    }\n  }\n}\n.cs_footer_main,\n.cs_footer_bottom {\n  position: relative;\n  z-index: 2;\n}\n.cs_text_widget {\n  font-size: 20px;\n  line-height: 1.5em;\n  font-weight: 500;\n  p {\n    margin: 0;\n  }\n}\n.cs_contact_widget {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  li {\n    display: flex;\n    align-items: flex-start;\n    &:not(:last-child) {\n      margin-bottom: 13px;\n    }\n  }\n  i {\n    height: 20px;\n    width: 20px;\n    display: flex;\n    flex: none;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    border-radius: 50%;\n    margin-right: 19px;\n    margin-top: 5px;\n  }\n}\n.cs_menu_widget {\n  li {\n    &:not(:last-child) {\n      margin-bottom: 17px;\n    }\n  }\n}\n\n.cs_footer_item {\n  padding: 30px 0;\n  @media (max-width: 575px) {\n    padding: 20px 0;\n  }\n}\n.cs_footer_spacing_305 {\n  width: 100%;\n  height: 305px;\n}\n@keyframes spinAnimaiton {\n  0% {\n    transform: rotateX(-20deg) rotateY(0deg);\n  }\n\n  75% {\n    transform: rotateX(-20deg) rotateY(360deg);\n  }\n  100% {\n    transform: rotateX(-20deg) rotateY(360deg);\n  }\n}\n.cs_footer.cs_style_2.cs_type_1 {\n  .cs_footer_bottom {\n    border: none;\n    padding: 16px 0;\n    background: linear-gradient(119deg, #d2eaef 17.16%, #86bbf1 89.78%);\n  }\n  .cs_copyright {\n    color: $primary;\n  }\n}\n","/*--------------------------------------------------------------\n9. Sidebar\n----------------------------------------------------------------*/\n.cs_sidebar {\n  padding-left: 100px;\n  @media (max-width: 1700px) {\n    padding-left: 40px;\n  }\n  @media (max-width: 1400px) {\n    padding-left: 0px;\n  }\n  @media (max-width: 1199px) {\n    .cs_btn.cs_style_1 {\n      padding: 12px 30px;\n    }\n  }\n  @media (max-width: 991px) {\n    padding-top: 80px;\n  }\n}\n.cs_sidebar_item {\n  border-radius: 6px;\n  background-color: #fff;\n  box-shadow: 0px 6px 31px 0px rgba(65, 91, 245, 0.06);\n  padding: 50px;\n  @media (max-width: 1700px) {\n    padding: 40px 35px;\n  }\n  @media (max-width: 1400px) {\n    padding: 40px 25px;\n  }\n  &:not(:last-child) {\n    margin-bottom: 70px;\n    @media (max-width: 1700px) {\n      margin-bottom: 40px;\n    }\n  }\n}\n.widget_categories {\n  ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    font-size: 20px;\n    line-height: 1.5em;\n    color: $accent;\n    font-weight: 500;\n    @media (max-width: 1700px) {\n      font-size: 18px;\n    }\n    li {\n      position: relative;\n      padding-left: 45px;\n      &:not(:last-child) {\n        margin-bottom: 32px;\n        @media (max-width: 1700px) {\n          margin-bottom: 22px;\n        }\n      }\n      &::before {\n        content: '';\n        height: 27px;\n        width: 26px;\n        display: inline-block;\n        background-image: url(../../../public/images/icons/category.svg);\n        background-size: contain;\n        background-position: center;\n        position: absolute;\n        left: 0;\n        top: 2px;\n      }\n    }\n  }\n}\n.cs_sidebar_widget_title {\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 1.5em;\n  margin-bottom: 30px;\n  @media (max-width: 1700px) {\n    font-size: 24px;\n    margin-bottom: 20px;\n  }\n}\n.cs_popular_posts {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  > li {\n    &:not(:last-child) {\n      margin-bottom: 40px;\n      @media (max-width: 1700px) {\n        margin-bottom: 30px;\n      }\n    }\n  }\n}\n\n.cs_popular_post_title {\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 1.5em;\n  color: $accent;\n  margin-bottom: 15px;\n  @media (max-width: 1700px) {\n    font-size: 18px;\n    margin-bottom: 10px;\n  }\n  a {\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}\n\n.cs_popular_post_meta {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px 15px;\n  justify-content: space-between;\n  li {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    &.cs_posted_author {\n      a {\n        color: $primary;\n        &:hover {\n          color: $accent;\n        }\n      }\n    }\n  }\n}\n","/*--------------------------------------------------------------\n10. Isotope\n----------------------------------------------------------------*/\n.cs_isotop {\n  transition: all 0.4s ease;\n}\n\n.cs_isotop.cs_has_gutter_24 {\n  margin-left: -12px;\n  margin-right: -12px;\n  margin-bottom: -24px;\n\n  .cs_isotop_item {\n    padding: 0 12px;\n    margin-bottom: 24px;\n  }\n}\n.cs_isotop.cs_has_gutter_24_67 {\n  margin-left: -12px;\n  margin-right: -12px;\n  margin-bottom: -67px;\n\n  .cs_isotop_item {\n    padding: 0 12px;\n    margin-bottom: 67px;\n  }\n}\n.cs_isotop.cs_has_gutter_80 {\n  margin-left: -40px;\n  margin-right: -40px;\n  margin-bottom: -80px;\n\n  .cs_isotop_item {\n    padding: 0 40px;\n    margin-bottom: 80px;\n  }\n}\n.cs_isotop.cs_has_gutter_40 {\n  margin-left: -20px;\n  margin-right: -20px;\n  margin-bottom: -30px;\n\n  .cs_isotop_item {\n    padding: 0 20px;\n    margin-bottom: 30px;\n  }\n}\n\n.cs_isotop.cs_has_gutter_100 {\n  margin-left: -50px;\n  margin-right: -50px;\n  margin-bottom: -40px;\n\n  .cs_isotop_item {\n    padding: 0 50px;\n    margin-bottom: 40px;\n  }\n}\n\n.cs_isotop_col_6 .cs_grid_sizer,\n.cs_isotop_col_6 .cs_isotop_item {\n  width: 16.666667%;\n}\n\n.cs_isotop_col_5 .cs_grid_sizer,\n.cs_isotop_col_5 .cs_isotop_item {\n  width: 20%;\n}\n\n.cs_isotop_col_4 .cs_grid_sizer,\n.cs_isotop_col_4 .cs_isotop_item {\n  width: 25%;\n}\n\n.cs_isotop_col_3 .cs_grid_sizer,\n.cs_isotop_col_3 .cs_isotop_item {\n  width: 33.333333%;\n}\n\n.cs_isotop_col_2 .cs_grid_sizer,\n.cs_isotop_col_2 .cs_isotop_item {\n  width: 50%;\n}\n\n.cs_isotop_col_1 .cs_grid_sizer,\n.cs_isotop_col_1 .cs_isotop_item {\n  width: 100%;\n}\n\n.cs_grid_sizer {\n  width: 33.333333%;\n}\n\n.cs_isotop_col_5 .cs_w20,\n.cs_isotop_col_4 .cs_w20,\n.cs_isotop_col_3 .cs_w20,\n.cs_isotop_col_2 .cs_w20,\n.cs_isotop_col_1 .cs_w20 {\n  width: 20%;\n}\n\n.cs_isotop_col_5 .cs_w25,\n.cs_isotop_col_4 .cs_w25,\n.cs_isotop_col_3 .cs_w25,\n.cs_isotop_col_2 .cs_w25,\n.cs_isotop_col_1 .cs_w25 {\n  width: 25%;\n}\n\n.cs_isotop_col_5 .cs_w33,\n.cs_isotop_col_4 .cs_w33,\n.cs_isotop_col_3 .cs_w33,\n.cs_isotop_col_2 .cs_w33,\n.cs_isotop_col_1 .cs_w33 {\n  width: 33.333333%;\n}\n\n.cs_isotop_col_5 .cs_w50,\n.cs_isotop_col_4 .cs_w50,\n.cs_isotop_col_3 .cs_w50,\n.cs_isotop_col_2 .cs_w50,\n.cs_isotop_col_1 .cs_w50 {\n  width: 50%;\n}\n\n.cs_isotop_col_5 .cs_w66,\n.cs_isotop_col_4 .cs_w66,\n.cs_isotop_col_3 .cs_w66,\n.cs_isotop_col_2 .cs_w66,\n.cs_isotop_col_1 .cs_w66 {\n  width: 66.666666%;\n}\n\n.cs_isotop_col_5 .cs_w100,\n.cs_isotop_col_4 .cs_w100,\n.cs_isotop_col_3 .cs_w100,\n.cs_isotop_col_2 .cs_w100,\n.cs_isotop_col_1 .cs_w100 {\n  width: 100%;\n}\n\n.cs_isotop_filter.cs_style1 {\n  display: flex;\n  align-items: center;\n  gap: 20px 80px;\n  @media (max-width: 1700px) {\n    gap: 20px 30px;\n  }\n  @media (max-width: 991px) {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  ul {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px 36px;\n    @media (max-width: 1700px) {\n      gap: 20px;\n    }\n    @media (max-width: 991px) {\n      gap: 15px;\n    }\n    a,\n    span {\n      border: 1px solid $accent;\n      border-radius: 20px;\n      display: inline-block;\n      cursor: pointer;\n      color: $primary;\n      padding: 11px 26px;\n      transition: all 0.3s ease;\n      @media (max-width: 991px) {\n        padding: 7px 20px;\n      }\n      &:hover {\n        background-color: rgba($accent, 0.15);\n        color: $accent;\n      }\n    }\n    .active {\n      a,\n      span {\n        color: #fff;\n        background-color: $accent;\n      }\n    }\n  }\n}\n.cs_view_box {\n  display: flex;\n  align-items: center;\n  gap: 30px;\n}\n.cs_view_box_in {\n  display: flex;\n  gap: 15px;\n  button {\n    padding: 0;\n    border: none;\n    background-color: transparent;\n    transition: all 0.3s ease;\n    opacity: 0.5;\n    &:hover {\n      opacity: 1;\n    }\n    &.active {\n      opacity: 1;\n      color: $accent;\n    }\n  }\n}\n.cs_doctors_heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 30px;\n  flex-wrap: wrap;\n}\n@media screen and (max-width: 1199px) {\n  .cs_isotop.cs_has_gutter_100 .cs_isotop_item {\n    padding: 0 15px;\n    margin-bottom: 30px;\n  }\n\n  .cs_isotop.cs_has_gutter_100 {\n    margin-left: -15px;\n    margin-right: -15px;\n    margin-bottom: -30px;\n  }\n  .cs_isotop.cs_has_gutter_80 {\n    margin-left: -12px;\n    margin-right: -12px;\n    margin-bottom: -25px;\n\n    .cs_isotop_item {\n      padding: 0 12px;\n      margin-bottom: 25px;\n    }\n  }\n  .cs_isotop_col_4 .cs_grid_sizer,\n  .cs_isotop_col_4 .cs_isotop_item {\n    width: 33.333333%;\n  }\n}\n\n@media screen and (max-width: 991px) {\n  .cs_isotop_col_4 .cs_grid_sizer,\n  .cs_isotop_col_4 .cs_isotop_item {\n    width: 50%;\n  }\n\n  .cs_isotop_col_4 .cs_w50 {\n    width: 100%;\n  }\n\n  .cs_isotop_col_3 .cs_grid_sizer,\n  .cs_isotop_col_3 .cs_isotop_item {\n    width: 50%;\n  }\n\n  .cs_isotop_col_2 .cs_grid_sizer,\n  .cs_isotop_col_2 .cs_isotop_item {\n    width: 100%;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .cs_isotop_col_5 .cs_w50,\n  .cs_isotop_col_4 .cs_w50,\n  .cs_isotop_col_3 .cs_w50,\n  .cs_isotop_col_2 .cs_w50,\n  .cs_isotop_col_1 .cs_w50,\n  .cs_isotop_col_5 .cs_w66,\n  .cs_isotop_col_4 .cs_w66,\n  .cs_isotop_col_3 .cs_w66,\n  .cs_isotop_col_2 .cs_w66,\n  .cs_isotop_col_1 .cs_w66 {\n    width: 100%;\n  }\n\n  .cs_isotop_col_5 .cs_grid_sizer,\n  .cs_isotop_col_5 .cs_isotop_item {\n    width: 100%;\n  }\n\n  .cs_isotop_col_4 .cs_grid_sizer,\n  .cs_isotop_col_4 .cs_isotop_item {\n    width: 100%;\n  }\n\n  .cs_isotop_col_3 .cs_grid_sizer,\n  .cs_isotop_col_3 .cs_isotop_item {\n    width: 100%;\n  }\n\n  .cs_isotop_col_2 .cs_grid_sizer,\n  .cs_isotop_col_2 .cs_isotop_item {\n    width: 100%;\n  }\n}\n","/*--------------------------------------------------------------\n11. Hero\n----------------------------------------------------------------*/\n\n.cs_hero.cs_style_1 {\n  height: 1200px;\n  padding-bottom: 110px;\n  position: relative;\n  @media (max-width: 1700px) {\n    height: 1075px;\n  }\n  @media (max-width: 1480px) {\n    height: 1115px;\n  }\n  @media (max-width: 1380px) {\n    height: 980px;\n  }\n  @media (max-width: 1300px) {\n    height: 1010px;\n  }\n  @media (max-width: 991px) {\n    height: initial;\n  }\n  .cs_hero_text {\n    position: relative;\n    z-index: 1;\n  }\n  .cs_hero_wrap {\n    height: 100%;\n    width: 100%;\n    padding-top: 248px;\n    position: relative;\n    @media (max-width: 1300px) {\n      padding-top: 220px;\n    }\n    @media (max-width: 1199px) {\n      padding-top: 150px;\n    }\n    > .container {\n      height: 100%;\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n    }\n  }\n  .cs_hero_title {\n    margin-bottom: 29px;\n    max-width: 900px;\n    @media (max-width: 1700px) {\n      max-width: 710px;\n    }\n    @media (max-width: 1199px) {\n      max-width: 580px;\n    }\n    @media (max-width: 1199px) {\n      margin-bottom: 20px;\n    }\n  }\n  .cs_hero_subtitle {\n    max-width: 700px;\n    margin-bottom: 110px;\n    @media (max-width: 1700px) {\n      max-width: 600px;\n    }\n    @media (max-width: 1199px) {\n      max-width: 580px;\n    }\n    @media (max-width: 991px) {\n      margin-bottom: 35px;\n    }\n  }\n\n  .cs_hero_info_wrap {\n    padding: 70px 140px;\n    margin-bottom: -110px;\n    flex-wrap: wrap;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 30px;\n    position: relative;\n    z-index: 2;\n    @media (max-width: 1700px) {\n      padding: 70px;\n    }\n    @media (max-width: 1199px) {\n      padding: 70px 25px;\n      gap: 24px;\n    }\n    @media (max-width: 991px) {\n      justify-content: center;\n    }\n    @media (max-width: 767px) {\n      justify-content: space-between;\n    }\n    @media (max-width: 575px) {\n      flex-direction: column;\n      align-items: flex-start;\n      padding: 40px 25px;\n    }\n  }\n  .cs_hero_info_title {\n    font-size: 16px;\n    line-height: 1.6em;\n    margin-bottom: 4px;\n  }\n  .cs_hero_info_subtitle {\n    line-height: 1.3em;\n    margin: 0;\n  }\n  .cs_hero_info_icon {\n    height: 70px;\n    width: 70px;\n    padding: 18px;\n    @media (max-width: 1199px) {\n      height: 60px;\n      width: 60px;\n      padding: 15px;\n    }\n    img {\n      filter: brightness(0) invert(1);\n    }\n  }\n  .cs_hero_info {\n    gap: 24px;\n    @media (max-width: 1199px) {\n      gap: 15px;\n    }\n  }\n  .cs_hero_img {\n    position: absolute;\n    bottom: -10px;\n    right: 6%;\n    max-height: 86%;\n    @media (max-width: 1700px) {\n      right: 4%;\n      max-height: 84%;\n    }\n    @media (max-width: 1480px) {\n      right: 1%;\n    }\n    @media (max-width: 1300px) {\n      max-height: 82%;\n      right: 0;\n    }\n    @media (max-width: 1199px) {\n      max-height: 72%;\n    }\n    @media (max-width: 991px) {\n      max-height: 100%;\n      position: initial;\n      margin-bottom: -100px;\n      margin-top: 20px;\n    }\n    @media (max-width: 575px) {\n      margin-bottom: -55px;\n    }\n  }\n  .cs_hero_patents {\n    position: absolute;\n    left: 39.3%;\n    top: 58.5%;\n    @media (max-width: 1700px) {\n      left: 33%;\n    }\n  }\n}\n.cs_hero.cs_style_2 {\n  height: 100vh;\n  min-height: 750px;\n  max-height: 1080px;\n  padding: 218px 0 0;\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  align-items: center;\n  background-color: #35546c;\n  @media (max-width: 1700px) {\n    padding: 190px 0 0;\n  }\n  @media (max-width: 1380px) {\n    padding-top: 170px;\n  }\n  @media (max-width: 1199px) {\n    min-height: initial;\n    height: initial;\n    max-height: initial;\n    padding-top: 150px;\n  }\n  .cs_hero_text {\n    position: relative;\n    z-index: 2;\n    @media (max-width: 1199px) {\n      margin-bottom: 60px;\n    }\n    @media (max-width: 767px) {\n      margin-bottom: 40px;\n    }\n  }\n  > .container {\n    &:first-child {\n      flex: 1;\n      position: relative;\n    }\n  }\n  .cs_hero_bottom {\n    display: flex;\n    gap: 0 50px;\n    min-height: 100px;\n    @media (max-width: 1380px) {\n      flex-direction: column;\n      gap: 40px 0;\n    }\n  }\n  .cs_hero_bottom_left {\n    flex: none;\n    width: 350px;\n    @media (max-width: 1700px) {\n      width: 280px;\n    }\n  }\n  .cs_hero_title {\n    max-width: 900px;\n    margin-bottom: 82px;\n    @media (max-width: 1380px) {\n      margin-bottom: 50px;\n    }\n    @media (max-width: 767px) {\n      margin-bottom: 20px;\n    }\n  }\n  .cs_hero_text_in {\n    display: flex;\n    gap: 30px 75px;\n    @media (max-width: 767px) {\n      flex-direction: column-reverse;\n    }\n  }\n  .cs_hero_subtitle {\n    margin: 0;\n    max-width: 500px;\n  }\n  .cs_hero_patents {\n    position: absolute;\n    top: -75px;\n    right: 0;\n    z-index: 1;\n    animation: anim-y 5s cubic-bezier(0.4, 0, 0.2, 1) infinite;\n    @media (max-width: 1380px) {\n      top: -40px;\n    }\n    @media (max-width: 991px) {\n      display: none;\n    }\n  }\n  .cs_hero_funfact {\n    display: flex;\n    max-width: 1210px;\n    margin-left: auto;\n    position: relative;\n    gap: 0 97px;\n    justify-content: space-between;\n    padding: 57px 0 73px 73px;\n    @media (max-width: 1700px) {\n      gap: 0 30px;\n      padding: 40px 0 50px 60px;\n    }\n    @media (max-width: 1700px) {\n      padding: 30px 0 50px 40px;\n    }\n    @media (max-width: 991px) {\n      flex-wrap: wrap;\n      gap: 30px 0px;\n      padding: 30px 0 35px 30px;\n    }\n    @media (max-width: 575px) {\n      padding-left: 0;\n    }\n    &::before {\n      content: '';\n      position: absolute;\n      height: 100%;\n      width: 100vw;\n      left: 0;\n      top: 0;\n      border-radius: 25px 0px 0px 0px;\n      background: rgba(255, 255, 255, 0.1);\n      backdrop-filter: blur(21.5px);\n      box-shadow: 0px 0px 0px 1px rgb(255 255 255 / 40%);\n    }\n    h3 {\n      margin-bottom: 8px;\n    }\n    .cs_hero_funfact_col {\n      position: relative;\n      z-index: 2;\n      @media (max-width: 991px) {\n        width: 50%;\n        padding: 0 10px;\n      }\n      @media (max-width: 450px) {\n        h3 {\n          font-size: 36px;\n        }\n      }\n    }\n  }\n  .cs_text_btn_2 {\n    &:hover {\n      color: #fff;\n    }\n  }\n}\n.cs_hero.cs_style_2.cs_type_1 {\n  background: linear-gradient(\n    -89deg,\n    #274760 0.95%,\n    rgba(39, 71, 96, 0.59) 98.78%\n  );\n  .cs_hero_funfact {\n    background-color: rgba(39, 71, 96, 0.9);\n    width: 100%;\n    padding: 57px 60px 73px 60px;\n    gap: 0 30px;\n    border: 1px solid rgba(255, 255, 255, 0.4);\n    border-bottom: 0;\n    border-radius: 25px 25px 0px 0px;\n    @media (max-width: 1700px) {\n      padding: 40px 50px 50px 50px;\n    }\n    @media (max-width: 1199px) {\n      padding: 30px 30px 35px 30px;\n    }\n    @media (max-width: 991px) {\n      padding: 30px 0px 35px 0px;\n      gap: 30px 0px;\n    }\n    &:before {\n      display: none;\n    }\n  }\n  .cs_hero_text {\n    padding-left: 50%;\n    @media (max-width: 1400px) {\n      padding-left: 42%;\n    }\n    @media (max-width: 1199px) {\n      padding-left: 0%;\n    }\n    @media (max-width: 420px) {\n      .cd-headline {\n        display: block;\n      }\n    }\n  }\n  .cs_hero_img {\n    position: absolute;\n    bottom: 0;\n    width: 50%;\n    left: 0;\n    text-align: center;\n    padding-top: 8%;\n    height: 100%;\n    padding-left: 15px;\n    padding-right: 15px;\n    display: flex;\n    align-items: flex-end;\n    justify-content: center;\n    @media (max-width: 1400px) {\n      width: 42%;\n    }\n    @media (max-width: 1199px) {\n      width: 100%;\n      position: initial;\n      max-width: 600px;\n      padding-top: 0;\n    }\n    img {\n      max-height: 100%;\n    }\n  }\n  .cs_hero_btn {\n    flex: none;\n  }\n  .cs_hero_title {\n    span {\n      color: $accent;\n    }\n  }\n}\n.cs_hero.cs_style_3 {\n  height: calc(100vh + 235px);\n  max-height: 1350px;\n  min-height: 1050px;\n  position: relative;\n  padding-top: 240px;\n  overflow: hidden;\n  @media (max-width: 1380px) {\n    padding-top: 200px;\n  }\n  @media (max-width: 991px) {\n    padding-top: 160px;\n    padding-bottom: 400px;\n    min-height: calc(100vh + 210px);\n    max-height: initial;\n    height: initial;\n  }\n  @media (max-width: 991px) {\n    display: flex;\n    align-items: center;\n  }\n  @media (max-width: 575px) {\n    padding-top: 140px;\n    min-height: initial;\n    max-height: initial;\n    height: initial;\n    .cs_fs_20 {\n      font-size: 16px;\n    }\n  }\n  .cs_hero_bg {\n    position: absolute;\n    height: calc(100% - 235px);\n    width: 100%;\n    left: 0;\n    top: 0;\n    display: flex;\n    align-items: flex-end;\n    @media (max-width: 991px) {\n      height: calc(100% - 210px);\n    }\n  }\n  > .container {\n    position: relative;\n    z-index: 2;\n  }\n  .cs_hero_title {\n    max-width: 1000px;\n    margin-bottom: 52px;\n    @media (max-width: 1700px) {\n      max-width: 750px;\n    }\n    @media (max-width: 1199px) {\n      max-width: 550px;\n    }\n    @media (max-width: 991px) {\n      margin-bottom: 20px;\n    }\n  }\n  .cs_hero_subtitle {\n    max-width: 540px;\n  }\n  .cs_hero_img_1 {\n    position: absolute;\n    top: 150px;\n    right: 90px;\n    @media (max-width: 1700px) {\n      top: 170px;\n      right: 70px;\n      max-width: 880px;\n    }\n    @media (max-width: 1400px) {\n      right: 15px;\n      margin-left: 15px;\n      max-width: 800px;\n    }\n    @media (max-width: 991px) {\n      display: none;\n    }\n  }\n  .cs_hero_img_2 {\n    position: absolute;\n    right: 5%;\n    top: 69%;\n    animation: animo-x 7s cubic-bezier(0.4, 0, 0.2, 1) infinite;\n    @media (max-width: 1700px) {\n      top: 66%;\n    }\n    @media (max-width: 991px) {\n      display: none;\n    }\n  }\n  .cs_hero_img_3 {\n    position: absolute;\n    right: 38%;\n    top: 40%;\n    animation: anim-y 5s cubic-bezier(0.4, 0, 0.2, 1) infinite;\n    @media (max-width: 1700px) {\n      right: 30%;\n    }\n    @media (max-width: 1400px) {\n      top: 50%;\n    }\n    @media (max-width: 1380px) {\n      top: 60%;\n      right: 34%;\n    }\n    @media (max-width: 1199px) {\n      display: none;\n    }\n  }\n  .cs_hero_img_4 {\n    position: absolute;\n    right: 7%;\n    top: 24%;\n    animation: zoom-anim 7s cubic-bezier(0.4, 0, 0.2, 1) infinite;\n    @media (max-width: 991px) {\n      display: none;\n    }\n  }\n  .cs_hero_card {\n    display: inline-block;\n    border-radius: 20px;\n    background: linear-gradient(163deg, #86bbf1 0%, #d2eaef 100%);\n    padding: 30px 40px;\n    position: relative;\n    bottom: -100px;\n    z-index: 2;\n    @media (max-width: 575px) {\n      width: 100%;\n      padding: 30px 15px;\n    }\n    @media (max-width: 380px) {\n      .cs_fs_24 {\n        font-size: 18px;\n      }\n      .cs_hero_shedule_list li {\n        gap: 8px;\n      }\n    }\n  }\n  .cs_hero_card_media {\n    display: flex;\n    align-items: center;\n    margin-bottom: 23px;\n    img {\n      flex: none;\n      border-radius: 50%;\n      width: 63px;\n      height: 63px;\n      margin-right: 12px;\n      object-fit: cover;\n      @media (max-width: 380px) {\n        width: 50px;\n        height: 50px;\n      }\n    }\n  }\n  .cs_hero_shedule_list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    li {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n      &:not(:last-child) {\n        margin-bottom: 3px;\n      }\n    }\n    strong {\n      font-weight: 600;\n    }\n  }\n  &.cs_type_1 {\n    height: 100vh;\n    min-height: initial;\n    max-height: 1050px;\n    @media (max-width: 991px) {\n      padding: 150px 0 110px;\n    }\n\n    .cs_hero_bg {\n      height: 100%;\n      &::before {\n        content: '';\n        position: absolute;\n        height: 100%;\n        width: 100%;\n        left: 0;\n        top: 0;\n        z-index: 1;\n        background: linear-gradient(\n          90deg,\n          #274760 0%,\n          rgba(48, 123, 196, 0) 100%\n        );\n      }\n    }\n  }\n}\n.cs_hero.cs_style_4 {\n  min-height: 750px;\n  position: relative;\n  padding: 210px 0 0;\n  @media (max-width: 1700px) {\n    padding: 190px 0 0;\n  }\n  @media (max-width: 1199px) {\n    padding: 150px 0 0;\n  }\n  .cs_hero_text {\n    max-width: 920px;\n    position: relative;\n    z-index: 2;\n  }\n  .cs_hero_title {\n    margin-bottom: 40px;\n    @media (max-width: 1199px) {\n      margin-bottom: 20px;\n    }\n  }\n  .cs_hero_subtitle {\n    max-width: 700px;\n    margin-bottom: 110px;\n    @media (max-width: 1700px) {\n      margin-bottom: 60px;\n    }\n  }\n  .cs_hero_img_1 {\n    position: absolute;\n    left: 53%;\n    top: 50%;\n    animation: anim-y 5s cubic-bezier(0.4, 0, 0.2, 1) infinite;\n    @media (max-width: 991px) {\n      display: none;\n    }\n  }\n  .cs_hero_img_2 {\n    position: absolute;\n    right: 3%;\n    bottom: 0%;\n    animation: animo-x 7s cubic-bezier(0.4, 0, 0.2, 1) infinite;\n    @media (max-width: 991px) {\n      display: none;\n    }\n  }\n  .cs_hero_img_3 {\n    position: absolute;\n    right: 8%;\n    top: 22%;\n    animation: zoom-anim 7s cubic-bezier(0.4, 0, 0.2, 1) infinite;\n    @media (max-width: 991px) {\n      display: none;\n    }\n  }\n}\n","/*--------------------------------------------------------------\n12. Iconbox\n----------------------------------------------------------------*/\n.cs_iconbox.cs_style_1 {\n  padding: 25px 30px 40px 30px;\n  height: 100%;\n  @media (max-width: 1700px) {\n    padding: 25px 20px 30px 20px;\n  }\n  @media (max-width: 1280px) {\n    padding: 25px 25px 30px 25px;\n  }\n  @media (max-width: 991px) {\n    .cs_fs_20 {\n      font-size: 20px;\n    }\n  }\n  @media (max-width: 340px) {\n    .cs_fs_20 {\n      font-size: 18px;\n    }\n  }\n  .cs_iconbox_icon {\n    height: 120px;\n    width: 120px;\n    flex: none;\n    padding: 25px;\n    position: relative;\n    overflow: hidden;\n    @media (max-width: 1700px) {\n      height: 90px;\n      width: 90px;\n      padding: 15px;\n    }\n    img {\n      max-height: 100%;\n    }\n    &:before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: -80%;\n      z-index: 2;\n      width: 50%;\n      height: 100%;\n      background: linear-gradient(\n        to right,\n        transparent,\n        rgba(255, 255, 255, 0.13)\n      );\n      transform: skewX(-25deg);\n      z-index: 1;\n    }\n  }\n  &:hover {\n    .cs_iconbox_icon {\n      &:before {\n        animation: shine 1.3s;\n      }\n    }\n  }\n  .cs_iconbox_top {\n    display: flex;\n    align-items: center;\n    gap: 25px;\n    margin-bottom: 43px;\n    max-width: 340px;\n    @media (max-width: 1700px) {\n      gap: 15px;\n      margin-bottom: 30px;\n      .cs_iconbox_title {\n        line-height: 1.4em;\n      }\n    }\n    @media (max-width: 991px) {\n      margin-bottom: 20px;\n    }\n  }\n  .cs_iconbox_text {\n    padding-left: 14px;\n    margin: 0;\n    @media (max-width: 1199px) {\n      padding-left: 0;\n    }\n  }\n}\n\n@keyframes shine {\n  100% {\n    left: 125%;\n  }\n}\n\n.cs_iconbox.cs_style_2 {\n  display: flex;\n  align-items: center;\n  min-height: 250px;\n  gap: 60px;\n  border-radius: 20px;\n  border: 1px solid $accent;\n  padding: 40px 70px;\n  margin-bottom: 60px;\n  transition: all 0.4s ease;\n  @media (max-width: 1700px) {\n    min-height: 220px;\n    gap: 30px;\n    padding: 40px;\n    margin-bottom: 50px;\n  }\n  @media (max-width: 1700px) {\n    min-height: 200px;\n    margin-bottom: 25px;\n  }\n  @media (max-width: 450px) {\n    min-height: 150px;\n    gap: 25px;\n    padding: 35px;\n  }\n  .cs_iconbox_title {\n    transition: all 0.4s ease;\n  }\n  img {\n    transition: all 0.4s ease;\n    color: $accent;\n    @media (max-width: 350px) {\n      max-width: 65px;\n    }\n  }\n  .cs_iconbox_icon {\n    flex: none;\n  }\n  &:hover {\n    background-color: $accent;\n    box-shadow: 6px 4px 70px 8px rgba($accent, 0.09);\n    .cs_iconbox_title {\n      color: #fff;\n    }\n    img {\n      filter: brightness(0) invert(1);\n    }\n  }\n}\n.cs_iconbox.cs_style_3 {\n  display: flex;\n  position: relative;\n  @media (max-width: 991px) {\n    gap: 0 20px;\n  }\n  @media (max-width: 420px) {\n    flex-direction: column;\n  }\n  &::before {\n    content: '';\n    position: absolute;\n    width: 9px;\n    height: calc(100% + 50px);\n    background-color: $accent;\n    left: 50%;\n    margin-left: -4px;\n    margin-top: -25px;\n    transition: all 0.4s ease;\n    opacity: 0;\n    @media (max-width: 991px) {\n      display: none;\n    }\n  }\n\n  .cs_iconbox_left,\n  .cs_iconbox_right {\n    width: 50%;\n    flex: none;\n    @media (max-width: 991px) {\n      width: initial;\n      flex: initial;\n    }\n  }\n  .cs_iconbox_left {\n    padding-right: 120px;\n    @media (max-width: 991px) {\n      padding-right: 0;\n      padding-top: 10px;\n    }\n  }\n  .cs_iconbox_right {\n    padding-left: 200px;\n    position: relative;\n    @media (max-width: 1400px) {\n      br {\n        display: none;\n      }\n    }\n    @media (max-width: 991px) {\n      padding-left: 0;\n    }\n  }\n  .cs_iconbox_number {\n    font-size: 72px;\n    color: rgba($accent, 0.08);\n    line-height: 1.14;\n    position: absolute;\n    left: 84px;\n    top: -20px;\n    @media (max-width: 991px) {\n      position: initial;\n      font-size: 56px;\n      margin-bottom: 10px;\n    }\n    @media (max-width: 420px) {\n      display: none;\n    }\n  }\n  .cs_iconbox_icon {\n    height: 136px;\n    width: 136px;\n    background: rgba($accent, 0.17);\n    margin-left: auto;\n    transition: all 0.4s ease;\n    padding: 25px;\n    @media (max-width: 991px) {\n      height: 100px;\n      width: 100px;\n    }\n    @media (max-width: 420px) {\n      height: 80px;\n      width: 80px;\n      margin-left: initial;\n      padding: 20px;\n      margin-bottom: 20px;\n    }\n  }\n  .cs_iconbox_title {\n    margin-bottom: 20px;\n    @media (max-width: 420px) {\n      margin-bottom: 10px;\n    }\n  }\n  &:hover {\n    &::before {\n      opacity: 1;\n    }\n    .cs_iconbox_icon {\n      background-color: $accent;\n    }\n  }\n}\n.cs_iconbox_3_wrap {\n  position: relative;\n  &::before {\n    content: '';\n    position: absolute;\n    left: 50%;\n    top: 0;\n    height: 100%;\n    width: 1px;\n    background-color: $primary;\n    @media (max-width: 991px) {\n      display: none;\n    }\n  }\n  .cs_iconbox.cs_style_3 {\n    &:not(:last-child) {\n      margin-bottom: 146px;\n      @media (max-width: 991px) {\n        margin-bottom: 50px;\n      }\n    }\n    &:nth-child(even) {\n      flex-direction: row-reverse;\n      @media (max-width: 991px) {\n        flex-direction: row;\n      }\n      @media (max-width: 420px) {\n        flex-direction: column;\n      }\n      .cs_iconbox_left {\n        padding-right: 0px;\n        padding-left: 120px;\n        @media (max-width: 991px) {\n          padding-left: 0;\n        }\n      }\n      .cs_iconbox_right {\n        padding-right: 200px;\n        padding-left: 0;\n        text-align: right;\n        @media (max-width: 991px) {\n          padding-right: 0;\n          text-align: left;\n        }\n      }\n      .cs_iconbox_icon {\n        margin-left: initial;\n      }\n      .cs_iconbox_number {\n        left: initial;\n        right: 84px;\n      }\n    }\n  }\n}\n.cs_iconbox.cs_style_4,\n.cs_iconbox.cs_style_7 {\n  border-radius: 20px;\n  background: #fff;\n  box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);\n  transition: all 0.4s ease;\n  position: relative;\n  .cs_iconbox_btn {\n    width: 90px;\n    height: 70px;\n    background-color: rgba($accent, 0.5);\n    border-radius: 10px 0 20px 0;\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    overflow: hidden;\n    @media (max-width: 1700px) {\n      width: 70px;\n      height: 50px;\n    }\n    img {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      transition: all 0.4s ease;\n\n      &:last-child {\n        left: -50%;\n      }\n    }\n    &:hover {\n      background-color: $accent;\n    }\n  }\n  &:hover {\n    .cs_iconbox_btn {\n      img {\n        &:first-child {\n          left: 150%;\n        }\n        &:last-child {\n          left: 50%;\n        }\n      }\n    }\n  }\n}\n.cs_iconbox.cs_style_4 {\n  padding: 30px 110px 32px 40px;\n  margin-bottom: 20px;\n  @media (max-width: 1700px) {\n    padding: 30px 90px 50px 25px;\n  }\n  @media (max-width: 1400px) {\n    padding: 30px 35px 50px 25px;\n  }\n  @media (max-width: 991px) {\n    padding: 30px 25px 70px 25px;\n  }\n  .cs_iconbox_title {\n    margin-bottom: 12px;\n    min-height: 83px;\n    @media (max-width: 1700px) {\n      min-height: initial;\n    }\n  }\n  @media (min-width: 1701px) {\n    .cs_iconbox_subtitle {\n      padding-right: 20%;\n    }\n  }\n\n  .cs_iconbox_icon {\n    height: 40px;\n    width: 40px;\n    margin-bottom: 21px;\n  }\n}\n.cs_iconbox.cs_style_5 {\n  display: flex;\n  gap: 25px;\n  align-items: center;\n  box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);\n  padding: 25px 30px;\n  @media (max-width: 1700px) {\n    padding: 20px;\n    gap: 15px;\n    .cs_iconbox_title {\n      line-height: 1.3em;\n    }\n  }\n  .cs_iconbox_icon {\n    flex: none;\n    width: 120px;\n    height: 120px;\n    padding: 18px;\n    position: relative;\n    overflow: hidden;\n    @media (max-width: 1700px) {\n      width: 80px;\n      height: 80px;\n      padding: 20px;\n    }\n    &:before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: -80%;\n      z-index: 2;\n      width: 50%;\n      height: 100%;\n      background: linear-gradient(\n        to right,\n        transparent,\n        rgba(255, 255, 255, 0.13)\n      );\n      transform: skewX(-25deg);\n      z-index: 1;\n    }\n  }\n  &:hover {\n    .cs_iconbox_icon {\n      &:before {\n        animation: shine 1.3s;\n      }\n    }\n  }\n}\n.cs_iconbox.cs_style_6 {\n  .cs_iconbox_icon {\n    height: 40px;\n    width: 40px;\n    margin-bottom: 18px;\n    padding: 8px;\n    img {\n      max-height: 100%;\n    }\n  }\n  .cs_iconbox_title {\n    margin-bottom: 12px;\n  }\n  @media (max-width: 1700px) {\n    br {\n      display: none;\n    }\n  }\n}\n.cs_iconbox.cs_style_7 {\n  padding: 48px 80px 88px 130px;\n  margin-bottom: 50px;\n  @media (max-width: 1700px) {\n    padding: 48px 50px 88px 130px;\n  }\n  @media (max-width: 1400px) {\n    padding: 40px 30px 88px 100px;\n  }\n  @media (max-width: 991px) {\n    margin-bottom: 25px;\n    padding: 30px 30px 70px 100px;\n  }\n  .cs_iconbox_title {\n    margin-bottom: 18px;\n  }\n  .cs_iconbox_icon {\n    position: absolute;\n    top: 56px;\n    left: 34px;\n    @media (max-width: 1400px) {\n      top: 50px;\n      left: 25px;\n      max-width: 54px;\n    }\n    @media (max-width: 991px) {\n      top: 40px;\n    }\n  }\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    border-radius: inherit;\n    background: linear-gradient(154deg, #d2eaef 0%, #86bbf1 100%);\n    height: 100%;\n    width: 100%;\n    transition: all 0.4s ease;\n    opacity: 0;\n  }\n  .cs_iconbox_title,\n  .cs_iconbox_subtitle {\n    position: relative;\n    z-index: 2;\n  }\n  &:hover {\n    &::before {\n      opacity: 1;\n    }\n  }\n}\n.cs_iconbox.cs_style_8 {\n  padding: 72px 41px 66px;\n  transition: all 0.4s ease;\n  @media (max-width: 1700px) {\n    padding: 55px 26px 50px;\n  }\n  @media (max-width: 1400px) {\n    padding: 30px 15px;\n  }\n\n  .cs_iconbox_title {\n    margin-bottom: 12px;\n    color: #fff;\n    transition: all 0.3s ease;\n  }\n  .cs_iconbox_subtitle {\n    color: #fff;\n    transition: all 0.3s ease;\n  }\n  .cs_iconbox_icon {\n    height: 72px;\n    width: 72px;\n    border: 1px solid $accent;\n    margin-bottom: 25px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n  &:hover {\n    background-color: #fff;\n    box-shadow: 6px 4px 70px 8px rgba(48, 123, 196, 0.09);\n    transform: translateY(-30px);\n    .cs_iconbox_title,\n    .cs_iconbox_subtitle {\n      color: $primary;\n    }\n  }\n}\n.cs_iconbox_8_wrap {\n  background: linear-gradient(172deg, #d2eaef 0%, #86bbf1 100%);\n  @media (max-width: 1400px) {\n    padding: 40px 15px;\n  }\n}\n.cs_iconbox.cs_style_9 {\n  background: linear-gradient(154deg, #d2eaef 0%, #86bbf1 100%);\n  padding: 40px 25px;\n  transition: all 0.4s ease;\n  margin-bottom: 24px;\n  min-height: 290px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  @media (max-width: 1700px) {\n    min-height: 250px;\n    padding: 25px 15px;\n  }\n  @media (max-width: 991px) {\n    min-height: 250px;\n    padding: 25px 25px;\n  }\n  &:hover {\n    transform: scale(1.04);\n  }\n  .cs_iconbox_title {\n    margin-top: 20px;\n  }\n}\n.cs_iconbox.cs_style_10 {\n  padding: 55px 50px;\n  box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);\n  transition: all 0.4s ease;\n  &:hover {\n    transform: translateY(-30px);\n    box-shadow: 6px 4px 70px 8px rgba(48, 123, 196, 0.09);\n  }\n  .cs_iconbox_title {\n    margin-bottom: 20px;\n  }\n  .cs_iconbox_icon {\n    height: 111px;\n    width: 111px;\n    padding: 10px;\n    border: 1px solid $accent;\n    margin-bottom: 24px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n  @media (max-width: 575px) {\n    padding: 40px 25px;\n  }\n  @media (max-width: 340px) {\n    padding: 40px 20px;\n  }\n}\n.cs_iconbox.cs_style_11 {\n  display: flex;\n  align-items: center;\n  background-color: rgba(210, 234, 239, 0.5);\n  padding: 38px 54px;\n  gap: 30px;\n  @media (max-width: 1700px) {\n    padding: 30px;\n    gap: 20px;\n  }\n  @media (max-width: 380px) {\n    padding: 25px 20px;\n    gap: 15px;\n  }\n  @media (max-width: 330px) {\n    padding: 20px 20px;\n    gap: 10px;\n  }\n  .cs_iconbox_icon {\n    flex: none;\n    @media (max-width: 1700px) {\n      max-width: 60px;\n    }\n    @media (max-width: 380px) {\n      max-width: 40px;\n    }\n    @media (max-width: 330px) {\n      max-width: 35px;\n    }\n  }\n  .cs_iconbox_right {\n    flex: 1;\n  }\n}\n.cs_iconbox.cs_style_12 {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 40px;\n  @media (max-width: 1400px) {\n    gap: 20px;\n  }\n  @media (max-width: 575px) {\n    flex-direction: column-reverse;\n    align-items: flex-start;\n    gap: 15px;\n  }\n  .cs_iconbox_icon {\n    flex: none;\n    width: 160px;\n    height: 160px;\n    border-radius: 50%;\n    padding: 35px;\n    background-color: #86bbf1;\n    transition: all 0.4s ease;\n    img {\n      filter: brightness(0) invert(1);\n    }\n    @media (max-width: 1400px) {\n      width: 120px;\n      height: 120px;\n      padding: 30px;\n    }\n    @media (max-width: 575px) {\n      width: 80px;\n      height: 80px;\n      padding: 20px;\n    }\n  }\n  .cs_iconbox_circle {\n    display: block;\n    height: 20px;\n    width: 20px;\n    border-radius: 50%;\n    margin-bottom: 28px;\n    @media (max-width: 1400px) {\n      margin-bottom: 15px;\n    }\n    @media (max-width: 991px) {\n      display: none;\n    }\n  }\n  .cs_iconbox_title {\n    margin-bottom: 16px;\n    @media (max-width: 1400px) {\n      margin-bottom: 8px;\n    }\n  }\n  .cs_iconbox_info {\n    max-width: 440px;\n    padding: 30px;\n    transition: all 0.4s ease;\n    @media (max-width: 1400px) {\n      padding: 25px;\n    }\n    @media (max-width: 575px) {\n      padding: 0px;\n      box-shadow: none;\n    }\n  }\n  &:hover {\n    .cs_iconbox_icon {\n      background-color: $accent;\n    }\n    @media (min-width: 575px) {\n      .cs_iconbox_info {\n        background-color: #fff;\n        box-shadow: 6px 4px 70px 8px rgba(48, 123, 196, 0.09);\n      }\n    }\n  }\n}\n.cs_iconbox_12_wrap {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 0 50px;\n  @media (max-width: 991px) {\n    grid-template-columns: repeat(1, 1fr);\n  }\n  @media (max-width: 575px) {\n    gap: 35px;\n  }\n  > * {\n    display: flex;\n    align-items: center;\n    > * {\n      width: 100%;\n    }\n    &:nth-child(even) {\n      .cs_iconbox.cs_style_12 {\n        flex-direction: row-reverse;\n        @media (max-width: 575px) {\n          flex-direction: column-reverse;\n        }\n      }\n    }\n  }\n}\n.cs_iconbox.cs_style_13 {\n  background-color: #fff;\n  box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);\n  margin-top: 60px;\n  padding: 1px 25px 32px;\n  .cs_iconbox_title {\n    margin-bottom: 18px;\n  }\n  .cs_iconbox_icon {\n    border-radius: 50%;\n    background-color: #fff;\n    box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);\n    height: 120px;\n    width: 120px;\n    padding: 10px;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: -60px;\n    margin-bottom: 32px;\n  }\n  .cs_iconbox_icon_in {\n    height: 100%;\n    width: 100%;\n    border-radius: inherit;\n    padding: 20px;\n  }\n}\n","/*--------------------------------------------------------------\n13. Posts\n----------------------------------------------------------------*/\n.cs_post.cs_style_1 {\n  box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);\n  border-radius: 20px;\n  overflow: hidden;\n  background-color: #fff;\n  transition: all 0.4s ease;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n\n  &:hover {\n    transform: translateY(-20px);\n    box-shadow: 6px 4px 70px 8px rgba(48, 123, 196, 0.09);\n  }\n  .cs_post_thumb {\n    display: block;\n    width: 100%;\n    img {\n      width: 100%;\n      border-radius: 20px;\n    }\n  }\n  .cs_post_info {\n    padding: 30px 40px 40px;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    @media (max-width: 991px) {\n      padding: 30px 25px 30px;\n    }\n  }\n  .cs_post_social {\n    display: flex;\n    gap: 10px;\n    a {\n      height: 30px;\n      width: 30px;\n      border: 1px solid $accent;\n      color: $accent;\n      font-size: 14px;\n      &:hover {\n        background-color: $accent;\n        color: #fff;\n      }\n    }\n  }\n  .cs_post_meta {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 28px;\n  }\n  .cs_post_title {\n    margin-bottom: 18px;\n  }\n  .cs_post_btn {\n    display: inline-block;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n  &.cs_type_1 {\n    padding: 28px 28px 0;\n    @media (max-width: 1400px) {\n      padding: 15px 15px 0;\n    }\n    .cs_post_title {\n      margin: 0;\n    }\n    .cs_post_info {\n      padding: 25px 15px 56px;\n      @media (max-width: 1400px) {\n        padding: 25px 0px 30px 10px;\n      }\n    }\n  }\n  &.cs_type_2 {\n    height: initial;\n    display: block;\n    .cs_post_thumb {\n      img {\n        border-radius: 20px 20px 0 0;\n      }\n    }\n    .cs_post_title {\n      margin-bottom: 20px;\n    }\n    .cs_post_info {\n      padding: 45px 40px 45px;\n      > div {\n        display: flex;\n        flex-direction: column-reverse;\n      }\n      @media (max-width: 480px) {\n        padding: 30px 25px;\n      }\n    }\n    .cs_post_meta {\n      margin-bottom: 0;\n    }\n    .cs_post_thumb {\n      height: 381px;\n      @media (max-width: 1700px) {\n        height: 396px;\n      }\n      @media (max-width: 991px) {\n        height: initial;\n      }\n      img {\n        height: 100%;\n        width: 100%;\n        object-fit: cover;\n      }\n    }\n  }\n}\n.cs_post.cs_style_2 {\n  display: flex;\n  box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);\n  transition: all 0.5s ease;\n  &:hover {\n    transform: scale(1.03);\n  }\n  @media (max-width: 380px) {\n    flex-direction: column;\n  }\n  // &:not(:last-child) {\n  //   margin-bottom: 20px;\n  // }\n  .cs_post_title {\n    margin-bottom: 12px;\n  }\n  .cs_post_info {\n    padding: 15px 15px 15px 60px;\n    display: flex;\n    align-items: center;\n    @media (max-width: 1700px) {\n      padding-left: 30px;\n    }\n    @media (max-width: 575px) {\n      padding-left: 20px;\n    }\n  }\n  .cs_post_thumb {\n    flex: none;\n    width: 190px;\n    min-height: 188px;\n    img {\n      height: 100%;\n      width: 100%;\n      object-fit: cover;\n    }\n    @media (max-width: 575px) {\n      width: 150px;\n      min-height: 150px;\n    }\n    @media (max-width: 380px) {\n      height: 180px;\n      width: 180px;\n      border-radius: 0 0 20px 0;\n      overflow: hidden;\n    }\n  }\n}\n.cs_post.cs_style_3 {\n  transition: all 0.4s ease;\n  &:hover {\n    box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);\n  }\n  .cs_post_thumb {\n    display: block;\n  }\n  .cs_post_category {\n    display: inline-flex;\n    border: 1px solid $accent;\n    padding: 6px 19px;\n    border-radius: 20px;\n    margin-bottom: 18px;\n    &:hover {\n      background-color: $accent;\n      color: #fff;\n    }\n  }\n  .cs_post_title {\n    margin-bottom: 18px;\n  }\n  .cs_posted_by {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    color: $primary;\n    i {\n      font-size: 18px;\n      color: $accent;\n      display: flex;\n    }\n  }\n  .cs_post_info {\n    padding: 35px 40px;\n    @media (max-width: 1700px) {\n      padding: 25px 24px;\n    }\n  }\n}\n","/*--------------------------------------------------------------\n14. Banner\n----------------------------------------------------------------*/\n.cs_banner.cs_style_1 {\n  position: relative;\n  padding: 100px 90px;\n  border-radius: 25px;\n  margin-top: 165px;\n  @media (max-width: 1700px) {\n    margin-top: 85px;\n  }\n  @media (max-width: 1199px) {\n    margin-top: 0px;\n  }\n  @media (max-width: 991px) {\n    padding: 70px 30px;\n  }\n  .cs_banner_title {\n    max-width: 800px;\n    margin-bottom: 24px;\n    position: relative;\n    z-index: 1;\n    @media (max-width: 1700px) {\n      max-width: 650px;\n    }\n  }\n  .cs_banner_subtitle {\n    max-width: 500px;\n    position: relative;\n    z-index: 1;\n  }\n  .cs_banner_img {\n    position: absolute;\n    bottom: -30px;\n    right: -15px;\n    @media (max-width: 1700px) {\n      max-width: 535px;\n    }\n    @media (max-width: 1199px) {\n      max-height: 100%;\n      bottom: 0;\n    }\n    @media (max-width: 991px) {\n      display: none;\n    }\n  }\n}\n.cs_banner.cs_style_2 {\n  padding: 200px 9% 200px 43%;\n  @media (max-width: 1700px) {\n    padding: 150px 9% 150px 43%;\n  }\n  @media (max-width: 1400px) {\n    padding: 150px 5% 150px 40%;\n  }\n  @media (max-width: 1199px) {\n    padding: 120px 4% 120px 36%;\n  }\n  @media (max-width: 991px) {\n    padding: 80px 30px 80px 25%;\n  }\n  @media (max-width: 767px) {\n    padding: 80px 30px;\n    background-position: right center;\n    br {\n      display: none;\n    }\n  }\n}\n.cs_banner.cs_style_3,\n.cs_banner.cs_style_5 {\n  padding: 225px 0 155px;\n  min-height: 700px;\n  position: relative;\n  @media (max-width: 1700px) {\n    min-height: 600px;\n  }\n  @media (max-width: 1199px) {\n    min-height: 500px;\n    padding: 160px 0 125px;\n    .container {\n      max-width: 100%;\n    }\n  }\n  @media (max-width: 991px) {\n    padding: 155px 0 100px;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    .container {\n      max-width: 720px;\n    }\n  }\n  @media (max-width: 767px) {\n    .container {\n      max-width: 540px;\n    }\n  }\n\n  .cs_banner_title {\n    margin-bottom: 25px;\n    @media (max-width: 1199px) {\n      font-size: 50px;\n    }\n    @media (max-width: 575px) {\n      font-size: 48px;\n    }\n  }\n  .cs_banner_img {\n    position: absolute;\n    bottom: 0;\n    height: 100%;\n    display: flex;\n    align-items: flex-end;\n    justify-content: center;\n    padding-top: 110px;\n    img {\n      max-height: 100%;\n    }\n    @media (max-width: 991px) {\n      display: none;\n    }\n  }\n  .cs_banner_text {\n    position: relative;\n    z-index: 1;\n    width: 50%;\n    @media (max-width: 991px) {\n      width: 100%;\n    }\n  }\n\n  @media (max-width: 1400px) {\n    .cs_fs_20 {\n      font-size: 18px;\n    }\n  }\n  @media (max-width: 991px) {\n    .cs_fs_20 {\n      font-size: 16px;\n    }\n  }\n  @media (max-width: 575px) {\n    br {\n      display: none;\n    }\n  }\n}\n.cs_banner.cs_style_3 {\n  .cs_banner_img {\n    left: 0;\n    width: 50%;\n    padding-left: 6%;\n    padding-right: 12px;\n    @media (max-width: 1700px) {\n      padding-left: 12px;\n    }\n  }\n  .cs_banner_subtitle {\n    max-width: 550px;\n    @media (max-width: 991px) {\n      margin-left: auto;\n      margin-right: auto;\n    }\n  }\n  @media (min-width: 991px) {\n    .cs_banner_text {\n      margin-left: auto;\n    }\n  }\n}\n.cs_banner.cs_style_4 {\n  position: relative;\n  box-shadow: 6px 4px 70px 8px rgba(48, 123, 196, 0.09);\n  padding: 280px 130px 340px;\n  border-radius: 30px 30px 0 0;\n  @media (max-width: 1700px) {\n    padding: 140px 130px 340px;\n  }\n  @media (max-width: 991px) {\n    padding: 120px 30px 250px;\n  }\n  @media (max-width: 767px) {\n    br {\n      display: none;\n    }\n  }\n  > * {\n    position: relative;\n    z-index: 2;\n  }\n  .cs_banner_title {\n    margin-bottom: 12px;\n  }\n}\n.cs_banner.cs_style_5 {\n  .cs_banner_img {\n    right: 0;\n    width: 50%;\n    padding-left: 12px;\n    padding-right: 5%;\n    @media (max-width: 1700px) {\n      padding-right: 12px;\n    }\n    @media (max-width: 1199px) {\n      width: 56%;\n    }\n  }\n  // .cs_banner_subtitle {\n  //   @media (max-width: 1700px) {\n  //     max-width: 500px;\n  //     // br {\n  //     //   display: none;\n  //     // }\n  //   }\n  //   @media (max-width: 1400px) {\n  //     max-width: 450px;\n  //   }\n  //   @media (max-width: 991px) {\n  //     max-width: 100%;\n  //   }\n  // }\n\n  // @media (max-width: 991px) {\n  //   br {\n  //     display: none;\n  //   }\n  // }\n}\n.cs_banner.cs_style_6 {\n  position: relative;\n  padding: 86px 70px 350px 50.4%;\n  box-shadow: 6px 4px 70px 8px rgba(48, 123, 196, 0.09);\n  margin-top: 100px;\n  @media (max-width: 1700px) {\n    margin-top: 35px;\n  }\n  @media (max-width: 1400px) {\n    padding: 86px 70px 350px 44%;\n    margin-top: 0;\n  }\n  @media (max-width: 1199px) {\n    padding: 80px 30px 340px 36%;\n  }\n  @media (max-width: 991px) {\n    padding: 70px 30px 240px 30px;\n  }\n  @media (max-width: 767px) {\n    br {\n      display: none;\n    }\n  }\n  .cs_banner_title {\n    margin-bottom: 22px;\n    position: relative;\n    z-index: 1;\n  }\n  .cs_banner_subtitle {\n    position: relative;\n    z-index: 1;\n  }\n  .cs_banner_img {\n    left: -10px;\n    bottom: 30px;\n    position: absolute;\n    @media (max-width: 1700px) {\n      max-width: 670px;\n    }\n    @media (max-width: 1400px) {\n      max-width: 610px;\n      left: -100px;\n    }\n    @media (max-width: 1199px) {\n      max-width: 560px;\n      left: -130px;\n    }\n    @media (max-width: 991px) {\n      display: none;\n    }\n  }\n}\n.cs_banner.cs_style_7 {\n  padding: 77px 50px 405px;\n  box-shadow: 6px 4px 70px 8px rgba(48, 123, 196, 0.09);\n  position: relative;\n  margin-top: 390px;\n  @media (max-width: 991px) {\n    padding: 70px 25px 245px;\n    margin-top: 305px;\n  }\n  @media (max-width: 767px) {\n    margin-top: 0;\n    br {\n      display: none;\n    }\n  }\n  .cs_banner_img {\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n    top: -390px;\n    z-index: -1;\n    @media (max-width: 991px) {\n      top: -310px;\n    }\n    @media (max-width: 767px) {\n      display: none;\n    }\n  }\n}\n.cs_banner_8_wrap {\n  position: relative;\n  &::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    height: 50%;\n    width: 100%;\n    background-color: #fff;\n  }\n}\n.cs_banner.cs_style_8 {\n  position: relative;\n  padding: 127px 100px 146px;\n  z-index: 2;\n  margin-top: 75px;\n  @media (max-width: 1700px) {\n    margin-top: 0;\n    padding: 110px 80px 110px;\n  }\n  @media (max-width: 1400px) {\n    margin-top: 0;\n    padding: 90px 60px 90px;\n  }\n  @media (max-width: 767px) {\n    padding: 70px 30px 70px;\n  }\n  .cs_banner_title {\n    margin-bottom: 17px;\n  }\n  .cs_banner_in {\n    max-width: 540px;\n    position: relative;\n    z-index: 2;\n  }\n  .cs_banner_img {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    width: 62%;\n    @media (max-width: 1700px) {\n      width: 58%;\n    }\n    @media (max-width: 1400px) {\n      width: 55%;\n    }\n    @media (max-width: 1199px) {\n      width: 52%;\n    }\n    @media (max-width: 991px) {\n      display: none;\n    }\n  }\n}\n.cs_banner.cs_style_9 {\n  position: relative;\n  box-shadow: 6px 4px 70px 8px rgba(48, 123, 196, 0.09);\n  padding: 183px 0 382px 130px;\n  margin-top: 130px;\n  @media (max-width: 1700px) {\n    padding: 140px 0 350px 110px;\n    margin-top: 80px;\n  }\n  @media (max-width: 1199px) {\n    padding: 100px 0 350px 50px;\n    margin-top: 0;\n  }\n  @media (max-width: 991px) {\n    padding: 100px 0 250px 30px;\n  }\n  @media (max-width: 767px) {\n    br {\n      display: none;\n    }\n  }\n  .cs_banner_img {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    @media (max-width: 1700px) {\n      max-width: 500px;\n    }\n    @media (max-width: 1199px) {\n      max-width: 400px;\n    }\n    @media (max-width: 991px) {\n      display: none;\n    }\n  }\n  .cs_banner_title {\n    margin-bottom: 22px;\n  }\n  &.cs_type_1 {\n    padding: 150px 60px 340px 50%;\n    margin: 0;\n    @media (max-width: 1199px) {\n      padding: 90px 60px 340px 50%;\n    }\n    @media (max-width: 991px) {\n      padding: 90px 30px 240px 30px;\n    }\n    .cs_banner_img {\n      right: initial;\n      left: 0;\n      max-width: 48%;\n    }\n  }\n}\n","/*--------------------------------------------------------------\n15. Testimonial\n----------------------------------------------------------------*/\n.cs_testimonial.cs_style_1 {\n  line-height: 1.87em;\n  position: relative;\n  > img {\n    position: absolute;\n    left: -88px;\n    top: -37px;\n    @media (max-width: 991px) {\n      top: -15px;\n      left: -75px;\n    }\n  }\n  > p {\n    margin-bottom: 30px;\n  }\n}\n.cs_testimonial.cs_style_2 {\n  .cs_testimonial_text {\n    padding: 80px 80px 80px 144px;\n    position: relative;\n    @media (max-width: 1700px) {\n      padding: 60px 60px 60px 124px;\n    }\n    @media (max-width: 575px) {\n      padding: 80px 25px 50px 45px;\n    }\n    p {\n      margin-bottom: 32px;\n    }\n    margin-bottom: 35px;\n  }\n  .cs_quote_icon {\n    position: absolute;\n    left: 60px;\n    top: 70px;\n    @media (max-width: 1700px) {\n      left: 40px;\n    }\n    @media (max-width: 575px) {\n      left: 25px;\n      top: 30px;\n    }\n  }\n  .cs_testimonial_meta {\n    display: flex;\n    gap: 25px 40px;\n    align-items: center;\n    @media (max-width: 575px) {\n      gap: 20px;\n    }\n  }\n  .cs_testimonial_avatar {\n    height: 96px;\n    width: 96px;\n    border-radius: 50%;\n    img {\n      height: 100%;\n      width: 100%;\n      object-fit: cover;\n      border-radius: inherit;\n    }\n  }\n}\n.cs_testimonial.cs_style_3 {\n  padding: 1px 82px 42px;\n  margin-top: 75px;\n  @media (max-width: 575px) {\n    padding: 1px 20px 30px;\n  }\n  .cs_testimonial_img {\n    height: 150px;\n    width: 150px;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: -75px;\n    margin-bottom: 24px;\n  }\n  .cs_testimonial_avatar {\n    margin-bottom: 10px;\n  }\n  .cs_testimonial_text {\n    margin-top: 42px;\n  }\n  .cs_rating {\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n.cs_testimonial.cs_style_4 {\n  background-color: #fff;\n  padding: 50px 30px;\n  box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);\n  padding: 40px 20px;\n  .cs_testimonial_meta {\n    display: flex;\n    align-items: center;\n    gap: 25px;\n  }\n  .cs_testimonial_avatar {\n    height: 80px;\n    width: 80px;\n    border-radius: 50%;\n    overflow: hidden;\n    flex: none;\n    img {\n      height: 100%;\n      width: 100%;\n      object-fit: cover;\n    }\n  }\n  .cs_testimonial_meta {\n    margin-bottom: 32px;\n  }\n  .cs_rating {\n    margin-top: 32px;\n  }\n}\n.cs_testimonial_carousel_2 {\n  .cs_slider_activate {\n    width: 58vw;\n    @media (max-width: 991px) {\n      width: 90vw;\n    }\n    @media (max-width: 575px) {\n      width: 100%;\n    }\n  }\n\n  .cs_testimonial.cs_style_4 {\n    max-width: 390px;\n    @media (max-width: 420px) {\n      max-width: 300px;\n    }\n  }\n  .slick-list {\n    padding-top: 30px;\n    padding-bottom: 30px;\n    margin-top: -30px;\n    margin-bottom: -30px;\n    box-shadow: -10px 0px 30px -20px rgba(48, 123, 196, 0.1);\n    border-radius: 60px;\n  }\n  .cs_slider_navigation.cs_style_1 {\n    justify-content: flex-end;\n    margin-top: 0;\n  }\n}\n","/*--------------------------------------------------------------\n16. Portfolio\n----------------------------------------------------------------*/\n.cs_portfolio.cs_style_1 {\n  height: 429px;\n  @media (max-width: 991px) {\n    height: 350px;\n  }\n  .cs_portfolio_img {\n    height: 100%;\n    border-radius: inherit;\n    position: relative;\n    &::before {\n      content: '';\n      background: $accent;\n      position: absolute;\n      height: 100%;\n      width: 100%;\n      left: 0;\n      top: 0;\n      opacity: 0;\n      transition: all 0.3s ease;\n    }\n  }\n  .cs_link_hover {\n    position: absolute;\n    z-index: 2;\n    top: -100px;\n    right: 50px;\n    width: 60px;\n    height: 200px;\n    background: $accent;\n    border-radius: 0 0 40px 40px;\n    display: flex;\n    align-items: flex-end;\n    justify-content: center;\n    opacity: 0;\n    transition: all 0.3s ease;\n    font-size: 20px;\n    i {\n      color: $accent;\n      background-color: #fff;\n      height: 50px;\n      width: 50px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 50%;\n      margin-bottom: 5px;\n      opacity: 0;\n      transform: scale(0.5) rotate(180deg);\n      transition: all 0.3s ease;\n    }\n  }\n  &:hover {\n    .cs_link_hover {\n      opacity: 1;\n      top: 0px;\n      i {\n        opacity: 1;\n        transform: scale(1) rotate(0deg);\n        transition-delay: 0.15s;\n      }\n    }\n    .cs_portfolio_img {\n      &::before {\n        opacity: 0.4;\n      }\n    }\n  }\n  &.cs_size_1 {\n    height: 716px;\n    @media (max-width: 991px) {\n      height: 607px;\n    }\n  }\n}\n","/*--------------------------------------------------------------\n17. Brands\n----------------------------------------------------------------*/\n.cs_brands.cs_style_1 {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 60px 30px;\n  @media (max-width: 1700px) {\n    gap: 40px 120px;\n  }\n  @media (max-width: 991px) {\n    gap: 20px 60px;\n  }\n  @media (max-width: 767px) {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  @media (max-width: 575px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  @media (max-width: 420px) {\n    gap: 20px 30px;\n  }\n}\n.cs_brands.cs_style_2 {\n  padding: 0 20px;\n  text-align: center;\n  height: 136px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.cs_brands.cs_style_3 {\n  display: flex;\n  justify-content: space-around;\n  flex-wrap: wrap;\n  gap: 30px 70px;\n  background-color: #fff;\n  box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);\n  padding: 70px;\n  @media (max-width: 1400px) {\n    justify-content: center;\n  }\n  @media (max-width: 575px) {\n    gap: 30px;\n    padding: 70px 40px;\n  }\n}\n","/*--------------------------------------------------------------\n18. Accordians\n----------------------------------------------------------------*/\n.cs_accordians.cs_style1 {\n  .cs_accordian {\n    border-radius: 25px;\n    border: 1px solid #d2eaef;\n    background: rgba(39, 71, 96, 0);\n    transition: all 0.4s ease;\n    width: 100%;\n    @media (max-width: 1700px) {\n      border-radius: 15px;\n    }\n    &:not(:last-child) {\n      margin-bottom: 20px;\n    }\n    &.active {\n      background-color: #d2eaef;\n      margin-left: 50px;\n      @media (max-width: 991px) {\n        margin-left: 0;\n      }\n      .cs_accordian_arrow {\n        transform: rotate(180deg);\n      }\n    }\n  }\n  .cs_accordian_arrow {\n    position: absolute;\n    display: flex;\n    right: 44px;\n    top: 25px;\n    height: 28px;\n    width: 28px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.3s ease;\n    @media (max-width: 1700px) {\n      right: 30px;\n      top: 18px;\n    }\n    @media (max-width: 991px) {\n      right: 20px;\n      top: 15px;\n    }\n  }\n  .cs_accordian_head {\n    font-size: 20px;\n    line-height: 1.6em;\n    font-weight: 500;\n    cursor: pointer;\n    position: relative;\n    padding: 23px 62px 23px 40px;\n    margin: 0;\n    @media (max-width: 1700px) {\n      padding: 16px 62px 16px 30px;\n    }\n    @media (max-width: 991px) {\n      font-size: 18px;\n      padding: 14px 55px 14px 20px;\n    }\n  }\n  .cs_accordian_body {\n    padding: 0 40px 38px 40px;\n    @media (max-width: 1700px) {\n      padding: 0 30px 28px 30px;\n    }\n    @media (max-width: 991px) {\n      padding: 0 20px 20px 20px;\n    }\n    p {\n      margin: 0;\n    }\n  }\n  &.cs_type_1 {\n    .cs_accordian {\n      box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);\n      border-color: transparent;\n      background-color: #fff;\n    }\n    .cs_accordian.active {\n      margin-left: -50px;\n      @media (max-width: 1400px) {\n        margin-left: 0;\n      }\n      .cs_accordian {\n        box-shadow: 6px 4px 70px 8px rgba(48, 123, 196, 0.09);\n        background-color: #fff;\n      }\n    }\n  }\n  &.cs_type_2 {\n    .cs_accordian {\n      border-radius: 0;\n      border-left: 0;\n      border-right: 0;\n      border-color: $accent;\n      margin-bottom: -1px;\n      &.active {\n        background-color: transparent;\n        margin-left: 0;\n      }\n      .cs_accordian_arrow {\n        right: initial;\n        left: 20px;\n        top: 32px;\n      }\n    }\n    .cs_accordian_head {\n      padding: 30px 20px 30px 85px;\n    }\n    .cs_accordian_body {\n      padding: 0 20px 38px 85px;\n    }\n  }\n  &.cs_type_3 {\n    .cs_accordian {\n      border-color: $accent;\n      border-radius: 20px;\n      &.active {\n        margin-left: 0px;\n        background-color: transparent;\n        .cs_accordian_head {\n          background: linear-gradient(119deg, #d2eaef 17.16%, #86bbf1 89.78%);\n          border-bottom: 1px solid $accent;\n          border-radius: 20px 20px 0 0;\n        }\n      }\n    }\n    .cs_accordian_head {\n      font-size: 24px;\n      padding: 27px 62px 27px 40px;\n      @media (max-width: 1700px) {\n        padding: 18px 52px 18px 24px;\n      }\n      @media (max-width: 991px) {\n        font-size: 20px;\n      }\n    }\n    .cs_accordian_arrow {\n      right: 40px;\n      top: 32px;\n      @media (max-width: 1700px) {\n        right: 24px;\n        top: 24px;\n      }\n      @media (max-width: 991px) {\n        top: 20px;\n      }\n    }\n    .cs_accordian_body {\n      padding: 38px 40px;\n      @media (max-width: 1700px) {\n        padding: 24px 24px;\n      }\n    }\n  }\n}\n","/*--------------------------------------------------------------\n19. Departments\n----------------------------------------------------------------*/\n.cs_departments.cs_style_1 {\n  padding-top: 100px;\n  position: relative;\n  .cs_department_list {\n    position: relative;\n    z-index: 1;\n    padding: 0 25px;\n    @media (max-width: 991px) {\n      padding: 0 15px;\n    }\n    @media (max-width: 575px) {\n      .cs_slider_navigation.cs_style_1 {\n        margin-top: 0;\n      }\n    }\n  }\n  .cs_section_heading {\n    position: relative;\n    z-index: 1;\n  }\n  .cs_department {\n    flex: 1;\n    text-align: center;\n    padding: 30px 30px;\n    height: 290px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    @media (max-width: 991px) {\n      height: 250px;\n    }\n    @media (max-width: 400px) {\n      padding: 30px 20%;\n    }\n    &:hover {\n      transform: translateY(-20px);\n      background-color: $accent;\n      img {\n        filter: brightness(0) invert(1);\n      }\n      .cs_heading_color {\n        color: #fff;\n      }\n    }\n  }\n  svg {\n    transition: all 0.4s ease;\n  }\n  .cs_department_title {\n    margin-top: 20px;\n    transition: all 0.4s ease;\n  }\n  .cs_departments_bg {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: calc(100% - 122px);\n  }\n}\n","/*--------------------------------------------------------------\n20. About\n----------------------------------------------------------------*/\n.cs_about.cs_style_1 {\n  .cs_about_img {\n    position: relative;\n    @media (min-width: 992px) {\n      padding-right: 70px;\n    }\n  }\n  .cs_about_text_list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    li {\n      position: relative;\n      padding-left: 60px;\n      &:not(:last-child) {\n        margin-bottom: 50px;\n      }\n      > i {\n        position: absolute;\n        left: 0;\n        top: 5px;\n        @media (max-width: 991px) {\n          top: 2px;\n        }\n      }\n      > h3 {\n        margin-bottom: 25px;\n      }\n    }\n  }\n  .cs_about_mini_img {\n    position: absolute;\n    top: -75px;\n    right: 20%;\n  }\n  .cs_right_icon {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n  .cs_rotate_animation {\n    animation: rotate360 15s linear infinite;\n  }\n  &.cs_type_1 {\n    .cs_about_mini_img {\n      right: initial;\n      top: 44%;\n      left: 35%;\n    }\n    br {\n      @media (max-width: 1400px) {\n        display: none;\n      }\n    }\n  }\n  &.cs_type_2 {\n    padding-left: 102px;\n    @media (max-width: 1700px) {\n      padding-left: 50px;\n    }\n    @media (max-width: 1400px) {\n      padding-left: 0px;\n    }\n    .cs_about_mini_img {\n      top: 50%;\n      right: initial;\n      left: 50%;\n      transform: translate(-50%, -50%);\n    }\n    .cs_about_img {\n      padding-right: 0;\n      position: relative;\n    }\n  }\n}\n@keyframes rotate360 {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n.cs_about.cs_style_2 {\n  .cs_about_img {\n    padding-left: 80px;\n    @media (max-width: 1700px) {\n      padding-left: 0;\n    }\n  }\n  .cs_section_heading.cs_style_1 {\n    p {\n      max-width: 580px;\n    }\n  }\n}\n.cs_about.cs_style_3 {\n  background: linear-gradient(119deg, #d2eaef 17.16%, #86bbf1 89.78%);\n  .cs_section_heading.cs_style_1 {\n    padding: 145px 80px;\n    @media (max-width: 1400px) {\n      padding: 145px 30px 145px 50px;\n    }\n    @media (max-width: 1199px) {\n      padding: 50px 50px 50px 50px;\n    }\n    @media (max-width: 767px) {\n      padding: 35px 24px 35px 24px;\n    }\n  }\n  .cs_about_text {\n    height: 100%;\n    @media (max-width: 1199px) {\n      height: initial;\n    }\n  }\n  .cs_about_img {\n    height: 100%;\n    img {\n      height: 100%;\n      width: 100%;\n      object-fit: cover;\n    }\n  }\n  .cs_section_minititle {\n    max-width: 630px;\n  }\n  .cs_support_card {\n    border-radius: 50px;\n    border: 1px solid #fff;\n    background-color: #fff;\n    box-shadow: 6px 4px 70px 8px rgba(48, 123, 196, 0.09);\n    padding: 20px 30px;\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    position: absolute;\n    right: -26%;\n    bottom: 75px;\n    .cs_support_card_icon {\n      flex: none;\n    }\n    @media (max-width: 1700px) {\n      right: -34%;\n      bottom: 65px;\n    }\n    @media (max-width: 1199px) {\n      position: initial;\n      margin-left: 50px;\n      margin-right: 50px;\n      margin-bottom: 60px;\n      @media (max-width: 767px) {\n        margin-left: 24px;\n        margin-right: 24px;\n        margin-bottom: 35px;\n        padding: 20px 20px;\n      }\n    }\n  }\n}\n","/*--------------------------------------------------------------\n21. Team\n----------------------------------------------------------------*/\n.cs_team.cs_style_1 {\n  border-radius: 20px;\n  background: linear-gradient(\n    154deg,\n    rgba(210, 234, 239, 0.27) 0%,\n    rgba(134, 187, 241, 0.27) 100%\n  );\n  box-shadow: initial;\n  transition: all 0.4s ease;\n  &:hover {\n    box-shadow: 6px 4px 70px 8px rgba(48, 123, 196, 0.09);\n  }\n  .cs_team_meta {\n    padding: 32px 40px;\n    @media (max-width: 1400px) {\n      padding: 32px 20px;\n    }\n  }\n  .cs_member_name {\n    margin-bottom: 7px;\n  }\n  .cs_member_designation {\n    margin-bottom: 9px;\n  }\n  .cs_member_description {\n    margin-bottom: 32px;\n  }\n  .cs_social_links {\n    justify-content: center;\n    a {\n      height: 40px;\n      width: 40px;\n      background-color: rgba($accent, 0.6);\n      color: #fff;\n      font-size: 18px;\n      transform: initial;\n      &:hover {\n        background-color: $accent;\n      }\n    }\n  }\n  .cs_label {\n    position: absolute;\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    padding: 12px 30px;\n    text-align: center;\n    min-width: 292px;\n    border-radius: 20px 20px 0 0;\n  }\n  &.cs_type_1 {\n    background: #fff;\n    margin-top: 115px;\n    height: initial;\n    padding-top: 1px;\n    .cs_member_img {\n      margin-top: -115px;\n    }\n  }\n  &.cs_type_2 {\n    box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);\n    margin-bottom: 0px;\n    .cs_member_img {\n      position: relative;\n    }\n    .cs_member_name {\n      margin-bottom: 5px;\n    }\n    .cs_member_designation,\n    .cs_member_description {\n      margin-bottom: 28px;\n    }\n    .cs_team_meta {\n      padding: 36px 50px 34px;\n      @media (max-width: 1600px) {\n        padding: 36px 40px 34px;\n      }\n      @media (max-width: 1400px) {\n        padding: 30px 25px 34px;\n      }\n    }\n  }\n}\n@media (min-width: 992px) {\n  .cs_list_view_wrap {\n    .cs_team.cs_style_1.cs_type_2 {\n      display: flex;\n      .cs_member_img {\n        position: relative;\n        flex: none;\n        width: 450px;\n      }\n      .cs_label {\n        position: initial;\n        width: 100%;\n        transform: initial;\n        border-radius: 0;\n        padding: 12px 15px;\n      }\n      .cs_team_meta {\n        display: flex;\n        flex-direction: column;\n        text-align: left;\n        justify-content: center;\n        padding-right: 30%;\n        @media (max-width: 1700px) {\n          padding-right: 20%;\n        }\n        @media (max-width: 1700px) {\n          padding-right: 30px;\n        }\n      }\n      .cs_social_links {\n        justify-content: flex-start;\n      }\n    }\n  }\n}\n","/*--------------------------------------------------------------\n22. Funfact\n----------------------------------------------------------------*/\n.cs_funfact_1_wrap {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  padding: 80px 50px 90px;\n  @media (max-width: 1400px) {\n    padding: 60px 30px 70px;\n  }\n}\n.cs_funfact.cs_style_1 {\n  max-width: 20%;\n  padding: 20px 30px;\n  @media (max-width: 1400px) {\n    padding: 10px 15px;\n  }\n  @media (max-width: 1199px) {\n    padding: 20px 20px;\n    max-width: 33.333333%;\n  }\n  @media (max-width: 767px) {\n    padding: 20px 20px;\n    max-width: 50%;\n  }\n  @media (max-width: 575px) {\n    max-width: 100%;\n    padding: 15px 0;\n  }\n  flex: none;\n  .cs_funfact_number {\n    margin-bottom: 8px;\n  }\n}\n",".cs_cta.cs_style_1 {\n  padding: 125px 60px 140px 50%;\n  @media (max-width: 1199px) {\n    padding: 95px 30px 100px 45%;\n  }\n  @media (max-width: 767px) {\n    padding: 95px 30px 100px 35%;\n  }\n  @media (max-width: 575px) {\n    padding: 100px 24px 90px;\n  }\n  .cs_cta_title,\n  .cs_cta_subtitle {\n    margin-bottom: 38px;\n  }\n  .cs_cta_subtitle {\n    max-width: 600px;\n  }\n}\n",".cs_pricing_card.cs_style_1 {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  .cs_pricing_card_head {\n    padding: 30px 40px 40px;\n    @media (max-width: 1400px) {\n      padding: 30px 30px 40px;\n    }\n    h3 {\n      margin-bottom: 0px;\n      border: 1px solid #fff;\n      display: inline-flex;\n      border-radius: 1.6em;\n      background: linear-gradient(119deg, #d2eaef 17.16%, #86bbf1 89.78%);\n      span {\n        display: inline-flex;\n        padding: 7px 20px;\n        position: relative;\n        z-index: 2;\n        &:first-child {\n          border-radius: 1.6em;\n          border: 1px solid #fff;\n          margin: -1px;\n        }\n      }\n    }\n    p {\n      margin-top: 28px;\n      margin-bottom: 0;\n    }\n    h2 {\n      margin-top: 40px;\n    }\n  }\n  .cs_pricing_card_body {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    padding: 50px 40px 30px;\n    border: 1px solid $accent;\n    border-top: 0;\n    border-radius: 0 0 20px 20px;\n    gap: 50px;\n    @media (max-width: 1400px) {\n      padding: 40px 24px 30px;\n    }\n  }\n  .cs_pricing_card_feature {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    li {\n      position: relative;\n      padding-left: 36px;\n      &:not(:last-child) {\n        margin-bottom: 30px;\n      }\n    }\n    i {\n      position: absolute;\n      left: 0;\n      color: $accent;\n    }\n  }\n}\n",".cs_site_header.cs_style1.cs_active_sticky {\n  background-color: #fff;\n}\n.cs_site_header.cs_style1.cs_white_color.cs_active_sticky {\n  background-color: #274760;\n}\n.cs_accent_bg .cs_social_links_wrap h2,\n.cs_site_header.cs_style1.cs_white_color.cs_active_sticky .cs_toolbox {\n  color: #fff;\n}\n.cs_contact_widget i {\n  height: 20px;\n  width: 20px;\n  margin-top: 2px;\n  color: #fff;\n  padding: 4px;\n}\n.cs_video_open {\n  cursor: pointer;\n}\n.cs_hero.cs_style_1 {\n  .cs_text_btn_2,\n  .cs_hero_title,\n  .cs_hero_subtitle {\n    position: relative;\n    z-index: 1;\n  }\n\n  .cs_hero_text {\n    position: initial;\n    z-index: initial;\n  }\n}\n.cs_accordian_body_wrap {\n  overflow: hidden;\n  transition: all 0.4s ease;\n}\n.cs_tabs.cs_style1 .cs_tab_links .cs_tab_link_in {\n  cursor: pointer;\n}\n.cs_rating {\n  i {\n    display: flex;\n  }\n}\n.cs_shape_wrap .cs_shape_2 {\n  top: -3%;\n}\n.cs_cs_slider_navigation_1 {\n  .cs_slider_next,\n  .cs_slider_prev {\n    transition: all 0.4s ease;\n    cursor: pointer;\n    border-radius: 10px;\n    padding: 5px;\n    height: 60px;\n    transform: translateY(-50%);\n    background-color: #fff;\n    width: 70px;\n    box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);\n    position: absolute;\n    top: 50%;\n    display: flex !important;\n    z-index: 1;\n    @media (min-width: 991px) {\n      opacity: 0;\n    }\n  }\n  .cs_slider_next {\n    right: -35px;\n  }\n  .cs_slider_prev {\n    left: -35px;\n  }\n  &:hover {\n    .cs_slider_next,\n    .cs_slider_prev {\n      opacity: 1;\n    }\n  }\n}\n.cs_cs_slider_navigation_2 {\n  .cs_slider_next,\n  .cs_slider_prev {\n    height: 40px;\n    width: 40px;\n    border: 2px solid $accent;\n    border-radius: 50%;\n    padding: 8px;\n    transition: all 0.4s ease;\n    cursor: pointer;\n    position: absolute;\n    display: flex !important;\n    bottom: 0;\n  }\n  .cs_slider_next {\n    right: 0;\n  }\n  .cs_slider_prev {\n    right: 52px;\n  }\n}\n.cs_cs_slider_navigation_3 {\n  .cs_slider_next,\n  .cs_slider_prev {\n    width: 90px;\n    height: 70px;\n    background-color: #fff;\n    border-radius: 10px;\n    padding: 5px;\n    transition: all 0.4s ease;\n    cursor: pointer;\n    display: flex !important;\n    position: absolute;\n    top: -213px;\n    @media (max-width: 1700px) {\n      width: 80px;\n      height: 60px;\n      top: -188px;\n    }\n    @media (max-width: 991px) {\n      display: none !important;\n    }\n    img {\n      transition: inherit;\n    }\n    &:hover {\n      background-color: $accent;\n      img {\n        filter: brightness(0) invert(1);\n      }\n    }\n  }\n  .cs_slider_next {\n    right: 0;\n  }\n  .cs_slider_prev {\n    right: 115px;\n    @media (max-width: 1700px) {\n      right: 100px;\n    }\n  }\n  .slick-dots {\n    display: none !important;\n    @media (max-width: 991px) {\n      display: flex !important;\n    }\n  }\n}\n.cs_related_doctor {\n  padding-bottom: 90px;\n  @media (max-width: 400px) {\n    padding-bottom: 75px;\n  }\n  .slick-dots {\n    bottom: 15px;\n  }\n}\n.cs_gallery_grid_1 {\n  display: grid;\n  grid-gap: 25px;\n  grid-template-columns: repeat(3, 1fr);\n  @media (max-width: 991px) {\n    grid-template-columns: repeat(2, 1fr);\n    .cs_grid_item {\n      &:nth-child(2) {\n        display: none;\n      }\n    }\n  }\n  @media (max-width: 767px) {\n    display: flex;\n    flex-direction: column;\n    gap: 25px;\n  }\n  .cs_section_heading.cs_style_1 {\n    min-height: 263px;\n    @media (max-width: 1700px) {\n      min-height: 166px;\n    }\n    @media (max-width: 991px) {\n      min-height: initial;\n    }\n  }\n  .cs_grid_item {\n    &:first-child {\n      grid-column: span 2;\n    }\n    @media (min-width: 992px) {\n      &:nth-child(6) {\n        grid-column: span 2;\n      }\n    }\n\n    &:nth-child(5) {\n      .cs_portfolio.cs_style_1 {\n        height: 767px;\n        margin-top: -338px;\n        @media (max-width: 1700px) {\n          height: 590px;\n          margin-top: -240px;\n        }\n        @media (max-width: 991px) {\n          margin-top: 0;\n          height: 400px;\n        }\n      }\n      @media (max-width: 991px) {\n        grid-column: span 2;\n      }\n      @media (max-width: 767px) {\n        grid-column: initial;\n      }\n    }\n  }\n  @media (max-width: 1700px) {\n    .cs_portfolio.cs_style_1 {\n      height: 350px;\n    }\n  }\n}\n.cs_gallery_grid_2 {\n  display: grid;\n  grid-gap: 25px;\n  grid-template-columns: repeat(3, 1fr);\n  @media (max-width: 991px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  @media (max-width: 767px) {\n    grid-template-columns: repeat(1, 1fr);\n    grid-gap: 25px 0px;\n  }\n\n  .cs_grid_item {\n    @media (min-width: 768px) {\n      &:first-child {\n        grid-column: span 2;\n      }\n    }\n\n    @media (min-width: 992px) {\n      &:nth-child(7) {\n        grid-column: span 2;\n      }\n    }\n  }\n  @media (max-width: 1700px) {\n    .cs_portfolio.cs_style_1 {\n      height: 350px;\n    }\n  }\n  @media (max-width: 420px) {\n    .cs_portfolio.cs_style_1 {\n      height: 300px;\n    }\n  }\n}\n.cs_portfolio.cs_style_1 .cs_portfolio_img > div > img {\n  cursor: zoom-in;\n  height: 100%;\n  left: 0;\n  -o-object-fit: cover;\n  object-fit: cover;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  z-index: 5;\n}\n.cs_team_grid {\n  display: grid;\n  grid-gap: 50px 25px;\n  grid-template-columns: repeat(3, 1fr);\n  @media (max-width: 991px) {\n    grid-template-columns: repeat(2, 1fr);\n    grid-gap: 40px 25px;\n  }\n  @media (max-width: 767px) {\n    grid-template-columns: repeat(1, 1fr);\n    grid-gap: 40px 25px;\n  }\n  &.cs_list_view_wrap {\n    grid-template-columns: repeat(1, 1fr);\n  }\n  &.cs_grid_view_wrap {\n    .cs_team.cs_style_1.cs_type_2 {\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n    }\n  }\n}\n.cs_isotop_filter.cs_style1 {\n  text-transform: capitalize;\n}\n.cs_pagination_box {\n  .cs_pagination_item,\n  .cs_pagination_arrow {\n    border: none;\n    &:hover {\n      color: $accent;\n    }\n  }\n  .cs_pagination_arrow {\n    background-color: transparent;\n  }\n}\n.form-check .form-check-input {\n  border-color: #636363;\n}\n.cs_related_doctor .slick-dots {\n  display: flex !important;\n}\n.react-datepicker-wrapper {\n  display: block;\n}\n.cs_blog_grid_1 {\n  display: grid;\n  grid-gap: 20px 130px;\n  grid-template-columns: repeat(4, 1fr);\n  @media (max-width: 1700px) {\n    grid-gap: 20px 80px;\n  }\n  @media (max-width: 1400px) {\n    grid-gap: 20px;\n  }\n  @media (max-width: 991px) {\n    grid-template-columns: repeat(1, 1fr);\n  }\n  @media (min-width: 992px) {\n    > * {\n      grid-column: span 2;\n      &:first-child {\n        grid-row: span 3;\n      }\n    }\n  }\n}\n.cs_error {\n  padding: 80px 0;\n  min-height: 100vh;\n}\n.cs_nav .cs_nav_list .cs_munu_dropdown_toggle.active + ul {\n  display: block;\n}\ninput[type='date']::-webkit-inner-spin-button,\ninput[type='date']::-webkit-calendar-picker-indicator,\ninput[type='time']::-webkit-inner-spin-button,\ninput[type='time']::-webkit-calendar-picker-indicator {\n  display: none;\n  -webkit-appearance: none;\n}\n\n/* Typewriter Effect Styles */\n.typewriter-cursor {\n  animation: blink 1s infinite;\n  font-weight: 100;\n  color: $accent;\n}\n\n@keyframes blink {\n  0%, 50% {\n    opacity: 1;\n  }\n  51%, 100% {\n    opacity: 0;\n  }\n}\n\n/* React-Typed Styles */\n.typed-cursor {\n  animation: typedjsBlink 0.7s infinite;\n  font-weight: 100;\n  color: $accent;\n  font-size: inherit;\n}\n\n@keyframes typedjsBlink {\n  50% {\n    opacity: 0;\n  }\n}\n\n.typewriter-title {\n  .typed-cursor {\n    font-size: inherit;\n    color: $accent;\n  }\n}\n\n/* Language Selector Styles */\n.cs_language_selector {\n  position: relative;\n  display: inline-block;\n}\n\n.cs_language_btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 6px;\n  color: inherit;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 14px;\n  font-weight: 500;\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.1);\n    border-color: rgba(255, 255, 255, 0.3);\n  }\n}\n\n.cs_language_flag {\n  font-size: 16px;\n  line-height: 1;\n}\n\n.cs_language_code {\n  font-weight: 600;\n  letter-spacing: 0.5px;\n}\n\n.cs_dropdown_arrow {\n  transition: transform 0.3s ease;\n  \n  &.active {\n    transform: rotate(180deg);\n  }\n}\n\n.cs_language_dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  margin-top: 8px;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  overflow: hidden;\n  z-index: 1000;\n  min-width: 140px;\n}\n\n.cs_language_option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 12px 16px;\n  background: transparent;\n  border: none;\n  color: #333;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  font-size: 14px;\n  text-align: left;\n\n  &:hover {\n    background: #f8f9fa;\n  }\n\n  &.active {\n    background: $accent;\n    color: #fff;\n  }\n}\n\n/* Dark theme support */\n.cs_site_header.cs_style1.cs_white_color {\n  .cs_language_btn {\n    border-color: rgba(255, 255, 255, 0.3);\n    color: #fff;\n\n    &:hover {\n      background: rgba(255, 255, 255, 0.1);\n      border-color: rgba(255, 255, 255, 0.5);\n    }\n  }\n}\n\n/* Center menu horizontally on desktop only */\n@media (min-width: 992px) {\n  .cs_main_header_in {\n    position: relative;\n  }\n  \n  .cs_nav {\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n}\n\n/* WhatsApp Button Styles */\n.whatsapp-button {\n  position: fixed;\n  bottom: 30px;\n  right: 30px;\n  width: 60px;\n  height: 60px;\n  background: #25D366;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-shadow: 0 4px 20px rgba(37, 211, 102, 0.4);\n  transition: all 0.3s ease;\n  z-index: 1000;\n\n  &:hover {\n    transform: scale(1.1);\n    box-shadow: 0 6px 25px rgba(37, 211, 102, 0.6);\n  }\n\n  .whatsapp-icon {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n  }\n}\n\n/* WhatsApp Popup Styles */\n.whatsapp-popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n}\n\n.whatsapp-popup {\n  background: white;\n  border-radius: 15px;\n  padding: 0;\n  max-width: 400px;\n  width: 90%;\n  max-height: 90vh;\n  overflow: hidden;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n}\n\n.whatsapp-popup-header {\n  background: #25D366;\n  color: white;\n  padding: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  h3 {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 600;\n  }\n}\n\n.whatsapp-close-btn {\n  background: none;\n  border: none;\n  color: white;\n  font-size: 24px;\n  cursor: pointer;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: background-color 0.2s ease;\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.2);\n  }\n}\n\n.whatsapp-form {\n  padding: 30px;\n\n  .whatsapp-form-group {\n    margin-bottom: 20px;\n\n    label {\n      display: block;\n      margin-bottom: 8px;\n      font-weight: 500;\n      color: #333;\n    }\n\n    input {\n      width: 100%;\n      padding: 12px 15px;\n      border: 2px solid #e1e5e9;\n      border-radius: 8px;\n      font-size: 14px;\n      transition: border-color 0.3s ease;\n\n      &:focus {\n        outline: none;\n        border-color: #25D366;\n      }\n\n      &::placeholder {\n        color: #999;\n      }\n    }\n  }\n}\n\n.whatsapp-submit-btn {\n  width: 100%;\n  background: #25D366;\n  color: white;\n  border: none;\n  padding: 15px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n\n  &:hover {\n    background: #128C7E;\n  }\n\n  &:active {\n    transform: translateY(1px);\n  }\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .whatsapp-button {\n    bottom: 20px;\n    right: 20px;\n    width: 55px;\n    height: 55px;\n\n    .whatsapp-icon {\n      width: 35px;\n      height: 35px;\n    }\n  }\n\n  .whatsapp-popup {\n    width: 95%;\n    margin: 20px;\n  }\n\n  .whatsapp-form {\n    padding: 20px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
